import React from 'react';

import { SimpleIcon } from './icon-utils';

interface RequestDocAccessImgProps {
  className?: string;
}
export function RequestDocAccessImg({ className }: RequestDocAccessImgProps) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={239}
      viewBoxDimensions="0 0 302 239"
      width={302}
    >
      <path
        d="M87.4996 217C87.7992 217 88.0421 216.757 88.0421 216.458C88.0421 216.158 87.7992 215.916 87.4996 215.916C87.1999 215.916 86.957 216.158 86.957 216.458C86.957 216.757 87.1999 217 87.4996 217Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 217C87.7992 217 88.0421 216.757 88.0421 216.458C88.0421 216.158 87.7992 215.916 87.4996 215.916C87.1999 215.916 86.957 216.158 86.957 216.458C86.957 216.757 87.1999 217 87.4996 217Z"
        fill="#324A52"
      />
      <path
        d="M92.6138 211.886C92.9135 211.886 93.1564 211.643 93.1564 211.343C93.1564 211.044 92.9135 210.801 92.6138 210.801C92.3142 210.801 92.0713 211.044 92.0713 211.343C92.0713 211.643 92.3142 211.886 92.6138 211.886Z"
        fill="#324A52"
      />
      <path
        d="M92.6138 211.886C92.9135 211.886 93.1564 211.643 93.1564 211.343C93.1564 211.044 92.9135 210.801 92.6138 210.801C92.3142 210.801 92.0713 211.044 92.0713 211.343C92.0713 211.643 92.3142 211.886 92.6138 211.886Z"
        fill="#324A52"
      />
      <path
        d="M97.7291 206.766C98.0287 206.766 98.2716 206.524 98.2716 206.224C98.2716 205.925 98.0287 205.682 97.7291 205.682C97.4294 205.682 97.1865 205.925 97.1865 206.224C97.1865 206.524 97.4294 206.766 97.7291 206.766Z"
        fill="#324A52"
      />
      <path
        d="M97.7291 206.766C98.0287 206.766 98.2716 206.524 98.2716 206.224C98.2716 205.925 98.0287 205.682 97.7291 205.682C97.4294 205.682 97.1865 205.925 97.1865 206.224C97.1865 206.524 97.4294 206.766 97.7291 206.766Z"
        fill="#324A52"
      />
      <path
        d="M102.843 201.648C103.143 201.648 103.386 201.405 103.386 201.106C103.386 200.806 103.143 200.563 102.843 200.563C102.544 200.563 102.301 200.806 102.301 201.106C102.301 201.405 102.544 201.648 102.843 201.648Z"
        fill="#324A52"
      />
      <path
        d="M102.843 201.648C103.143 201.648 103.386 201.405 103.386 201.106C103.386 200.806 103.143 200.563 102.843 200.563C102.544 200.563 102.301 200.806 102.301 201.106C102.301 201.405 102.544 201.648 102.843 201.648Z"
        fill="#324A52"
      />
      <path
        d="M107.957 196.536C108.257 196.536 108.5 196.293 108.5 195.993C108.5 195.694 108.257 195.451 107.957 195.451C107.657 195.451 107.415 195.694 107.415 195.993C107.415 196.293 107.657 196.536 107.957 196.536Z"
        fill="#324A52"
      />
      <path
        d="M107.957 196.536C108.257 196.536 108.5 196.293 108.5 195.993C108.5 195.694 108.257 195.451 107.957 195.451C107.657 195.451 107.415 195.694 107.415 195.993C107.415 196.293 107.657 196.536 107.957 196.536Z"
        fill="#324A52"
      />
      <path
        d="M113.463 191.261C113.253 191.47 112.906 191.47 112.696 191.261C112.487 191.051 112.487 190.704 112.696 190.494C112.906 190.284 113.253 190.284 113.463 190.494C113.673 190.704 113.673 191.051 113.463 191.261Z"
        fill="#324A52"
      />
      <path
        d="M113.463 191.261C113.253 191.47 112.906 191.47 112.696 191.261C112.487 191.051 112.487 190.704 112.696 190.494C112.906 190.284 113.253 190.284 113.463 190.494C113.673 190.704 113.673 191.051 113.463 191.261Z"
        fill="#324A52"
      />
      <path
        d="M118.194 186.307C118.494 186.307 118.736 186.064 118.736 185.765C118.736 185.465 118.494 185.222 118.194 185.222C117.894 185.222 117.651 185.465 117.651 185.765C117.651 186.064 117.894 186.307 118.194 186.307Z"
        fill="#324A52"
      />
      <path
        d="M118.194 186.307C118.494 186.307 118.736 186.064 118.736 185.765C118.736 185.465 118.494 185.222 118.194 185.222C117.894 185.222 117.651 185.465 117.651 185.765C117.651 186.064 117.894 186.307 118.194 186.307Z"
        fill="#324A52"
      />
      <path
        d="M123.309 181.192C123.609 181.192 123.852 180.95 123.852 180.65C123.852 180.35 123.609 180.108 123.309 180.108C123.01 180.108 122.767 180.35 122.767 180.65C122.767 180.95 123.01 181.192 123.309 181.192Z"
        fill="#324A52"
      />
      <path
        d="M123.309 181.192C123.609 181.192 123.852 180.95 123.852 180.65C123.852 180.35 123.609 180.108 123.309 180.108C123.01 180.108 122.767 180.35 122.767 180.65C122.767 180.95 123.01 181.192 123.309 181.192Z"
        fill="#324A52"
      />
      <path
        d="M128.805 175.919C128.596 176.129 128.248 176.129 128.039 175.919C127.829 175.71 127.829 175.363 128.039 175.153C128.248 174.943 128.596 174.943 128.805 175.153C129.015 175.363 129.015 175.71 128.805 175.919Z"
        fill="#324A52"
      />
      <path
        d="M128.805 175.919C128.596 176.129 128.248 176.129 128.039 175.919C127.829 175.71 127.829 175.363 128.039 175.153C128.248 174.943 128.596 174.943 128.805 175.153C129.015 175.363 129.015 175.71 128.805 175.919Z"
        fill="#324A52"
      />
      <path
        d="M133.538 170.964C133.837 170.964 134.08 170.721 134.08 170.422C134.08 170.122 133.837 169.88 133.538 169.88C133.238 169.88 132.995 170.122 132.995 170.422C132.995 170.721 133.238 170.964 133.538 170.964Z"
        fill="#324A52"
      />
      <path
        d="M133.538 170.964C133.837 170.964 134.08 170.721 134.08 170.422C134.08 170.122 133.837 169.88 133.538 169.88C133.238 169.88 132.995 170.122 132.995 170.422C132.995 170.721 133.238 170.964 133.538 170.964Z"
        fill="#324A52"
      />
      <path
        d="M139.035 165.69C138.825 165.9 138.478 165.9 138.268 165.69C138.058 165.481 138.058 165.134 138.268 164.924C138.478 164.714 138.825 164.714 139.035 164.924C139.245 165.134 139.245 165.473 139.035 165.69Z"
        fill="#324A52"
      />
      <path
        d="M139.035 165.69C138.825 165.9 138.478 165.9 138.268 165.69C138.058 165.481 138.058 165.134 138.268 164.924C138.478 164.714 138.825 164.714 139.035 164.924C139.245 165.134 139.245 165.473 139.035 165.69Z"
        fill="#324A52"
      />
      <path
        d="M144.149 160.57C143.939 160.779 143.592 160.779 143.382 160.57C143.173 160.36 143.173 160.013 143.382 159.803C143.592 159.593 143.939 159.593 144.149 159.803C144.359 160.013 144.359 160.36 144.149 160.57Z"
        fill="#324A52"
      />
      <path
        d="M144.149 160.57C143.939 160.779 143.592 160.779 143.382 160.57C143.173 160.36 143.173 160.013 143.382 159.803C143.592 159.593 143.939 159.593 144.149 159.803C144.359 160.013 144.359 160.36 144.149 160.57Z"
        fill="#324A52"
      />
      <path
        d="M149.264 155.455C149.054 155.665 148.707 155.665 148.497 155.455C148.287 155.245 148.287 154.898 148.497 154.689C148.707 154.479 149.054 154.479 149.264 154.689C149.474 154.898 149.481 155.245 149.264 155.455Z"
        fill="#324A52"
      />
      <path
        d="M149.264 155.455C149.054 155.665 148.707 155.665 148.497 155.455C148.287 155.245 148.287 154.898 148.497 154.689C148.707 154.479 149.054 154.479 149.264 154.689C149.474 154.898 149.481 155.245 149.264 155.455Z"
        fill="#324A52"
      />
      <path
        d="M154.378 150.341C154.168 150.551 153.821 150.551 153.611 150.341C153.402 150.132 153.402 149.785 153.611 149.575C153.821 149.365 154.168 149.365 154.378 149.575C154.595 149.792 154.595 150.132 154.378 150.341Z"
        fill="#324A52"
      />
      <path
        d="M154.378 150.341C154.168 150.551 153.821 150.551 153.611 150.341C153.402 150.132 153.402 149.785 153.611 149.575C153.821 149.365 154.168 149.365 154.378 149.575C154.595 149.792 154.595 150.132 154.378 150.341Z"
        fill="#324A52"
      />
      <path
        d="M159.492 145.224C159.283 145.434 158.935 145.434 158.726 145.224C158.516 145.015 158.516 144.668 158.726 144.458C158.935 144.248 159.283 144.248 159.492 144.458C159.702 144.668 159.71 145.015 159.492 145.224Z"
        fill="#324A52"
      />
      <path
        d="M159.492 145.224C159.283 145.434 158.935 145.434 158.726 145.224C158.516 145.015 158.516 144.668 158.726 144.458C158.935 144.248 159.283 144.248 159.492 144.458C159.702 144.668 159.71 145.015 159.492 145.224Z"
        fill="#324A52"
      />
      <path
        d="M164.615 140.112C164.405 140.322 164.058 140.322 163.848 140.112C163.638 139.903 163.638 139.556 163.848 139.346C164.058 139.136 164.405 139.136 164.615 139.346C164.825 139.556 164.825 139.903 164.615 140.112Z"
        fill="#324A52"
      />
      <path
        d="M164.615 140.112C164.405 140.322 164.058 140.322 163.848 140.112C163.638 139.903 163.638 139.556 163.848 139.346C164.058 139.136 164.405 139.136 164.615 139.346C164.825 139.556 164.825 139.903 164.615 140.112Z"
        fill="#324A52"
      />
      <path
        d="M169.729 135C169.52 135.21 169.172 135.21 168.963 135C168.753 134.791 168.753 134.444 168.963 134.234C169.172 134.024 169.52 134.024 169.729 134.234C169.939 134.444 169.939 134.791 169.729 135Z"
        fill="#324A52"
      />
      <path
        d="M169.729 135C169.52 135.21 169.172 135.21 168.963 135C168.753 134.791 168.753 134.444 168.963 134.234C169.172 134.024 169.52 134.024 169.729 134.234C169.939 134.444 169.939 134.791 169.729 135Z"
        fill="#324A52"
      />
      <path
        d="M174.843 129.884C174.633 130.093 174.286 130.093 174.076 129.884C173.866 129.674 173.866 129.327 174.076 129.117C174.286 128.907 174.633 128.907 174.843 129.117C175.052 129.327 175.052 129.674 174.843 129.884Z"
        fill="#324A52"
      />
      <path
        d="M174.843 129.884C174.633 130.093 174.286 130.093 174.076 129.884C173.866 129.674 173.866 129.327 174.076 129.117C174.286 128.907 174.633 128.907 174.843 129.117C175.052 129.327 175.052 129.674 174.843 129.884Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 211.886C82.6855 211.886 82.9284 211.643 82.9284 211.343C82.9284 211.044 82.6855 210.801 82.3858 210.801C82.0862 210.801 81.8433 211.044 81.8433 211.343C81.8433 211.643 82.0862 211.886 82.3858 211.886Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 211.886C82.6855 211.886 82.9284 211.643 82.9284 211.343C82.9284 211.044 82.6855 210.801 82.3858 210.801C82.0862 210.801 81.8433 211.044 81.8433 211.343C81.8433 211.643 82.0862 211.886 82.3858 211.886Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 206.765C87.7997 206.765 88.0426 206.522 88.0426 206.222C88.0426 205.923 87.7997 205.68 87.5001 205.68C87.2004 205.68 86.9575 205.923 86.9575 206.222C86.9575 206.522 87.2004 206.765 87.5001 206.765Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 206.765C87.7997 206.765 88.0426 206.522 88.0426 206.222C88.0426 205.923 87.7997 205.68 87.5001 205.68C87.2004 205.68 86.9575 205.923 86.9575 206.222C86.9575 206.522 87.2004 206.765 87.5001 206.765Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 201.645C92.9145 201.645 93.1574 201.403 93.1574 201.103C93.1574 200.804 92.9145 200.561 92.6148 200.561C92.3152 200.561 92.0723 200.804 92.0723 201.103C92.0723 201.403 92.3152 201.645 92.6148 201.645Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 201.645C92.9145 201.645 93.1574 201.403 93.1574 201.103C93.1574 200.804 92.9145 200.561 92.6148 200.561C92.3152 200.561 92.0723 200.804 92.0723 201.103C92.0723 201.403 92.3152 201.645 92.6148 201.645Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 196.536C98.0292 196.536 98.2721 196.293 98.2721 195.993C98.2721 195.694 98.0292 195.451 97.7296 195.451C97.4299 195.451 97.187 195.694 97.187 195.993C97.187 196.293 97.4299 196.536 97.7296 196.536Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 196.536C98.0292 196.536 98.2721 196.293 98.2721 195.993C98.2721 195.694 98.0292 195.451 97.7296 195.451C97.4299 195.451 97.187 195.694 97.187 195.993C97.187 196.293 97.4299 196.536 97.7296 196.536Z"
        fill="#324A52"
      />
      <path
        d="M102.843 191.419C103.143 191.419 103.386 191.176 103.386 190.876C103.386 190.577 103.143 190.334 102.843 190.334C102.544 190.334 102.301 190.577 102.301 190.876C102.301 191.176 102.544 191.419 102.843 191.419Z"
        fill="#324A52"
      />
      <path
        d="M102.843 191.419C103.143 191.419 103.386 191.176 103.386 190.876C103.386 190.577 103.143 190.334 102.843 190.334C102.544 190.334 102.301 190.577 102.301 190.876C102.301 191.176 102.544 191.419 102.843 191.419Z"
        fill="#324A52"
      />
      <path
        d="M107.959 186.307C108.258 186.307 108.501 186.064 108.501 185.764C108.501 185.465 108.258 185.222 107.959 185.222C107.659 185.222 107.416 185.465 107.416 185.764C107.416 186.064 107.659 186.307 107.959 186.307Z"
        fill="#324A52"
      />
      <path
        d="M107.959 186.307C108.258 186.307 108.501 186.064 108.501 185.764C108.501 185.465 108.258 185.222 107.959 185.222C107.659 185.222 107.416 185.465 107.416 185.764C107.416 186.064 107.659 186.307 107.959 186.307Z"
        fill="#324A52"
      />
      <path
        d="M113.464 181.034C113.254 181.244 112.907 181.244 112.697 181.034C112.487 180.824 112.487 180.477 112.697 180.267C112.907 180.058 113.254 180.058 113.464 180.267C113.673 180.477 113.673 180.824 113.464 181.034Z"
        fill="#324A52"
      />
      <path
        d="M113.464 181.034C113.254 181.244 112.907 181.244 112.697 181.034C112.487 180.824 112.487 180.477 112.697 180.267C112.907 180.058 113.254 180.058 113.464 180.267C113.673 180.477 113.673 180.824 113.464 181.034Z"
        fill="#324A52"
      />
      <path
        d="M118.194 176.078C118.494 176.078 118.737 175.835 118.737 175.535C118.737 175.236 118.494 174.993 118.194 174.993C117.895 174.993 117.652 175.236 117.652 175.535C117.652 175.835 117.895 176.078 118.194 176.078Z"
        fill="#324A52"
      />
      <path
        d="M118.194 176.078C118.494 176.078 118.737 175.835 118.737 175.535C118.737 175.236 118.494 174.993 118.194 174.993C117.895 174.993 117.652 175.236 117.652 175.535C117.652 175.835 117.895 176.078 118.194 176.078Z"
        fill="#324A52"
      />
      <path
        d="M123.309 170.964C123.609 170.964 123.852 170.721 123.852 170.422C123.852 170.122 123.609 169.88 123.309 169.88C123.01 169.88 122.767 170.122 122.767 170.422C122.767 170.721 123.01 170.964 123.309 170.964Z"
        fill="#324A52"
      />
      <path
        d="M123.309 170.964C123.609 170.964 123.852 170.721 123.852 170.422C123.852 170.122 123.609 169.88 123.309 169.88C123.01 169.88 122.767 170.122 122.767 170.422C122.767 170.721 123.01 170.964 123.309 170.964Z"
        fill="#324A52"
      />
      <path
        d="M128.806 165.689C128.596 165.899 128.249 165.899 128.039 165.689C127.829 165.479 127.829 165.132 128.039 164.922C128.249 164.713 128.596 164.713 128.806 164.922C129.016 165.132 129.016 165.472 128.806 165.689Z"
        fill="#324A52"
      />
      <path
        d="M128.806 165.689C128.596 165.899 128.249 165.899 128.039 165.689C127.829 165.479 127.829 165.132 128.039 164.922C128.249 164.713 128.596 164.713 128.806 164.922C129.016 165.132 129.016 165.472 128.806 165.689Z"
        fill="#324A52"
      />
      <path
        d="M133.537 160.729C133.837 160.729 134.08 160.486 134.08 160.187C134.08 159.887 133.837 159.644 133.537 159.644C133.238 159.644 132.995 159.887 132.995 160.187C132.995 160.486 133.238 160.729 133.537 160.729Z"
        fill="#324A52"
      />
      <path
        d="M133.537 160.729C133.837 160.729 134.08 160.486 134.08 160.187C134.08 159.887 133.837 159.644 133.537 159.644C133.238 159.644 132.995 159.887 132.995 160.187C132.995 160.486 133.238 160.729 133.537 160.729Z"
        fill="#324A52"
      />
      <path
        d="M139.035 155.453C138.826 155.663 138.478 155.663 138.269 155.453C138.059 155.244 138.059 154.897 138.269 154.687C138.478 154.477 138.826 154.477 139.035 154.687C139.245 154.904 139.245 155.244 139.035 155.453Z"
        fill="#324A52"
      />
      <path
        d="M139.035 155.453C138.826 155.663 138.478 155.663 138.269 155.453C138.059 155.244 138.059 154.897 138.269 154.687C138.478 154.477 138.826 154.477 139.035 154.687C139.245 154.904 139.245 155.244 139.035 155.453Z"
        fill="#324A52"
      />
      <path
        d="M144.15 150.339C143.94 150.549 143.593 150.549 143.383 150.339C143.174 150.129 143.174 149.782 143.383 149.572C143.593 149.363 143.94 149.363 144.15 149.572C144.36 149.782 144.36 150.129 144.15 150.339Z"
        fill="#324A52"
      />
      <path
        d="M144.15 150.339C143.94 150.549 143.593 150.549 143.383 150.339C143.174 150.129 143.174 149.782 143.383 149.572C143.593 149.363 143.94 149.363 144.15 149.572C144.36 149.782 144.36 150.129 144.15 150.339Z"
        fill="#324A52"
      />
      <path
        d="M148.88 145.385C149.18 145.385 149.423 145.142 149.423 144.843C149.423 144.543 149.18 144.301 148.88 144.301C148.581 144.301 148.338 144.543 148.338 144.843C148.338 145.142 148.581 145.385 148.88 145.385Z"
        fill="#324A52"
      />
      <path
        d="M148.88 145.385C149.18 145.385 149.423 145.142 149.423 144.843C149.423 144.543 149.18 144.301 148.88 144.301C148.581 144.301 148.338 144.543 148.338 144.843C148.338 145.142 148.581 145.385 148.88 145.385Z"
        fill="#324A52"
      />
      <path
        d="M154.379 140.11C154.169 140.32 153.822 140.32 153.612 140.11C153.402 139.9 153.402 139.553 153.612 139.344C153.822 139.134 154.169 139.134 154.379 139.344C154.596 139.553 154.596 139.9 154.379 140.11Z"
        fill="#324A52"
      />
      <path
        d="M154.379 140.11C154.169 140.32 153.822 140.32 153.612 140.11C153.402 139.9 153.402 139.553 153.612 139.344C153.822 139.134 154.169 139.134 154.379 139.344C154.596 139.553 154.596 139.9 154.379 140.11Z"
        fill="#324A52"
      />
      <path
        d="M159.493 134.995C159.284 135.205 158.936 135.205 158.727 134.995C158.517 134.786 158.517 134.439 158.727 134.229C158.936 134.019 159.284 134.019 159.493 134.229C159.703 134.439 159.71 134.786 159.493 134.995Z"
        fill="#324A52"
      />
      <path
        d="M159.493 134.995C159.284 135.205 158.936 135.205 158.727 134.995C158.517 134.786 158.517 134.439 158.727 134.229C158.936 134.019 159.284 134.019 159.493 134.229C159.703 134.439 159.71 134.786 159.493 134.995Z"
        fill="#324A52"
      />
      <path
        d="M164.615 129.883C164.405 130.093 164.058 130.093 163.848 129.883C163.638 129.674 163.638 129.327 163.848 129.117C164.058 128.907 164.405 128.907 164.615 129.117C164.825 129.327 164.825 129.674 164.615 129.883Z"
        fill="#324A52"
      />
      <path
        d="M164.615 129.883C164.405 130.093 164.058 130.093 163.848 129.883C163.638 129.674 163.638 129.327 163.848 129.117C164.058 128.907 164.405 128.907 164.615 129.117C164.825 129.327 164.825 129.674 164.615 129.883Z"
        fill="#324A52"
      />
      <path
        d="M169.729 124.769C169.52 124.978 169.172 124.978 168.963 124.769C168.753 124.559 168.753 124.212 168.963 124.002C169.172 123.793 169.52 123.793 169.729 124.002C169.939 124.212 169.939 124.552 169.729 124.769Z"
        fill="#324A52"
      />
      <path
        d="M169.729 124.769C169.52 124.978 169.172 124.978 168.963 124.769C168.753 124.559 168.753 124.212 168.963 124.002C169.172 123.793 169.52 123.793 169.729 124.002C169.939 124.212 169.939 124.552 169.729 124.769Z"
        fill="#324A52"
      />
      <path
        d="M77.2711 206.767C77.5707 206.767 77.8136 206.524 77.8136 206.225C77.8136 205.925 77.5707 205.682 77.2711 205.682C76.9714 205.682 76.7285 205.925 76.7285 206.225C76.7285 206.524 76.9714 206.767 77.2711 206.767Z"
        fill="#324A52"
      />
      <path
        d="M77.2711 206.767C77.5707 206.767 77.8136 206.524 77.8136 206.225C77.8136 205.925 77.5707 205.682 77.2711 205.682C76.9714 205.682 76.7285 205.925 76.7285 206.225C76.7285 206.524 76.9714 206.767 77.2711 206.767Z"
        fill="#324A52"
      />
      <path
        d="M82.3853 201.648C82.685 201.648 82.9279 201.406 82.9279 201.106C82.9279 200.807 82.685 200.564 82.3853 200.564C82.0857 200.564 81.8428 200.807 81.8428 201.106C81.8428 201.406 82.0857 201.648 82.3853 201.648Z"
        fill="#324A52"
      />
      <path
        d="M82.3853 201.648C82.685 201.648 82.9279 201.406 82.9279 201.106C82.9279 200.807 82.685 200.564 82.3853 200.564C82.0857 200.564 81.8428 200.807 81.8428 201.106C81.8428 201.406 82.0857 201.648 82.3853 201.648Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 196.536C87.7997 196.536 88.0426 196.293 88.0426 195.994C88.0426 195.694 87.7997 195.452 87.5001 195.452C87.2004 195.452 86.9575 195.694 86.9575 195.994C86.9575 196.293 87.2004 196.536 87.5001 196.536Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 196.536C87.7997 196.536 88.0426 196.293 88.0426 195.994C88.0426 195.694 87.7997 195.452 87.5001 195.452C87.2004 195.452 86.9575 195.694 86.9575 195.994C86.9575 196.293 87.2004 196.536 87.5001 196.536Z"
        fill="#324A52"
      />
      <path
        d="M92.6138 191.419C92.9135 191.419 93.1564 191.177 93.1564 190.877C93.1564 190.578 92.9135 190.335 92.6138 190.335C92.3142 190.335 92.0713 190.578 92.0713 190.877C92.0713 191.177 92.3142 191.419 92.6138 191.419Z"
        fill="#324A52"
      />
      <path
        d="M92.6138 191.419C92.9135 191.419 93.1564 191.177 93.1564 190.877C93.1564 190.578 92.9135 190.335 92.6138 190.335C92.3142 190.335 92.0713 190.578 92.0713 190.877C92.0713 191.177 92.3142 191.419 92.6138 191.419Z"
        fill="#324A52"
      />
      <path
        d="M97.7286 186.307C98.0282 186.307 98.2711 186.065 98.2711 185.765C98.2711 185.466 98.0282 185.223 97.7286 185.223C97.4289 185.223 97.186 185.466 97.186 185.765C97.186 186.065 97.4289 186.307 97.7286 186.307Z"
        fill="#324A52"
      />
      <path
        d="M97.7286 186.307C98.0282 186.307 98.2711 186.065 98.2711 185.765C98.2711 185.466 98.0282 185.223 97.7286 185.223C97.4289 185.223 97.186 185.466 97.186 185.765C97.186 186.065 97.4289 186.307 97.7286 186.307Z"
        fill="#324A52"
      />
      <path
        d="M102.844 181.193C103.143 181.193 103.386 180.95 103.386 180.651C103.386 180.351 103.143 180.108 102.844 180.108C102.544 180.108 102.301 180.351 102.301 180.651C102.301 180.95 102.544 181.193 102.844 181.193Z"
        fill="#324A52"
      />
      <path
        d="M102.844 181.193C103.143 181.193 103.386 180.95 103.386 180.651C103.386 180.351 103.143 180.108 102.844 180.108C102.544 180.108 102.301 180.351 102.301 180.651C102.301 180.95 102.544 181.193 102.844 181.193Z"
        fill="#324A52"
      />
      <path
        d="M107.958 176.078C108.257 176.078 108.5 175.836 108.5 175.536C108.5 175.236 108.257 174.994 107.958 174.994C107.658 174.994 107.415 175.236 107.415 175.536C107.415 175.836 107.658 176.078 107.958 176.078Z"
        fill="#324A52"
      />
      <path
        d="M107.958 176.078C108.257 176.078 108.5 175.836 108.5 175.536C108.5 175.236 108.257 174.994 107.958 174.994C107.658 174.994 107.415 175.236 107.415 175.536C107.415 175.836 107.658 176.078 107.958 176.078Z"
        fill="#324A52"
      />
      <path
        d="M113.463 170.805C113.253 171.015 112.906 171.015 112.696 170.805C112.486 170.596 112.486 170.249 112.696 170.039C112.906 169.829 113.253 169.829 113.463 170.039C113.672 170.249 113.672 170.588 113.463 170.805Z"
        fill="#324A52"
      />
      <path
        d="M113.463 170.805C113.253 171.015 112.906 171.015 112.696 170.805C112.486 170.596 112.486 170.249 112.696 170.039C112.906 169.829 113.253 169.829 113.463 170.039C113.672 170.249 113.672 170.588 113.463 170.805Z"
        fill="#324A52"
      />
      <path
        d="M118.194 165.85C118.494 165.85 118.736 165.607 118.736 165.308C118.736 165.008 118.494 164.766 118.194 164.766C117.894 164.766 117.651 165.008 117.651 165.308C117.651 165.607 117.894 165.85 118.194 165.85Z"
        fill="#324A52"
      />
      <path
        d="M118.194 165.85C118.494 165.85 118.736 165.607 118.736 165.308C118.736 165.008 118.494 164.766 118.194 164.766C117.894 164.766 117.651 165.008 117.651 165.308C117.651 165.607 117.894 165.85 118.194 165.85Z"
        fill="#324A52"
      />
      <path
        d="M123.309 160.731C123.608 160.731 123.851 160.488 123.851 160.189C123.851 159.889 123.608 159.646 123.309 159.646C123.009 159.646 122.766 159.889 122.766 160.189C122.766 160.488 123.009 160.731 123.309 160.731Z"
        fill="#324A52"
      />
      <path
        d="M123.309 160.731C123.608 160.731 123.851 160.488 123.851 160.189C123.851 159.889 123.608 159.646 123.309 159.646C123.009 159.646 122.766 159.889 122.766 160.189C122.766 160.488 123.009 160.731 123.309 160.731Z"
        fill="#324A52"
      />
      <path
        d="M128.806 155.454C128.597 155.664 128.249 155.664 128.04 155.454C127.83 155.244 127.83 154.897 128.04 154.688C128.249 154.478 128.597 154.478 128.806 154.688C129.016 154.897 129.016 155.244 128.806 155.454Z"
        fill="#324A52"
      />
      <path
        d="M128.806 155.454C128.597 155.664 128.249 155.664 128.04 155.454C127.83 155.244 127.83 154.897 128.04 154.688C128.249 154.478 128.597 154.478 128.806 154.688C129.016 154.897 129.016 155.244 128.806 155.454Z"
        fill="#324A52"
      />
      <path
        d="M133.537 150.5C133.837 150.5 134.08 150.258 134.08 149.958C134.08 149.659 133.837 149.416 133.537 149.416C133.238 149.416 132.995 149.659 132.995 149.958C132.995 150.258 133.238 150.5 133.537 150.5Z"
        fill="#324A52"
      />
      <path
        d="M133.537 150.5C133.837 150.5 134.08 150.258 134.08 149.958C134.08 149.659 133.837 149.416 133.537 149.416C133.238 149.416 132.995 149.659 132.995 149.958C132.995 150.258 133.238 150.5 133.537 150.5Z"
        fill="#324A52"
      />
      <path
        d="M139.035 145.225C138.826 145.435 138.478 145.435 138.269 145.225C138.059 145.015 138.059 144.668 138.269 144.458C138.478 144.249 138.826 144.249 139.035 144.458C139.245 144.668 139.245 145.015 139.035 145.225Z"
        fill="#324A52"
      />
      <path
        d="M139.035 145.225C138.826 145.435 138.478 145.435 138.269 145.225C138.059 145.015 138.059 144.668 138.269 144.458C138.478 144.249 138.826 144.249 139.035 144.458C139.245 144.668 139.245 145.015 139.035 145.225Z"
        fill="#324A52"
      />
      <path
        d="M144.149 140.113C143.939 140.323 143.592 140.323 143.382 140.113C143.173 139.903 143.173 139.556 143.382 139.346C143.592 139.137 143.939 139.137 144.149 139.346C144.359 139.556 144.359 139.903 144.149 140.113Z"
        fill="#324A52"
      />
      <path
        d="M144.149 140.113C143.939 140.323 143.592 140.323 143.382 140.113C143.173 139.903 143.173 139.556 143.382 139.346C143.592 139.137 143.939 139.137 144.149 139.346C144.359 139.556 144.359 139.903 144.149 140.113Z"
        fill="#324A52"
      />
      <path
        d="M148.88 135.154C149.18 135.154 149.422 134.912 149.422 134.612C149.422 134.313 149.18 134.07 148.88 134.07C148.58 134.07 148.337 134.313 148.337 134.612C148.337 134.912 148.58 135.154 148.88 135.154Z"
        fill="#324A52"
      />
      <path
        d="M148.88 135.154C149.18 135.154 149.422 134.912 149.422 134.612C149.422 134.313 149.18 134.07 148.88 134.07C148.58 134.07 148.337 134.313 148.337 134.612C148.337 134.912 148.58 135.154 148.88 135.154Z"
        fill="#324A52"
      />
      <path
        d="M154.378 129.884C154.168 130.094 153.821 130.094 153.611 129.884C153.402 129.674 153.402 129.327 153.611 129.118C153.821 128.908 154.168 128.908 154.378 129.118C154.595 129.327 154.595 129.674 154.378 129.884Z"
        fill="#324A52"
      />
      <path
        d="M154.378 129.884C154.168 130.094 153.821 130.094 153.611 129.884C153.402 129.674 153.402 129.327 153.611 129.118C153.821 128.908 154.168 128.908 154.378 129.118C154.595 129.327 154.595 129.674 154.378 129.884Z"
        fill="#324A52"
      />
      <path
        d="M159.493 124.769C159.283 124.979 158.936 124.979 158.726 124.769C158.516 124.56 158.516 124.213 158.726 124.003C158.936 123.793 159.283 123.793 159.493 124.003C159.703 124.213 159.71 124.552 159.493 124.769Z"
        fill="#324A52"
      />
      <path
        d="M159.493 124.769C159.283 124.979 158.936 124.979 158.726 124.769C158.516 124.56 158.516 124.213 158.726 124.003C158.936 123.793 159.283 123.793 159.493 124.003C159.703 124.213 159.71 124.552 159.493 124.769Z"
        fill="#324A52"
      />
      <path
        d="M164.232 119.814C164.531 119.814 164.774 119.572 164.774 119.272C164.774 118.973 164.531 118.73 164.232 118.73C163.932 118.73 163.689 118.973 163.689 119.272C163.689 119.572 163.932 119.814 164.232 119.814Z"
        fill="#324A52"
      />
      <path
        d="M164.232 119.814C164.531 119.814 164.774 119.572 164.774 119.272C164.774 118.973 164.531 118.73 164.232 118.73C163.932 118.73 163.689 118.973 163.689 119.272C163.689 119.572 163.932 119.814 164.232 119.814Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 201.645C72.4569 201.645 72.6998 201.402 72.6998 201.103C72.6998 200.803 72.4569 200.56 72.1573 200.56C71.8577 200.56 71.6147 200.803 71.6147 201.103C71.6147 201.402 71.8577 201.645 72.1573 201.645Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 201.645C72.4569 201.645 72.6998 201.402 72.6998 201.103C72.6998 200.803 72.4569 200.56 72.1573 200.56C71.8577 200.56 71.6147 200.803 71.6147 201.103C71.6147 201.402 71.8577 201.645 72.1573 201.645Z"
        fill="#324A52"
      />
      <path
        d="M77.2711 196.535C77.5707 196.535 77.8136 196.293 77.8136 195.993C77.8136 195.694 77.5707 195.451 77.2711 195.451C76.9714 195.451 76.7285 195.694 76.7285 195.993C76.7285 196.293 76.9714 196.535 77.2711 196.535Z"
        fill="#324A52"
      />
      <path
        d="M77.2711 196.535C77.5707 196.535 77.8136 196.293 77.8136 195.993C77.8136 195.694 77.5707 195.451 77.2711 195.451C76.9714 195.451 76.7285 195.694 76.7285 195.993C76.7285 196.293 76.9714 196.535 77.2711 196.535Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 191.419C82.6859 191.419 82.9288 191.176 82.9288 190.876C82.9288 190.577 82.6859 190.334 82.3863 190.334C82.0867 190.334 81.8438 190.577 81.8438 190.876C81.8438 191.176 82.0867 191.419 82.3863 191.419Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 191.419C82.6859 191.419 82.9288 191.176 82.9288 190.876C82.9288 190.577 82.6859 190.334 82.3863 190.334C82.0867 190.334 81.8438 190.577 81.8438 190.876C81.8438 191.176 82.0867 191.419 82.3863 191.419Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 186.306C87.7992 186.306 88.0421 186.064 88.0421 185.764C88.0421 185.465 87.7992 185.222 87.4996 185.222C87.1999 185.222 86.957 185.465 86.957 185.764C86.957 186.064 87.1999 186.306 87.4996 186.306Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 186.306C87.7992 186.306 88.0421 186.064 88.0421 185.764C88.0421 185.465 87.7992 185.222 87.4996 185.222C87.1999 185.222 86.957 185.465 86.957 185.764C86.957 186.064 87.1999 186.306 87.4996 186.306Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 181.188C92.914 181.188 93.1569 180.945 93.1569 180.646C93.1569 180.346 92.914 180.103 92.6143 180.103C92.3147 180.103 92.0718 180.346 92.0718 180.646C92.0718 180.945 92.3147 181.188 92.6143 181.188Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 181.188C92.914 181.188 93.1569 180.945 93.1569 180.646C93.1569 180.346 92.914 180.103 92.6143 180.103C92.3147 180.103 92.0718 180.346 92.0718 180.646C92.0718 180.945 92.3147 181.188 92.6143 181.188Z"
        fill="#324A52"
      />
      <path
        d="M97.7291 176.077C98.0287 176.077 98.2716 175.835 98.2716 175.535C98.2716 175.236 98.0287 174.993 97.7291 174.993C97.4294 174.993 97.1865 175.236 97.1865 175.535C97.1865 175.835 97.4294 176.077 97.7291 176.077Z"
        fill="#324A52"
      />
      <path
        d="M97.7291 176.077C98.0287 176.077 98.2716 175.835 98.2716 175.535C98.2716 175.236 98.0287 174.993 97.7291 174.993C97.4294 174.993 97.1865 175.236 97.1865 175.535C97.1865 175.835 97.4294 176.077 97.7291 176.077Z"
        fill="#324A52"
      />
      <path
        d="M102.843 170.964C103.143 170.964 103.386 170.721 103.386 170.422C103.386 170.122 103.143 169.879 102.843 169.879C102.544 169.879 102.301 170.122 102.301 170.422C102.301 170.721 102.544 170.964 102.843 170.964Z"
        fill="#324A52"
      />
      <path
        d="M102.843 170.964C103.143 170.964 103.386 170.721 103.386 170.422C103.386 170.122 103.143 169.879 102.843 169.879C102.544 169.879 102.301 170.122 102.301 170.422C102.301 170.721 102.544 170.964 102.843 170.964Z"
        fill="#324A52"
      />
      <path
        d="M107.958 165.849C108.258 165.849 108.501 165.607 108.501 165.307C108.501 165.008 108.258 164.765 107.958 164.765C107.658 164.765 107.416 165.008 107.416 165.307C107.416 165.607 107.658 165.849 107.958 165.849Z"
        fill="#324A52"
      />
      <path
        d="M107.958 165.849C108.258 165.849 108.501 165.607 108.501 165.307C108.501 165.008 108.258 164.765 107.958 164.765C107.658 164.765 107.416 165.008 107.416 165.307C107.416 165.607 107.658 165.849 107.958 165.849Z"
        fill="#324A52"
      />
      <path
        d="M113.463 160.569C113.253 160.779 112.906 160.779 112.696 160.569C112.487 160.359 112.487 160.012 112.696 159.803C112.906 159.593 113.253 159.593 113.463 159.803C113.673 160.012 113.673 160.359 113.463 160.569Z"
        fill="#324A52"
      />
      <path
        d="M113.463 160.569C113.253 160.779 112.906 160.779 112.696 160.569C112.487 160.359 112.487 160.012 112.696 159.803C112.906 159.593 113.253 159.593 113.463 159.803C113.673 160.012 113.673 160.359 113.463 160.569Z"
        fill="#324A52"
      />
      <path
        d="M118.577 155.453C118.368 155.663 118.02 155.663 117.811 155.453C117.601 155.243 117.601 154.896 117.811 154.687C118.02 154.477 118.368 154.477 118.577 154.687C118.787 154.904 118.787 155.243 118.577 155.453Z"
        fill="#324A52"
      />
      <path
        d="M118.577 155.453C118.368 155.663 118.02 155.663 117.811 155.453C117.601 155.243 117.601 154.896 117.811 154.687C118.02 154.477 118.368 154.477 118.577 154.687C118.787 154.904 118.787 155.243 118.577 155.453Z"
        fill="#324A52"
      />
      <path
        d="M123.309 150.5C123.609 150.5 123.852 150.257 123.852 149.957C123.852 149.658 123.609 149.415 123.309 149.415C123.01 149.415 122.767 149.658 122.767 149.957C122.767 150.257 123.01 150.5 123.309 150.5Z"
        fill="#324A52"
      />
      <path
        d="M123.309 150.5C123.609 150.5 123.852 150.257 123.852 149.957C123.852 149.658 123.609 149.415 123.309 149.415C123.01 149.415 122.767 149.658 122.767 149.957C122.767 150.257 123.01 150.5 123.309 150.5Z"
        fill="#324A52"
      />
      <path
        d="M128.806 145.224C128.596 145.434 128.249 145.434 128.039 145.224C127.829 145.014 127.829 144.667 128.039 144.458C128.249 144.248 128.596 144.248 128.806 144.458C129.016 144.667 129.016 145.014 128.806 145.224Z"
        fill="#324A52"
      />
      <path
        d="M128.806 145.224C128.596 145.434 128.249 145.434 128.039 145.224C127.829 145.014 127.829 144.667 128.039 144.458C128.249 144.248 128.596 144.248 128.806 144.458C129.016 144.667 129.016 145.014 128.806 145.224Z"
        fill="#324A52"
      />
      <path
        d="M133.921 140.11C133.711 140.319 133.364 140.319 133.154 140.11C132.945 139.9 132.945 139.553 133.154 139.343C133.364 139.134 133.711 139.134 133.921 139.343C134.131 139.553 134.131 139.9 133.921 140.11Z"
        fill="#324A52"
      />
      <path
        d="M133.921 140.11C133.711 140.319 133.364 140.319 133.154 140.11C132.945 139.9 132.945 139.553 133.154 139.343C133.364 139.134 133.711 139.134 133.921 139.343C134.131 139.553 134.131 139.9 133.921 140.11Z"
        fill="#324A52"
      />
      <path
        d="M139.035 134.995C138.825 135.205 138.478 135.205 138.268 134.995C138.058 134.785 138.058 134.438 138.268 134.229C138.478 134.019 138.825 134.019 139.035 134.229C139.245 134.438 139.245 134.785 139.035 134.995Z"
        fill="#324A52"
      />
      <path
        d="M139.035 134.995C138.825 135.205 138.478 135.205 138.268 134.995C138.058 134.785 138.058 134.438 138.268 134.229C138.478 134.019 138.825 134.019 139.035 134.229C139.245 134.438 139.245 134.785 139.035 134.995Z"
        fill="#324A52"
      />
      <path
        d="M144.15 129.881C143.94 130.09 143.593 130.09 143.383 129.881C143.173 129.671 143.173 129.324 143.383 129.114C143.593 128.904 143.94 128.904 144.15 129.114C144.36 129.324 144.36 129.671 144.15 129.881Z"
        fill="#324A52"
      />
      <path
        d="M144.15 129.881C143.94 130.09 143.593 130.09 143.383 129.881C143.173 129.671 143.173 129.324 143.383 129.114C143.593 128.904 143.94 128.904 144.15 129.114C144.36 129.324 144.36 129.671 144.15 129.881Z"
        fill="#324A52"
      />
      <path
        d="M149.264 124.769C149.054 124.978 148.707 124.978 148.497 124.769C148.287 124.559 148.287 124.212 148.497 124.002C148.707 123.792 149.054 123.792 149.264 124.002C149.474 124.212 149.481 124.552 149.264 124.769Z"
        fill="#324A52"
      />
      <path
        d="M149.264 124.769C149.054 124.978 148.707 124.978 148.497 124.769C148.287 124.559 148.287 124.212 148.497 124.002C148.707 123.792 149.054 123.792 149.264 124.002C149.474 124.212 149.481 124.552 149.264 124.769Z"
        fill="#324A52"
      />
      <path
        d="M154.379 119.654C154.169 119.864 153.822 119.864 153.612 119.654C153.402 119.444 153.402 119.097 153.612 118.888C153.822 118.678 154.169 118.678 154.379 118.888C154.596 119.097 154.596 119.437 154.379 119.654Z"
        fill="#324A52"
      />
      <path
        d="M154.379 119.654C154.169 119.864 153.822 119.864 153.612 119.654C153.402 119.444 153.402 119.097 153.612 118.888C153.822 118.678 154.169 118.678 154.379 118.888C154.596 119.097 154.596 119.437 154.379 119.654Z"
        fill="#324A52"
      />
      <path
        d="M159.493 114.54C159.283 114.749 158.936 114.749 158.726 114.54C158.516 114.33 158.516 113.983 158.726 113.773C158.936 113.563 159.283 113.563 159.493 113.773C159.71 113.983 159.71 114.323 159.493 114.54Z"
        fill="#324A52"
      />
      <path
        d="M159.493 114.54C159.283 114.749 158.936 114.749 158.726 114.54C158.516 114.33 158.516 113.983 158.726 113.773C158.936 113.563 159.283 113.563 159.493 113.773C159.71 113.983 159.71 114.323 159.493 114.54Z"
        fill="#324A52"
      />
      <path
        d="M67.0435 196.536C67.3432 196.536 67.5861 196.293 67.5861 195.993C67.5861 195.694 67.3432 195.451 67.0435 195.451C66.7439 195.451 66.501 195.694 66.501 195.993C66.501 196.293 66.7439 196.536 67.0435 196.536Z"
        fill="#324A52"
      />
      <path
        d="M67.0435 196.536C67.3432 196.536 67.5861 196.293 67.5861 195.993C67.5861 195.694 67.3432 195.451 67.0435 195.451C66.7439 195.451 66.501 195.694 66.501 195.993C66.501 196.293 66.7439 196.536 67.0435 196.536Z"
        fill="#324A52"
      />
      <path
        d="M72.1578 191.419C72.4574 191.419 72.7003 191.176 72.7003 190.876C72.7003 190.577 72.4574 190.334 72.1578 190.334C71.8581 190.334 71.6152 190.577 71.6152 190.876C71.6152 191.176 71.8581 191.419 72.1578 191.419Z"
        fill="#324A52"
      />
      <path
        d="M72.1578 191.419C72.4574 191.419 72.7003 191.176 72.7003 190.876C72.7003 190.577 72.4574 190.334 72.1578 190.334C71.8581 190.334 71.6152 190.577 71.6152 190.876C71.6152 191.176 71.8581 191.419 72.1578 191.419Z"
        fill="#324A52"
      />
      <path
        d="M77.272 186.307C77.5717 186.307 77.8146 186.064 77.8146 185.764C77.8146 185.465 77.5717 185.222 77.272 185.222C76.9724 185.222 76.7295 185.465 76.7295 185.764C76.7295 186.064 76.9724 186.307 77.272 186.307Z"
        fill="#324A52"
      />
      <path
        d="M77.272 186.307C77.5717 186.307 77.8146 186.064 77.8146 185.764C77.8146 185.465 77.5717 185.222 77.272 185.222C76.9724 185.222 76.7295 185.465 76.7295 185.764C76.7295 186.064 76.9724 186.307 77.272 186.307Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 181.192C82.6859 181.192 82.9288 180.949 82.9288 180.65C82.9288 180.35 82.6859 180.107 82.3863 180.107C82.0867 180.107 81.8438 180.35 81.8438 180.65C81.8438 180.949 82.0867 181.192 82.3863 181.192Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 181.192C82.6859 181.192 82.9288 180.949 82.9288 180.65C82.9288 180.35 82.6859 180.107 82.3863 180.107C82.0867 180.107 81.8438 180.35 81.8438 180.65C81.8438 180.949 82.0867 181.192 82.3863 181.192Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 176.078C87.7997 176.078 88.0426 175.835 88.0426 175.535C88.0426 175.236 87.7997 174.993 87.5001 174.993C87.2004 174.993 86.9575 175.236 86.9575 175.535C86.9575 175.835 87.2004 176.078 87.5001 176.078Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 176.078C87.7997 176.078 88.0426 175.835 88.0426 175.535C88.0426 175.236 87.7997 174.993 87.5001 174.993C87.2004 174.993 86.9575 175.236 86.9575 175.535C86.9575 175.835 87.2004 176.078 87.5001 176.078Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 170.964C92.9145 170.964 93.1574 170.721 93.1574 170.422C93.1574 170.122 92.9145 169.879 92.6148 169.879C92.3152 169.879 92.0723 170.122 92.0723 170.422C92.0723 170.721 92.3152 170.964 92.6148 170.964Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 170.964C92.9145 170.964 93.1574 170.721 93.1574 170.422C93.1574 170.122 92.9145 169.879 92.6148 169.879C92.3152 169.879 92.0723 170.122 92.0723 170.422C92.0723 170.721 92.3152 170.964 92.6148 170.964Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 165.85C98.0292 165.85 98.2721 165.607 98.2721 165.307C98.2721 165.008 98.0292 164.765 97.7296 164.765C97.4299 164.765 97.187 165.008 97.187 165.307C97.187 165.607 97.4299 165.85 97.7296 165.85Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 165.85C98.0292 165.85 98.2721 165.607 98.2721 165.307C98.2721 165.008 98.0292 164.765 97.7296 164.765C97.4299 164.765 97.187 165.008 97.187 165.307C97.187 165.607 97.4299 165.85 97.7296 165.85Z"
        fill="#324A52"
      />
      <path
        d="M102.843 160.73C103.143 160.73 103.386 160.487 103.386 160.188C103.386 159.888 103.143 159.646 102.843 159.646C102.544 159.646 102.301 159.888 102.301 160.188C102.301 160.487 102.544 160.73 102.843 160.73Z"
        fill="#324A52"
      />
      <path
        d="M102.843 160.73C103.143 160.73 103.386 160.487 103.386 160.188C103.386 159.888 103.143 159.646 102.843 159.646C102.544 159.646 102.301 159.888 102.301 160.188C102.301 160.487 102.544 160.73 102.843 160.73Z"
        fill="#324A52"
      />
      <path
        d="M108.342 155.455C108.132 155.664 107.785 155.664 107.575 155.455C107.365 155.245 107.365 154.898 107.575 154.688C107.785 154.479 108.132 154.479 108.342 154.688C108.551 154.898 108.559 155.245 108.342 155.455Z"
        fill="#324A52"
      />
      <path
        d="M108.342 155.455C108.132 155.664 107.785 155.664 107.575 155.455C107.365 155.245 107.365 154.898 107.575 154.688C107.785 154.479 108.132 154.479 108.342 154.688C108.551 154.898 108.559 155.245 108.342 155.455Z"
        fill="#324A52"
      />
      <path
        d="M113.464 150.341C113.254 150.551 112.907 150.551 112.697 150.341C112.487 150.132 112.487 149.784 112.697 149.575C112.907 149.365 113.254 149.365 113.464 149.575C113.673 149.784 113.673 150.132 113.464 150.341Z"
        fill="#324A52"
      />
      <path
        d="M113.464 150.341C113.254 150.551 112.907 150.551 112.697 150.341C112.487 150.132 112.487 149.784 112.697 149.575C112.907 149.365 113.254 149.365 113.464 149.575C113.673 149.784 113.673 150.132 113.464 150.341Z"
        fill="#324A52"
      />
      <path
        d="M118.194 145.385C118.494 145.385 118.737 145.142 118.737 144.843C118.737 144.543 118.494 144.3 118.194 144.3C117.895 144.3 117.652 144.543 117.652 144.843C117.652 145.142 117.895 145.385 118.194 145.385Z"
        fill="#324A52"
      />
      <path
        d="M118.194 145.385C118.494 145.385 118.737 145.142 118.737 144.843C118.737 144.543 118.494 144.3 118.194 144.3C117.895 144.3 117.652 144.543 117.652 144.843C117.652 145.142 117.895 145.385 118.194 145.385Z"
        fill="#324A52"
      />
      <path
        d="M123.693 140.112C123.483 140.322 123.136 140.322 122.926 140.112C122.716 139.903 122.716 139.555 122.926 139.346C123.136 139.136 123.483 139.136 123.693 139.346C123.902 139.555 123.902 139.903 123.693 140.112Z"
        fill="#324A52"
      />
      <path
        d="M123.693 140.112C123.483 140.322 123.136 140.322 122.926 140.112C122.716 139.903 122.716 139.555 122.926 139.346C123.136 139.136 123.483 139.136 123.693 139.346C123.902 139.555 123.902 139.903 123.693 140.112Z"
        fill="#324A52"
      />
      <path
        d="M128.807 135C128.597 135.21 128.25 135.21 128.04 135C127.83 134.79 127.83 134.443 128.04 134.234C128.25 134.024 128.597 134.024 128.807 134.234C129.017 134.443 129.017 134.79 128.807 135Z"
        fill="#324A52"
      />
      <path
        d="M128.807 135C128.597 135.21 128.25 135.21 128.04 135C127.83 134.79 127.83 134.443 128.04 134.234C128.25 134.024 128.597 134.024 128.807 134.234C129.017 134.443 129.017 134.79 128.807 135Z"
        fill="#324A52"
      />
      <path
        d="M133.921 129.883C133.711 130.093 133.364 130.093 133.154 129.883C132.944 129.674 132.944 129.327 133.154 129.117C133.364 128.907 133.711 128.907 133.921 129.117C134.131 129.327 134.131 129.674 133.921 129.883Z"
        fill="#324A52"
      />
      <path
        d="M133.921 129.883C133.711 130.093 133.364 130.093 133.154 129.883C132.944 129.674 132.944 129.327 133.154 129.117C133.364 128.907 133.711 128.907 133.921 129.117C134.131 129.327 134.131 129.674 133.921 129.883Z"
        fill="#324A52"
      />
      <path
        d="M139.036 124.769C138.826 124.978 138.479 124.978 138.269 124.769C138.059 124.559 138.059 124.212 138.269 124.002C138.479 123.793 138.826 123.793 139.036 124.002C139.246 124.212 139.246 124.552 139.036 124.769Z"
        fill="#324A52"
      />
      <path
        d="M139.036 124.769C138.826 124.978 138.479 124.978 138.269 124.769C138.059 124.559 138.059 124.212 138.269 124.002C138.479 123.793 138.826 123.793 139.036 124.002C139.246 124.212 139.246 124.552 139.036 124.769Z"
        fill="#324A52"
      />
      <path
        d="M144.15 119.654C143.94 119.864 143.593 119.864 143.383 119.654C143.174 119.444 143.174 119.097 143.383 118.888C143.593 118.678 143.94 118.678 144.15 118.888C144.36 119.097 144.36 119.437 144.15 119.654Z"
        fill="#324A52"
      />
      <path
        d="M144.15 119.654C143.94 119.864 143.593 119.864 143.383 119.654C143.174 119.444 143.174 119.097 143.383 118.888C143.593 118.678 143.94 118.678 144.15 118.888C144.36 119.097 144.36 119.437 144.15 119.654Z"
        fill="#324A52"
      />
      <path
        d="M149.264 114.542C149.054 114.752 148.707 114.752 148.497 114.542C148.287 114.332 148.287 113.985 148.497 113.776C148.707 113.566 149.054 113.566 149.264 113.776C149.481 113.985 149.481 114.325 149.264 114.542Z"
        fill="#324A52"
      />
      <path
        d="M149.264 114.542C149.054 114.752 148.707 114.752 148.497 114.542C148.287 114.332 148.287 113.985 148.497 113.776C148.707 113.566 149.054 113.566 149.264 113.776C149.481 113.985 149.481 114.325 149.264 114.542Z"
        fill="#324A52"
      />
      <path
        d="M154.38 109.419C154.17 109.629 153.823 109.629 153.613 109.419C153.403 109.209 153.403 108.862 153.613 108.652C153.823 108.443 154.17 108.443 154.38 108.652C154.597 108.869 154.597 109.209 154.38 109.419Z"
        fill="#324A52"
      />
      <path
        d="M154.38 109.419C154.17 109.629 153.823 109.629 153.613 109.419C153.403 109.209 153.403 108.862 153.613 108.652C153.823 108.443 154.17 108.443 154.38 108.652C154.597 108.869 154.597 109.209 154.38 109.419Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 191.419C62.2216 191.419 62.4645 191.176 62.4645 190.876C62.4645 190.577 62.2216 190.334 61.9219 190.334C61.6223 190.334 61.3794 190.577 61.3794 190.876C61.3794 191.176 61.6223 191.419 61.9219 191.419Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 191.419C62.2216 191.419 62.4645 191.176 62.4645 190.876C62.4645 190.577 62.2216 190.334 61.9219 190.334C61.6223 190.334 61.3794 190.577 61.3794 190.876C61.3794 191.176 61.6223 191.419 61.9219 191.419Z"
        fill="#324A52"
      />
      <path
        d="M67.044 186.306C67.3437 186.306 67.5866 186.064 67.5866 185.764C67.5866 185.465 67.3437 185.222 67.044 185.222C66.7444 185.222 66.5015 185.465 66.5015 185.764C66.5015 186.064 66.7444 186.306 67.044 186.306Z"
        fill="#324A52"
      />
      <path
        d="M67.044 186.306C67.3437 186.306 67.5866 186.064 67.5866 185.764C67.5866 185.465 67.3437 185.222 67.044 185.222C66.7444 185.222 66.5015 185.465 66.5015 185.764C66.5015 186.064 66.7444 186.306 67.044 186.306Z"
        fill="#324A52"
      />
      <path
        d="M72.1583 181.192C72.4579 181.192 72.7008 180.949 72.7008 180.65C72.7008 180.35 72.4579 180.107 72.1583 180.107C71.8586 180.107 71.6157 180.35 71.6157 180.65C71.6157 180.949 71.8586 181.192 72.1583 181.192Z"
        fill="#324A52"
      />
      <path
        d="M72.1583 181.192C72.4579 181.192 72.7008 180.949 72.7008 180.65C72.7008 180.35 72.4579 180.107 72.1583 180.107C71.8586 180.107 71.6157 180.35 71.6157 180.65C71.6157 180.949 71.8586 181.192 72.1583 181.192Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 176.077C77.5712 176.077 77.8141 175.835 77.8141 175.535C77.8141 175.236 77.5712 174.993 77.2716 174.993C76.9719 174.993 76.729 175.236 76.729 175.535C76.729 175.835 76.9719 176.077 77.2716 176.077Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 176.077C77.5712 176.077 77.8141 175.835 77.8141 175.535C77.8141 175.236 77.5712 174.993 77.2716 174.993C76.9719 174.993 76.729 175.236 76.729 175.535C76.729 175.835 76.9719 176.077 77.2716 176.077Z"
        fill="#324A52"
      />
      <path
        d="M82.3868 170.964C82.6864 170.964 82.9293 170.721 82.9293 170.422C82.9293 170.122 82.6864 169.879 82.3868 169.879C82.0871 169.879 81.8442 170.122 81.8442 170.422C81.8442 170.721 82.0871 170.964 82.3868 170.964Z"
        fill="#324A52"
      />
      <path
        d="M82.3868 170.964C82.6864 170.964 82.9293 170.721 82.9293 170.422C82.9293 170.122 82.6864 169.879 82.3868 169.879C82.0871 169.879 81.8442 170.122 81.8442 170.422C81.8442 170.721 82.0871 170.964 82.3868 170.964Z"
        fill="#324A52"
      />
      <path
        d="M87.5006 165.849C87.8002 165.849 88.0431 165.607 88.0431 165.307C88.0431 165.008 87.8002 164.765 87.5006 164.765C87.2009 164.765 86.958 165.008 86.958 165.307C86.958 165.607 87.2009 165.849 87.5006 165.849Z"
        fill="#324A52"
      />
      <path
        d="M87.5006 165.849C87.8002 165.849 88.0431 165.607 88.0431 165.307C88.0431 165.008 87.8002 164.765 87.5006 164.765C87.2009 164.765 86.958 165.008 86.958 165.307C86.958 165.607 87.2009 165.849 87.5006 165.849Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 160.73C92.9145 160.73 93.1574 160.487 93.1574 160.188C93.1574 159.888 92.9145 159.645 92.6148 159.645C92.3152 159.645 92.0723 159.888 92.0723 160.188C92.0723 160.487 92.3152 160.73 92.6148 160.73Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 160.73C92.9145 160.73 93.1574 160.487 93.1574 160.188C93.1574 159.888 92.9145 159.645 92.6148 159.645C92.3152 159.645 92.0723 159.888 92.0723 160.188C92.0723 160.487 92.3152 160.73 92.6148 160.73Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 155.453C97.9033 155.663 97.5561 155.663 97.3463 155.453C97.1365 155.243 97.1365 154.896 97.3463 154.687C97.5561 154.477 97.9033 154.477 98.1131 154.687C98.3229 154.904 98.3229 155.243 98.1131 155.453Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 155.453C97.9033 155.663 97.5561 155.663 97.3463 155.453C97.1365 155.243 97.1365 154.896 97.3463 154.687C97.5561 154.477 97.9033 154.477 98.1131 154.687C98.3229 154.904 98.3229 155.243 98.1131 155.453Z"
        fill="#324A52"
      />
      <path
        d="M102.845 150.5C103.144 150.5 103.387 150.257 103.387 149.957C103.387 149.658 103.144 149.415 102.845 149.415C102.545 149.415 102.302 149.658 102.302 149.957C102.302 150.257 102.545 150.5 102.845 150.5Z"
        fill="#324A52"
      />
      <path
        d="M102.845 150.5C103.144 150.5 103.387 150.257 103.387 149.957C103.387 149.658 103.144 149.415 102.845 149.415C102.545 149.415 102.302 149.658 102.302 149.957C102.302 150.257 102.545 150.5 102.845 150.5Z"
        fill="#324A52"
      />
      <path
        d="M107.959 145.385C108.258 145.385 108.501 145.142 108.501 144.843C108.501 144.543 108.258 144.3 107.959 144.3C107.659 144.3 107.416 144.543 107.416 144.843C107.416 145.142 107.659 145.385 107.959 145.385Z"
        fill="#324A52"
      />
      <path
        d="M107.959 145.385C108.258 145.385 108.501 145.142 108.501 144.843C108.501 144.543 108.258 144.3 107.959 144.3C107.659 144.3 107.416 144.543 107.416 144.843C107.416 145.142 107.659 145.385 107.959 145.385Z"
        fill="#324A52"
      />
      <path
        d="M113.464 140.112C113.254 140.322 112.907 140.322 112.697 140.112C112.487 139.902 112.487 139.555 112.697 139.346C112.907 139.136 113.254 139.136 113.464 139.346C113.673 139.555 113.673 139.902 113.464 140.112Z"
        fill="#324A52"
      />
      <path
        d="M113.464 140.112C113.254 140.322 112.907 140.322 112.697 140.112C112.487 139.902 112.487 139.555 112.697 139.346C112.907 139.136 113.254 139.136 113.464 139.346C113.673 139.555 113.673 139.902 113.464 140.112Z"
        fill="#324A52"
      />
      <path
        d="M118.194 135.154C118.494 135.154 118.737 134.911 118.737 134.611C118.737 134.312 118.494 134.069 118.194 134.069C117.895 134.069 117.652 134.312 117.652 134.611C117.652 134.911 117.895 135.154 118.194 135.154Z"
        fill="#324A52"
      />
      <path
        d="M118.194 135.154C118.494 135.154 118.737 134.911 118.737 134.611C118.737 134.312 118.494 134.069 118.194 134.069C117.895 134.069 117.652 134.312 117.652 134.611C117.652 134.911 117.895 135.154 118.194 135.154Z"
        fill="#324A52"
      />
      <path
        d="M123.693 129.883C123.483 130.093 123.136 130.093 122.926 129.883C122.716 129.674 122.716 129.326 122.926 129.117C123.136 128.907 123.483 128.907 123.693 129.117C123.902 129.326 123.902 129.674 123.693 129.883Z"
        fill="#324A52"
      />
      <path
        d="M123.693 129.883C123.483 130.093 123.136 130.093 122.926 129.883C122.716 129.674 122.716 129.326 122.926 129.117C123.136 128.907 123.483 128.907 123.693 129.117C123.902 129.326 123.902 129.674 123.693 129.883Z"
        fill="#324A52"
      />
      <path
        d="M128.807 124.769C128.597 124.978 128.25 124.978 128.04 124.769C127.83 124.559 127.83 124.212 128.04 124.002C128.25 123.792 128.597 123.792 128.807 124.002C129.017 124.212 129.017 124.552 128.807 124.769Z"
        fill="#324A52"
      />
      <path
        d="M128.807 124.769C128.597 124.978 128.25 124.978 128.04 124.769C127.83 124.559 127.83 124.212 128.04 124.002C128.25 123.792 128.597 123.792 128.807 124.002C129.017 124.212 129.017 124.552 128.807 124.769Z"
        fill="#324A52"
      />
      <path
        d="M133.538 119.813C133.837 119.813 134.08 119.571 134.08 119.271C134.08 118.972 133.837 118.729 133.538 118.729C133.238 118.729 132.995 118.972 132.995 119.271C132.995 119.571 133.238 119.813 133.538 119.813Z"
        fill="#324A52"
      />
      <path
        d="M133.538 119.813C133.837 119.813 134.08 119.571 134.08 119.271C134.08 118.972 133.837 118.729 133.538 118.729C133.238 118.729 132.995 118.972 132.995 119.271C132.995 119.571 133.238 119.813 133.538 119.813Z"
        fill="#324A52"
      />
      <path
        d="M139.036 114.54C138.826 114.749 138.479 114.749 138.269 114.54C138.059 114.33 138.059 113.983 138.269 113.773C138.479 113.563 138.826 113.563 139.036 113.773C139.246 113.983 139.246 114.323 139.036 114.54Z"
        fill="#324A52"
      />
      <path
        d="M139.036 114.54C138.826 114.749 138.479 114.749 138.269 114.54C138.059 114.33 138.059 113.983 138.269 113.773C138.479 113.563 138.826 113.563 139.036 113.773C139.246 113.983 139.246 114.323 139.036 114.54Z"
        fill="#324A52"
      />
      <path
        d="M144.15 109.417C143.94 109.627 143.593 109.627 143.383 109.417C143.174 109.208 143.174 108.86 143.383 108.651C143.593 108.441 143.94 108.441 144.15 108.651C144.36 108.86 144.36 109.208 144.15 109.417Z"
        fill="#324A52"
      />
      <path
        d="M144.15 109.417C143.94 109.627 143.593 109.627 143.383 109.417C143.174 109.208 143.174 108.86 143.383 108.651C143.593 108.441 143.94 108.441 144.15 108.651C144.36 108.86 144.36 109.208 144.15 109.417Z"
        fill="#324A52"
      />
      <path
        d="M148.881 104.465C149.181 104.465 149.424 104.222 149.424 103.923C149.424 103.623 149.181 103.38 148.881 103.38C148.582 103.38 148.339 103.623 148.339 103.923C148.339 104.222 148.582 104.465 148.881 104.465Z"
        fill="#324A52"
      />
      <path
        d="M148.881 104.465C149.181 104.465 149.424 104.222 149.424 103.923C149.424 103.623 149.181 103.38 148.881 103.38C148.582 103.38 148.339 103.623 148.339 103.923C148.339 104.222 148.582 104.465 148.881 104.465Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 186.307C57.1068 186.307 57.3497 186.065 57.3497 185.765C57.3497 185.465 57.1068 185.223 56.8072 185.223C56.5076 185.223 56.2646 185.465 56.2646 185.765C56.2646 186.065 56.5076 186.307 56.8072 186.307Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 186.307C57.1068 186.307 57.3497 186.065 57.3497 185.765C57.3497 185.465 57.1068 185.223 56.8072 185.223C56.5076 185.223 56.2646 185.465 56.2646 185.765C56.2646 186.065 56.5076 186.307 56.8072 186.307Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 181.193C62.2216 181.193 62.4645 180.95 62.4645 180.65C62.4645 180.351 62.2216 180.108 61.9219 180.108C61.6223 180.108 61.3794 180.351 61.3794 180.65C61.3794 180.95 61.6223 181.193 61.9219 181.193Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 181.193C62.2216 181.193 62.4645 180.95 62.4645 180.65C62.4645 180.351 62.2216 180.108 61.9219 180.108C61.6223 180.108 61.3794 180.351 61.3794 180.65C61.3794 180.95 61.6223 181.193 61.9219 181.193Z"
        fill="#324A52"
      />
      <path
        d="M67.0435 176.078C67.3432 176.078 67.5861 175.836 67.5861 175.536C67.5861 175.236 67.3432 174.994 67.0435 174.994C66.7439 174.994 66.501 175.236 66.501 175.536C66.501 175.836 66.7439 176.078 67.0435 176.078Z"
        fill="#324A52"
      />
      <path
        d="M67.0435 176.078C67.3432 176.078 67.5861 175.836 67.5861 175.536C67.5861 175.236 67.3432 174.994 67.0435 174.994C66.7439 174.994 66.501 175.236 66.501 175.536C66.501 175.836 66.7439 176.078 67.0435 176.078Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 170.965C72.4569 170.965 72.6998 170.722 72.6998 170.422C72.6998 170.123 72.4569 169.88 72.1573 169.88C71.8577 169.88 71.6147 170.123 71.6147 170.422C71.6147 170.722 71.8577 170.965 72.1573 170.965Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 170.965C72.4569 170.965 72.6998 170.722 72.6998 170.422C72.6998 170.123 72.4569 169.88 72.1573 169.88C71.8577 169.88 71.6147 170.123 71.6147 170.422C71.6147 170.722 71.8577 170.965 72.1573 170.965Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 165.85C77.5712 165.85 77.8141 165.607 77.8141 165.308C77.8141 165.008 77.5712 164.766 77.2716 164.766C76.9719 164.766 76.729 165.008 76.729 165.308C76.729 165.607 76.9719 165.85 77.2716 165.85Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 165.85C77.5712 165.85 77.8141 165.607 77.8141 165.308C77.8141 165.008 77.5712 164.766 77.2716 164.766C76.9719 164.766 76.729 165.008 76.729 165.308C76.729 165.607 76.9719 165.85 77.2716 165.85Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 160.731C82.6855 160.731 82.9284 160.488 82.9284 160.189C82.9284 159.889 82.6855 159.646 82.3858 159.646C82.0862 159.646 81.8433 159.889 81.8433 160.189C81.8433 160.488 82.0862 160.731 82.3858 160.731Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 160.731C82.6855 160.731 82.9284 160.488 82.9284 160.189C82.9284 159.889 82.6855 159.646 82.3858 159.646C82.0862 159.646 81.8433 159.889 81.8433 160.189C81.8433 160.488 82.0862 160.731 82.3858 160.731Z"
        fill="#324A52"
      />
      <path
        d="M87.8841 155.455C87.6743 155.665 87.3271 155.665 87.1173 155.455C86.9075 155.246 86.9075 154.899 87.1173 154.689C87.3271 154.479 87.6743 154.479 87.8841 154.689C88.0939 154.906 88.0939 155.246 87.8841 155.455Z"
        fill="#324A52"
      />
      <path
        d="M87.8841 155.455C87.6743 155.665 87.3271 155.665 87.1173 155.455C86.9075 155.246 86.9075 154.899 87.1173 154.689C87.3271 154.479 87.6743 154.479 87.8841 154.689C88.0939 154.906 88.0939 155.246 87.8841 155.455Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 150.5C92.9145 150.5 93.1574 150.258 93.1574 149.958C93.1574 149.659 92.9145 149.416 92.6148 149.416C92.3152 149.416 92.0723 149.659 92.0723 149.958C92.0723 150.258 92.3152 150.5 92.6148 150.5Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 150.5C92.9145 150.5 93.1574 150.258 93.1574 149.958C93.1574 149.659 92.9145 149.416 92.6148 149.416C92.3152 149.416 92.0723 149.659 92.0723 149.958C92.0723 150.258 92.3152 150.5 92.6148 150.5Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 145.386C98.0292 145.386 98.2721 145.143 98.2721 144.844C98.2721 144.544 98.0292 144.301 97.7296 144.301C97.4299 144.301 97.187 144.544 97.187 144.844C97.187 145.143 97.4299 145.386 97.7296 145.386Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 145.386C98.0292 145.386 98.2721 145.143 98.2721 144.844C98.2721 144.544 98.0292 144.301 97.7296 144.301C97.4299 144.301 97.187 144.544 97.187 144.844C97.187 145.143 97.4299 145.386 97.7296 145.386Z"
        fill="#324A52"
      />
      <path
        d="M103.227 140.113C103.017 140.323 102.67 140.323 102.46 140.113C102.25 139.903 102.25 139.556 102.46 139.346C102.67 139.137 103.017 139.137 103.227 139.346C103.444 139.556 103.444 139.903 103.227 140.113Z"
        fill="#324A52"
      />
      <path
        d="M103.227 140.113C103.017 140.323 102.67 140.323 102.46 140.113C102.25 139.903 102.25 139.556 102.46 139.346C102.67 139.137 103.017 139.137 103.227 139.346C103.444 139.556 103.444 139.903 103.227 140.113Z"
        fill="#324A52"
      />
      <path
        d="M107.959 135.157C108.258 135.157 108.501 134.914 108.501 134.615C108.501 134.315 108.258 134.072 107.959 134.072C107.659 134.072 107.416 134.315 107.416 134.615C107.416 134.914 107.659 135.157 107.959 135.157Z"
        fill="#324A52"
      />
      <path
        d="M107.959 135.157C108.258 135.157 108.501 134.914 108.501 134.615C108.501 134.315 108.258 134.072 107.959 134.072C107.659 134.072 107.416 134.315 107.416 134.615C107.416 134.914 107.659 135.157 107.959 135.157Z"
        fill="#324A52"
      />
      <path
        d="M113.463 129.884C113.253 130.094 112.906 130.094 112.696 129.884C112.487 129.674 112.487 129.327 112.696 129.118C112.906 128.908 113.253 128.908 113.463 129.118C113.673 129.327 113.673 129.674 113.463 129.884Z"
        fill="#324A52"
      />
      <path
        d="M113.463 129.884C113.253 130.094 112.906 130.094 112.696 129.884C112.487 129.674 112.487 129.327 112.696 129.118C112.906 128.908 113.253 128.908 113.463 129.118C113.673 129.327 113.673 129.674 113.463 129.884Z"
        fill="#324A52"
      />
      <path
        d="M118.577 124.769C118.368 124.979 118.02 124.979 117.811 124.769C117.601 124.56 117.601 124.213 117.811 124.003C118.02 123.793 118.368 123.793 118.577 124.003C118.787 124.213 118.787 124.552 118.577 124.769Z"
        fill="#324A52"
      />
      <path
        d="M118.577 124.769C118.368 124.979 118.02 124.979 117.811 124.769C117.601 124.56 117.601 124.213 117.811 124.003C118.02 123.793 118.368 123.793 118.577 124.003C118.787 124.213 118.787 124.552 118.577 124.769Z"
        fill="#324A52"
      />
      <path
        d="M123.309 119.814C123.609 119.814 123.852 119.572 123.852 119.272C123.852 118.972 123.609 118.73 123.309 118.73C123.01 118.73 122.767 118.972 122.767 119.272C122.767 119.572 123.01 119.814 123.309 119.814Z"
        fill="#324A52"
      />
      <path
        d="M123.309 119.814C123.609 119.814 123.852 119.572 123.852 119.272C123.852 118.972 123.609 118.73 123.309 118.73C123.01 118.73 122.767 118.972 122.767 119.272C122.767 119.572 123.01 119.814 123.309 119.814Z"
        fill="#324A52"
      />
      <path
        d="M128.806 114.543C128.596 114.753 128.249 114.753 128.039 114.543C127.829 114.333 127.829 113.986 128.039 113.776C128.249 113.567 128.596 113.567 128.806 113.776C129.016 113.986 129.016 114.326 128.806 114.543Z"
        fill="#324A52"
      />
      <path
        d="M128.806 114.543C128.596 114.753 128.249 114.753 128.039 114.543C127.829 114.333 127.829 113.986 128.039 113.776C128.249 113.567 128.596 113.567 128.806 113.776C129.016 113.986 129.016 114.326 128.806 114.543Z"
        fill="#324A52"
      />
      <path
        d="M133.921 109.42C133.711 109.629 133.364 109.629 133.154 109.42C132.945 109.21 132.945 108.863 133.154 108.653C133.364 108.443 133.711 108.443 133.921 108.653C134.131 108.863 134.131 109.21 133.921 109.42Z"
        fill="#324A52"
      />
      <path
        d="M133.921 109.42C133.711 109.629 133.364 109.629 133.154 109.42C132.945 109.21 132.945 108.863 133.154 108.653C133.364 108.443 133.711 108.443 133.921 108.653C134.131 108.863 134.131 109.21 133.921 109.42Z"
        fill="#324A52"
      />
      <path
        d="M139.036 104.307C138.826 104.517 138.479 104.517 138.269 104.307C138.059 104.098 138.059 103.751 138.269 103.541C138.479 103.331 138.826 103.331 139.036 103.541C139.246 103.758 139.246 104.098 139.036 104.307Z"
        fill="#324A52"
      />
      <path
        d="M139.036 104.307C138.826 104.517 138.479 104.517 138.269 104.307C138.059 104.098 138.059 103.751 138.269 103.541C138.479 103.331 138.826 103.331 139.036 103.541C139.246 103.758 139.246 104.098 139.036 104.307Z"
        fill="#324A52"
      />
      <path
        d="M144.15 99.1915C143.94 99.4012 143.593 99.4012 143.383 99.1915C143.173 98.9818 143.173 98.6347 143.383 98.425C143.593 98.2153 143.94 98.2153 144.15 98.425C144.36 98.6347 144.36 98.9818 144.15 99.1915Z"
        fill="#324A52"
      />
      <path
        d="M144.15 99.1915C143.94 99.4012 143.593 99.4012 143.383 99.1915C143.173 98.9818 143.173 98.6347 143.383 98.425C143.593 98.2153 143.94 98.2153 144.15 98.425C144.36 98.6347 144.36 98.9818 144.15 99.1915Z"
        fill="#324A52"
      />
      <path
        d="M51.692 181.193C51.9916 181.193 52.2345 180.95 52.2345 180.65C52.2345 180.351 51.9916 180.108 51.692 180.108C51.3923 180.108 51.1494 180.351 51.1494 180.65C51.1494 180.95 51.3923 181.193 51.692 181.193Z"
        fill="#324A52"
      />
      <path
        d="M51.692 181.193C51.9916 181.193 52.2345 180.95 52.2345 180.65C52.2345 180.351 51.9916 180.108 51.692 180.108C51.3923 180.108 51.1494 180.351 51.1494 180.65C51.1494 180.95 51.3923 181.193 51.692 181.193Z"
        fill="#324A52"
      />
      <path
        d="M56.8057 176.078C57.1054 176.078 57.3483 175.835 57.3483 175.536C57.3483 175.236 57.1054 174.994 56.8057 174.994C56.5061 174.994 56.2632 175.236 56.2632 175.536C56.2632 175.835 56.5061 176.078 56.8057 176.078Z"
        fill="#324A52"
      />
      <path
        d="M56.8057 176.078C57.1054 176.078 57.3483 175.835 57.3483 175.536C57.3483 175.236 57.1054 174.994 56.8057 174.994C56.5061 174.994 56.2632 175.236 56.2632 175.536C56.2632 175.835 56.5061 176.078 56.8057 176.078Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 170.965C62.2211 170.965 62.464 170.722 62.464 170.422C62.464 170.123 62.2211 169.88 61.9215 169.88C61.6218 169.88 61.3789 170.123 61.3789 170.422C61.3789 170.722 61.6218 170.965 61.9215 170.965Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 170.965C62.2211 170.965 62.464 170.722 62.464 170.422C62.464 170.123 62.2211 169.88 61.9215 169.88C61.6218 169.88 61.3789 170.123 61.3789 170.422C61.3789 170.722 61.6218 170.965 61.9215 170.965Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 165.85C67.3422 165.85 67.5851 165.607 67.5851 165.308C67.5851 165.008 67.3422 164.766 67.0425 164.766C66.7429 164.766 66.5 165.008 66.5 165.308C66.5 165.607 66.7429 165.85 67.0425 165.85Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 165.85C67.3422 165.85 67.5851 165.607 67.5851 165.308C67.5851 165.008 67.3422 164.766 67.0425 164.766C66.7429 164.766 66.5 165.008 66.5 165.308C66.5 165.607 66.7429 165.85 67.0425 165.85Z"
        fill="#324A52"
      />
      <path
        d="M72.1568 160.729C72.4564 160.729 72.6994 160.487 72.6994 160.187C72.6994 159.887 72.4564 159.645 72.1568 159.645C71.8572 159.645 71.6143 159.887 71.6143 160.187C71.6143 160.487 71.8572 160.729 72.1568 160.729Z"
        fill="#324A52"
      />
      <path
        d="M72.1568 160.729C72.4564 160.729 72.6994 160.487 72.6994 160.187C72.6994 159.887 72.4564 159.645 72.1568 159.645C71.8572 159.645 71.6143 159.887 71.6143 160.187C71.6143 160.487 71.8572 160.729 72.1568 160.729Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 155.454C77.4453 155.664 77.0981 155.664 76.8883 155.454C76.6785 155.244 76.6785 154.897 76.8883 154.687C77.0981 154.478 77.4453 154.478 77.6551 154.687C77.8649 154.904 77.8649 155.244 77.6551 155.454Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 155.454C77.4453 155.664 77.0981 155.664 76.8883 155.454C76.6785 155.244 76.6785 154.897 76.8883 154.687C77.0981 154.478 77.4453 154.478 77.6551 154.687C77.8649 154.904 77.8649 155.244 77.6551 155.454Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 150.5C82.6859 150.5 82.9288 150.257 82.9288 149.958C82.9288 149.658 82.6859 149.416 82.3863 149.416C82.0867 149.416 81.8438 149.658 81.8438 149.958C81.8438 150.257 82.0867 150.5 82.3863 150.5Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 150.5C82.6859 150.5 82.9288 150.257 82.9288 149.958C82.9288 149.658 82.6859 149.416 82.3863 149.416C82.0867 149.416 81.8438 149.658 81.8438 149.958C81.8438 150.257 82.0867 150.5 82.3863 150.5Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 145.386C87.7992 145.386 88.0421 145.143 88.0421 144.843C88.0421 144.544 87.7992 144.301 87.4996 144.301C87.1999 144.301 86.957 144.544 86.957 144.843C86.957 145.143 87.1999 145.386 87.4996 145.386Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 145.386C87.7992 145.386 88.0421 145.143 88.0421 144.843C88.0421 144.544 87.7992 144.301 87.4996 144.301C87.1999 144.301 86.957 144.544 86.957 144.843C86.957 145.143 87.1999 145.386 87.4996 145.386Z"
        fill="#324A52"
      />
      <path
        d="M92.9979 140.113C92.7881 140.323 92.4409 140.323 92.2311 140.113C92.0213 139.903 92.0213 139.556 92.2311 139.346C92.4409 139.137 92.7881 139.137 92.9979 139.346C93.2077 139.556 93.2077 139.903 92.9979 140.113Z"
        fill="#324A52"
      />
      <path
        d="M92.9979 140.113C92.7881 140.323 92.4409 140.323 92.2311 140.113C92.0213 139.903 92.0213 139.556 92.2311 139.346C92.4409 139.137 92.7881 139.137 92.9979 139.346C93.2077 139.556 93.2077 139.903 92.9979 140.113Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 135.154C98.0292 135.154 98.2721 134.912 98.2721 134.612C98.2721 134.312 98.0292 134.07 97.7296 134.07C97.4299 134.07 97.187 134.312 97.187 134.612C97.187 134.912 97.4299 135.154 97.7296 135.154Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 135.154C98.0292 135.154 98.2721 134.912 98.2721 134.612C98.2721 134.312 98.0292 134.07 97.7296 134.07C97.4299 134.07 97.187 134.312 97.187 134.612C97.187 134.912 97.4299 135.154 97.7296 135.154Z"
        fill="#324A52"
      />
      <path
        d="M103.227 129.884C103.017 130.094 102.67 130.094 102.46 129.884C102.25 129.674 102.25 129.327 102.46 129.117C102.67 128.908 103.017 128.908 103.227 129.117C103.444 129.327 103.444 129.674 103.227 129.884Z"
        fill="#324A52"
      />
      <path
        d="M103.227 129.884C103.017 130.094 102.67 130.094 102.46 129.884C102.25 129.674 102.25 129.327 102.46 129.117C102.67 128.908 103.017 128.908 103.227 129.117C103.444 129.327 103.444 129.674 103.227 129.884Z"
        fill="#324A52"
      />
      <path
        d="M108.341 124.769C108.131 124.979 107.784 124.979 107.574 124.769C107.365 124.56 107.365 124.213 107.574 124.003C107.784 123.793 108.131 123.793 108.341 124.003C108.551 124.213 108.558 124.552 108.341 124.769Z"
        fill="#324A52"
      />
      <path
        d="M108.341 124.769C108.131 124.979 107.784 124.979 107.574 124.769C107.365 124.56 107.365 124.213 107.574 124.003C107.784 123.793 108.131 123.793 108.341 124.003C108.551 124.213 108.558 124.552 108.341 124.769Z"
        fill="#324A52"
      />
      <path
        d="M113.463 119.655C113.253 119.864 112.906 119.864 112.696 119.655C112.486 119.445 112.486 119.098 112.696 118.888C112.906 118.679 113.253 118.679 113.463 118.888C113.672 119.098 113.672 119.438 113.463 119.655Z"
        fill="#324A52"
      />
      <path
        d="M113.463 119.655C113.253 119.864 112.906 119.864 112.696 119.655C112.486 119.445 112.486 119.098 112.696 118.888C112.906 118.679 113.253 118.679 113.463 118.888C113.672 119.098 113.672 119.438 113.463 119.655Z"
        fill="#324A52"
      />
      <path
        d="M118.577 114.54C118.368 114.75 118.02 114.75 117.811 114.54C117.601 114.331 117.601 113.983 117.811 113.774C118.02 113.564 118.368 113.564 118.577 113.774C118.787 113.983 118.787 114.323 118.577 114.54Z"
        fill="#324A52"
      />
      <path
        d="M118.577 114.54C118.368 114.75 118.02 114.75 117.811 114.54C117.601 114.331 117.601 113.983 117.811 113.774C118.02 113.564 118.368 113.564 118.577 113.774C118.787 113.983 118.787 114.323 118.577 114.54Z"
        fill="#324A52"
      />
      <path
        d="M123.692 109.418C123.482 109.628 123.135 109.628 122.925 109.418C122.716 109.208 122.716 108.861 122.925 108.652C123.135 108.442 123.482 108.442 123.692 108.652C123.902 108.861 123.902 109.208 123.692 109.418Z"
        fill="#324A52"
      />
      <path
        d="M123.692 109.418C123.482 109.628 123.135 109.628 122.925 109.418C122.716 109.208 122.716 108.861 122.925 108.652C123.135 108.442 123.482 108.442 123.692 108.652C123.902 108.861 123.902 109.208 123.692 109.418Z"
        fill="#324A52"
      />
      <path
        d="M128.806 104.305C128.596 104.515 128.249 104.515 128.039 104.305C127.829 104.095 127.829 103.748 128.039 103.538C128.249 103.329 128.596 103.329 128.806 103.538C129.016 103.748 129.016 104.095 128.806 104.305Z"
        fill="#324A52"
      />
      <path
        d="M128.806 104.305C128.596 104.515 128.249 104.515 128.039 104.305C127.829 104.095 127.829 103.748 128.039 103.538C128.249 103.329 128.596 103.329 128.806 103.538C129.016 103.748 129.016 104.095 128.806 104.305Z"
        fill="#324A52"
      />
      <path
        d="M133.921 99.1914C133.711 99.4011 133.364 99.4011 133.154 99.1914C132.944 98.9817 132.944 98.6346 133.154 98.4249C133.364 98.2152 133.711 98.2152 133.921 98.4249C134.131 98.6346 134.131 98.9817 133.921 99.1914Z"
        fill="#324A52"
      />
      <path
        d="M133.921 99.1914C133.711 99.4011 133.364 99.4011 133.154 99.1914C132.944 98.9817 132.944 98.6346 133.154 98.4249C133.364 98.2152 133.711 98.2152 133.921 98.4249C134.131 98.6346 134.131 98.9817 133.921 99.1914Z"
        fill="#324A52"
      />
      <path
        d="M139.035 94.0769C138.825 94.2866 138.478 94.2866 138.268 94.0769C138.058 93.8672 138.058 93.5201 138.268 93.3104C138.478 93.1007 138.825 93.1007 139.035 93.3104C139.245 93.5201 139.245 93.8672 139.035 94.0769Z"
        fill="#324A52"
      />
      <path
        d="M139.035 94.0769C138.825 94.2866 138.478 94.2866 138.268 94.0769C138.058 93.8672 138.058 93.5201 138.268 93.3104C138.478 93.1007 138.825 93.1007 139.035 93.3104C139.245 93.5201 139.245 93.8672 139.035 94.0769Z"
        fill="#324A52"
      />
      <path
        d="M46.5782 176.078C46.8778 176.078 47.1207 175.835 47.1207 175.536C47.1207 175.236 46.8778 174.993 46.5782 174.993C46.2786 174.993 46.0356 175.236 46.0356 175.536C46.0356 175.835 46.2786 176.078 46.5782 176.078Z"
        fill="#324A52"
      />
      <path
        d="M46.5782 176.078C46.8778 176.078 47.1207 175.835 47.1207 175.536C47.1207 175.236 46.8778 174.993 46.5782 174.993C46.2786 174.993 46.0356 175.236 46.0356 175.536C46.0356 175.835 46.2786 176.078 46.5782 176.078Z"
        fill="#324A52"
      />
      <path
        d="M51.692 170.964C51.9916 170.964 52.2345 170.721 52.2345 170.422C52.2345 170.122 51.9916 169.88 51.692 169.88C51.3923 169.88 51.1494 170.122 51.1494 170.422C51.1494 170.721 51.3923 170.964 51.692 170.964Z"
        fill="#324A52"
      />
      <path
        d="M51.692 170.964C51.9916 170.964 52.2345 170.721 52.2345 170.422C52.2345 170.122 51.9916 169.88 51.692 169.88C51.3923 169.88 51.1494 170.122 51.1494 170.422C51.1494 170.721 51.3923 170.964 51.692 170.964Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 165.85C57.1068 165.85 57.3497 165.607 57.3497 165.307C57.3497 165.008 57.1068 164.765 56.8072 164.765C56.5076 164.765 56.2646 165.008 56.2646 165.307C56.2646 165.607 56.5076 165.85 56.8072 165.85Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 165.85C57.1068 165.85 57.3497 165.607 57.3497 165.307C57.3497 165.008 57.1068 164.765 56.8072 164.765C56.5076 164.765 56.2646 165.008 56.2646 165.307C56.2646 165.607 56.5076 165.85 56.8072 165.85Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 160.73C62.2216 160.73 62.4645 160.488 62.4645 160.188C62.4645 159.889 62.2216 159.646 61.9219 159.646C61.6223 159.646 61.3794 159.889 61.3794 160.188C61.3794 160.488 61.6223 160.73 61.9219 160.73Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 160.73C62.2216 160.73 62.4645 160.488 62.4645 160.188C62.4645 159.889 62.2216 159.646 61.9219 159.646C61.6223 159.646 61.3794 159.889 61.3794 160.188C61.3794 160.488 61.6223 160.73 61.9219 160.73Z"
        fill="#324A52"
      />
      <path
        d="M67.4266 155.455C67.2168 155.665 66.8696 155.665 66.6598 155.455C66.45 155.245 66.45 154.898 66.6598 154.689C66.8696 154.479 67.2168 154.479 67.4266 154.689C67.6364 154.905 67.6364 155.245 67.4266 155.455Z"
        fill="#324A52"
      />
      <path
        d="M67.4266 155.455C67.2168 155.665 66.8696 155.665 66.6598 155.455C66.45 155.245 66.45 154.898 66.6598 154.689C66.8696 154.479 67.2168 154.479 67.4266 154.689C67.6364 154.905 67.6364 155.245 67.4266 155.455Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 150.5C72.4569 150.5 72.6998 150.257 72.6998 149.958C72.6998 149.658 72.4569 149.415 72.1573 149.415C71.8577 149.415 71.6147 149.658 71.6147 149.958C71.6147 150.257 71.8577 150.5 72.1573 150.5Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 150.5C72.4569 150.5 72.6998 150.257 72.6998 149.958C72.6998 149.658 72.4569 149.415 72.1573 149.415C71.8577 149.415 71.6147 149.658 71.6147 149.958C71.6147 150.257 71.8577 150.5 72.1573 150.5Z"
        fill="#324A52"
      />
      <path
        d="M77.272 145.385C77.5717 145.385 77.8146 145.143 77.8146 144.843C77.8146 144.544 77.5717 144.301 77.272 144.301C76.9724 144.301 76.7295 144.544 76.7295 144.843C76.7295 145.143 76.9724 145.385 77.272 145.385Z"
        fill="#324A52"
      />
      <path
        d="M77.272 145.385C77.5717 145.385 77.8146 145.143 77.8146 144.843C77.8146 144.544 77.5717 144.301 77.272 144.301C76.9724 144.301 76.7295 144.544 76.7295 144.843C76.7295 145.143 76.9724 145.385 77.272 145.385Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 140.112C82.5596 140.322 82.2123 140.322 82.0026 140.112C81.7928 139.903 81.7928 139.556 82.0026 139.346C82.2123 139.136 82.5596 139.136 82.7694 139.346C82.9791 139.556 82.9791 139.903 82.7694 140.112Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 140.112C82.5596 140.322 82.2123 140.322 82.0026 140.112C81.7928 139.903 81.7928 139.556 82.0026 139.346C82.2123 139.136 82.5596 139.136 82.7694 139.346C82.9791 139.556 82.9791 139.903 82.7694 140.112Z"
        fill="#324A52"
      />
      <path
        d="M87.501 135.156C87.8007 135.156 88.0436 134.914 88.0436 134.614C88.0436 134.315 87.8007 134.072 87.501 134.072C87.2014 134.072 86.9585 134.315 86.9585 134.614C86.9585 134.914 87.2014 135.156 87.501 135.156Z"
        fill="#324A52"
      />
      <path
        d="M87.501 135.156C87.8007 135.156 88.0436 134.914 88.0436 134.614C88.0436 134.315 87.8007 134.072 87.501 134.072C87.2014 134.072 86.9585 134.315 86.9585 134.614C86.9585 134.914 87.2014 135.156 87.501 135.156Z"
        fill="#324A52"
      />
      <path
        d="M92.9984 129.884C92.7886 130.093 92.4413 130.093 92.2316 129.884C92.0218 129.674 92.0218 129.327 92.2316 129.117C92.4413 128.907 92.7886 128.907 92.9984 129.117C93.2081 129.327 93.2081 129.674 92.9984 129.884Z"
        fill="#324A52"
      />
      <path
        d="M92.9984 129.884C92.7886 130.093 92.4413 130.093 92.2316 129.884C92.0218 129.674 92.0218 129.327 92.2316 129.117C92.4413 128.907 92.7886 128.907 92.9984 129.117C93.2081 129.327 93.2081 129.674 92.9984 129.884Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 124.769C97.9033 124.979 97.5561 124.979 97.3463 124.769C97.1365 124.559 97.1365 124.212 97.3463 124.002C97.5561 123.793 97.9033 123.793 98.1131 124.002C98.3229 124.212 98.3229 124.552 98.1131 124.769Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 124.769C97.9033 124.979 97.5561 124.979 97.3463 124.769C97.1365 124.559 97.1365 124.212 97.3463 124.002C97.5561 123.793 97.9033 123.793 98.1131 124.002C98.3229 124.212 98.3229 124.552 98.1131 124.769Z"
        fill="#324A52"
      />
      <path
        d="M102.844 119.814C103.143 119.814 103.386 119.571 103.386 119.272C103.386 118.972 103.143 118.729 102.844 118.729C102.544 118.729 102.301 118.972 102.301 119.272C102.301 119.571 102.544 119.814 102.844 119.814Z"
        fill="#324A52"
      />
      <path
        d="M102.844 119.814C103.143 119.814 103.386 119.571 103.386 119.272C103.386 118.972 103.143 118.729 102.844 118.729C102.544 118.729 102.301 118.972 102.301 119.272C102.301 119.571 102.544 119.814 102.844 119.814Z"
        fill="#324A52"
      />
      <path
        d="M108.342 114.542C108.132 114.752 107.785 114.752 107.575 114.542C107.366 114.333 107.366 113.986 107.575 113.776C107.785 113.566 108.132 113.566 108.342 113.776C108.559 113.986 108.559 114.325 108.342 114.542Z"
        fill="#324A52"
      />
      <path
        d="M108.342 114.542C108.132 114.752 107.785 114.752 107.575 114.542C107.366 114.333 107.366 113.986 107.575 113.776C107.785 113.566 108.132 113.566 108.342 113.776C108.559 113.986 108.559 114.325 108.342 114.542Z"
        fill="#324A52"
      />
      <path
        d="M113.464 109.419C113.254 109.629 112.907 109.629 112.697 109.419C112.487 109.209 112.487 108.862 112.697 108.653C112.907 108.443 113.254 108.443 113.464 108.653C113.673 108.862 113.673 109.209 113.464 109.419Z"
        fill="#324A52"
      />
      <path
        d="M113.464 109.419C113.254 109.629 112.907 109.629 112.697 109.419C112.487 109.209 112.487 108.862 112.697 108.653C112.907 108.443 113.254 108.443 113.464 108.653C113.673 108.862 113.673 109.209 113.464 109.419Z"
        fill="#324A52"
      />
      <path
        d="M118.194 104.465C118.494 104.465 118.737 104.223 118.737 103.923C118.737 103.624 118.494 103.381 118.194 103.381C117.895 103.381 117.652 103.624 117.652 103.923C117.652 104.223 117.895 104.465 118.194 104.465Z"
        fill="#324A52"
      />
      <path
        d="M118.194 104.465C118.494 104.465 118.737 104.223 118.737 103.923C118.737 103.624 118.494 103.381 118.194 103.381C117.895 103.381 117.652 103.624 117.652 103.923C117.652 104.223 117.895 104.465 118.194 104.465Z"
        fill="#324A52"
      />
      <path
        d="M123.693 99.191C123.483 99.4007 123.136 99.4007 122.926 99.191C122.716 98.9813 122.716 98.6342 122.926 98.4246C123.136 98.2149 123.483 98.2149 123.693 98.4246C123.902 98.6342 123.902 98.9813 123.693 99.191Z"
        fill="#324A52"
      />
      <path
        d="M123.693 99.191C123.483 99.4007 123.136 99.4007 122.926 99.191C122.716 98.9813 122.716 98.6342 122.926 98.4246C123.136 98.2149 123.483 98.2149 123.693 98.4246C123.902 98.6342 123.902 98.9813 123.693 99.191Z"
        fill="#324A52"
      />
      <path
        d="M128.807 94.078C128.597 94.2877 128.25 94.2877 128.04 94.078C127.83 93.8683 127.83 93.5212 128.04 93.3115C128.25 93.1018 128.597 93.1018 128.807 93.3115C129.017 93.5212 129.017 93.8683 128.807 94.078Z"
        fill="#324A52"
      />
      <path
        d="M128.807 94.078C128.597 94.2877 128.25 94.2877 128.04 94.078C127.83 93.8683 127.83 93.5212 128.04 93.3115C128.25 93.1018 128.597 93.1018 128.807 93.3115C129.017 93.5212 129.017 93.8683 128.807 94.078Z"
        fill="#324A52"
      />
      <path
        d="M133.538 89.1205C133.837 89.1205 134.08 88.8777 134.08 88.5781C134.08 88.2786 133.837 88.0358 133.538 88.0358C133.238 88.0358 132.995 88.2786 132.995 88.5781C132.995 88.8777 133.238 89.1205 133.538 89.1205Z"
        fill="#324A52"
      />
      <path
        d="M133.538 89.1205C133.837 89.1205 134.08 88.8777 134.08 88.5781C134.08 88.2786 133.837 88.0358 133.538 88.0358C133.238 88.0358 132.995 88.2786 132.995 88.5781C132.995 88.8777 133.238 89.1205 133.538 89.1205Z"
        fill="#324A52"
      />
      <path
        d="M41.8465 170.805C41.6367 171.015 41.2895 171.015 41.0797 170.805C40.8699 170.595 40.8699 170.248 41.0797 170.038C41.2895 169.829 41.6367 169.829 41.8465 170.038C42.0563 170.248 42.0563 170.588 41.8465 170.805Z"
        fill="#324A52"
      />
      <path
        d="M41.8465 170.805C41.6367 171.015 41.2895 171.015 41.0797 170.805C40.8699 170.595 40.8699 170.248 41.0797 170.038C41.2895 169.829 41.6367 169.829 41.8465 170.038C42.0563 170.248 42.0563 170.588 41.8465 170.805Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 165.85C46.8773 165.85 47.1203 165.607 47.1203 165.308C47.1203 165.008 46.8773 164.765 46.5777 164.765C46.2781 164.765 46.0352 165.008 46.0352 165.308C46.0352 165.607 46.2781 165.85 46.5777 165.85Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 165.85C46.8773 165.85 47.1203 165.607 47.1203 165.308C47.1203 165.008 46.8773 164.765 46.5777 164.765C46.2781 164.765 46.0352 165.008 46.0352 165.308C46.0352 165.607 46.2781 165.85 46.5777 165.85Z"
        fill="#324A52"
      />
      <path
        d="M51.692 160.729C51.9916 160.729 52.2345 160.486 52.2345 160.187C52.2345 159.887 51.9916 159.644 51.692 159.644C51.3923 159.644 51.1494 159.887 51.1494 160.187C51.1494 160.486 51.3923 160.729 51.692 160.729Z"
        fill="#324A52"
      />
      <path
        d="M51.692 160.729C51.9916 160.729 52.2345 160.486 52.2345 160.187C52.2345 159.887 51.9916 159.644 51.692 159.644C51.3923 159.644 51.1494 159.887 51.1494 160.187C51.1494 160.486 51.3923 160.729 51.692 160.729Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 155.454C56.9805 155.663 56.6332 155.663 56.4235 155.454C56.2137 155.244 56.2137 154.897 56.4235 154.687C56.6332 154.477 56.9805 154.477 57.1903 154.687C57.4 154.897 57.4073 155.244 57.1903 155.454Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 155.454C56.9805 155.663 56.6332 155.663 56.4235 155.454C56.2137 155.244 56.2137 154.897 56.4235 154.687C56.6332 154.477 56.9805 154.477 57.1903 154.687C57.4 154.897 57.4073 155.244 57.1903 155.454Z"
        fill="#324A52"
      />
      <path
        d="M61.921 150.5C62.2206 150.5 62.4635 150.257 62.4635 149.958C62.4635 149.658 62.2206 149.415 61.921 149.415C61.6213 149.415 61.3784 149.658 61.3784 149.958C61.3784 150.257 61.6213 150.5 61.921 150.5Z"
        fill="#324A52"
      />
      <path
        d="M61.921 150.5C62.2206 150.5 62.4635 150.257 62.4635 149.958C62.4635 149.658 62.2206 149.415 61.921 149.415C61.6213 149.415 61.3784 149.658 61.3784 149.958C61.3784 150.257 61.6213 150.5 61.921 150.5Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 145.385C67.3422 145.385 67.5851 145.143 67.5851 144.843C67.5851 144.544 67.3422 144.301 67.0425 144.301C66.7429 144.301 66.5 144.544 66.5 144.843C66.5 145.143 66.7429 145.385 67.0425 145.385Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 145.385C67.3422 145.385 67.5851 145.143 67.5851 144.843C67.5851 144.544 67.3422 144.301 67.0425 144.301C66.7429 144.301 66.5 144.544 66.5 144.843C66.5 145.143 66.7429 145.385 67.0425 145.385Z"
        fill="#324A52"
      />
      <path
        d="M72.5403 140.113C72.3306 140.322 71.9833 140.322 71.7735 140.113C71.5638 139.903 71.5638 139.556 71.7735 139.346C71.9833 139.136 72.3306 139.136 72.5403 139.346C72.7501 139.556 72.7501 139.903 72.5403 140.113Z"
        fill="#324A52"
      />
      <path
        d="M72.5403 140.113C72.3306 140.322 71.9833 140.322 71.7735 140.113C71.5638 139.903 71.5638 139.556 71.7735 139.346C71.9833 139.136 72.3306 139.136 72.5403 139.346C72.7501 139.556 72.7501 139.903 72.5403 140.113Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 135.154C77.5712 135.154 77.8141 134.911 77.8141 134.612C77.8141 134.312 77.5712 134.069 77.2716 134.069C76.9719 134.069 76.729 134.312 76.729 134.612C76.729 134.911 76.9719 135.154 77.2716 135.154Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 135.154C77.5712 135.154 77.8141 134.911 77.8141 134.612C77.8141 134.312 77.5712 134.069 77.2716 134.069C76.9719 134.069 76.729 134.312 76.729 134.612C76.729 134.911 76.9719 135.154 77.2716 135.154Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 129.884C82.5596 130.093 82.2123 130.093 82.0026 129.884C81.7928 129.674 81.7928 129.327 82.0026 129.117C82.2123 128.907 82.5596 128.907 82.7694 129.117C82.9791 129.327 82.9791 129.674 82.7694 129.884Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 129.884C82.5596 130.093 82.2123 130.093 82.0026 129.884C81.7928 129.674 81.7928 129.327 82.0026 129.117C82.2123 128.907 82.5596 128.907 82.7694 129.117C82.9791 129.327 82.9791 129.674 82.7694 129.884Z"
        fill="#324A52"
      />
      <path
        d="M87.8831 124.769C87.6733 124.979 87.3261 124.979 87.1163 124.769C86.9065 124.559 86.9065 124.212 87.1163 124.003C87.3261 123.793 87.6733 123.793 87.8831 124.003C88.0929 124.212 88.0929 124.552 87.8831 124.769Z"
        fill="#324A52"
      />
      <path
        d="M87.8831 124.769C87.6733 124.979 87.3261 124.979 87.1163 124.769C86.9065 124.559 86.9065 124.212 87.1163 124.003C87.3261 123.793 87.6733 123.793 87.8831 124.003C88.0929 124.212 88.0929 124.552 87.8831 124.769Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 119.814C92.9145 119.814 93.1574 119.571 93.1574 119.272C93.1574 118.972 92.9145 118.729 92.6148 118.729C92.3152 118.729 92.0723 118.972 92.0723 119.272C92.0723 119.571 92.3152 119.814 92.6148 119.814Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 119.814C92.9145 119.814 93.1574 119.571 93.1574 119.272C93.1574 118.972 92.9145 118.729 92.6148 118.729C92.3152 118.729 92.0723 118.972 92.0723 119.272C92.0723 119.571 92.3152 119.814 92.6148 119.814Z"
        fill="#324A52"
      />
      <path
        d="M98.1126 114.54C97.9028 114.75 97.5556 114.75 97.3458 114.54C97.136 114.33 97.136 113.983 97.3458 113.774C97.5556 113.564 97.9028 113.564 98.1126 113.774C98.3224 113.983 98.3224 114.323 98.1126 114.54Z"
        fill="#324A52"
      />
      <path
        d="M98.1126 114.54C97.9028 114.75 97.5556 114.75 97.3458 114.54C97.136 114.33 97.136 113.983 97.3458 113.774C97.5556 113.564 97.9028 113.564 98.1126 113.774C98.3224 113.983 98.3224 114.323 98.1126 114.54Z"
        fill="#324A52"
      />
      <path
        d="M103.227 109.418C103.017 109.627 102.67 109.627 102.46 109.418C102.25 109.208 102.25 108.861 102.46 108.651C102.67 108.442 103.017 108.442 103.227 108.651C103.444 108.868 103.444 109.208 103.227 109.418Z"
        fill="#324A52"
      />
      <path
        d="M103.227 109.418C103.017 109.627 102.67 109.627 102.46 109.418C102.25 109.208 102.25 108.861 102.46 108.651C102.67 108.442 103.017 108.442 103.227 108.651C103.444 108.868 103.444 109.208 103.227 109.418Z"
        fill="#324A52"
      />
      <path
        d="M107.959 104.466C108.258 104.466 108.501 104.223 108.501 103.923C108.501 103.624 108.258 103.381 107.959 103.381C107.659 103.381 107.416 103.624 107.416 103.923C107.416 104.223 107.659 104.466 107.959 104.466Z"
        fill="#324A52"
      />
      <path
        d="M107.959 104.466C108.258 104.466 108.501 104.223 108.501 103.923C108.501 103.624 108.258 103.381 107.959 103.381C107.659 103.381 107.416 103.624 107.416 103.923C107.416 104.223 107.659 104.466 107.959 104.466Z"
        fill="#324A52"
      />
      <path
        d="M113.463 99.1911C113.253 99.4008 112.906 99.4008 112.696 99.1911C112.487 98.9814 112.487 98.6344 112.696 98.4247C112.906 98.215 113.253 98.215 113.463 98.4247C113.673 98.6344 113.673 98.9814 113.463 99.1911Z"
        fill="#324A52"
      />
      <path
        d="M113.463 99.1911C113.253 99.4008 112.906 99.4008 112.696 99.1911C112.487 98.9814 112.487 98.6344 112.696 98.4247C112.906 98.215 113.253 98.215 113.463 98.4247C113.673 98.6344 113.673 98.9814 113.463 99.1911Z"
        fill="#324A52"
      />
      <path
        d="M118.194 94.2351C118.494 94.2351 118.736 93.9923 118.736 93.6927C118.736 93.3932 118.494 93.1504 118.194 93.1504C117.894 93.1504 117.651 93.3932 117.651 93.6927C117.651 93.9923 117.894 94.2351 118.194 94.2351Z"
        fill="#324A52"
      />
      <path
        d="M118.194 94.2351C118.494 94.2351 118.736 93.9923 118.736 93.6927C118.736 93.3932 118.494 93.1504 118.194 93.1504C117.894 93.1504 117.651 93.3932 117.651 93.6927C117.651 93.9923 117.894 94.2351 118.194 94.2351Z"
        fill="#324A52"
      />
      <path
        d="M123.309 89.1206C123.608 89.1206 123.851 88.8778 123.851 88.5783C123.851 88.2788 123.608 88.0359 123.309 88.0359C123.009 88.0359 122.766 88.2788 122.766 88.5783C122.766 88.8778 123.009 89.1206 123.309 89.1206Z"
        fill="#324A52"
      />
      <path
        d="M123.309 89.1206C123.608 89.1206 123.851 88.8778 123.851 88.5783C123.851 88.2788 123.608 88.0359 123.309 88.0359C123.009 88.0359 122.766 88.2788 122.766 88.5783C122.766 88.8778 123.009 89.1206 123.309 89.1206Z"
        fill="#324A52"
      />
      <path
        d="M128.806 83.8476C128.596 84.0573 128.249 84.0573 128.039 83.8476C127.829 83.6379 127.829 83.2908 128.039 83.0811C128.249 82.8714 128.596 82.8714 128.806 83.0811C129.016 83.2908 129.016 83.6379 128.806 83.8476Z"
        fill="#324A52"
      />
      <path
        d="M128.806 83.8476C128.596 84.0573 128.249 84.0573 128.039 83.8476C127.829 83.6379 127.829 83.2908 128.039 83.0811C128.249 82.8714 128.596 82.8714 128.806 83.0811C129.016 83.2908 129.016 83.6379 128.806 83.8476Z"
        fill="#324A52"
      />
      <path
        d="M36.3497 165.85C36.6493 165.85 36.8922 165.607 36.8922 165.307C36.8922 165.008 36.6493 164.765 36.3497 164.765C36.05 164.765 35.8071 165.008 35.8071 165.307C35.8071 165.607 36.05 165.85 36.3497 165.85Z"
        fill="#324A52"
      />
      <path
        d="M36.3497 165.85C36.6493 165.85 36.8922 165.607 36.8922 165.307C36.8922 165.008 36.6493 164.765 36.3497 164.765C36.05 164.765 35.8071 165.008 35.8071 165.307C35.8071 165.607 36.05 165.85 36.3497 165.85Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 160.569C41.6377 160.779 41.2905 160.779 41.0807 160.569C40.8709 160.36 40.8709 160.012 41.0807 159.803C41.2905 159.593 41.6377 159.593 41.8475 159.803C42.0573 160.02 42.0573 160.36 41.8475 160.569Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 160.569C41.6377 160.779 41.2905 160.779 41.0807 160.569C40.8709 160.36 40.8709 160.012 41.0807 159.803C41.2905 159.593 41.6377 159.593 41.8475 159.803C42.0573 160.02 42.0573 160.36 41.8475 160.569Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 155.455C46.752 155.664 46.4047 155.664 46.1949 155.455C45.9852 155.245 45.9852 154.898 46.1949 154.688C46.4047 154.479 46.752 154.479 46.9617 154.688C47.1715 154.905 47.1715 155.245 46.9617 155.455Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 155.455C46.752 155.664 46.4047 155.664 46.1949 155.455C45.9852 155.245 45.9852 154.898 46.1949 154.688C46.4047 154.479 46.752 154.479 46.9617 154.688C47.1715 154.905 47.1715 155.245 46.9617 155.455Z"
        fill="#324A52"
      />
      <path
        d="M51.6929 150.5C51.9926 150.5 52.2355 150.257 52.2355 149.957C52.2355 149.658 51.9926 149.415 51.6929 149.415C51.3933 149.415 51.1504 149.658 51.1504 149.957C51.1504 150.257 51.3933 150.5 51.6929 150.5Z"
        fill="#324A52"
      />
      <path
        d="M51.6929 150.5C51.9926 150.5 52.2355 150.257 52.2355 149.957C52.2355 149.658 51.9926 149.415 51.6929 149.415C51.3933 149.415 51.1504 149.658 51.1504 149.957C51.1504 150.257 51.3933 150.5 51.6929 150.5Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 145.385C57.1068 145.385 57.3497 145.142 57.3497 144.843C57.3497 144.543 57.1068 144.3 56.8072 144.3C56.5076 144.3 56.2646 144.543 56.2646 144.843C56.2646 145.142 56.5076 145.385 56.8072 145.385Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 145.385C57.1068 145.385 57.3497 145.142 57.3497 144.843C57.3497 144.543 57.1068 144.3 56.8072 144.3C56.5076 144.3 56.2646 144.543 56.2646 144.843C56.2646 145.142 56.5076 145.385 56.8072 145.385Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 140.112C62.0957 140.322 61.7485 140.322 61.5387 140.112C61.3289 139.902 61.3289 139.555 61.5387 139.346C61.7485 139.136 62.0957 139.136 62.3055 139.346C62.5225 139.555 62.5225 139.902 62.3055 140.112Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 140.112C62.0957 140.322 61.7485 140.322 61.5387 140.112C61.3289 139.902 61.3289 139.555 61.5387 139.346C61.7485 139.136 62.0957 139.136 62.3055 139.346C62.5225 139.555 62.5225 139.902 62.3055 140.112Z"
        fill="#324A52"
      />
      <path
        d="M67.044 135.156C67.3437 135.156 67.5866 134.913 67.5866 134.614C67.5866 134.314 67.3437 134.071 67.044 134.071C66.7444 134.071 66.5015 134.314 66.5015 134.614C66.5015 134.913 66.7444 135.156 67.044 135.156Z"
        fill="#324A52"
      />
      <path
        d="M67.044 135.156C67.3437 135.156 67.5866 134.913 67.5866 134.614C67.5866 134.314 67.3437 134.071 67.044 134.071C66.7444 134.071 66.5015 134.314 66.5015 134.614C66.5015 134.913 66.7444 135.156 67.044 135.156Z"
        fill="#324A52"
      />
      <path
        d="M72.5408 129.883C72.3311 130.093 71.9838 130.093 71.774 129.883C71.5643 129.674 71.5643 129.326 71.774 129.117C71.9838 128.907 72.3311 128.907 72.5408 129.117C72.7506 129.326 72.7506 129.674 72.5408 129.883Z"
        fill="#324A52"
      />
      <path
        d="M72.5408 129.883C72.3311 130.093 71.9838 130.093 71.774 129.883C71.5643 129.674 71.5643 129.326 71.774 129.117C71.9838 128.907 72.3311 128.907 72.5408 129.117C72.7506 129.326 72.7506 129.674 72.5408 129.883Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 124.769C77.4453 124.978 77.0981 124.978 76.8883 124.769C76.6785 124.559 76.6785 124.212 76.8883 124.002C77.0981 123.792 77.4453 123.792 77.6551 124.002C77.8649 124.212 77.8649 124.552 77.6551 124.769Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 124.769C77.4453 124.978 77.0981 124.978 76.8883 124.769C76.6785 124.559 76.6785 124.212 76.8883 124.002C77.0981 123.792 77.4453 123.792 77.6551 124.002C77.8649 124.212 77.8649 124.552 77.6551 124.769Z"
        fill="#324A52"
      />
      <path
        d="M82.3873 119.814C82.6869 119.814 82.9298 119.571 82.9298 119.271C82.9298 118.972 82.6869 118.729 82.3873 118.729C82.0876 118.729 81.8447 118.972 81.8447 119.271C81.8447 119.571 82.0876 119.814 82.3873 119.814Z"
        fill="#324A52"
      />
      <path
        d="M82.3873 119.814C82.6869 119.814 82.9298 119.571 82.9298 119.271C82.9298 118.972 82.6869 118.729 82.3873 118.729C82.0876 118.729 81.8447 118.972 81.8447 119.271C81.8447 119.571 82.0876 119.814 82.3873 119.814Z"
        fill="#324A52"
      />
      <path
        d="M87.8841 114.542C87.6743 114.752 87.3271 114.752 87.1173 114.542C86.9075 114.332 86.9075 113.985 87.1173 113.776C87.3271 113.566 87.6743 113.566 87.8841 113.776C88.0939 113.985 88.0939 114.325 87.8841 114.542Z"
        fill="#324A52"
      />
      <path
        d="M87.8841 114.542C87.6743 114.752 87.3271 114.752 87.1173 114.542C86.9075 114.332 86.9075 113.985 87.1173 113.776C87.3271 113.566 87.6743 113.566 87.8841 113.776C88.0939 113.985 88.0939 114.325 87.8841 114.542Z"
        fill="#324A52"
      />
      <path
        d="M92.9984 109.419C92.7886 109.629 92.4413 109.629 92.2316 109.419C92.0218 109.209 92.0218 108.862 92.2316 108.652C92.4413 108.443 92.7886 108.443 92.9984 108.652C93.2081 108.862 93.2081 109.209 92.9984 109.419Z"
        fill="#324A52"
      />
      <path
        d="M92.9984 109.419C92.7886 109.629 92.4413 109.629 92.2316 109.419C92.0218 109.209 92.0218 108.862 92.2316 108.652C92.4413 108.443 92.7886 108.443 92.9984 108.652C93.2081 108.862 93.2081 109.209 92.9984 109.419Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 104.465C98.0292 104.465 98.2721 104.222 98.2721 103.923C98.2721 103.623 98.0292 103.381 97.7296 103.381C97.4299 103.381 97.187 103.623 97.187 103.923C97.187 104.222 97.4299 104.465 97.7296 104.465Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 104.465C98.0292 104.465 98.2721 104.222 98.2721 103.923C98.2721 103.623 98.0292 103.381 97.7296 103.381C97.4299 103.381 97.187 103.623 97.187 103.923C97.187 104.222 97.4299 104.465 97.7296 104.465Z"
        fill="#324A52"
      />
      <path
        d="M103.228 99.1908C103.018 99.4005 102.671 99.4005 102.461 99.1908C102.251 98.9811 102.251 98.634 102.461 98.4243C102.671 98.2146 103.018 98.2146 103.228 98.4243C103.445 98.634 103.445 98.9811 103.228 99.1908Z"
        fill="#324A52"
      />
      <path
        d="M103.228 99.1908C103.018 99.4005 102.671 99.4005 102.461 99.1908C102.251 98.9811 102.251 98.634 102.461 98.4243C102.671 98.2146 103.018 98.2146 103.228 98.4243C103.445 98.634 103.445 98.9811 103.228 99.1908Z"
        fill="#324A52"
      />
      <path
        d="M107.959 94.2347C108.259 94.2347 108.502 93.9919 108.502 93.6924C108.502 93.3929 108.259 93.1501 107.959 93.1501C107.659 93.1501 107.417 93.3929 107.417 93.6924C107.417 93.9919 107.659 94.2347 107.959 94.2347Z"
        fill="#324A52"
      />
      <path
        d="M107.959 94.2347C108.259 94.2347 108.502 93.9919 108.502 93.6924C108.502 93.3929 108.259 93.1501 107.959 93.1501C107.659 93.1501 107.417 93.3929 107.417 93.6924C107.417 93.9919 107.659 94.2347 107.959 94.2347Z"
        fill="#324A52"
      />
      <path
        d="M113.464 88.9617C113.254 89.1714 112.907 89.1714 112.697 88.9617C112.487 88.752 112.487 88.405 112.697 88.1953C112.907 87.9856 113.254 87.9856 113.464 88.1953C113.673 88.405 113.673 88.752 113.464 88.9617Z"
        fill="#324A52"
      />
      <path
        d="M113.464 88.9617C113.254 89.1714 112.907 89.1714 112.697 88.9617C112.487 88.752 112.487 88.405 112.697 88.1953C112.907 87.9856 113.254 87.9856 113.464 88.1953C113.673 88.405 113.673 88.752 113.464 88.9617Z"
        fill="#324A52"
      />
      <path
        d="M118.578 83.8497C118.368 84.0594 118.021 84.0594 117.811 83.8497C117.601 83.64 117.601 83.2929 117.811 83.0832C118.021 82.8735 118.368 82.8735 118.578 83.0832C118.788 83.2929 118.788 83.64 118.578 83.8497Z"
        fill="#324A52"
      />
      <path
        d="M118.578 83.8497C118.368 84.0594 118.021 84.0594 117.811 83.8497C117.601 83.64 117.601 83.2929 117.811 83.0832C118.021 82.8735 118.368 82.8735 118.578 83.0832C118.788 83.2929 118.788 83.64 118.578 83.8497Z"
        fill="#324A52"
      />
      <path
        d="M123.309 78.8912C123.609 78.8912 123.852 78.6484 123.852 78.3489C123.852 78.0494 123.609 77.8065 123.309 77.8065C123.01 77.8065 122.767 78.0494 122.767 78.3489C122.767 78.6484 123.01 78.8912 123.309 78.8912Z"
        fill="#324A52"
      />
      <path
        d="M123.309 78.8912C123.609 78.8912 123.852 78.6484 123.852 78.3489C123.852 78.0494 123.609 77.8065 123.309 77.8065C123.01 77.8065 122.767 78.0494 122.767 78.3489C122.767 78.6484 123.01 78.8912 123.309 78.8912Z"
        fill="#324A52"
      />
      <path
        d="M31.2354 160.73C31.5351 160.73 31.778 160.487 31.778 160.188C31.778 159.888 31.5351 159.645 31.2354 159.645C30.9358 159.645 30.6929 159.888 30.6929 160.188C30.6929 160.487 30.9358 160.73 31.2354 160.73Z"
        fill="#324A52"
      />
      <path
        d="M31.2354 160.73C31.5351 160.73 31.778 160.487 31.778 160.188C31.778 159.888 31.5351 159.645 31.2354 159.645C30.9358 159.645 30.6929 159.888 30.6929 160.188C30.6929 160.487 30.9358 160.73 31.2354 160.73Z"
        fill="#324A52"
      />
      <path
        d="M36.7337 155.453C36.5239 155.663 36.1767 155.663 35.9669 155.453C35.7571 155.243 35.7571 154.896 35.9669 154.687C36.1767 154.477 36.5239 154.477 36.7337 154.687C36.9435 154.896 36.9435 155.243 36.7337 155.453Z"
        fill="#324A52"
      />
      <path
        d="M36.7337 155.453C36.5239 155.663 36.1767 155.663 35.9669 155.453C35.7571 155.243 35.7571 154.896 35.9669 154.687C36.1767 154.477 36.5239 154.477 36.7337 154.687C36.9435 154.896 36.9435 155.243 36.7337 155.453Z"
        fill="#324A52"
      />
      <path
        d="M41.848 150.341C41.6382 150.551 41.291 150.551 41.0812 150.341C40.8714 150.131 40.8714 149.784 41.0812 149.575C41.291 149.365 41.6382 149.365 41.848 149.575C42.0578 149.792 42.0578 150.131 41.848 150.341Z"
        fill="#324A52"
      />
      <path
        d="M41.848 150.341C41.6382 150.551 41.291 150.551 41.0812 150.341C40.8714 150.131 40.8714 149.784 41.0812 149.575C41.291 149.365 41.6382 149.365 41.848 149.575C42.0578 149.792 42.0578 150.131 41.848 150.341Z"
        fill="#324A52"
      />
      <path
        d="M46.5787 145.385C46.8783 145.385 47.1212 145.142 47.1212 144.843C47.1212 144.543 46.8783 144.3 46.5787 144.3C46.279 144.3 46.0361 144.543 46.0361 144.843C46.0361 145.142 46.279 145.385 46.5787 145.385Z"
        fill="#324A52"
      />
      <path
        d="M46.5787 145.385C46.8783 145.385 47.1212 145.142 47.1212 144.843C47.1212 144.543 46.8783 144.3 46.5787 144.3C46.279 144.3 46.0361 144.543 46.0361 144.843C46.0361 145.142 46.279 145.385 46.5787 145.385Z"
        fill="#324A52"
      />
      <path
        d="M52.077 140.112C51.8672 140.322 51.52 140.322 51.3102 140.112C51.1004 139.902 51.1004 139.555 51.3102 139.346C51.52 139.136 51.8672 139.136 52.077 139.346C52.294 139.555 52.294 139.902 52.077 140.112Z"
        fill="#324A52"
      />
      <path
        d="M52.077 140.112C51.8672 140.322 51.52 140.322 51.3102 140.112C51.1004 139.902 51.1004 139.555 51.3102 139.346C51.52 139.136 51.8672 139.136 52.077 139.346C52.294 139.555 52.294 139.902 52.077 140.112Z"
        fill="#324A52"
      />
      <path
        d="M56.8082 135.154C57.1078 135.154 57.3507 134.911 57.3507 134.611C57.3507 134.312 57.1078 134.069 56.8082 134.069C56.5085 134.069 56.2656 134.312 56.2656 134.611C56.2656 134.911 56.5085 135.154 56.8082 135.154Z"
        fill="#324A52"
      />
      <path
        d="M56.8082 135.154C57.1078 135.154 57.3507 134.911 57.3507 134.611C57.3507 134.312 57.1078 134.069 56.8082 134.069C56.5085 134.069 56.2656 134.312 56.2656 134.611C56.2656 134.911 56.5085 135.154 56.8082 135.154Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 129.883C62.0957 130.093 61.7485 130.093 61.5387 129.883C61.3289 129.673 61.3289 129.326 61.5387 129.117C61.7485 128.907 62.0957 128.907 62.3055 129.117C62.5225 129.326 62.5225 129.673 62.3055 129.883Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 129.883C62.0957 130.093 61.7485 130.093 61.5387 129.883C61.3289 129.673 61.3289 129.326 61.5387 129.117C61.7485 128.907 62.0957 128.907 62.3055 129.117C62.5225 129.326 62.5225 129.673 62.3055 129.883Z"
        fill="#324A52"
      />
      <path
        d="M67.4271 124.769C67.2173 124.978 66.8701 124.978 66.6603 124.769C66.4505 124.559 66.4505 124.212 66.6603 124.002C66.8701 123.792 67.2173 123.792 67.4271 124.002C67.6369 124.212 67.6369 124.552 67.4271 124.769Z"
        fill="#324A52"
      />
      <path
        d="M67.4271 124.769C67.2173 124.978 66.8701 124.978 66.6603 124.769C66.4505 124.559 66.4505 124.212 66.6603 124.002C66.8701 123.792 67.2173 123.792 67.4271 124.002C67.6369 124.212 67.6369 124.552 67.4271 124.769Z"
        fill="#324A52"
      />
      <path
        d="M72.1588 119.813C72.4584 119.813 72.7013 119.571 72.7013 119.271C72.7013 118.972 72.4584 118.729 72.1588 118.729C71.8591 118.729 71.6162 118.972 71.6162 119.271C71.6162 119.571 71.8591 119.813 72.1588 119.813Z"
        fill="#324A52"
      />
      <path
        d="M72.1588 119.813C72.4584 119.813 72.7013 119.571 72.7013 119.271C72.7013 118.972 72.4584 118.729 72.1588 118.729C71.8591 118.729 71.6162 118.972 71.6162 119.271C71.6162 119.571 71.8591 119.813 72.1588 119.813Z"
        fill="#324A52"
      />
      <path
        d="M77.6561 114.54C77.4463 114.749 77.0991 114.749 76.8893 114.54C76.6795 114.33 76.6795 113.983 76.8893 113.773C77.0991 113.563 77.4463 113.563 77.6561 113.773C77.8659 113.983 77.8659 114.323 77.6561 114.54Z"
        fill="#324A52"
      />
      <path
        d="M77.6561 114.54C77.4463 114.749 77.0991 114.749 76.8893 114.54C76.6795 114.33 76.6795 113.983 76.8893 113.773C77.0991 113.563 77.4463 113.563 77.6561 113.773C77.8659 113.983 77.8659 114.323 77.6561 114.54Z"
        fill="#324A52"
      />
      <path
        d="M82.7703 109.417C82.5605 109.627 82.2133 109.627 82.0035 109.417C81.7937 109.208 81.7937 108.86 82.0035 108.651C82.2133 108.441 82.5605 108.441 82.7703 108.651C82.9801 108.868 82.9801 109.208 82.7703 109.417Z"
        fill="#324A52"
      />
      <path
        d="M82.7703 109.417C82.5605 109.627 82.2133 109.627 82.0035 109.417C81.7937 109.208 81.7937 108.86 82.0035 108.651C82.2133 108.441 82.5605 108.441 82.7703 108.651C82.9801 108.868 82.9801 109.208 82.7703 109.417Z"
        fill="#324A52"
      />
      <path
        d="M87.501 104.465C87.8007 104.465 88.0436 104.222 88.0436 103.923C88.0436 103.623 87.8007 103.38 87.501 103.38C87.2014 103.38 86.9585 103.623 86.9585 103.923C86.9585 104.222 87.2014 104.465 87.501 104.465Z"
        fill="#324A52"
      />
      <path
        d="M87.501 104.465C87.8007 104.465 88.0436 104.222 88.0436 103.923C88.0436 103.623 87.8007 103.38 87.501 103.38C87.2014 103.38 86.9585 103.623 86.9585 103.923C86.9585 104.222 87.2014 104.465 87.501 104.465Z"
        fill="#324A52"
      />
      <path
        d="M92.9993 99.1906C92.7895 99.4003 92.4423 99.4003 92.2325 99.1906C92.0227 98.981 92.0227 98.6339 92.2325 98.4242C92.4423 98.2145 92.7895 98.2145 92.9993 98.4242C93.2091 98.6339 93.2091 98.981 92.9993 99.1906Z"
        fill="#324A52"
      />
      <path
        d="M92.9993 99.1906C92.7895 99.4003 92.4423 99.4003 92.2325 99.1906C92.0227 98.981 92.0227 98.6339 92.2325 98.4242C92.4423 98.2145 92.7895 98.2145 92.9993 98.4242C93.2091 98.6339 93.2091 98.981 92.9993 99.1906Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 94.2346C98.0292 94.2346 98.2721 93.9918 98.2721 93.6923C98.2721 93.3927 98.0292 93.1499 97.7296 93.1499C97.4299 93.1499 97.187 93.3927 97.187 93.6923C97.187 93.9918 97.4299 94.2346 97.7296 94.2346Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 94.2346C98.0292 94.2346 98.2721 93.9918 98.2721 93.6923C98.2721 93.3927 98.0292 93.1499 97.7296 93.1499C97.4299 93.1499 97.187 93.3927 97.187 93.6923C97.187 93.9918 97.4299 94.2346 97.7296 94.2346Z"
        fill="#324A52"
      />
      <path
        d="M102.845 89.1201C103.144 89.1201 103.387 88.8773 103.387 88.5778C103.387 88.2783 103.144 88.0355 102.845 88.0355C102.545 88.0355 102.302 88.2783 102.302 88.5778C102.302 88.8773 102.545 89.1201 102.845 89.1201Z"
        fill="#324A52"
      />
      <path
        d="M102.845 89.1201C103.144 89.1201 103.387 88.8773 103.387 88.5778C103.387 88.2783 103.144 88.0355 102.845 88.0355C102.545 88.0355 102.302 88.2783 102.302 88.5778C102.302 88.8773 102.545 89.1201 102.845 89.1201Z"
        fill="#324A52"
      />
      <path
        d="M108.342 83.8471C108.132 84.0568 107.785 84.0568 107.575 83.8471C107.366 83.6374 107.366 83.2903 107.575 83.0806C107.785 82.8709 108.132 82.8709 108.342 83.0806C108.559 83.2903 108.559 83.6374 108.342 83.8471Z"
        fill="#324A52"
      />
      <path
        d="M108.342 83.8471C108.132 84.0568 107.785 84.0568 107.575 83.8471C107.366 83.6374 107.366 83.2903 107.575 83.0806C107.785 82.8709 108.132 82.8709 108.342 83.0806C108.559 83.2903 108.559 83.6374 108.342 83.8471Z"
        fill="#324A52"
      />
      <path
        d="M113.464 78.7326C113.254 78.9423 112.907 78.9423 112.697 78.7326C112.487 78.5229 112.487 78.1758 112.697 77.9661C112.907 77.7564 113.254 77.7564 113.464 77.9661C113.673 78.1758 113.673 78.5157 113.464 78.7326Z"
        fill="#324A52"
      />
      <path
        d="M113.464 78.7326C113.254 78.9423 112.907 78.9423 112.697 78.7326C112.487 78.5229 112.487 78.1758 112.697 77.9661C112.907 77.7564 113.254 77.7564 113.464 77.9661C113.673 78.1758 113.673 78.5157 113.464 78.7326Z"
        fill="#324A52"
      />
      <path
        d="M118.195 73.7766C118.495 73.7766 118.738 73.5338 118.738 73.2342C118.738 72.9347 118.495 72.6919 118.195 72.6919C117.896 72.6919 117.653 72.9347 117.653 73.2342C117.653 73.5338 117.896 73.7766 118.195 73.7766Z"
        fill="#324A52"
      />
      <path
        d="M118.195 73.7766C118.495 73.7766 118.738 73.5338 118.738 73.2342C118.738 72.9347 118.495 72.6919 118.195 72.6919C117.896 72.6919 117.653 72.9347 117.653 73.2342C117.653 73.5338 117.896 73.7766 118.195 73.7766Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 155.455C26.2939 155.665 25.9467 155.665 25.7369 155.455C25.5271 155.245 25.5271 154.898 25.7369 154.689C25.9467 154.479 26.2939 154.479 26.5037 154.689C26.7135 154.905 26.7135 155.245 26.5037 155.455Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 155.455C26.2939 155.665 25.9467 155.665 25.7369 155.455C25.5271 155.245 25.5271 154.898 25.7369 154.689C25.9467 154.479 26.2939 154.479 26.5037 154.689C26.7135 154.905 26.7135 155.245 26.5037 155.455Z"
        fill="#324A52"
      />
      <path
        d="M31.2349 150.5C31.5346 150.5 31.7775 150.257 31.7775 149.958C31.7775 149.658 31.5346 149.415 31.2349 149.415C30.9353 149.415 30.6924 149.658 30.6924 149.958C30.6924 150.257 30.9353 150.5 31.2349 150.5Z"
        fill="#324A52"
      />
      <path
        d="M31.2349 150.5C31.5346 150.5 31.7775 150.257 31.7775 149.958C31.7775 149.658 31.5346 149.415 31.2349 149.415C30.9353 149.415 30.6924 149.658 30.6924 149.958C30.6924 150.257 30.9353 150.5 31.2349 150.5Z"
        fill="#324A52"
      />
      <path
        d="M36.3497 145.385C36.6493 145.385 36.8922 145.143 36.8922 144.843C36.8922 144.544 36.6493 144.301 36.3497 144.301C36.05 144.301 35.8071 144.544 35.8071 144.843C35.8071 145.143 36.05 145.385 36.3497 145.385Z"
        fill="#324A52"
      />
      <path
        d="M36.3497 145.385C36.6493 145.385 36.8922 145.143 36.8922 144.843C36.8922 144.544 36.6493 144.301 36.3497 144.301C36.05 144.301 35.8071 144.544 35.8071 144.843C35.8071 145.143 36.05 145.385 36.3497 145.385Z"
        fill="#324A52"
      />
      <path
        d="M41.847 140.112C41.6372 140.322 41.29 140.322 41.0802 140.112C40.8704 139.903 40.8704 139.556 41.0802 139.346C41.29 139.136 41.6372 139.136 41.847 139.346C42.0568 139.556 42.0568 139.903 41.847 140.112Z"
        fill="#324A52"
      />
      <path
        d="M41.847 140.112C41.6372 140.322 41.29 140.322 41.0802 140.112C40.8704 139.903 40.8704 139.556 41.0802 139.346C41.29 139.136 41.6372 139.136 41.847 139.346C42.0568 139.556 42.0568 139.903 41.847 140.112Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 135.154C46.8773 135.154 47.1203 134.911 47.1203 134.612C47.1203 134.312 46.8773 134.069 46.5777 134.069C46.2781 134.069 46.0352 134.312 46.0352 134.612C46.0352 134.911 46.2781 135.154 46.5777 135.154Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 135.154C46.8773 135.154 47.1203 134.911 47.1203 134.612C47.1203 134.312 46.8773 134.069 46.5777 134.069C46.2781 134.069 46.0352 134.312 46.0352 134.612C46.0352 134.911 46.2781 135.154 46.5777 135.154Z"
        fill="#324A52"
      />
      <path
        d="M52.076 129.884C51.8662 130.093 51.519 130.093 51.3092 129.884C51.0994 129.674 51.0994 129.327 51.3092 129.117C51.519 128.907 51.8662 128.907 52.076 129.117C52.293 129.327 52.293 129.674 52.076 129.884Z"
        fill="#324A52"
      />
      <path
        d="M52.076 129.884C51.8662 130.093 51.519 130.093 51.3092 129.884C51.0994 129.674 51.0994 129.327 51.3092 129.117C51.519 128.907 51.8662 128.907 52.076 129.117C52.293 129.327 52.293 129.674 52.076 129.884Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 124.769C56.9805 124.979 56.6332 124.979 56.4235 124.769C56.2137 124.559 56.2137 124.212 56.4235 124.002C56.6332 123.793 56.9805 123.793 57.1903 124.002C57.4 124.212 57.4073 124.552 57.1903 124.769Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 124.769C56.9805 124.979 56.6332 124.979 56.4235 124.769C56.2137 124.559 56.2137 124.212 56.4235 124.002C56.6332 123.793 56.9805 123.793 57.1903 124.002C57.4 124.212 57.4073 124.552 57.1903 124.769Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 119.814C62.2211 119.814 62.464 119.571 62.464 119.272C62.464 118.972 62.2211 118.729 61.9215 118.729C61.6218 118.729 61.3789 118.972 61.3789 119.272C61.3789 119.571 61.6218 119.814 61.9215 119.814Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 119.814C62.2211 119.814 62.464 119.571 62.464 119.272C62.464 118.972 62.2211 118.729 61.9215 118.729C61.6218 118.729 61.3789 118.972 61.3789 119.272C61.3789 119.571 61.6218 119.814 61.9215 119.814Z"
        fill="#324A52"
      />
      <path
        d="M67.4266 114.542C67.2168 114.752 66.8696 114.752 66.6598 114.542C66.45 114.333 66.45 113.986 66.6598 113.776C66.8696 113.566 67.2168 113.566 67.4266 113.776C67.6364 113.986 67.6364 114.325 67.4266 114.542Z"
        fill="#324A52"
      />
      <path
        d="M67.4266 114.542C67.2168 114.752 66.8696 114.752 66.6598 114.542C66.45 114.333 66.45 113.986 66.6598 113.776C66.8696 113.566 67.2168 113.566 67.4266 113.776C67.6364 113.986 67.6364 114.325 67.4266 114.542Z"
        fill="#324A52"
      />
      <path
        d="M72.5403 109.419C72.3306 109.629 71.9833 109.629 71.7735 109.419C71.5638 109.209 71.5638 108.862 71.7735 108.653C71.9833 108.443 72.3306 108.443 72.5403 108.653C72.7501 108.862 72.7501 109.209 72.5403 109.419Z"
        fill="#324A52"
      />
      <path
        d="M72.5403 109.419C72.3306 109.629 71.9833 109.629 71.7735 109.419C71.5638 109.209 71.5638 108.862 71.7735 108.653C71.9833 108.443 72.3306 108.443 72.5403 108.653C72.7501 108.862 72.7501 109.209 72.5403 109.419Z"
        fill="#324A52"
      />
      <path
        d="M77.272 104.465C77.5717 104.465 77.8146 104.223 77.8146 103.923C77.8146 103.624 77.5717 103.381 77.272 103.381C76.9724 103.381 76.7295 103.624 76.7295 103.923C76.7295 104.223 76.9724 104.465 77.272 104.465Z"
        fill="#324A52"
      />
      <path
        d="M77.272 104.465C77.5717 104.465 77.8146 104.223 77.8146 103.923C77.8146 103.624 77.5717 103.381 77.272 103.381C76.9724 103.381 76.7295 103.624 76.7295 103.923C76.7295 104.223 76.9724 104.465 77.272 104.465Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 99.191C82.5596 99.4007 82.2123 99.4007 82.0026 99.191C81.7928 98.9813 81.7928 98.6342 82.0026 98.4245C82.2123 98.2148 82.5596 98.2148 82.7694 98.4245C82.9791 98.6342 82.9791 98.9813 82.7694 99.191Z"
        fill="#324A52"
      />
      <path
        d="M82.7694 99.191C82.5596 99.4007 82.2123 99.4007 82.0026 99.191C81.7928 98.9813 81.7928 98.6342 82.0026 98.4245C82.2123 98.2148 82.5596 98.2148 82.7694 98.4245C82.9791 98.6342 82.9791 98.9813 82.7694 99.191Z"
        fill="#324A52"
      />
      <path
        d="M87.501 94.2349C87.8007 94.2349 88.0436 93.9921 88.0436 93.6926C88.0436 93.3931 87.8007 93.1503 87.501 93.1503C87.2014 93.1503 86.9585 93.3931 86.9585 93.6926C86.9585 93.9921 87.2014 94.2349 87.501 94.2349Z"
        fill="#324A52"
      />
      <path
        d="M87.501 94.2349C87.8007 94.2349 88.0436 93.9921 88.0436 93.6926C88.0436 93.3931 87.8007 93.1503 87.501 93.1503C87.2014 93.1503 86.9585 93.3931 86.9585 93.6926C86.9585 93.9921 87.2014 94.2349 87.501 94.2349Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 89.1204C92.9145 89.1204 93.1574 88.8776 93.1574 88.5781C93.1574 88.2786 92.9145 88.0358 92.6148 88.0358C92.3152 88.0358 92.0723 88.2786 92.0723 88.5781C92.0723 88.8776 92.3152 89.1204 92.6148 89.1204Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 89.1204C92.9145 89.1204 93.1574 88.8776 93.1574 88.5781C93.1574 88.2786 92.9145 88.0358 92.6148 88.0358C92.3152 88.0358 92.0723 88.2786 92.0723 88.5781C92.0723 88.8776 92.3152 89.1204 92.6148 89.1204Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 83.8475C97.9033 84.0572 97.5561 84.0572 97.3463 83.8475C97.1365 83.6378 97.1365 83.2907 97.3463 83.081C97.5561 82.8713 97.9033 82.8713 98.1131 83.081C98.3229 83.2907 98.3229 83.6378 98.1131 83.8475Z"
        fill="#324A52"
      />
      <path
        d="M98.1131 83.8475C97.9033 84.0572 97.5561 84.0572 97.3463 83.8475C97.1365 83.6378 97.1365 83.2907 97.3463 83.081C97.5561 82.8713 97.9033 82.8713 98.1131 83.081C98.3229 83.2907 98.3229 83.6378 98.1131 83.8475Z"
        fill="#324A52"
      />
      <path
        d="M102.844 78.8914C103.143 78.8914 103.386 78.6486 103.386 78.3491C103.386 78.0496 103.143 77.8068 102.844 77.8068C102.544 77.8068 102.301 78.0496 102.301 78.3491C102.301 78.6486 102.544 78.8914 102.844 78.8914Z"
        fill="#324A52"
      />
      <path
        d="M102.844 78.8914C103.143 78.8914 103.386 78.6486 103.386 78.3491C103.386 78.0496 103.143 77.8068 102.844 77.8068C102.544 77.8068 102.301 78.0496 102.301 78.3491C102.301 78.6486 102.544 78.8914 102.844 78.8914Z"
        fill="#324A52"
      />
      <path
        d="M107.959 73.7769C108.258 73.7769 108.501 73.5341 108.501 73.2346C108.501 72.9351 108.258 72.6923 107.959 72.6923C107.659 72.6923 107.416 72.9351 107.416 73.2346C107.416 73.5341 107.659 73.7769 107.959 73.7769Z"
        fill="#324A52"
      />
      <path
        d="M107.959 73.7769C108.258 73.7769 108.501 73.5341 108.501 73.2346C108.501 72.9351 108.258 72.6923 107.959 72.6923C107.659 72.6923 107.416 72.9351 107.416 73.2346C107.416 73.5341 107.659 73.7769 107.959 73.7769Z"
        fill="#324A52"
      />
      <path
        d="M113.463 68.5064C113.253 68.7161 112.906 68.7161 112.696 68.5064C112.487 68.2967 112.487 67.9496 112.696 67.7399C112.906 67.5302 113.253 67.5302 113.463 67.7399C113.673 67.9496 113.673 68.2895 113.463 68.5064Z"
        fill="#324A52"
      />
      <path
        d="M113.463 68.5064C113.253 68.7161 112.906 68.7161 112.696 68.5064C112.487 68.2967 112.487 67.9496 112.696 67.7399C112.906 67.5302 113.253 67.5302 113.463 67.7399C113.673 67.9496 113.673 68.2895 113.463 68.5064Z"
        fill="#324A52"
      />
      <path
        d="M21.0064 150.5C21.3061 150.5 21.549 150.257 21.549 149.957C21.549 149.658 21.3061 149.415 21.0064 149.415C20.7068 149.415 20.4639 149.658 20.4639 149.957C20.4639 150.257 20.7068 150.5 21.0064 150.5Z"
        fill="#324A52"
      />
      <path
        d="M21.0064 150.5C21.3061 150.5 21.549 150.257 21.549 149.957C21.549 149.658 21.3061 149.415 21.0064 149.415C20.7068 149.415 20.4639 149.658 20.4639 149.957C20.4639 150.257 20.7068 150.5 21.0064 150.5Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 145.224C26.2939 145.434 25.9467 145.434 25.7369 145.224C25.5271 145.014 25.5271 144.667 25.7369 144.458C25.9467 144.248 26.2939 144.248 26.5037 144.458C26.7135 144.667 26.7135 145.014 26.5037 145.224Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 145.224C26.2939 145.434 25.9467 145.434 25.7369 145.224C25.5271 145.014 25.5271 144.667 25.7369 144.458C25.9467 144.248 26.2939 144.248 26.5037 144.458C26.7135 144.667 26.7135 145.014 26.5037 145.224Z"
        fill="#324A52"
      />
      <path
        d="M31.6199 140.112C31.4102 140.322 31.0629 140.322 30.8531 140.112C30.6434 139.902 30.6434 139.555 30.8531 139.346C31.0629 139.136 31.4102 139.136 31.6199 139.346C31.8297 139.555 31.8297 139.902 31.6199 140.112Z"
        fill="#324A52"
      />
      <path
        d="M31.6199 140.112C31.4102 140.322 31.0629 140.322 30.8531 140.112C30.6434 139.902 30.6434 139.555 30.8531 139.346C31.0629 139.136 31.4102 139.136 31.6199 139.346C31.8297 139.555 31.8297 139.902 31.6199 140.112Z"
        fill="#324A52"
      />
      <path
        d="M36.3502 135.154C36.6498 135.154 36.8927 134.911 36.8927 134.611C36.8927 134.312 36.6498 134.069 36.3502 134.069C36.0505 134.069 35.8076 134.312 35.8076 134.611C35.8076 134.911 36.0505 135.154 36.3502 135.154Z"
        fill="#324A52"
      />
      <path
        d="M36.3502 135.154C36.6498 135.154 36.8927 134.911 36.8927 134.611C36.8927 134.312 36.6498 134.069 36.3502 134.069C36.0505 134.069 35.8076 134.312 35.8076 134.611C35.8076 134.911 36.0505 135.154 36.3502 135.154Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 129.883C41.6377 130.093 41.2905 130.093 41.0807 129.883C40.8709 129.674 40.8709 129.326 41.0807 129.117C41.2905 128.907 41.6377 128.907 41.8475 129.117C42.0573 129.326 42.0573 129.674 41.8475 129.883Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 129.883C41.6377 130.093 41.2905 130.093 41.0807 129.883C40.8709 129.674 40.8709 129.326 41.0807 129.117C41.2905 128.907 41.6377 128.907 41.8475 129.117C42.0573 129.326 42.0573 129.674 41.8475 129.883Z"
        fill="#324A52"
      />
      <path
        d="M46.9627 124.769C46.7529 124.978 46.4057 124.978 46.1959 124.769C45.9861 124.559 45.9861 124.212 46.1959 124.002C46.4057 123.792 46.7529 123.792 46.9627 124.002C47.1725 124.212 47.1725 124.552 46.9627 124.769Z"
        fill="#324A52"
      />
      <path
        d="M46.9627 124.769C46.7529 124.978 46.4057 124.978 46.1959 124.769C45.9861 124.559 45.9861 124.212 46.1959 124.002C46.4057 123.792 46.7529 123.792 46.9627 124.002C47.1725 124.212 47.1725 124.552 46.9627 124.769Z"
        fill="#324A52"
      />
      <path
        d="M51.6934 119.813C51.9931 119.813 52.236 119.571 52.236 119.271C52.236 118.972 51.9931 118.729 51.6934 118.729C51.3938 118.729 51.1509 118.972 51.1509 119.271C51.1509 119.571 51.3938 119.813 51.6934 119.813Z"
        fill="#324A52"
      />
      <path
        d="M51.6934 119.813C51.9931 119.813 52.236 119.571 52.236 119.271C52.236 118.972 51.9931 118.729 51.6934 118.729C51.3938 118.729 51.1509 118.972 51.1509 119.271C51.1509 119.571 51.3938 119.813 51.6934 119.813Z"
        fill="#324A52"
      />
      <path
        d="M57.1912 114.54C56.9814 114.749 56.6342 114.749 56.4244 114.54C56.2146 114.33 56.2146 113.983 56.4244 113.773C56.6342 113.563 56.9814 113.563 57.1912 113.773C57.4082 113.983 57.4082 114.323 57.1912 114.54Z"
        fill="#324A52"
      />
      <path
        d="M57.1912 114.54C56.9814 114.749 56.6342 114.749 56.4244 114.54C56.2146 114.33 56.2146 113.983 56.4244 113.773C56.6342 113.563 56.9814 113.563 57.1912 113.773C57.4082 113.983 57.4082 114.323 57.1912 114.54Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 109.419C62.0957 109.628 61.7485 109.628 61.5387 109.419C61.3289 109.209 61.3289 108.862 61.5387 108.652C61.7485 108.443 62.0957 108.443 62.3055 108.652C62.5225 108.869 62.5225 109.209 62.3055 109.419Z"
        fill="#324A52"
      />
      <path
        d="M62.3055 109.419C62.0957 109.628 61.7485 109.628 61.5387 109.419C61.3289 109.209 61.3289 108.862 61.5387 108.652C61.7485 108.443 62.0957 108.443 62.3055 108.652C62.5225 108.869 62.5225 109.209 62.3055 109.419Z"
        fill="#324A52"
      />
      <path
        d="M67.044 104.465C67.3437 104.465 67.5866 104.222 67.5866 103.923C67.5866 103.623 67.3437 103.38 67.044 103.38C66.7444 103.38 66.5015 103.623 66.5015 103.923C66.5015 104.222 66.7444 104.465 67.044 104.465Z"
        fill="#324A52"
      />
      <path
        d="M67.044 104.465C67.3437 104.465 67.5866 104.222 67.5866 103.923C67.5866 103.623 67.3437 103.38 67.044 103.38C66.7444 103.38 66.5015 103.623 66.5015 103.923C66.5015 104.222 66.7444 104.465 67.044 104.465Z"
        fill="#324A52"
      />
      <path
        d="M72.5413 99.1907C72.3315 99.4004 71.9843 99.4004 71.7745 99.1907C71.5647 98.981 71.5647 98.6339 71.7745 98.4242C71.9843 98.2145 72.3315 98.2145 72.5413 98.4242C72.7511 98.6339 72.7511 98.981 72.5413 99.1907Z"
        fill="#324A52"
      />
      <path
        d="M72.5413 99.1907C72.3315 99.4004 71.9843 99.4004 71.7745 99.1907C71.5647 98.981 71.5647 98.6339 71.7745 98.4242C71.9843 98.2145 72.3315 98.2145 72.5413 98.4242C72.7511 98.6339 72.7511 98.981 72.5413 99.1907Z"
        fill="#324A52"
      />
      <path
        d="M77.273 94.2346C77.5727 94.2346 77.8156 93.9918 77.8156 93.6923C77.8156 93.3928 77.5727 93.15 77.273 93.15C76.9734 93.15 76.7305 93.3928 76.7305 93.6923C76.7305 93.9918 76.9734 94.2346 77.273 94.2346Z"
        fill="#324A52"
      />
      <path
        d="M77.273 94.2346C77.5727 94.2346 77.8156 93.9918 77.8156 93.6923C77.8156 93.3928 77.5727 93.15 77.273 93.15C76.9734 93.15 76.7305 93.3928 76.7305 93.6923C76.7305 93.9918 76.9734 94.2346 77.273 94.2346Z"
        fill="#324A52"
      />
      <path
        d="M82.3868 89.1201C82.6864 89.1201 82.9293 88.8773 82.9293 88.5778C82.9293 88.2783 82.6864 88.0355 82.3868 88.0355C82.0871 88.0355 81.8442 88.2783 81.8442 88.5778C81.8442 88.8773 82.0871 89.1201 82.3868 89.1201Z"
        fill="#324A52"
      />
      <path
        d="M82.3868 89.1201C82.6864 89.1201 82.9293 88.8773 82.9293 88.5778C82.9293 88.2783 82.6864 88.0355 82.3868 88.0355C82.0871 88.0355 81.8442 88.2783 81.8442 88.5778C81.8442 88.8773 82.0871 89.1201 82.3868 89.1201Z"
        fill="#324A52"
      />
      <path
        d="M87.8836 83.8471C87.6738 84.0568 87.3266 84.0568 87.1168 83.8471C86.907 83.6374 86.907 83.2904 87.1168 83.0807C87.3266 82.871 87.6738 82.871 87.8836 83.0807C88.0934 83.2904 88.0934 83.6374 87.8836 83.8471Z"
        fill="#324A52"
      />
      <path
        d="M87.8836 83.8471C87.6738 84.0568 87.3266 84.0568 87.1168 83.8471C86.907 83.6374 86.907 83.2904 87.1168 83.0807C87.3266 82.871 87.6738 82.871 87.8836 83.0807C88.0934 83.2904 88.0934 83.6374 87.8836 83.8471Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 78.8911C92.9145 78.8911 93.1574 78.6483 93.1574 78.3488C93.1574 78.0493 92.9145 77.8065 92.6148 77.8065C92.3152 77.8065 92.0723 78.0493 92.0723 78.3488C92.0723 78.6483 92.3152 78.8911 92.6148 78.8911Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 78.8911C92.9145 78.8911 93.1574 78.6483 93.1574 78.3488C93.1574 78.0493 92.9145 77.8065 92.6148 77.8065C92.3152 77.8065 92.0723 78.0493 92.0723 78.3488C92.0723 78.6483 92.3152 78.8911 92.6148 78.8911Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 73.7766C98.0292 73.7766 98.2721 73.5338 98.2721 73.2343C98.2721 72.9347 98.0292 72.6919 97.7296 72.6919C97.4299 72.6919 97.187 72.9347 97.187 73.2343C97.187 73.5338 97.4299 73.7766 97.7296 73.7766Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 73.7766C98.0292 73.7766 98.2721 73.5338 98.2721 73.2343C98.2721 72.9347 98.0292 72.6919 97.7296 72.6919C97.4299 72.6919 97.187 72.9347 97.187 73.2343C97.187 73.5338 97.4299 73.7766 97.7296 73.7766Z"
        fill="#324A52"
      />
      <path
        d="M102.844 68.6645C103.144 68.6645 103.387 68.4217 103.387 68.1222C103.387 67.8227 103.144 67.5799 102.844 67.5799C102.545 67.5799 102.302 67.8227 102.302 68.1222C102.302 68.4217 102.545 68.6645 102.844 68.6645Z"
        fill="#324A52"
      />
      <path
        d="M102.844 68.6645C103.144 68.6645 103.387 68.4217 103.387 68.1222C103.387 67.8227 103.144 67.5799 102.844 67.5799C102.545 67.5799 102.302 67.8227 102.302 68.1222C102.302 68.4217 102.545 68.6645 102.844 68.6645Z"
        fill="#324A52"
      />
      <path
        d="M107.959 63.5412C108.258 63.5412 108.501 63.2984 108.501 62.9989C108.501 62.6994 108.258 62.4566 107.959 62.4566C107.659 62.4566 107.416 62.6994 107.416 62.9989C107.416 63.2984 107.659 63.5412 107.959 63.5412Z"
        fill="#324A52"
      />
      <path
        d="M107.959 63.5412C108.258 63.5412 108.501 63.2984 108.501 62.9989C108.501 62.6994 108.258 62.4566 107.959 62.4566C107.659 62.4566 107.416 62.6994 107.416 62.9989C107.416 63.2984 107.659 63.5412 107.959 63.5412Z"
        fill="#324A52"
      />
      <path
        d="M16.2679 145.225C16.0581 145.434 15.7109 145.434 15.5011 145.225C15.2913 145.015 15.2913 144.668 15.5011 144.458C15.7109 144.249 16.0581 144.249 16.2679 144.458C16.4777 144.668 16.4849 145.015 16.2679 145.225Z"
        fill="#324A52"
      />
      <path
        d="M16.2679 145.225C16.0581 145.434 15.7109 145.434 15.5011 145.225C15.2913 145.015 15.2913 144.668 15.5011 144.458C15.7109 144.249 16.0581 144.249 16.2679 144.458C16.4777 144.668 16.4849 145.015 16.2679 145.225Z"
        fill="#324A52"
      />
      <path
        d="M21.3895 140.11C21.1797 140.32 20.8325 140.32 20.6227 140.11C20.4129 139.901 20.4129 139.554 20.6227 139.344C20.8325 139.134 21.1797 139.134 21.3895 139.344C21.5993 139.554 21.5993 139.901 21.3895 140.11Z"
        fill="#324A52"
      />
      <path
        d="M21.3895 140.11C21.1797 140.32 20.8325 140.32 20.6227 140.11C20.4129 139.901 20.4129 139.554 20.6227 139.344C20.8325 139.134 21.1797 139.134 21.3895 139.344C21.5993 139.554 21.5993 139.901 21.3895 140.11Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 134.996C26.2939 135.205 25.9467 135.205 25.7369 134.996C25.5271 134.786 25.5271 134.439 25.7369 134.229C25.9467 134.02 26.2939 134.02 26.5037 134.229C26.7135 134.439 26.7135 134.786 26.5037 134.996Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 134.996C26.2939 135.205 25.9467 135.205 25.7369 134.996C25.5271 134.786 25.5271 134.439 25.7369 134.229C25.9467 134.02 26.2939 134.02 26.5037 134.229C26.7135 134.439 26.7135 134.786 26.5037 134.996Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 129.881C31.4087 130.091 31.0615 130.091 30.8517 129.881C30.6419 129.672 30.6419 129.324 30.8517 129.115C31.0615 128.905 31.4087 128.905 31.6185 129.115C31.8283 129.324 31.8283 129.672 31.6185 129.881Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 129.881C31.4087 130.091 31.0615 130.091 30.8517 129.881C30.6419 129.672 30.6419 129.324 30.8517 129.115C31.0615 128.905 31.4087 128.905 31.6185 129.115C31.8283 129.324 31.8283 129.672 31.6185 129.881Z"
        fill="#324A52"
      />
      <path
        d="M36.7327 124.769C36.5229 124.979 36.1757 124.979 35.9659 124.769C35.7561 124.559 35.7561 124.212 35.9659 124.003C36.1757 123.793 36.5229 123.793 36.7327 124.003C36.9425 124.212 36.9425 124.552 36.7327 124.769Z"
        fill="#324A52"
      />
      <path
        d="M36.7327 124.769C36.5229 124.979 36.1757 124.979 35.9659 124.769C35.7561 124.559 35.7561 124.212 35.9659 124.003C36.1757 123.793 36.5229 123.793 36.7327 124.003C36.9425 124.212 36.9425 124.552 36.7327 124.769Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 119.653C41.6377 119.863 41.2905 119.863 41.0807 119.653C40.8709 119.444 40.8709 119.096 41.0807 118.887C41.2905 118.677 41.6377 118.677 41.8475 118.887C42.0573 119.096 42.0573 119.436 41.8475 119.653Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 119.653C41.6377 119.863 41.2905 119.863 41.0807 119.653C40.8709 119.444 40.8709 119.096 41.0807 118.887C41.2905 118.677 41.6377 118.677 41.8475 118.887C42.0573 119.096 42.0573 119.436 41.8475 119.653Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 114.54C46.752 114.75 46.4047 114.75 46.1949 114.54C45.9852 114.33 45.9852 113.983 46.1949 113.774C46.4047 113.564 46.752 113.564 46.9617 113.774C47.1715 113.983 47.1715 114.323 46.9617 114.54Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 114.54C46.752 114.75 46.4047 114.75 46.1949 114.54C45.9852 114.33 45.9852 113.983 46.1949 113.774C46.4047 113.564 46.752 113.564 46.9617 113.774C47.1715 113.983 47.1715 114.323 46.9617 114.54Z"
        fill="#324A52"
      />
      <path
        d="M52.0765 109.418C51.8667 109.628 51.5195 109.628 51.3097 109.418C51.0999 109.208 51.0999 108.861 51.3097 108.651C51.5195 108.442 51.8667 108.442 52.0765 108.651C52.2935 108.868 52.2935 109.208 52.0765 109.418Z"
        fill="#324A52"
      />
      <path
        d="M52.0765 109.418C51.8667 109.628 51.5195 109.628 51.3097 109.418C51.0999 109.208 51.0999 108.861 51.3097 108.651C51.5195 108.442 51.8667 108.442 52.0765 108.651C52.2935 108.868 52.2935 109.208 52.0765 109.418Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 104.466C57.1068 104.466 57.3497 104.223 57.3497 103.923C57.3497 103.624 57.1068 103.381 56.8072 103.381C56.5076 103.381 56.2646 103.624 56.2646 103.923C56.2646 104.223 56.5076 104.466 56.8072 104.466Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 104.466C57.1068 104.466 57.3497 104.223 57.3497 103.923C57.3497 103.624 57.1068 103.381 56.8072 103.381C56.5076 103.381 56.2646 103.624 56.2646 103.923C56.2646 104.223 56.5076 104.466 56.8072 104.466Z"
        fill="#324A52"
      />
      <path
        d="M62.305 99.1913C62.0952 99.401 61.748 99.401 61.5382 99.1913C61.3284 98.9816 61.3284 98.6345 61.5382 98.4248C61.748 98.2151 62.0952 98.2151 62.305 98.4248C62.522 98.6345 62.522 98.9816 62.305 99.1913Z"
        fill="#324A52"
      />
      <path
        d="M62.305 99.1913C62.0952 99.401 61.748 99.401 61.5382 99.1913C61.3284 98.9816 61.3284 98.6345 61.5382 98.4248C61.748 98.2151 62.0952 98.2151 62.305 98.4248C62.522 98.6345 62.522 98.9816 62.305 99.1913Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 94.2352C67.3422 94.2352 67.5851 93.9924 67.5851 93.6929C67.5851 93.3934 67.3422 93.1506 67.0425 93.1506C66.7429 93.1506 66.5 93.3934 66.5 93.6929C66.5 93.9924 66.7429 94.2352 67.0425 94.2352Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 94.2352C67.3422 94.2352 67.5851 93.9924 67.5851 93.6929C67.5851 93.3934 67.3422 93.1506 67.0425 93.1506C66.7429 93.1506 66.5 93.3934 66.5 93.6929C66.5 93.9924 66.7429 94.2352 67.0425 94.2352Z"
        fill="#324A52"
      />
      <path
        d="M72.1578 89.1207C72.4574 89.1207 72.7003 88.8779 72.7003 88.5784C72.7003 88.2789 72.4574 88.0361 72.1578 88.0361C71.8581 88.0361 71.6152 88.2789 71.6152 88.5784C71.6152 88.8779 71.8581 89.1207 72.1578 89.1207Z"
        fill="#324A52"
      />
      <path
        d="M72.1578 89.1207C72.4574 89.1207 72.7003 88.8779 72.7003 88.5784C72.7003 88.2789 72.4574 88.0361 72.1578 88.0361C71.8581 88.0361 71.6152 88.2789 71.6152 88.5784C71.6152 88.8779 71.8581 89.1207 72.1578 89.1207Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 83.8477C77.4453 84.0574 77.0981 84.0574 76.8883 83.8477C76.6785 83.638 76.6785 83.291 76.8883 83.0813C77.0981 82.8716 77.4453 82.8716 77.6551 83.0813C77.8649 83.291 77.8649 83.638 77.6551 83.8477Z"
        fill="#324A52"
      />
      <path
        d="M77.6551 83.8477C77.4453 84.0574 77.0981 84.0574 76.8883 83.8477C76.6785 83.638 76.6785 83.291 76.8883 83.0813C77.0981 82.8716 77.4453 82.8716 77.6551 83.0813C77.8649 83.291 77.8649 83.638 77.6551 83.8477Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 78.8902C82.6855 78.8902 82.9284 78.6474 82.9284 78.3479C82.9284 78.0484 82.6855 77.8056 82.3858 77.8056C82.0862 77.8056 81.8433 78.0484 81.8433 78.3479C81.8433 78.6474 82.0862 78.8902 82.3858 78.8902Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 78.8902C82.6855 78.8902 82.9284 78.6474 82.9284 78.3479C82.9284 78.0484 82.6855 77.8056 82.3858 77.8056C82.0862 77.8056 81.8433 78.0484 81.8433 78.3479C81.8433 78.6474 82.0862 78.8902 82.3858 78.8902Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 73.7772C87.7992 73.7772 88.0421 73.5344 88.0421 73.2349C88.0421 72.9354 87.7992 72.6926 87.4996 72.6926C87.1999 72.6926 86.957 72.9354 86.957 73.2349C86.957 73.5344 87.1999 73.7772 87.4996 73.7772Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 73.7772C87.7992 73.7772 88.0421 73.5344 88.0421 73.2349C88.0421 72.9354 87.7992 72.6926 87.4996 72.6926C87.1999 72.6926 86.957 72.9354 86.957 73.2349C86.957 73.5344 87.1999 73.7772 87.4996 73.7772Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 68.6651C92.914 68.6651 93.1569 68.4223 93.1569 68.1228C93.1569 67.8233 92.914 67.5805 92.6143 67.5805C92.3147 67.5805 92.0718 67.8233 92.0718 68.1228C92.0718 68.4223 92.3147 68.6651 92.6143 68.6651Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 68.6651C92.914 68.6651 93.1569 68.4223 93.1569 68.1228C93.1569 67.8233 92.914 67.5805 92.6143 67.5805C92.3147 67.5805 92.0718 67.8233 92.0718 68.1228C92.0718 68.4223 92.3147 68.6651 92.6143 68.6651Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 63.5404C98.0292 63.5404 98.2721 63.2976 98.2721 62.9981C98.2721 62.6986 98.0292 62.4558 97.7296 62.4558C97.4299 62.4558 97.187 62.6986 97.187 62.9981C97.187 63.2976 97.4299 63.5404 97.7296 63.5404Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 63.5404C98.0292 63.5404 98.2721 63.2976 98.2721 62.9981C98.2721 62.6986 98.0292 62.4558 97.7296 62.4558C97.4299 62.4558 97.187 62.6986 97.187 62.9981C97.187 63.2976 97.4299 63.5404 97.7296 63.5404Z"
        fill="#324A52"
      />
      <path
        d="M102.843 58.4259C103.143 58.4259 103.386 58.1831 103.386 57.8836C103.386 57.5841 103.143 57.3412 102.843 57.3412C102.544 57.3412 102.301 57.5841 102.301 57.8836C102.301 58.1831 102.544 58.4259 102.843 58.4259Z"
        fill="#324A52"
      />
      <path
        d="M102.843 58.4259C103.143 58.4259 103.386 58.1831 103.386 57.8836C103.386 57.5841 103.143 57.3412 102.843 57.3412C102.544 57.3412 102.301 57.5841 102.301 57.8836C102.301 58.1831 102.544 58.4259 102.843 58.4259Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 140.113C10.9434 140.322 10.5961 140.322 10.3863 140.113C10.1766 139.903 10.1766 139.556 10.3863 139.346C10.5961 139.137 10.9434 139.137 11.1531 139.346C11.3702 139.556 11.3702 139.903 11.1531 140.113Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 140.113C10.9434 140.322 10.5961 140.322 10.3863 140.113C10.1766 139.903 10.1766 139.556 10.3863 139.346C10.5961 139.137 10.9434 139.137 11.1531 139.346C11.3702 139.556 11.3702 139.903 11.1531 140.113Z"
        fill="#324A52"
      />
      <path
        d="M16.2684 134.996C16.0586 135.206 15.7114 135.206 15.5016 134.996C15.2918 134.786 15.2918 134.439 15.5016 134.229C15.7114 134.02 16.0586 134.02 16.2684 134.229C16.4782 134.439 16.4854 134.786 16.2684 134.996Z"
        fill="#324A52"
      />
      <path
        d="M16.2684 134.996C16.0586 135.206 15.7114 135.206 15.5016 134.996C15.2918 134.786 15.2918 134.439 15.5016 134.229C15.7114 134.02 16.0586 134.02 16.2684 134.229C16.4782 134.439 16.4854 134.786 16.2684 134.996Z"
        fill="#324A52"
      />
      <path
        d="M21.3895 129.884C21.1797 130.094 20.8325 130.094 20.6227 129.884C20.4129 129.674 20.4129 129.327 20.6227 129.117C20.8325 128.908 21.1797 128.908 21.3895 129.117C21.5993 129.327 21.5993 129.674 21.3895 129.884Z"
        fill="#324A52"
      />
      <path
        d="M21.3895 129.884C21.1797 130.094 20.8325 130.094 20.6227 129.884C20.4129 129.674 20.4129 129.327 20.6227 129.117C20.8325 128.908 21.1797 128.908 21.3895 129.117C21.5993 129.327 21.5993 129.674 21.3895 129.884Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 124.769C26.2939 124.979 25.9467 124.979 25.7369 124.769C25.5271 124.56 25.5271 124.213 25.7369 124.003C25.9467 123.793 26.2939 123.793 26.5037 124.003C26.7135 124.213 26.7135 124.552 26.5037 124.769Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 124.769C26.2939 124.979 25.9467 124.979 25.7369 124.769C25.5271 124.56 25.5271 124.213 25.7369 124.003C25.9467 123.793 26.2939 123.793 26.5037 124.003C26.7135 124.213 26.7135 124.552 26.5037 124.769Z"
        fill="#324A52"
      />
      <path
        d="M31.2354 119.814C31.5351 119.814 31.778 119.571 31.778 119.272C31.778 118.972 31.5351 118.73 31.2354 118.73C30.9358 118.73 30.6929 118.972 30.6929 119.272C30.6929 119.571 30.9358 119.814 31.2354 119.814Z"
        fill="#324A52"
      />
      <path
        d="M31.2354 119.814C31.5351 119.814 31.778 119.571 31.778 119.272C31.778 118.972 31.5351 118.73 31.2354 118.73C30.9358 118.73 30.6929 118.972 30.6929 119.272C30.6929 119.571 30.9358 119.814 31.2354 119.814Z"
        fill="#324A52"
      />
      <path
        d="M36.7327 114.54C36.5229 114.75 36.1757 114.75 35.9659 114.54C35.7561 114.331 35.7561 113.983 35.9659 113.774C36.1757 113.564 36.5229 113.564 36.7327 113.774C36.9425 113.983 36.9425 114.323 36.7327 114.54Z"
        fill="#324A52"
      />
      <path
        d="M36.7327 114.54C36.5229 114.75 36.1757 114.75 35.9659 114.54C35.7561 114.331 35.7561 113.983 35.9659 113.774C36.1757 113.564 36.5229 113.564 36.7327 113.774C36.9425 113.983 36.9425 114.323 36.7327 114.54Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 109.419C41.6377 109.629 41.2905 109.629 41.0807 109.419C40.8709 109.21 40.8709 108.863 41.0807 108.653C41.2905 108.443 41.6377 108.443 41.8475 108.653C42.0573 108.87 42.0573 109.21 41.8475 109.419Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 109.419C41.6377 109.629 41.2905 109.629 41.0807 109.419C40.8709 109.21 40.8709 108.863 41.0807 108.653C41.2905 108.443 41.6377 108.443 41.8475 108.653C42.0573 108.87 42.0573 109.21 41.8475 109.419Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 104.466C46.8773 104.466 47.1203 104.223 47.1203 103.923C47.1203 103.624 46.8773 103.381 46.5777 103.381C46.2781 103.381 46.0352 103.624 46.0352 103.923C46.0352 104.223 46.2781 104.466 46.5777 104.466Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 104.466C46.8773 104.466 47.1203 104.223 47.1203 103.923C47.1203 103.624 46.8773 103.381 46.5777 103.381C46.2781 103.381 46.0352 103.624 46.0352 103.923C46.0352 104.223 46.2781 104.466 46.5777 104.466Z"
        fill="#324A52"
      />
      <path
        d="M52.0765 99.1914C51.8667 99.4011 51.5195 99.4011 51.3097 99.1914C51.0999 98.9817 51.0999 98.6346 51.3097 98.4249C51.5195 98.2152 51.8667 98.2152 52.0765 98.4249C52.2935 98.6346 52.2935 98.9817 52.0765 99.1914Z"
        fill="#324A52"
      />
      <path
        d="M52.0765 99.1914C51.8667 99.4011 51.5195 99.4011 51.3097 99.1914C51.0999 98.9817 51.0999 98.6346 51.3097 98.4249C51.5195 98.2152 51.8667 98.2152 52.0765 98.4249C52.2935 98.6346 52.2935 98.9817 52.0765 99.1914Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 94.2353C57.1068 94.2353 57.3497 93.9925 57.3497 93.693C57.3497 93.3935 57.1068 93.1507 56.8072 93.1507C56.5076 93.1507 56.2646 93.3935 56.2646 93.693C56.2646 93.9925 56.5076 94.2353 56.8072 94.2353Z"
        fill="#324A52"
      />
      <path
        d="M56.8072 94.2353C57.1068 94.2353 57.3497 93.9925 57.3497 93.693C57.3497 93.3935 57.1068 93.1507 56.8072 93.1507C56.5076 93.1507 56.2646 93.3935 56.2646 93.693C56.2646 93.9925 56.5076 94.2353 56.8072 94.2353Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 89.1208C62.2211 89.1208 62.464 88.878 62.464 88.5785C62.464 88.279 62.2211 88.0362 61.9215 88.0362C61.6218 88.0362 61.3789 88.279 61.3789 88.5785C61.3789 88.878 61.6218 89.1208 61.9215 89.1208Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 89.1208C62.2211 89.1208 62.464 88.878 62.464 88.5785C62.464 88.279 62.2211 88.0362 61.9215 88.0362C61.6218 88.0362 61.3789 88.279 61.3789 88.5785C61.3789 88.878 61.6218 89.1208 61.9215 89.1208Z"
        fill="#324A52"
      />
      <path
        d="M67.4261 83.8478C67.2163 84.0575 66.8691 84.0575 66.6593 83.8478C66.4495 83.6381 66.4495 83.2911 66.6593 83.0814C66.8691 82.8717 67.2163 82.8717 67.4261 83.0814C67.6359 83.2911 67.6359 83.6381 67.4261 83.8478Z"
        fill="#324A52"
      />
      <path
        d="M67.4261 83.8478C67.2163 84.0575 66.8691 84.0575 66.6593 83.8478C66.4495 83.6381 66.4495 83.2911 66.6593 83.0814C66.8691 82.8717 67.2163 82.8717 67.4261 83.0814C67.6359 83.2911 67.6359 83.6381 67.4261 83.8478Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 78.8918C72.4569 78.8918 72.6998 78.649 72.6998 78.3495C72.6998 78.05 72.4569 77.8072 72.1573 77.8072C71.8577 77.8072 71.6147 78.05 71.6147 78.3495C71.6147 78.649 71.8577 78.8918 72.1573 78.8918Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 78.8918C72.4569 78.8918 72.6998 78.649 72.6998 78.3495C72.6998 78.05 72.4569 77.8072 72.1573 77.8072C71.8577 77.8072 71.6147 78.05 71.6147 78.3495C71.6147 78.649 71.8577 78.8918 72.1573 78.8918Z"
        fill="#324A52"
      />
      <path
        d="M77.272 73.7773C77.5717 73.7773 77.8146 73.5345 77.8146 73.235C77.8146 72.9355 77.5717 72.6927 77.272 72.6927C76.9724 72.6927 76.7295 72.9355 76.7295 73.235C76.7295 73.5345 76.9724 73.7773 77.272 73.7773Z"
        fill="#324A52"
      />
      <path
        d="M77.272 73.7773C77.5717 73.7773 77.8146 73.5345 77.8146 73.235C77.8146 72.9355 77.5717 72.6927 77.272 72.6927C76.9724 72.6927 76.7295 72.9355 76.7295 73.235C76.7295 73.5345 76.9724 73.7773 77.272 73.7773Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 68.6652C82.6859 68.6652 82.9288 68.4224 82.9288 68.1229C82.9288 67.8234 82.6859 67.5806 82.3863 67.5806C82.0867 67.5806 81.8438 67.8234 81.8438 68.1229C81.8438 68.4224 82.0867 68.6652 82.3863 68.6652Z"
        fill="#324A52"
      />
      <path
        d="M82.3863 68.6652C82.6859 68.6652 82.9288 68.4224 82.9288 68.1229C82.9288 67.8234 82.6859 67.5806 82.3863 67.5806C82.0867 67.5806 81.8438 67.8234 81.8438 68.1229C81.8438 68.4224 82.0867 68.6652 82.3863 68.6652Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 63.542C87.7997 63.542 88.0426 63.2991 88.0426 62.9996C88.0426 62.7001 87.7997 62.4573 87.5001 62.4573C87.2004 62.4573 86.9575 62.7001 86.9575 62.9996C86.9575 63.2991 87.2004 63.542 87.5001 63.542Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 63.542C87.7997 63.542 88.0426 63.2991 88.0426 62.9996C88.0426 62.7001 87.7997 62.4573 87.5001 62.4573C87.2004 62.4573 86.9575 62.7001 86.9575 62.9996C86.9575 63.2991 87.2004 63.542 87.5001 63.542Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 58.426C92.9145 58.426 93.1574 58.1832 93.1574 57.8837C93.1574 57.5842 92.9145 57.3414 92.6148 57.3414C92.3152 57.3414 92.0723 57.5842 92.0723 57.8837C92.0723 58.1832 92.3152 58.426 92.6148 58.426Z"
        fill="#324A52"
      />
      <path
        d="M92.6148 58.426C92.9145 58.426 93.1574 58.1832 93.1574 57.8837C93.1574 57.5842 92.9145 57.3414 92.6148 57.3414C92.3152 57.3414 92.0723 57.5842 92.0723 57.8837C92.0723 58.1832 92.3152 58.426 92.6148 58.426Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 53.3139C98.0292 53.3139 98.2721 53.0711 98.2721 52.7716C98.2721 52.4721 98.0292 52.2293 97.7296 52.2293C97.4299 52.2293 97.187 52.4721 97.187 52.7716C97.187 53.0711 97.4299 53.3139 97.7296 53.3139Z"
        fill="#324A52"
      />
      <path
        d="M97.7296 53.3139C98.0292 53.3139 98.2721 53.0711 98.2721 52.7716C98.2721 52.4721 98.0292 52.2293 97.7296 52.2293C97.4299 52.2293 97.187 52.4721 97.187 52.7716C97.187 53.0711 97.4299 53.3139 97.7296 53.3139Z"
        fill="#324A52"
      />
      <path
        d="M5.65485 135.154C5.95449 135.154 6.1974 134.911 6.1974 134.612C6.1974 134.312 5.95449 134.069 5.65485 134.069C5.35521 134.069 5.1123 134.312 5.1123 134.612C5.1123 134.911 5.35521 135.154 5.65485 135.154Z"
        fill="#324A52"
      />
      <path
        d="M5.65485 135.154C5.95449 135.154 6.1974 134.911 6.1974 134.612C6.1974 134.312 5.95449 134.069 5.65485 134.069C5.35521 134.069 5.1123 134.312 5.1123 134.612C5.1123 134.911 5.35521 135.154 5.65485 135.154Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 129.881C10.9434 130.091 10.5961 130.091 10.3863 129.881C10.1766 129.671 10.1766 129.324 10.3863 129.115C10.5961 128.905 10.9434 128.905 11.1531 129.115C11.3702 129.324 11.3702 129.671 11.1531 129.881Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 129.881C10.9434 130.091 10.5961 130.091 10.3863 129.881C10.1766 129.671 10.1766 129.324 10.3863 129.115C10.5961 128.905 10.9434 128.905 11.1531 129.115C11.3702 129.324 11.3702 129.671 11.1531 129.881Z"
        fill="#324A52"
      />
      <path
        d="M16.2679 124.769C16.0581 124.979 15.7109 124.979 15.5011 124.769C15.2913 124.559 15.2913 124.212 15.5011 124.002C15.7109 123.793 16.0581 123.793 16.2679 124.002C16.4777 124.212 16.4849 124.552 16.2679 124.769Z"
        fill="#324A52"
      />
      <path
        d="M16.2679 124.769C16.0581 124.979 15.7109 124.979 15.5011 124.769C15.2913 124.559 15.2913 124.212 15.5011 124.002C15.7109 123.793 16.0581 123.793 16.2679 124.002C16.4777 124.212 16.4849 124.552 16.2679 124.769Z"
        fill="#324A52"
      />
      <path
        d="M21.005 119.811C21.3046 119.811 21.5475 119.569 21.5475 119.269C21.5475 118.97 21.3046 118.727 21.005 118.727C20.7053 118.727 20.4624 118.97 20.4624 119.269C20.4624 119.569 20.7053 119.811 21.005 119.811Z"
        fill="#324A52"
      />
      <path
        d="M21.005 119.811C21.3046 119.811 21.5475 119.569 21.5475 119.269C21.5475 118.97 21.3046 118.727 21.005 118.727C20.7053 118.727 20.4624 118.97 20.4624 119.269C20.4624 119.569 20.7053 119.811 21.005 119.811Z"
        fill="#324A52"
      />
      <path
        d="M26.5032 114.54C26.2935 114.75 25.9462 114.75 25.7364 114.54C25.5267 114.33 25.5267 113.983 25.7364 113.773C25.9462 113.564 26.2935 113.564 26.5032 113.773C26.713 113.983 26.713 114.323 26.5032 114.54Z"
        fill="#324A52"
      />
      <path
        d="M26.5032 114.54C26.2935 114.75 25.9462 114.75 25.7364 114.54C25.5267 114.33 25.5267 113.983 25.7364 113.773C25.9462 113.564 26.2935 113.564 26.5032 113.773C26.713 113.983 26.713 114.323 26.5032 114.54Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 109.418C31.4087 109.627 31.0615 109.627 30.8517 109.418C30.6419 109.208 30.6419 108.861 30.8517 108.651C31.0615 108.441 31.4087 108.441 31.6185 108.651C31.8283 108.868 31.8283 109.208 31.6185 109.418Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 109.418C31.4087 109.627 31.0615 109.627 30.8517 109.418C30.6419 109.208 30.6419 108.861 30.8517 108.651C31.0615 108.441 31.4087 108.441 31.6185 108.651C31.8283 108.868 31.8283 109.208 31.6185 109.418Z"
        fill="#324A52"
      />
      <path
        d="M36.3492 104.465C36.6488 104.465 36.8917 104.223 36.8917 103.923C36.8917 103.624 36.6488 103.381 36.3492 103.381C36.0495 103.381 35.8066 103.624 35.8066 103.923C35.8066 104.223 36.0495 104.465 36.3492 104.465Z"
        fill="#324A52"
      />
      <path
        d="M36.3492 104.465C36.6488 104.465 36.8917 104.223 36.8917 103.923C36.8917 103.624 36.6488 103.381 36.3492 103.381C36.0495 103.381 35.8066 103.624 35.8066 103.923C35.8066 104.223 36.0495 104.465 36.3492 104.465Z"
        fill="#324A52"
      />
      <path
        d="M41.8465 99.191C41.6367 99.4007 41.2895 99.4007 41.0797 99.191C40.8699 98.9813 40.8699 98.6342 41.0797 98.4245C41.2895 98.2148 41.6367 98.2148 41.8465 98.4245C42.0563 98.6342 42.0563 98.9813 41.8465 99.191Z"
        fill="#324A52"
      />
      <path
        d="M41.8465 99.191C41.6367 99.4007 41.2895 99.4007 41.0797 99.191C40.8699 98.9813 40.8699 98.6342 41.0797 98.4245C41.2895 98.2148 41.6367 98.2148 41.8465 98.4245C42.0563 98.6342 42.0563 98.9813 41.8465 99.191Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 94.2349C46.8773 94.2349 47.1203 93.9921 47.1203 93.6926C47.1203 93.3931 46.8773 93.1503 46.5777 93.1503C46.2781 93.1503 46.0352 93.3931 46.0352 93.6926C46.0352 93.9921 46.2781 94.2349 46.5777 94.2349Z"
        fill="#324A52"
      />
      <path
        d="M46.5777 94.2349C46.8773 94.2349 47.1203 93.9921 47.1203 93.6926C47.1203 93.3931 46.8773 93.1503 46.5777 93.1503C46.2781 93.1503 46.0352 93.3931 46.0352 93.6926C46.0352 93.9921 46.2781 94.2349 46.5777 94.2349Z"
        fill="#324A52"
      />
      <path
        d="M51.692 89.1205C51.9916 89.1205 52.2345 88.8776 52.2345 88.5781C52.2345 88.2786 51.9916 88.0358 51.692 88.0358C51.3923 88.0358 51.1494 88.2786 51.1494 88.5781C51.1494 88.8776 51.3923 89.1205 51.692 89.1205Z"
        fill="#324A52"
      />
      <path
        d="M51.692 89.1205C51.9916 89.1205 52.2345 88.8776 52.2345 88.5781C52.2345 88.2786 51.9916 88.0358 51.692 88.0358C51.3923 88.0358 51.1494 88.2786 51.1494 88.5781C51.1494 88.8776 51.3923 89.1205 51.692 89.1205Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 83.8475C56.9805 84.0572 56.6332 84.0572 56.4235 83.8475C56.2137 83.6378 56.2137 83.2907 56.4235 83.081C56.6332 82.8713 56.9805 82.8713 57.1903 83.081C57.4073 83.2907 57.4073 83.6378 57.1903 83.8475Z"
        fill="#324A52"
      />
      <path
        d="M57.1903 83.8475C56.9805 84.0572 56.6332 84.0572 56.4235 83.8475C56.2137 83.6378 56.2137 83.2907 56.4235 83.081C56.6332 82.8713 56.9805 82.8713 57.1903 83.081C57.4073 83.2907 57.4073 83.6378 57.1903 83.8475Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 78.89C62.2211 78.89 62.464 78.6472 62.464 78.3477C62.464 78.0482 62.2211 77.8053 61.9215 77.8053C61.6218 77.8053 61.3789 78.0482 61.3789 78.3477C61.3789 78.6472 61.6218 78.89 61.9215 78.89Z"
        fill="#324A52"
      />
      <path
        d="M61.9215 78.89C62.2211 78.89 62.464 78.6472 62.464 78.3477C62.464 78.0482 62.2211 77.8053 61.9215 77.8053C61.6218 77.8053 61.3789 78.0482 61.3789 78.3477C61.3789 78.6472 61.6218 78.89 61.9215 78.89Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 73.7769C67.3422 73.7769 67.5851 73.5341 67.5851 73.2346C67.5851 72.9351 67.3422 72.6923 67.0425 72.6923C66.7429 72.6923 66.5 72.9351 66.5 73.2346C66.5 73.5341 66.7429 73.7769 67.0425 73.7769Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 73.7769C67.3422 73.7769 67.5851 73.5341 67.5851 73.2346C67.5851 72.9351 67.3422 72.6923 67.0425 72.6923C66.7429 72.6923 66.5 72.9351 66.5 73.2346C66.5 73.5341 66.7429 73.7769 67.0425 73.7769Z"
        fill="#324A52"
      />
      <path
        d="M72.1583 68.6648C72.4579 68.6648 72.7008 68.422 72.7008 68.1225C72.7008 67.823 72.4579 67.5802 72.1583 67.5802C71.8586 67.5802 71.6157 67.823 71.6157 68.1225C71.6157 68.422 71.8586 68.6648 72.1583 68.6648Z"
        fill="#324A52"
      />
      <path
        d="M72.1583 68.6648C72.4579 68.6648 72.7008 68.422 72.7008 68.1225C72.7008 67.823 72.4579 67.5802 72.1583 67.5802C71.8586 67.5802 71.6157 67.823 71.6157 68.1225C71.6157 68.422 71.8586 68.6648 72.1583 68.6648Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 63.5401C77.5712 63.5401 77.8141 63.2973 77.8141 62.9978C77.8141 62.6983 77.5712 62.4555 77.2716 62.4555C76.9719 62.4555 76.729 62.6983 76.729 62.9978C76.729 63.2973 76.9719 63.5401 77.2716 63.5401Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 63.5401C77.5712 63.5401 77.8141 63.2973 77.8141 62.9978C77.8141 62.6983 77.5712 62.4555 77.2716 62.4555C76.9719 62.4555 76.729 62.6983 76.729 62.9978C76.729 63.2973 76.9719 63.5401 77.2716 63.5401Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 58.4256C82.6855 58.4256 82.9284 58.1828 82.9284 57.8833C82.9284 57.5838 82.6855 57.341 82.3858 57.341C82.0862 57.341 81.8433 57.5838 81.8433 57.8833C81.8433 58.1828 82.0862 58.4256 82.3858 58.4256Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 58.4256C82.6855 58.4256 82.9284 58.1828 82.9284 57.8833C82.9284 57.5838 82.6855 57.341 82.3858 57.341C82.0862 57.341 81.8433 57.5838 81.8433 57.8833C81.8433 58.1828 82.0862 58.4256 82.3858 58.4256Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 53.3111C87.7997 53.3111 88.0426 53.0683 88.0426 52.7688C88.0426 52.4693 87.7997 52.2265 87.5001 52.2265C87.2004 52.2265 86.9575 52.4693 86.9575 52.7688C86.9575 53.0683 87.2004 53.3111 87.5001 53.3111Z"
        fill="#324A52"
      />
      <path
        d="M87.5001 53.3111C87.7997 53.3111 88.0426 53.0683 88.0426 52.7688C88.0426 52.4693 87.7997 52.2265 87.5001 52.2265C87.2004 52.2265 86.9575 52.4693 86.9575 52.7688C86.9575 53.0683 87.2004 53.3111 87.5001 53.3111Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 48.1966C92.914 48.1966 93.1569 47.9538 93.1569 47.6543C93.1569 47.3548 92.914 47.112 92.6143 47.112C92.3147 47.112 92.0718 47.3548 92.0718 47.6543C92.0718 47.9538 92.3147 48.1966 92.6143 48.1966Z"
        fill="#324A52"
      />
      <path
        d="M92.6143 48.1966C92.914 48.1966 93.1569 47.9538 93.1569 47.6543C93.1569 47.3548 92.914 47.112 92.6143 47.112C92.3147 47.112 92.0718 47.3548 92.0718 47.6543C92.0718 47.9538 92.3147 48.1966 92.6143 48.1966Z"
        fill="#324A52"
      />
      <path
        d="M0.924139 129.884C0.714354 130.093 0.367124 130.093 0.157339 129.884C-0.0524463 129.674 -0.0524463 129.327 0.157339 129.117C0.367124 128.907 0.714354 128.907 0.924139 129.117C1.13392 129.327 1.13392 129.674 0.924139 129.884Z"
        fill="#324A52"
      />
      <path
        d="M0.924139 129.884C0.714354 130.093 0.367124 130.093 0.157339 129.884C-0.0524463 129.674 -0.0524463 129.327 0.157339 129.117C0.367124 128.907 0.714354 128.907 0.924139 129.117C1.13392 129.327 1.13392 129.674 0.924139 129.884Z"
        fill="#324A52"
      />
      <path
        d="M6.03888 124.769C5.8291 124.979 5.48187 124.979 5.27209 124.769C5.0623 124.559 5.0623 124.212 5.27209 124.003C5.48187 123.793 5.8291 123.793 6.03888 124.003C6.24867 124.212 6.2559 124.552 6.03888 124.769Z"
        fill="#324A52"
      />
      <path
        d="M6.03888 124.769C5.8291 124.979 5.48187 124.979 5.27209 124.769C5.0623 124.559 5.0623 124.212 5.27209 124.003C5.48187 123.793 5.8291 123.793 6.03888 124.003C6.24867 124.212 6.2559 124.552 6.03888 124.769Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 119.655C10.9434 119.864 10.5961 119.864 10.3863 119.655C10.1766 119.445 10.1766 119.098 10.3863 118.888C10.5961 118.678 10.9434 118.678 11.1531 118.888C11.3702 119.098 11.3702 119.438 11.1531 119.655Z"
        fill="#324A52"
      />
      <path
        d="M11.1531 119.655C10.9434 119.864 10.5961 119.864 10.3863 119.655C10.1766 119.445 10.1766 119.098 10.3863 118.888C10.5961 118.678 10.9434 118.678 11.1531 118.888C11.3702 119.098 11.3702 119.438 11.1531 119.655Z"
        fill="#324A52"
      />
      <path
        d="M16.2669 114.54C16.0571 114.75 15.7099 114.75 15.5001 114.54C15.2903 114.33 15.2903 113.983 15.5001 113.774C15.7099 113.564 16.0571 113.564 16.2669 113.774C16.4839 113.983 16.4839 114.323 16.2669 114.54Z"
        fill="#324A52"
      />
      <path
        d="M16.2669 114.54C16.0571 114.75 15.7099 114.75 15.5001 114.54C15.2903 114.33 15.2903 113.983 15.5001 113.774C15.7099 113.564 16.0571 113.564 16.2669 113.774C16.4839 113.983 16.4839 114.323 16.2669 114.54Z"
        fill="#324A52"
      />
      <path
        d="M21.3885 109.419C21.1787 109.629 20.8315 109.629 20.6217 109.419C20.4119 109.209 20.4119 108.862 20.6217 108.653C20.8315 108.443 21.1787 108.443 21.3885 108.653C21.5983 108.862 21.5983 109.209 21.3885 109.419Z"
        fill="#324A52"
      />
      <path
        d="M21.3885 109.419C21.1787 109.629 20.8315 109.629 20.6217 109.419C20.4119 109.209 20.4119 108.862 20.6217 108.653C20.8315 108.443 21.1787 108.443 21.3885 108.653C21.5983 108.862 21.5983 109.209 21.3885 109.419Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 104.305C26.2939 104.514 25.9467 104.514 25.7369 104.305C25.5271 104.095 25.5271 103.748 25.7369 103.538C25.9467 103.328 26.2939 103.328 26.5037 103.538C26.7135 103.755 26.7135 104.095 26.5037 104.305Z"
        fill="#324A52"
      />
      <path
        d="M26.5037 104.305C26.2939 104.514 25.9467 104.514 25.7369 104.305C25.5271 104.095 25.5271 103.748 25.7369 103.538C25.9467 103.328 26.2939 103.328 26.5037 103.538C26.7135 103.755 26.7135 104.095 26.5037 104.305Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 99.1911C31.4087 99.4008 31.0615 99.4008 30.8517 99.1911C30.6419 98.9814 30.6419 98.6343 30.8517 98.4247C31.0615 98.215 31.4087 98.215 31.6185 98.4247C31.8283 98.6343 31.8283 98.9814 31.6185 99.1911Z"
        fill="#324A52"
      />
      <path
        d="M31.6185 99.1911C31.4087 99.4008 31.0615 99.4008 30.8517 99.1911C30.6419 98.9814 30.6419 98.6343 30.8517 98.4247C31.0615 98.215 31.4087 98.215 31.6185 98.4247C31.8283 98.6343 31.8283 98.9814 31.6185 99.1911Z"
        fill="#324A52"
      />
      <path
        d="M36.3492 94.235C36.6488 94.235 36.8917 93.9922 36.8917 93.6927C36.8917 93.3932 36.6488 93.1504 36.3492 93.1504C36.0495 93.1504 35.8066 93.3932 35.8066 93.6927C35.8066 93.9922 36.0495 94.235 36.3492 94.235Z"
        fill="#324A52"
      />
      <path
        d="M36.3492 94.235C36.6488 94.235 36.8917 93.9922 36.8917 93.6927C36.8917 93.3932 36.6488 93.1504 36.3492 93.1504C36.0495 93.1504 35.8066 93.3932 35.8066 93.6927C35.8066 93.9922 36.0495 94.235 36.3492 94.235Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 88.9621C41.6377 89.1718 41.2905 89.1718 41.0807 88.9621C40.8709 88.7524 40.8709 88.4053 41.0807 88.1956C41.2905 87.9859 41.6377 87.9859 41.8475 88.1956C42.0573 88.4053 42.0573 88.7524 41.8475 88.9621Z"
        fill="#324A52"
      />
      <path
        d="M41.8475 88.9621C41.6377 89.1718 41.2905 89.1718 41.0807 88.9621C40.8709 88.7524 40.8709 88.4053 41.0807 88.1956C41.2905 87.9859 41.6377 87.9859 41.8475 88.1956C42.0573 88.4053 42.0573 88.7524 41.8475 88.9621Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 83.8476C46.752 84.0573 46.4047 84.0573 46.1949 83.8476C45.9852 83.6379 45.9852 83.2908 46.1949 83.0811C46.4047 82.8714 46.752 82.8714 46.9617 83.0811C47.1715 83.2908 47.1715 83.6379 46.9617 83.8476Z"
        fill="#324A52"
      />
      <path
        d="M46.9617 83.8476C46.752 84.0573 46.4047 84.0573 46.1949 83.8476C45.9852 83.6379 45.9852 83.2908 46.1949 83.0811C46.4047 82.8714 46.752 82.8714 46.9617 83.0811C47.1715 83.2908 47.1715 83.6379 46.9617 83.8476Z"
        fill="#324A52"
      />
      <path
        d="M51.6929 78.8915C51.9926 78.8915 52.2355 78.6487 52.2355 78.3492C52.2355 78.0497 51.9926 77.8069 51.6929 77.8069C51.3933 77.8069 51.1504 78.0497 51.1504 78.3492C51.1504 78.6487 51.3933 78.8915 51.6929 78.8915Z"
        fill="#324A52"
      />
      <path
        d="M51.6929 78.8915C51.9926 78.8915 52.2355 78.6487 52.2355 78.3492C52.2355 78.0497 51.9926 77.8069 51.6929 77.8069C51.3933 77.8069 51.1504 78.0497 51.1504 78.3492C51.1504 78.6487 51.3933 78.8915 51.6929 78.8915Z"
        fill="#324A52"
      />
      <path
        d="M56.8067 73.777C57.1063 73.777 57.3493 73.5342 57.3493 73.2347C57.3493 72.9352 57.1063 72.6924 56.8067 72.6924C56.5071 72.6924 56.2642 72.9352 56.2642 73.2347C56.2642 73.5342 56.5071 73.777 56.8067 73.777Z"
        fill="#324A52"
      />
      <path
        d="M56.8067 73.777C57.1063 73.777 57.3493 73.5342 57.3493 73.2347C57.3493 72.9352 57.1063 72.6924 56.8067 72.6924C56.5071 72.6924 56.2642 72.9352 56.2642 73.2347C56.2642 73.5342 56.5071 73.777 56.8067 73.777Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 68.665C62.2216 68.665 62.4645 68.4222 62.4645 68.1226C62.4645 67.8231 62.2216 67.5803 61.9219 67.5803C61.6223 67.5803 61.3794 67.8231 61.3794 68.1226C61.3794 68.4222 61.6223 68.665 61.9219 68.665Z"
        fill="#324A52"
      />
      <path
        d="M61.9219 68.665C62.2216 68.665 62.4645 68.4222 62.4645 68.1226C62.4645 67.8231 62.2216 67.5803 61.9219 67.5803C61.6223 67.5803 61.3794 67.8231 61.3794 68.1226C61.3794 68.4222 61.6223 68.665 61.9219 68.665Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 63.5417C67.3422 63.5417 67.5851 63.2989 67.5851 62.9994C67.5851 62.6999 67.3422 62.4571 67.0425 62.4571C66.7429 62.4571 66.5 62.6999 66.5 62.9994C66.5 63.2989 66.7429 63.5417 67.0425 63.5417Z"
        fill="#324A52"
      />
      <path
        d="M67.0425 63.5417C67.3422 63.5417 67.5851 63.2989 67.5851 62.9994C67.5851 62.6999 67.3422 62.4571 67.0425 62.4571C66.7429 62.4571 66.5 62.6999 66.5 62.9994C66.5 63.2989 66.7429 63.5417 67.0425 63.5417Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 58.4257C72.4569 58.4257 72.6998 58.1829 72.6998 57.8834C72.6998 57.5839 72.4569 57.3411 72.1573 57.3411C71.8577 57.3411 71.6147 57.5839 71.6147 57.8834C71.6147 58.1829 71.8577 58.4257 72.1573 58.4257Z"
        fill="#324A52"
      />
      <path
        d="M72.1573 58.4257C72.4569 58.4257 72.6998 58.1829 72.6998 57.8834C72.6998 57.5839 72.4569 57.3411 72.1573 57.3411C71.8577 57.3411 71.6147 57.5839 71.6147 57.8834C71.6147 58.1829 71.8577 58.4257 72.1573 58.4257Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 53.3136C77.5712 53.3136 77.8141 53.0708 77.8141 52.7713C77.8141 52.4718 77.5712 52.229 77.2716 52.229C76.9719 52.229 76.729 52.4718 76.729 52.7713C76.729 53.0708 76.9719 53.3136 77.2716 53.3136Z"
        fill="#324A52"
      />
      <path
        d="M77.2716 53.3136C77.5712 53.3136 77.8141 53.0708 77.8141 52.7713C77.8141 52.4718 77.5712 52.229 77.2716 52.229C76.9719 52.229 76.729 52.4718 76.729 52.7713C76.729 53.0708 76.9719 53.3136 77.2716 53.3136Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 48.1967C82.6855 48.1967 82.9284 47.9539 82.9284 47.6544C82.9284 47.3549 82.6855 47.1121 82.3858 47.1121C82.0862 47.1121 81.8433 47.3549 81.8433 47.6544C81.8433 47.9539 82.0862 48.1967 82.3858 48.1967Z"
        fill="#324A52"
      />
      <path
        d="M82.3858 48.1967C82.6855 48.1967 82.9284 47.9539 82.9284 47.6544C82.9284 47.3549 82.6855 47.1121 82.3858 47.1121C82.0862 47.1121 81.8433 47.3549 81.8433 47.6544C81.8433 47.9539 82.0862 48.1967 82.3858 48.1967Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 43.0846C87.7992 43.0846 88.0421 42.8418 88.0421 42.5423C88.0421 42.2428 87.7992 42 87.4996 42C87.2 42 86.957 42.2428 86.957 42.5423C86.957 42.8418 87.2 43.0846 87.4996 43.0846Z"
        fill="#324A52"
      />
      <path
        d="M87.4996 43.0846C87.7992 43.0846 88.0421 42.8418 88.0421 42.5423C88.0421 42.2428 87.7992 42 87.4996 42C87.2 42 86.957 42.2428 86.957 42.5423C86.957 42.8418 87.2 43.0846 87.4996 43.0846Z"
        fill="#324A52"
      />
      <path
        d="M207.5 116C207.695 116 207.853 115.842 207.853 115.647C207.853 115.452 207.695 115.293 207.5 115.293C207.304 115.293 207.146 115.452 207.146 115.647C207.146 115.842 207.304 116 207.5 116Z"
        fill="#324A52"
      />
      <path
        d="M207.5 116C207.695 116 207.853 115.842 207.853 115.647C207.853 115.452 207.695 115.293 207.5 115.293C207.304 115.293 207.146 115.452 207.146 115.647C207.146 115.842 207.304 116 207.5 116Z"
        fill="#324A52"
      />
      <path
        d="M210.831 112.668C211.026 112.668 211.185 112.51 211.185 112.315C211.185 112.12 211.026 111.962 210.831 111.962C210.636 111.962 210.478 112.12 210.478 112.315C210.478 112.51 210.636 112.668 210.831 112.668Z"
        fill="#324A52"
      />
      <path
        d="M210.831 112.668C211.026 112.668 211.185 112.51 211.185 112.315C211.185 112.12 211.026 111.962 210.831 111.962C210.636 111.962 210.478 112.12 210.478 112.315C210.478 112.51 210.636 112.668 210.831 112.668Z"
        fill="#324A52"
      />
      <path
        d="M214.163 109.333C214.359 109.333 214.517 109.175 214.517 108.98C214.517 108.785 214.359 108.627 214.163 108.627C213.968 108.627 213.81 108.785 213.81 108.98C213.81 109.175 213.968 109.333 214.163 109.333Z"
        fill="#324A52"
      />
      <path
        d="M214.163 109.333C214.359 109.333 214.517 109.175 214.517 108.98C214.517 108.785 214.359 108.627 214.163 108.627C213.968 108.627 213.81 108.785 213.81 108.98C213.81 109.175 213.968 109.333 214.163 109.333Z"
        fill="#324A52"
      />
      <path
        d="M217.495 105.999C217.69 105.999 217.848 105.841 217.848 105.646C217.848 105.451 217.69 105.293 217.495 105.293C217.3 105.293 217.142 105.451 217.142 105.646C217.142 105.841 217.3 105.999 217.495 105.999Z"
        fill="#324A52"
      />
      <path
        d="M217.495 105.999C217.69 105.999 217.848 105.841 217.848 105.646C217.848 105.451 217.69 105.293 217.495 105.293C217.3 105.293 217.142 105.451 217.142 105.646C217.142 105.841 217.3 105.999 217.495 105.999Z"
        fill="#324A52"
      />
      <path
        d="M220.826 102.669C221.021 102.669 221.18 102.511 221.18 102.316C221.18 102.121 221.021 101.962 220.826 101.962C220.631 101.962 220.473 102.121 220.473 102.316C220.473 102.511 220.631 102.669 220.826 102.669Z"
        fill="#324A52"
      />
      <path
        d="M220.826 102.669C221.021 102.669 221.18 102.511 221.18 102.316C221.18 102.121 221.021 101.962 220.826 101.962C220.631 101.962 220.473 102.121 220.473 102.316C220.473 102.511 220.631 102.669 220.826 102.669Z"
        fill="#324A52"
      />
      <path
        d="M224.413 99.2324C224.276 99.369 224.05 99.369 223.914 99.2324C223.777 99.0958 223.777 98.8697 223.914 98.7331C224.05 98.5965 224.276 98.5965 224.413 98.7331C224.55 98.8697 224.55 99.0958 224.413 99.2324Z"
        fill="#324A52"
      />
      <path
        d="M224.413 99.2324C224.276 99.369 224.05 99.369 223.914 99.2324C223.777 99.0958 223.777 98.8697 223.914 98.7331C224.05 98.5965 224.276 98.5965 224.413 98.7331C224.55 98.8697 224.55 99.0958 224.413 99.2324Z"
        fill="#324A52"
      />
      <path
        d="M227.495 96.0055C227.69 96.0055 227.848 95.8473 227.848 95.6522C227.848 95.4571 227.69 95.2989 227.495 95.2989C227.3 95.2989 227.141 95.4571 227.141 95.6522C227.141 95.8473 227.3 96.0055 227.495 96.0055Z"
        fill="#324A52"
      />
      <path
        d="M227.495 96.0055C227.69 96.0055 227.848 95.8473 227.848 95.6522C227.848 95.4571 227.69 95.2989 227.495 95.2989C227.3 95.2989 227.141 95.4571 227.141 95.6522C227.141 95.8473 227.3 96.0055 227.495 96.0055Z"
        fill="#324A52"
      />
      <path
        d="M230.827 92.6737C231.022 92.6737 231.18 92.5156 231.18 92.3205C231.18 92.1254 231.022 91.9672 230.827 91.9672C230.632 91.9672 230.474 92.1254 230.474 92.3205C230.474 92.5156 230.632 92.6737 230.827 92.6737Z"
        fill="#324A52"
      />
      <path
        d="M230.827 92.6737C231.022 92.6737 231.18 92.5156 231.18 92.3205C231.18 92.1254 231.022 91.9672 230.827 91.9672C230.632 91.9672 230.474 92.1254 230.474 92.3205C230.474 92.5156 230.632 92.6737 230.827 92.6737Z"
        fill="#324A52"
      />
      <path
        d="M234.407 89.2388C234.271 89.3754 234.045 89.3754 233.908 89.2388C233.771 89.1022 233.771 88.8761 233.908 88.7395C234.045 88.6029 234.271 88.6029 234.407 88.7395C234.544 88.8761 234.544 89.1022 234.407 89.2388Z"
        fill="#324A52"
      />
      <path
        d="M234.407 89.2388C234.271 89.3754 234.045 89.3754 233.908 89.2388C233.771 89.1022 233.771 88.8761 233.908 88.7395C234.045 88.6029 234.271 88.6029 234.407 88.7395C234.544 88.8761 234.544 89.1022 234.407 89.2388Z"
        fill="#324A52"
      />
      <path
        d="M237.49 86.0109C237.685 86.0109 237.844 85.8527 237.844 85.6576C237.844 85.4625 237.685 85.3044 237.49 85.3044C237.295 85.3044 237.137 85.4625 237.137 85.6576C237.137 85.8527 237.295 86.0109 237.49 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M237.49 86.0109C237.685 86.0109 237.844 85.8527 237.844 85.6576C237.844 85.4625 237.685 85.3044 237.49 85.3044C237.295 85.3044 237.137 85.4625 237.137 85.6576C237.137 85.8527 237.295 86.0109 237.49 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M241.071 82.5754C240.935 82.712 240.708 82.712 240.572 82.5754C240.435 82.4388 240.435 82.2126 240.572 82.076C240.708 81.9394 240.935 81.9394 241.071 82.076C241.208 82.2126 241.208 82.434 241.071 82.5754Z"
        fill="#324A52"
      />
      <path
        d="M241.071 82.5754C240.935 82.712 240.708 82.712 240.572 82.5754C240.435 82.4388 240.435 82.2126 240.572 82.076C240.708 81.9394 240.935 81.9394 241.071 82.076C241.208 82.2126 241.208 82.434 241.071 82.5754Z"
        fill="#324A52"
      />
      <path
        d="M244.403 79.2395C244.266 79.3761 244.04 79.3761 243.903 79.2395C243.767 79.1029 243.767 78.8768 243.903 78.7402C244.04 78.6036 244.266 78.6036 244.403 78.7402C244.539 78.8768 244.539 79.1029 244.403 79.2395Z"
        fill="#324A52"
      />
      <path
        d="M244.403 79.2395C244.266 79.3761 244.04 79.3761 243.903 79.2395C243.767 79.1029 243.767 78.8768 243.903 78.7402C244.04 78.6036 244.266 78.6036 244.403 78.7402C244.539 78.8768 244.539 79.1029 244.403 79.2395Z"
        fill="#324A52"
      />
      <path
        d="M247.735 75.9077C247.598 76.0443 247.372 76.0443 247.235 75.9077C247.099 75.7711 247.099 75.545 247.235 75.4084C247.372 75.2718 247.598 75.2718 247.735 75.4084C247.871 75.545 247.876 75.7711 247.735 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M247.735 75.9077C247.598 76.0443 247.372 76.0443 247.235 75.9077C247.099 75.7711 247.099 75.545 247.235 75.4084C247.372 75.2718 247.598 75.2718 247.735 75.4084C247.871 75.545 247.876 75.7711 247.735 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M251.066 72.5766C250.93 72.7132 250.703 72.7132 250.567 72.5766C250.43 72.44 250.43 72.2139 250.567 72.0773C250.703 71.9407 250.93 71.9407 251.066 72.0773C251.208 72.2187 251.208 72.44 251.066 72.5766Z"
        fill="#324A52"
      />
      <path
        d="M251.066 72.5766C250.93 72.7132 250.703 72.7132 250.567 72.5766C250.43 72.44 250.43 72.2139 250.567 72.0773C250.703 71.9407 250.93 71.9407 251.066 72.0773C251.208 72.2187 251.208 72.44 251.066 72.5766Z"
        fill="#324A52"
      />
      <path
        d="M254.398 69.2433C254.261 69.3799 254.035 69.3799 253.898 69.2433C253.762 69.1067 253.762 68.8806 253.898 68.744C254.035 68.6074 254.261 68.6074 254.398 68.744C254.535 68.8806 254.539 69.1067 254.398 69.2433Z"
        fill="#324A52"
      />
      <path
        d="M254.398 69.2433C254.261 69.3799 254.035 69.3799 253.898 69.2433C253.762 69.1067 253.762 68.8806 253.898 68.744C254.035 68.6074 254.261 68.6074 254.398 68.744C254.535 68.8806 254.539 69.1067 254.398 69.2433Z"
        fill="#324A52"
      />
      <path
        d="M257.735 65.9132C257.598 66.0498 257.372 66.0498 257.235 65.9132C257.099 65.7766 257.099 65.5505 257.235 65.4139C257.372 65.2773 257.598 65.2773 257.735 65.4139C257.871 65.5505 257.871 65.7766 257.735 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M257.735 65.9132C257.598 66.0498 257.372 66.0498 257.235 65.9132C257.099 65.7766 257.099 65.5505 257.235 65.4139C257.372 65.2773 257.598 65.2773 257.735 65.4139C257.871 65.5505 257.871 65.7766 257.735 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M261.066 62.583C260.93 62.7196 260.704 62.7196 260.567 62.583C260.43 62.4464 260.43 62.2203 260.567 62.0837C260.704 61.9471 260.93 61.9471 261.066 62.0837C261.203 62.2203 261.203 62.4464 261.066 62.583Z"
        fill="#324A52"
      />
      <path
        d="M261.066 62.583C260.93 62.7196 260.704 62.7196 260.567 62.583C260.43 62.4464 260.43 62.2203 260.567 62.0837C260.704 61.9471 260.93 61.9471 261.066 62.0837C261.203 62.2203 261.203 62.4464 261.066 62.583Z"
        fill="#324A52"
      />
      <path
        d="M264.397 59.2499C264.261 59.3865 264.035 59.3865 263.898 59.2499C263.761 59.1132 263.761 58.8871 263.898 58.7505C264.035 58.6139 264.261 58.6139 264.397 58.7505C264.534 58.8871 264.534 59.1132 264.397 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M264.397 59.2499C264.261 59.3865 264.035 59.3865 263.898 59.2499C263.761 59.1132 263.761 58.8871 263.898 58.7505C264.035 58.6139 264.261 58.6139 264.397 58.7505C264.534 58.8871 264.534 59.1132 264.397 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M204.168 112.668C204.364 112.668 204.522 112.51 204.522 112.315C204.522 112.12 204.364 111.962 204.168 111.962C203.973 111.962 203.815 112.12 203.815 112.315C203.815 112.51 203.973 112.668 204.168 112.668Z"
        fill="#324A52"
      />
      <path
        d="M204.168 112.668C204.364 112.668 204.522 112.51 204.522 112.315C204.522 112.12 204.364 111.962 204.168 111.962C203.973 111.962 203.815 112.12 203.815 112.315C203.815 112.51 203.973 112.668 204.168 112.668Z"
        fill="#324A52"
      />
      <path
        d="M207.5 109.332C207.695 109.332 207.853 109.174 207.853 108.979C207.853 108.784 207.695 108.626 207.5 108.626C207.305 108.626 207.147 108.784 207.147 108.979C207.147 109.174 207.305 109.332 207.5 109.332Z"
        fill="#324A52"
      />
      <path
        d="M207.5 109.332C207.695 109.332 207.853 109.174 207.853 108.979C207.853 108.784 207.695 108.626 207.5 108.626C207.305 108.626 207.147 108.784 207.147 108.979C207.147 109.174 207.305 109.332 207.5 109.332Z"
        fill="#324A52"
      />
      <path
        d="M210.832 105.997C211.027 105.997 211.185 105.839 211.185 105.644C211.185 105.449 211.027 105.291 210.832 105.291C210.637 105.291 210.478 105.449 210.478 105.644C210.478 105.839 210.637 105.997 210.832 105.997Z"
        fill="#324A52"
      />
      <path
        d="M210.832 105.997C211.027 105.997 211.185 105.839 211.185 105.644C211.185 105.449 211.027 105.291 210.832 105.291C210.637 105.291 210.478 105.449 210.478 105.644C210.478 105.839 210.637 105.997 210.832 105.997Z"
        fill="#324A52"
      />
      <path
        d="M214.164 102.669C214.359 102.669 214.517 102.511 214.517 102.316C214.517 102.12 214.359 101.962 214.164 101.962C213.969 101.962 213.81 102.12 213.81 102.316C213.81 102.511 213.969 102.669 214.164 102.669Z"
        fill="#324A52"
      />
      <path
        d="M214.164 102.669C214.359 102.669 214.517 102.511 214.517 102.316C214.517 102.12 214.359 101.962 214.164 101.962C213.969 101.962 213.81 102.12 213.81 102.316C213.81 102.511 213.969 102.669 214.164 102.669Z"
        fill="#324A52"
      />
      <path
        d="M217.495 99.3356C217.69 99.3356 217.848 99.1774 217.848 98.9823C217.848 98.7872 217.69 98.629 217.495 98.629C217.3 98.629 217.142 98.7872 217.142 98.9823C217.142 99.1774 217.3 99.3356 217.495 99.3356Z"
        fill="#324A52"
      />
      <path
        d="M217.495 99.3356C217.69 99.3356 217.848 99.1774 217.848 98.9823C217.848 98.7872 217.69 98.629 217.495 98.629C217.3 98.629 217.142 98.7872 217.142 98.9823C217.142 99.1774 217.3 99.3356 217.495 99.3356Z"
        fill="#324A52"
      />
      <path
        d="M220.827 96.0054C221.022 96.0054 221.181 95.8472 221.181 95.6521C221.181 95.457 221.022 95.2989 220.827 95.2989C220.632 95.2989 220.474 95.457 220.474 95.6521C220.474 95.8472 220.632 96.0054 220.827 96.0054Z"
        fill="#324A52"
      />
      <path
        d="M220.827 96.0054C221.022 96.0054 221.181 95.8472 221.181 95.6521C221.181 95.457 221.022 95.2989 220.827 95.2989C220.632 95.2989 220.474 95.457 220.474 95.6521C220.474 95.8472 220.632 96.0054 220.827 96.0054Z"
        fill="#324A52"
      />
      <path
        d="M224.413 92.5705C224.277 92.7071 224.051 92.7071 223.914 92.5705C223.777 92.4339 223.777 92.2078 223.914 92.0712C224.051 91.9346 224.277 91.9346 224.413 92.0712C224.55 92.2078 224.55 92.4339 224.413 92.5705Z"
        fill="#324A52"
      />
      <path
        d="M224.413 92.5705C224.277 92.7071 224.051 92.7071 223.914 92.5705C223.777 92.4339 223.777 92.2078 223.914 92.0712C224.051 91.9346 224.277 91.9346 224.413 92.0712C224.55 92.2078 224.55 92.4339 224.413 92.5705Z"
        fill="#324A52"
      />
      <path
        d="M227.495 89.342C227.69 89.342 227.849 89.1838 227.849 88.9887C227.849 88.7936 227.69 88.6354 227.495 88.6354C227.3 88.6354 227.142 88.7936 227.142 88.9887C227.142 89.1838 227.3 89.342 227.495 89.342Z"
        fill="#324A52"
      />
      <path
        d="M227.495 89.342C227.69 89.342 227.849 89.1838 227.849 88.9887C227.849 88.7936 227.69 88.6354 227.495 88.6354C227.3 88.6354 227.142 88.7936 227.142 88.9887C227.142 89.1838 227.3 89.342 227.495 89.342Z"
        fill="#324A52"
      />
      <path
        d="M230.827 86.0109C231.022 86.0109 231.18 85.8527 231.18 85.6576C231.18 85.4625 231.022 85.3043 230.827 85.3043C230.632 85.3043 230.474 85.4625 230.474 85.6576C230.474 85.8527 230.632 86.0109 230.827 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M230.827 86.0109C231.022 86.0109 231.18 85.8527 231.18 85.6576C231.18 85.4625 231.022 85.3043 230.827 85.3043C230.632 85.3043 230.474 85.4625 230.474 85.6576C230.474 85.8527 230.632 86.0109 230.827 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M234.408 82.5743C234.271 82.7109 234.045 82.7109 233.908 82.5743C233.772 82.4377 233.772 82.2116 233.908 82.075C234.045 81.9384 234.271 81.9384 234.408 82.075C234.544 82.2116 234.544 82.433 234.408 82.5743Z"
        fill="#324A52"
      />
      <path
        d="M234.408 82.5743C234.271 82.7109 234.045 82.7109 233.908 82.5743C233.772 82.4377 233.772 82.2116 233.908 82.075C234.045 81.9384 234.271 81.9384 234.408 82.075C234.544 82.2116 234.544 82.433 234.408 82.5743Z"
        fill="#324A52"
      />
      <path
        d="M237.49 79.3433C237.685 79.3433 237.843 79.1851 237.843 78.99C237.843 78.7949 237.685 78.6367 237.49 78.6367C237.295 78.6367 237.136 78.7949 237.136 78.99C237.136 79.1851 237.295 79.3433 237.49 79.3433Z"
        fill="#324A52"
      />
      <path
        d="M237.49 79.3433C237.685 79.3433 237.843 79.1851 237.843 78.99C237.843 78.7949 237.685 78.6367 237.49 78.6367C237.295 78.6367 237.136 78.7949 237.136 78.99C237.136 79.1851 237.295 79.3433 237.49 79.3433Z"
        fill="#324A52"
      />
      <path
        d="M241.072 75.9067C240.935 76.0433 240.709 76.0433 240.572 75.9067C240.435 75.7701 240.435 75.544 240.572 75.4074C240.709 75.2708 240.935 75.2708 241.072 75.4074C241.208 75.5487 241.208 75.7701 241.072 75.9067Z"
        fill="#324A52"
      />
      <path
        d="M241.072 75.9067C240.935 76.0433 240.709 76.0433 240.572 75.9067C240.435 75.7701 240.435 75.544 240.572 75.4074C240.709 75.2708 240.935 75.2708 241.072 75.4074C241.208 75.5487 241.208 75.7701 241.072 75.9067Z"
        fill="#324A52"
      />
      <path
        d="M244.403 72.575C244.267 72.7116 244.041 72.7116 243.904 72.575C243.767 72.4384 243.767 72.2123 243.904 72.0757C244.041 71.9391 244.267 71.9391 244.403 72.0757C244.54 72.2123 244.54 72.4384 244.403 72.575Z"
        fill="#324A52"
      />
      <path
        d="M244.403 72.575C244.267 72.7116 244.041 72.7116 243.904 72.575C243.767 72.4384 243.767 72.2123 243.904 72.0757C244.041 71.9391 244.267 71.9391 244.403 72.0757C244.54 72.2123 244.54 72.4384 244.403 72.575Z"
        fill="#324A52"
      />
      <path
        d="M247.485 69.348C247.68 69.348 247.838 69.1899 247.838 68.9948C247.838 68.7996 247.68 68.6415 247.485 68.6415C247.29 68.6415 247.131 68.7996 247.131 68.9948C247.131 69.1899 247.29 69.348 247.485 69.348Z"
        fill="#324A52"
      />
      <path
        d="M247.485 69.348C247.68 69.348 247.838 69.1899 247.838 68.9948C247.838 68.7996 247.68 68.6415 247.485 68.6415C247.29 68.6415 247.131 68.7996 247.131 68.9948C247.131 69.1899 247.29 69.348 247.485 69.348Z"
        fill="#324A52"
      />
      <path
        d="M251.067 65.9116C250.93 66.0482 250.704 66.0482 250.567 65.9116C250.43 65.775 250.43 65.5489 250.567 65.4123C250.704 65.2757 250.93 65.2757 251.067 65.4123C251.208 65.5489 251.208 65.775 251.067 65.9116Z"
        fill="#324A52"
      />
      <path
        d="M251.067 65.9116C250.93 66.0482 250.704 66.0482 250.567 65.9116C250.43 65.775 250.43 65.5489 250.567 65.4123C250.704 65.2757 250.93 65.2757 251.067 65.4123C251.208 65.5489 251.208 65.775 251.067 65.9116Z"
        fill="#324A52"
      />
      <path
        d="M254.398 62.5798C254.262 62.7164 254.036 62.7164 253.899 62.5798C253.762 62.4432 253.762 62.2171 253.899 62.0805C254.036 61.9439 254.262 61.9439 254.398 62.0805C254.535 62.2171 254.54 62.4432 254.398 62.5798Z"
        fill="#324A52"
      />
      <path
        d="M254.398 62.5798C254.262 62.7164 254.036 62.7164 253.899 62.5798C253.762 62.4432 253.762 62.2171 253.899 62.0805C254.036 61.9439 254.262 61.9439 254.398 62.0805C254.535 62.2171 254.54 62.4432 254.398 62.5798Z"
        fill="#324A52"
      />
      <path
        d="M257.735 59.2497C257.598 59.3863 257.372 59.3863 257.235 59.2497C257.099 59.1131 257.099 58.887 257.235 58.7504C257.372 58.6138 257.598 58.6138 257.735 58.7504C257.871 58.887 257.871 59.1131 257.735 59.2497Z"
        fill="#324A52"
      />
      <path
        d="M257.735 59.2497C257.598 59.3863 257.372 59.3863 257.235 59.2497C257.099 59.1131 257.099 58.887 257.235 58.7504C257.372 58.6138 257.598 58.6138 257.735 58.7504C257.871 58.887 257.871 59.1131 257.735 59.2497Z"
        fill="#324A52"
      />
      <path
        d="M261.066 55.9179C260.93 56.0545 260.704 56.0545 260.567 55.9179C260.43 55.7813 260.43 55.5552 260.567 55.4186C260.704 55.282 260.93 55.282 261.066 55.4186C261.203 55.5552 261.203 55.7766 261.066 55.9179Z"
        fill="#324A52"
      />
      <path
        d="M261.066 55.9179C260.93 56.0545 260.704 56.0545 260.567 55.9179C260.43 55.7813 260.43 55.5552 260.567 55.4186C260.704 55.282 260.93 55.282 261.066 55.4186C261.203 55.5552 261.203 55.7766 261.066 55.9179Z"
        fill="#324A52"
      />
      <path
        d="M200.836 109.334C201.032 109.334 201.19 109.176 201.19 108.98C201.19 108.785 201.032 108.627 200.836 108.627C200.641 108.627 200.483 108.785 200.483 108.98C200.483 109.176 200.641 109.334 200.836 109.334Z"
        fill="#324A52"
      />
      <path
        d="M200.836 109.334C201.032 109.334 201.19 109.176 201.19 108.98C201.19 108.785 201.032 108.627 200.836 108.627C200.641 108.627 200.483 108.785 200.483 108.98C200.483 109.176 200.641 109.334 200.836 109.334Z"
        fill="#324A52"
      />
      <path
        d="M204.168 105.999C204.363 105.999 204.521 105.841 204.521 105.646C204.521 105.451 204.363 105.293 204.168 105.293C203.973 105.293 203.815 105.451 203.815 105.646C203.815 105.841 203.973 105.999 204.168 105.999Z"
        fill="#324A52"
      />
      <path
        d="M204.168 105.999C204.363 105.999 204.521 105.841 204.521 105.646C204.521 105.451 204.363 105.293 204.168 105.293C203.973 105.293 203.815 105.451 203.815 105.646C203.815 105.841 203.973 105.999 204.168 105.999Z"
        fill="#324A52"
      />
      <path
        d="M207.5 102.669C207.695 102.669 207.853 102.511 207.853 102.316C207.853 102.121 207.695 101.963 207.5 101.963C207.305 101.963 207.146 102.121 207.146 102.316C207.146 102.511 207.305 102.669 207.5 102.669Z"
        fill="#324A52"
      />
      <path
        d="M207.5 102.669C207.695 102.669 207.853 102.511 207.853 102.316C207.853 102.121 207.695 101.963 207.5 101.963C207.305 101.963 207.146 102.121 207.146 102.316C207.146 102.511 207.305 102.669 207.5 102.669Z"
        fill="#324A52"
      />
      <path
        d="M210.831 99.3359C211.026 99.3359 211.185 99.1778 211.185 98.9827C211.185 98.7876 211.026 98.6294 210.831 98.6294C210.636 98.6294 210.478 98.7876 210.478 98.9827C210.478 99.1778 210.636 99.3359 210.831 99.3359Z"
        fill="#324A52"
      />
      <path
        d="M210.831 99.3359C211.026 99.3359 211.185 99.1778 211.185 98.9827C211.185 98.7876 211.026 98.6294 210.831 98.6294C210.636 98.6294 210.478 98.7876 210.478 98.9827C210.478 99.1778 210.636 99.3359 210.831 99.3359Z"
        fill="#324A52"
      />
      <path
        d="M214.163 96.0058C214.358 96.0058 214.516 95.8476 214.516 95.6525C214.516 95.4574 214.358 95.2992 214.163 95.2992C213.968 95.2992 213.81 95.4574 213.81 95.6525C213.81 95.8476 213.968 96.0058 214.163 96.0058Z"
        fill="#324A52"
      />
      <path
        d="M214.163 96.0058C214.358 96.0058 214.516 95.8476 214.516 95.6525C214.516 95.4574 214.358 95.2992 214.163 95.2992C213.968 95.2992 213.81 95.4574 213.81 95.6525C213.81 95.8476 213.968 96.0058 214.163 96.0058Z"
        fill="#324A52"
      />
      <path
        d="M217.495 92.6741C217.69 92.6741 217.849 92.5159 217.849 92.3208C217.849 92.1257 217.69 91.9675 217.495 91.9675C217.3 91.9675 217.142 92.1257 217.142 92.3208C217.142 92.5159 217.3 92.6741 217.495 92.6741Z"
        fill="#324A52"
      />
      <path
        d="M217.495 92.6741C217.69 92.6741 217.849 92.5159 217.849 92.3208C217.849 92.1257 217.69 91.9675 217.495 91.9675C217.3 91.9675 217.142 92.1257 217.142 92.3208C217.142 92.5159 217.3 92.6741 217.495 92.6741Z"
        fill="#324A52"
      />
      <path
        d="M220.827 89.3423C221.022 89.3423 221.18 89.1842 221.18 88.9891C221.18 88.7939 221.022 88.6358 220.827 88.6358C220.631 88.6358 220.473 88.7939 220.473 88.9891C220.473 89.1842 220.631 89.3423 220.827 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M220.827 89.3423C221.022 89.3423 221.18 89.1842 221.18 88.9891C221.18 88.7939 221.022 88.6358 220.827 88.6358C220.631 88.6358 220.473 88.7939 220.473 88.9891C220.473 89.1842 220.631 89.3423 220.827 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M224.413 85.9074C224.276 86.044 224.05 86.044 223.913 85.9074C223.777 85.7708 223.777 85.5447 223.913 85.4081C224.05 85.2715 224.276 85.2715 224.413 85.4081C224.549 85.5447 224.549 85.7661 224.413 85.9074Z"
        fill="#324A52"
      />
      <path
        d="M224.413 85.9074C224.276 86.044 224.05 86.044 223.913 85.9074C223.777 85.7708 223.777 85.5447 223.913 85.4081C224.05 85.2715 224.276 85.2715 224.413 85.4081C224.549 85.5447 224.549 85.7661 224.413 85.9074Z"
        fill="#324A52"
      />
      <path
        d="M227.495 82.6795C227.69 82.6795 227.848 82.5213 227.848 82.3262C227.848 82.1311 227.69 81.9729 227.495 81.9729C227.3 81.9729 227.141 82.1311 227.141 82.3262C227.141 82.5213 227.3 82.6795 227.495 82.6795Z"
        fill="#324A52"
      />
      <path
        d="M227.495 82.6795C227.69 82.6795 227.848 82.5213 227.848 82.3262C227.848 82.1311 227.69 81.9729 227.495 81.9729C227.3 81.9729 227.141 82.1311 227.141 82.3262C227.141 82.5213 227.3 82.6795 227.495 82.6795Z"
        fill="#324A52"
      />
      <path
        d="M230.827 79.3446C231.022 79.3446 231.18 79.1864 231.18 78.9913C231.18 78.7962 231.022 78.638 230.827 78.638C230.631 78.638 230.473 78.7962 230.473 78.9913C230.473 79.1864 230.631 79.3446 230.827 79.3446Z"
        fill="#324A52"
      />
      <path
        d="M230.827 79.3446C231.022 79.3446 231.18 79.1864 231.18 78.9913C231.18 78.7962 231.022 78.638 230.827 78.638C230.631 78.638 230.473 78.7962 230.473 78.9913C230.473 79.1864 230.631 79.3446 230.827 79.3446Z"
        fill="#324A52"
      />
      <path
        d="M234.408 75.9071C234.271 76.0437 234.045 76.0437 233.909 75.9071C233.772 75.7705 233.772 75.5444 233.909 75.4078C234.045 75.2712 234.271 75.2712 234.408 75.4078C234.545 75.5444 234.545 75.7705 234.408 75.9071Z"
        fill="#324A52"
      />
      <path
        d="M234.408 75.9071C234.271 76.0437 234.045 76.0437 233.909 75.9071C233.772 75.7705 233.772 75.5444 233.909 75.4078C234.045 75.2712 234.271 75.2712 234.408 75.4078C234.545 75.5444 234.545 75.7705 234.408 75.9071Z"
        fill="#324A52"
      />
      <path
        d="M237.49 72.6802C237.685 72.6802 237.843 72.522 237.843 72.3269C237.843 72.1318 237.685 71.9736 237.49 71.9736C237.295 71.9736 237.136 72.1318 237.136 72.3269C237.136 72.522 237.295 72.6802 237.49 72.6802Z"
        fill="#324A52"
      />
      <path
        d="M237.49 72.6802C237.685 72.6802 237.843 72.522 237.843 72.3269C237.843 72.1318 237.685 71.9736 237.49 71.9736C237.295 71.9736 237.136 72.1318 237.136 72.3269C237.136 72.522 237.295 72.6802 237.49 72.6802Z"
        fill="#324A52"
      />
      <path
        d="M241.072 69.2436C240.935 69.3802 240.709 69.3802 240.572 69.2436C240.435 69.107 240.435 68.8809 240.572 68.7443C240.709 68.6077 240.935 68.6077 241.072 68.7443C241.208 68.8809 241.208 69.107 241.072 69.2436Z"
        fill="#324A52"
      />
      <path
        d="M241.072 69.2436C240.935 69.3802 240.709 69.3802 240.572 69.2436C240.435 69.107 240.435 68.8809 240.572 68.7443C240.709 68.6077 240.935 68.6077 241.072 68.7443C241.208 68.8809 241.208 69.107 241.072 69.2436Z"
        fill="#324A52"
      />
      <path
        d="M244.403 65.9135C244.266 66.0501 244.04 66.0501 243.903 65.9135C243.767 65.7769 243.767 65.5508 243.903 65.4142C244.04 65.2776 244.266 65.2776 244.403 65.4142C244.539 65.5508 244.539 65.7769 244.403 65.9135Z"
        fill="#324A52"
      />
      <path
        d="M244.403 65.9135C244.266 66.0501 244.04 66.0501 243.903 65.9135C243.767 65.7769 243.767 65.5508 243.903 65.4142C244.04 65.2776 244.266 65.2776 244.403 65.4142C244.539 65.5508 244.539 65.7769 244.403 65.9135Z"
        fill="#324A52"
      />
      <path
        d="M247.484 62.6834C247.68 62.6834 247.838 62.5252 247.838 62.3301C247.838 62.135 247.68 61.9768 247.484 61.9768C247.289 61.9768 247.131 62.135 247.131 62.3301C247.131 62.5252 247.289 62.6834 247.484 62.6834Z"
        fill="#324A52"
      />
      <path
        d="M247.484 62.6834C247.68 62.6834 247.838 62.5252 247.838 62.3301C247.838 62.135 247.68 61.9768 247.484 61.9768C247.289 61.9768 247.131 62.135 247.131 62.3301C247.131 62.5252 247.289 62.6834 247.484 62.6834Z"
        fill="#324A52"
      />
      <path
        d="M251.066 59.2501C250.93 59.3867 250.703 59.3867 250.567 59.2501C250.43 59.1135 250.43 58.8874 250.567 58.7508C250.703 58.6142 250.93 58.6142 251.066 58.7508C251.208 58.8874 251.208 59.1135 251.066 59.2501Z"
        fill="#324A52"
      />
      <path
        d="M251.066 59.2501C250.93 59.3867 250.703 59.3867 250.567 59.2501C250.43 59.1135 250.43 58.8874 250.567 58.7508C250.703 58.6142 250.93 58.6142 251.066 58.7508C251.208 58.8874 251.208 59.1135 251.066 59.2501Z"
        fill="#324A52"
      />
      <path
        d="M254.398 55.9183C254.261 56.0549 254.035 56.0549 253.899 55.9183C253.762 55.7817 253.762 55.5556 253.899 55.419C254.035 55.2824 254.261 55.2824 254.398 55.419C254.535 55.5556 254.539 55.777 254.398 55.9183Z"
        fill="#324A52"
      />
      <path
        d="M254.398 55.9183C254.261 56.0549 254.035 56.0549 253.899 55.9183C253.762 55.7817 253.762 55.5556 253.899 55.419C254.035 55.2824 254.261 55.2824 254.398 55.419C254.535 55.5556 254.539 55.777 254.398 55.9183Z"
        fill="#324A52"
      />
      <path
        d="M257.485 52.6904C257.68 52.6904 257.838 52.5322 257.838 52.3371C257.838 52.142 257.68 51.9839 257.485 51.9839C257.29 51.9839 257.131 52.142 257.131 52.3371C257.131 52.5322 257.29 52.6904 257.485 52.6904Z"
        fill="#324A52"
      />
      <path
        d="M257.485 52.6904C257.68 52.6904 257.838 52.5322 257.838 52.3371C257.838 52.142 257.68 51.9839 257.485 51.9839C257.29 51.9839 257.131 52.142 257.131 52.3371C257.131 52.5322 257.29 52.6904 257.485 52.6904Z"
        fill="#324A52"
      />
      <path
        d="M197.505 105.997C197.7 105.997 197.859 105.839 197.859 105.644C197.859 105.449 197.7 105.291 197.505 105.291C197.31 105.291 197.152 105.449 197.152 105.644C197.152 105.839 197.31 105.997 197.505 105.997Z"
        fill="#324A52"
      />
      <path
        d="M197.505 105.997C197.7 105.997 197.859 105.839 197.859 105.644C197.859 105.449 197.7 105.291 197.505 105.291C197.31 105.291 197.152 105.449 197.152 105.644C197.152 105.839 197.31 105.997 197.505 105.997Z"
        fill="#324A52"
      />
      <path
        d="M200.837 102.669C201.032 102.669 201.19 102.51 201.19 102.315C201.19 102.12 201.032 101.962 200.837 101.962C200.641 101.962 200.483 102.12 200.483 102.315C200.483 102.51 200.641 102.669 200.837 102.669Z"
        fill="#324A52"
      />
      <path
        d="M200.837 102.669C201.032 102.669 201.19 102.51 201.19 102.315C201.19 102.12 201.032 101.962 200.837 101.962C200.641 101.962 200.483 102.12 200.483 102.315C200.483 102.51 200.641 102.669 200.837 102.669Z"
        fill="#324A52"
      />
      <path
        d="M204.169 99.3354C204.364 99.3354 204.522 99.1772 204.522 98.9821C204.522 98.787 204.364 98.6288 204.169 98.6288C203.974 98.6288 203.815 98.787 203.815 98.9821C203.815 99.1772 203.974 99.3354 204.169 99.3354Z"
        fill="#324A52"
      />
      <path
        d="M204.169 99.3354C204.364 99.3354 204.522 99.1772 204.522 98.9821C204.522 98.787 204.364 98.6288 204.169 98.6288C203.974 98.6288 203.815 98.787 203.815 98.9821C203.815 99.1772 203.974 99.3354 204.169 99.3354Z"
        fill="#324A52"
      />
      <path
        d="M207.5 96.0052C207.695 96.0052 207.853 95.8471 207.853 95.652C207.853 95.4569 207.695 95.2987 207.5 95.2987C207.304 95.2987 207.146 95.4569 207.146 95.652C207.146 95.8471 207.304 96.0052 207.5 96.0052Z"
        fill="#324A52"
      />
      <path
        d="M207.5 96.0052C207.695 96.0052 207.853 95.8471 207.853 95.652C207.853 95.4569 207.695 95.2987 207.5 95.2987C207.304 95.2987 207.146 95.4569 207.146 95.652C207.146 95.8471 207.304 96.0052 207.5 96.0052Z"
        fill="#324A52"
      />
      <path
        d="M210.832 92.671C211.027 92.671 211.185 92.5128 211.185 92.3177C211.185 92.1226 211.027 91.9644 210.832 91.9644C210.636 91.9644 210.478 92.1226 210.478 92.3177C210.478 92.5128 210.636 92.671 210.832 92.671Z"
        fill="#324A52"
      />
      <path
        d="M210.832 92.671C211.027 92.671 211.185 92.5128 211.185 92.3177C211.185 92.1226 211.027 91.9644 210.832 91.9644C210.636 91.9644 210.478 92.1226 210.478 92.3177C210.478 92.5128 210.636 92.671 210.832 92.671Z"
        fill="#324A52"
      />
      <path
        d="M214.163 89.3418C214.359 89.3418 214.517 89.1836 214.517 88.9885C214.517 88.7934 214.359 88.6352 214.163 88.6352C213.968 88.6352 213.81 88.7934 213.81 88.9885C213.81 89.1836 213.968 89.3418 214.163 89.3418Z"
        fill="#324A52"
      />
      <path
        d="M214.163 89.3418C214.359 89.3418 214.517 89.1836 214.517 88.9885C214.517 88.7934 214.359 88.6352 214.163 88.6352C213.968 88.6352 213.81 88.7934 213.81 88.9885C213.81 89.1836 213.968 89.3418 214.163 89.3418Z"
        fill="#324A52"
      />
      <path
        d="M217.495 86.0107C217.69 86.0107 217.848 85.8525 217.848 85.6574C217.848 85.4623 217.69 85.3041 217.495 85.3041C217.3 85.3041 217.142 85.4623 217.142 85.6574C217.142 85.8525 217.3 86.0107 217.495 86.0107Z"
        fill="#324A52"
      />
      <path
        d="M217.495 86.0107C217.69 86.0107 217.848 85.8525 217.848 85.6574C217.848 85.4623 217.69 85.3041 217.495 85.3041C217.3 85.3041 217.142 85.4623 217.142 85.6574C217.142 85.8525 217.3 86.0107 217.495 86.0107Z"
        fill="#324A52"
      />
      <path
        d="M220.827 82.679C221.022 82.679 221.18 82.5208 221.18 82.3257C221.18 82.1306 221.022 81.9724 220.827 81.9724C220.632 81.9724 220.473 82.1306 220.473 82.3257C220.473 82.5208 220.632 82.679 220.827 82.679Z"
        fill="#324A52"
      />
      <path
        d="M220.827 82.679C221.022 82.679 221.18 82.5208 221.18 82.3257C221.18 82.1306 221.022 81.9724 220.827 81.9724C220.632 81.9724 220.473 82.1306 220.473 82.3257C220.473 82.5208 220.632 82.679 220.827 82.679Z"
        fill="#324A52"
      />
      <path
        d="M224.413 79.2392C224.276 79.3758 224.05 79.3758 223.914 79.2392C223.777 79.1026 223.777 78.8765 223.914 78.7399C224.05 78.6033 224.276 78.6033 224.413 78.7399C224.55 78.8765 224.55 79.1026 224.413 79.2392Z"
        fill="#324A52"
      />
      <path
        d="M224.413 79.2392C224.276 79.3758 224.05 79.3758 223.914 79.2392C223.777 79.1026 223.777 78.8765 223.914 78.7399C224.05 78.6033 224.276 78.6033 224.413 78.7399C224.55 78.8765 224.55 79.1026 224.413 79.2392Z"
        fill="#324A52"
      />
      <path
        d="M227.745 75.9066C227.608 76.0432 227.382 76.0432 227.245 75.9066C227.108 75.77 227.108 75.5439 227.245 75.4073C227.382 75.2707 227.608 75.2707 227.745 75.4073C227.881 75.5486 227.881 75.77 227.745 75.9066Z"
        fill="#324A52"
      />
      <path
        d="M227.745 75.9066C227.608 76.0432 227.382 76.0432 227.245 75.9066C227.108 75.77 227.108 75.5439 227.245 75.4073C227.382 75.2707 227.608 75.2707 227.745 75.4073C227.881 75.5486 227.881 75.77 227.745 75.9066Z"
        fill="#324A52"
      />
      <path
        d="M230.827 72.6796C231.022 72.6796 231.18 72.5215 231.18 72.3264C231.18 72.1312 231.022 71.9731 230.827 71.9731C230.632 71.9731 230.474 72.1312 230.474 72.3264C230.474 72.5215 230.632 72.6796 230.827 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M230.827 72.6796C231.022 72.6796 231.18 72.5215 231.18 72.3264C231.18 72.1312 231.022 71.9731 230.827 71.9731C230.632 71.9731 230.474 72.1312 230.474 72.3264C230.474 72.5215 230.632 72.6796 230.827 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M234.408 69.2431C234.271 69.3797 234.045 69.3797 233.908 69.2431C233.772 69.1065 233.772 68.8804 233.908 68.7438C234.045 68.6072 234.271 68.6072 234.408 68.7438C234.544 68.8804 234.544 69.1065 234.408 69.2431Z"
        fill="#324A52"
      />
      <path
        d="M234.408 69.2431C234.271 69.3797 234.045 69.3797 233.908 69.2431C233.772 69.1065 233.772 68.8804 233.908 68.7438C234.045 68.6072 234.271 68.6072 234.408 68.7438C234.544 68.8804 234.544 69.1065 234.408 69.2431Z"
        fill="#324A52"
      />
      <path
        d="M237.74 65.9114C237.603 66.048 237.377 66.048 237.24 65.9114C237.104 65.7748 237.104 65.5487 237.24 65.4121C237.377 65.2755 237.603 65.2755 237.74 65.4121C237.877 65.5487 237.877 65.7748 237.74 65.9114Z"
        fill="#324A52"
      />
      <path
        d="M237.74 65.9114C237.603 66.048 237.377 66.048 237.24 65.9114C237.104 65.7748 237.104 65.5487 237.24 65.4121C237.377 65.2755 237.603 65.2755 237.74 65.4121C237.877 65.5487 237.877 65.7748 237.74 65.9114Z"
        fill="#324A52"
      />
      <path
        d="M241.071 62.5796C240.935 62.7162 240.708 62.7162 240.572 62.5796C240.435 62.443 240.435 62.2169 240.572 62.0803C240.708 61.9437 240.935 61.9437 241.071 62.0803C241.208 62.2169 241.208 62.443 241.071 62.5796Z"
        fill="#324A52"
      />
      <path
        d="M241.071 62.5796C240.935 62.7162 240.708 62.7162 240.572 62.5796C240.435 62.443 240.435 62.2169 240.572 62.0803C240.708 61.9437 240.935 61.9437 241.071 62.0803C241.208 62.2169 241.208 62.443 241.071 62.5796Z"
        fill="#324A52"
      />
      <path
        d="M244.403 59.2479C244.266 59.3845 244.04 59.3845 243.904 59.2479C243.767 59.1113 243.767 58.8852 243.904 58.7486C244.04 58.612 244.266 58.612 244.403 58.7486C244.54 58.8852 244.54 59.1113 244.403 59.2479Z"
        fill="#324A52"
      />
      <path
        d="M244.403 59.2479C244.266 59.3845 244.04 59.3845 243.904 59.2479C243.767 59.1113 243.767 58.8852 243.904 58.7486C244.04 58.612 244.266 58.612 244.403 58.7486C244.54 58.8852 244.54 59.1113 244.403 59.2479Z"
        fill="#324A52"
      />
      <path
        d="M247.735 55.9177C247.598 56.0543 247.372 56.0543 247.235 55.9177C247.099 55.7811 247.099 55.555 247.235 55.4184C247.372 55.2818 247.598 55.2818 247.735 55.4184C247.871 55.555 247.876 55.7764 247.735 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M247.735 55.9177C247.598 56.0543 247.372 56.0543 247.235 55.9177C247.099 55.7811 247.099 55.555 247.235 55.4184C247.372 55.2818 247.598 55.2818 247.735 55.4184C247.871 55.555 247.876 55.7764 247.735 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M251.067 52.586C250.93 52.7226 250.704 52.7226 250.567 52.586C250.43 52.4494 250.43 52.2233 250.567 52.0867C250.704 51.9501 250.93 51.9501 251.067 52.0867C251.208 52.2233 251.208 52.4447 251.067 52.586Z"
        fill="#324A52"
      />
      <path
        d="M251.067 52.586C250.93 52.7226 250.704 52.7226 250.567 52.586C250.43 52.4494 250.43 52.2233 250.567 52.0867C250.704 51.9501 250.93 51.9501 251.067 52.0867C251.208 52.2233 251.208 52.4447 251.067 52.586Z"
        fill="#324A52"
      />
      <path
        d="M254.398 49.2543C254.262 49.3909 254.035 49.3909 253.899 49.2543C253.762 49.1177 253.762 48.8916 253.899 48.755C254.035 48.6184 254.262 48.6184 254.398 48.755C254.54 48.8916 254.54 49.113 254.398 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M254.398 49.2543C254.262 49.3909 254.035 49.3909 253.899 49.2543C253.762 49.1177 253.762 48.8916 253.899 48.755C254.035 48.6184 254.262 48.6184 254.398 48.755C254.54 48.8916 254.54 49.113 254.398 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M194.174 102.669C194.369 102.669 194.527 102.511 194.527 102.315C194.527 102.12 194.369 101.962 194.174 101.962C193.979 101.962 193.821 102.12 193.821 102.315C193.821 102.511 193.979 102.669 194.174 102.669Z"
        fill="#324A52"
      />
      <path
        d="M194.174 102.669C194.369 102.669 194.527 102.511 194.527 102.315C194.527 102.12 194.369 101.962 194.174 101.962C193.979 101.962 193.821 102.12 193.821 102.315C193.821 102.511 193.979 102.669 194.174 102.669Z"
        fill="#324A52"
      />
      <path
        d="M197.506 99.3355C197.701 99.3355 197.859 99.1773 197.859 98.9822C197.859 98.7871 197.701 98.6289 197.506 98.6289C197.31 98.6289 197.152 98.7871 197.152 98.9822C197.152 99.1773 197.31 99.3355 197.506 99.3355Z"
        fill="#324A52"
      />
      <path
        d="M197.506 99.3355C197.701 99.3355 197.859 99.1773 197.859 98.9822C197.859 98.7871 197.701 98.6289 197.506 98.6289C197.31 98.6289 197.152 98.7871 197.152 98.9822C197.152 99.1773 197.31 99.3355 197.506 99.3355Z"
        fill="#324A52"
      />
      <path
        d="M200.837 96.0053C201.032 96.0053 201.191 95.8472 201.191 95.652C201.191 95.4569 201.032 95.2988 200.837 95.2988C200.642 95.2988 200.484 95.4569 200.484 95.652C200.484 95.8472 200.642 96.0053 200.837 96.0053Z"
        fill="#324A52"
      />
      <path
        d="M200.837 96.0053C201.032 96.0053 201.191 95.8472 201.191 95.652C201.191 95.4569 201.032 95.2988 200.837 95.2988C200.642 95.2988 200.484 95.4569 200.484 95.652C200.484 95.8472 200.642 96.0053 200.837 96.0053Z"
        fill="#324A52"
      />
      <path
        d="M204.169 92.6736C204.364 92.6736 204.522 92.5154 204.522 92.3203C204.522 92.1252 204.364 91.967 204.169 91.967C203.974 91.967 203.815 92.1252 203.815 92.3203C203.815 92.5154 203.974 92.6736 204.169 92.6736Z"
        fill="#324A52"
      />
      <path
        d="M204.169 92.6736C204.364 92.6736 204.522 92.5154 204.522 92.3203C204.522 92.1252 204.364 91.967 204.169 91.967C203.974 91.967 203.815 92.1252 203.815 92.3203C203.815 92.5154 203.974 92.6736 204.169 92.6736Z"
        fill="#324A52"
      />
      <path
        d="M207.5 89.3419C207.695 89.3419 207.853 89.1837 207.853 88.9886C207.853 88.7935 207.695 88.6353 207.5 88.6353C207.305 88.6353 207.147 88.7935 207.147 88.9886C207.147 89.1837 207.305 89.3419 207.5 89.3419Z"
        fill="#324A52"
      />
      <path
        d="M207.5 89.3419C207.695 89.3419 207.853 89.1837 207.853 88.9886C207.853 88.7935 207.695 88.6353 207.5 88.6353C207.305 88.6353 207.147 88.7935 207.147 88.9886C207.147 89.1837 207.305 89.3419 207.5 89.3419Z"
        fill="#324A52"
      />
      <path
        d="M210.832 86.0108C211.027 86.0108 211.185 85.8526 211.185 85.6575C211.185 85.4624 211.027 85.3042 210.832 85.3042C210.637 85.3042 210.478 85.4624 210.478 85.6575C210.478 85.8526 210.637 86.0108 210.832 86.0108Z"
        fill="#324A52"
      />
      <path
        d="M210.832 86.0108C211.027 86.0108 211.185 85.8526 211.185 85.6575C211.185 85.4624 211.027 85.3042 210.832 85.3042C210.637 85.3042 210.478 85.4624 210.478 85.6575C210.478 85.8526 210.637 86.0108 210.832 86.0108Z"
        fill="#324A52"
      />
      <path
        d="M214.164 82.679C214.359 82.679 214.517 82.5208 214.517 82.3257C214.517 82.1306 214.359 81.9725 214.164 81.9725C213.969 81.9725 213.81 82.1306 213.81 82.3257C213.81 82.5208 213.969 82.679 214.164 82.679Z"
        fill="#324A52"
      />
      <path
        d="M214.164 82.679C214.359 82.679 214.517 82.5208 214.517 82.3257C214.517 82.1306 214.359 81.9725 214.164 81.9725C213.969 81.9725 213.81 82.1306 213.81 82.3257C213.81 82.5208 213.969 82.679 214.164 82.679Z"
        fill="#324A52"
      />
      <path
        d="M217.495 79.3441C217.69 79.3441 217.848 79.1859 217.848 78.9908C217.848 78.7957 217.69 78.6376 217.495 78.6376C217.3 78.6376 217.142 78.7957 217.142 78.9908C217.142 79.1859 217.3 79.3441 217.495 79.3441Z"
        fill="#324A52"
      />
      <path
        d="M217.495 79.3441C217.69 79.3441 217.848 79.1859 217.848 78.9908C217.848 78.7957 217.69 78.6376 217.495 78.6376C217.3 78.6376 217.142 78.7957 217.142 78.9908C217.142 79.1859 217.3 79.3441 217.495 79.3441Z"
        fill="#324A52"
      />
      <path
        d="M221.077 75.9076C220.94 76.0442 220.714 76.0442 220.577 75.9076C220.441 75.771 220.441 75.5449 220.577 75.4083C220.714 75.2717 220.94 75.2717 221.077 75.4083C221.213 75.5449 221.218 75.771 221.077 75.9076Z"
        fill="#324A52"
      />
      <path
        d="M221.077 75.9076C220.94 76.0442 220.714 76.0442 220.577 75.9076C220.441 75.771 220.441 75.5449 220.577 75.4083C220.714 75.2717 220.94 75.2717 221.077 75.4083C221.213 75.5449 221.218 75.771 221.077 75.9076Z"
        fill="#324A52"
      />
      <path
        d="M224.413 72.5765C224.277 72.7131 224.051 72.7131 223.914 72.5765C223.777 72.4399 223.777 72.2138 223.914 72.0772C224.051 71.9406 224.277 71.9406 224.413 72.0772C224.55 72.2138 224.55 72.4399 224.413 72.5765Z"
        fill="#324A52"
      />
      <path
        d="M224.413 72.5765C224.277 72.7131 224.051 72.7131 223.914 72.5765C223.777 72.4399 223.777 72.2138 223.914 72.0772C224.051 71.9406 224.277 71.9406 224.413 72.0772C224.55 72.2138 224.55 72.4399 224.413 72.5765Z"
        fill="#324A52"
      />
      <path
        d="M227.495 69.3479C227.69 69.3479 227.849 69.1898 227.849 68.9947C227.849 68.7995 227.69 68.6414 227.495 68.6414C227.3 68.6414 227.142 68.7995 227.142 68.9947C227.142 69.1898 227.3 69.3479 227.495 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M227.495 69.3479C227.69 69.3479 227.849 69.1898 227.849 68.9947C227.849 68.7995 227.69 68.6414 227.495 68.6414C227.3 68.6414 227.142 68.7995 227.142 68.9947C227.142 69.1898 227.3 69.3479 227.495 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M231.077 65.913C230.94 66.0496 230.714 66.0496 230.577 65.913C230.441 65.7764 230.441 65.5503 230.577 65.4137C230.714 65.2771 230.94 65.2771 231.077 65.4137C231.213 65.5503 231.213 65.7764 231.077 65.913Z"
        fill="#324A52"
      />
      <path
        d="M231.077 65.913C230.94 66.0496 230.714 66.0496 230.577 65.913C230.441 65.7764 230.441 65.5503 230.577 65.4137C230.714 65.2771 230.94 65.2771 231.077 65.4137C231.213 65.5503 231.213 65.7764 231.077 65.913Z"
        fill="#324A52"
      />
      <path
        d="M234.408 62.5829C234.272 62.7195 234.046 62.7195 233.909 62.5829C233.772 62.4463 233.772 62.2202 233.909 62.0836C234.046 61.947 234.272 61.947 234.408 62.0836C234.545 62.2202 234.545 62.4463 234.408 62.5829Z"
        fill="#324A52"
      />
      <path
        d="M234.408 62.5829C234.272 62.7195 234.046 62.7195 233.909 62.5829C233.772 62.4463 233.772 62.2202 233.909 62.0836C234.046 61.947 234.272 61.947 234.408 62.0836C234.545 62.2202 234.545 62.4463 234.408 62.5829Z"
        fill="#324A52"
      />
      <path
        d="M237.74 59.2496C237.603 59.3862 237.377 59.3862 237.24 59.2496C237.103 59.113 237.103 58.8869 237.24 58.7503C237.377 58.6137 237.603 58.6137 237.74 58.7503C237.876 58.8869 237.876 59.113 237.74 59.2496Z"
        fill="#324A52"
      />
      <path
        d="M237.74 59.2496C237.603 59.3862 237.377 59.3862 237.24 59.2496C237.103 59.113 237.103 58.8869 237.24 58.7503C237.377 58.6137 237.603 58.6137 237.74 58.7503C237.876 58.8869 237.876 59.113 237.74 59.2496Z"
        fill="#324A52"
      />
      <path
        d="M241.072 55.9178C240.935 56.0544 240.709 56.0544 240.572 55.9178C240.436 55.7812 240.436 55.5551 240.572 55.4185C240.709 55.2819 240.935 55.2819 241.072 55.4185C241.209 55.5551 241.209 55.7765 241.072 55.9178Z"
        fill="#324A52"
      />
      <path
        d="M241.072 55.9178C240.935 56.0544 240.709 56.0544 240.572 55.9178C240.436 55.7812 240.436 55.5551 240.572 55.4185C240.709 55.2819 240.935 55.2819 241.072 55.4185C241.209 55.5551 241.209 55.7765 241.072 55.9178Z"
        fill="#324A52"
      />
      <path
        d="M244.403 52.5861C244.267 52.7227 244.041 52.7227 243.904 52.5861C243.767 52.4495 243.767 52.2234 243.904 52.0868C244.041 51.9502 244.267 51.9502 244.403 52.0868C244.54 52.2234 244.54 52.4448 244.403 52.5861Z"
        fill="#324A52"
      />
      <path
        d="M244.403 52.5861C244.267 52.7227 244.041 52.7227 243.904 52.5861C243.767 52.4495 243.767 52.2234 243.904 52.0868C244.041 51.9502 244.267 51.9502 244.403 52.0868C244.54 52.2234 244.54 52.4448 244.403 52.5861Z"
        fill="#324A52"
      />
      <path
        d="M247.735 49.2559C247.598 49.3925 247.372 49.3925 247.235 49.2559C247.098 49.1193 247.098 48.8932 247.235 48.7566C247.372 48.62 247.598 48.62 247.735 48.7566C247.876 48.8932 247.876 49.1146 247.735 49.2559Z"
        fill="#324A52"
      />
      <path
        d="M247.735 49.2559C247.598 49.3925 247.372 49.3925 247.235 49.2559C247.098 49.1193 247.098 48.8932 247.235 48.7566C247.372 48.62 247.598 48.62 247.735 48.7566C247.876 48.8932 247.876 49.1146 247.735 49.2559Z"
        fill="#324A52"
      />
      <path
        d="M251.067 45.9185C250.931 46.0551 250.704 46.0551 250.568 45.9185C250.431 45.7819 250.431 45.5558 250.568 45.4192C250.704 45.2826 250.931 45.2826 251.067 45.4192C251.209 45.5605 251.209 45.7819 251.067 45.9185Z"
        fill="#324A52"
      />
      <path
        d="M251.067 45.9185C250.931 46.0551 250.704 46.0551 250.568 45.9185C250.431 45.7819 250.431 45.5558 250.568 45.4192C250.704 45.2826 250.931 45.2826 251.067 45.4192C251.209 45.5605 251.209 45.7819 251.067 45.9185Z"
        fill="#324A52"
      />
      <path
        d="M190.838 99.3354C191.033 99.3354 191.191 99.1772 191.191 98.9821C191.191 98.787 191.033 98.6288 190.838 98.6288C190.642 98.6288 190.484 98.787 190.484 98.9821C190.484 99.1772 190.642 99.3354 190.838 99.3354Z"
        fill="#324A52"
      />
      <path
        d="M190.838 99.3354C191.033 99.3354 191.191 99.1772 191.191 98.9821C191.191 98.787 191.033 98.6288 190.838 98.6288C190.642 98.6288 190.484 98.787 190.484 98.9821C190.484 99.1772 190.642 99.3354 190.838 99.3354Z"
        fill="#324A52"
      />
      <path
        d="M194.174 96.0052C194.37 96.0052 194.528 95.8471 194.528 95.652C194.528 95.4569 194.37 95.2987 194.174 95.2987C193.979 95.2987 193.821 95.4569 193.821 95.652C193.821 95.8471 193.979 96.0052 194.174 96.0052Z"
        fill="#324A52"
      />
      <path
        d="M194.174 96.0052C194.37 96.0052 194.528 95.8471 194.528 95.652C194.528 95.4569 194.37 95.2987 194.174 95.2987C193.979 95.2987 193.821 95.4569 193.821 95.652C193.821 95.8471 193.979 96.0052 194.174 96.0052Z"
        fill="#324A52"
      />
      <path
        d="M197.506 92.6735C197.701 92.6735 197.859 92.5153 197.859 92.3202C197.859 92.1251 197.701 91.9669 197.506 91.9669C197.311 91.9669 197.152 92.1251 197.152 92.3202C197.152 92.5153 197.311 92.6735 197.506 92.6735Z"
        fill="#324A52"
      />
      <path
        d="M197.506 92.6735C197.701 92.6735 197.859 92.5153 197.859 92.3202C197.859 92.1251 197.701 91.9669 197.506 91.9669C197.311 91.9669 197.152 92.1251 197.152 92.3202C197.152 92.5153 197.311 92.6735 197.506 92.6735Z"
        fill="#324A52"
      />
      <path
        d="M200.837 89.3418C201.032 89.3418 201.19 89.1836 201.19 88.9885C201.19 88.7934 201.032 88.6352 200.837 88.6352C200.642 88.6352 200.483 88.7934 200.483 88.9885C200.483 89.1836 200.642 89.3418 200.837 89.3418Z"
        fill="#324A52"
      />
      <path
        d="M200.837 89.3418C201.032 89.3418 201.19 89.1836 201.19 88.9885C201.19 88.7934 201.032 88.6352 200.837 88.6352C200.642 88.6352 200.483 88.7934 200.483 88.9885C200.483 89.1836 200.642 89.3418 200.837 89.3418Z"
        fill="#324A52"
      />
      <path
        d="M204.169 86.0107C204.364 86.0107 204.522 85.8525 204.522 85.6574C204.522 85.4623 204.364 85.3041 204.169 85.3041C203.974 85.3041 203.816 85.4623 203.816 85.6574C203.816 85.8525 203.974 86.0107 204.169 86.0107Z"
        fill="#324A52"
      />
      <path
        d="M204.169 86.0107C204.364 86.0107 204.522 85.8525 204.522 85.6574C204.522 85.4623 204.364 85.3041 204.169 85.3041C203.974 85.3041 203.816 85.4623 203.816 85.6574C203.816 85.8525 203.974 86.0107 204.169 86.0107Z"
        fill="#324A52"
      />
      <path
        d="M207.5 82.6789C207.696 82.6789 207.854 82.5208 207.854 82.3257C207.854 82.1305 207.696 81.9724 207.5 81.9724C207.305 81.9724 207.147 82.1305 207.147 82.3257C207.147 82.5208 207.305 82.6789 207.5 82.6789Z"
        fill="#324A52"
      />
      <path
        d="M207.5 82.6789C207.696 82.6789 207.854 82.5208 207.854 82.3257C207.854 82.1305 207.696 81.9724 207.5 81.9724C207.305 81.9724 207.147 82.1305 207.147 82.3257C207.147 82.5208 207.305 82.6789 207.5 82.6789Z"
        fill="#324A52"
      />
      <path
        d="M210.832 79.344C211.027 79.344 211.185 79.1859 211.185 78.9908C211.185 78.7956 211.027 78.6375 210.832 78.6375C210.637 78.6375 210.478 78.7956 210.478 78.9908C210.478 79.1859 210.637 79.344 210.832 79.344Z"
        fill="#324A52"
      />
      <path
        d="M210.832 79.344C211.027 79.344 211.185 79.1859 211.185 78.9908C211.185 78.7956 211.027 78.6375 210.832 78.6375C210.637 78.6375 210.478 78.7956 210.478 78.9908C210.478 79.1859 210.637 79.344 210.832 79.344Z"
        fill="#324A52"
      />
      <path
        d="M214.414 75.9065C214.277 76.0431 214.051 76.0431 213.914 75.9065C213.777 75.7699 213.777 75.5438 213.914 75.4072C214.051 75.2706 214.277 75.2706 214.414 75.4072C214.55 75.5486 214.55 75.7699 214.414 75.9065Z"
        fill="#324A52"
      />
      <path
        d="M214.414 75.9065C214.277 76.0431 214.051 76.0431 213.914 75.9065C213.777 75.7699 213.777 75.5438 213.914 75.4072C214.051 75.2706 214.277 75.2706 214.414 75.4072C214.55 75.5486 214.55 75.7699 214.414 75.9065Z"
        fill="#324A52"
      />
      <path
        d="M217.496 72.6796C217.691 72.6796 217.849 72.5215 217.849 72.3263C217.849 72.1312 217.691 71.9731 217.496 71.9731C217.301 71.9731 217.143 72.1312 217.143 72.3263C217.143 72.5215 217.301 72.6796 217.496 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M217.496 72.6796C217.691 72.6796 217.849 72.5215 217.849 72.3263C217.849 72.1312 217.691 71.9731 217.496 71.9731C217.301 71.9731 217.143 72.1312 217.143 72.3263C217.143 72.5215 217.301 72.6796 217.496 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M220.827 69.3479C221.022 69.3479 221.181 69.1897 221.181 68.9946C221.181 68.7995 221.022 68.6413 220.827 68.6413C220.632 68.6413 220.474 68.7995 220.474 68.9946C220.474 69.1897 220.632 69.3479 220.827 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M220.827 69.3479C221.022 69.3479 221.181 69.1897 221.181 68.9946C221.181 68.7995 221.022 68.6413 220.827 68.6413C220.632 68.6413 220.474 68.7995 220.474 68.9946C220.474 69.1897 220.632 69.3479 220.827 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M224.413 65.9129C224.277 66.0495 224.051 66.0495 223.914 65.9129C223.777 65.7763 223.777 65.5502 223.914 65.4136C224.051 65.277 224.277 65.277 224.413 65.4136C224.55 65.5502 224.55 65.7763 224.413 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M224.413 65.9129C224.277 66.0495 224.051 66.0495 223.914 65.9129C223.777 65.7763 223.777 65.5502 223.914 65.4136C224.051 65.277 224.277 65.277 224.413 65.4136C224.55 65.5502 224.55 65.7763 224.413 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M227.495 62.6828C227.69 62.6828 227.849 62.5247 227.849 62.3296C227.849 62.1344 227.69 61.9763 227.495 61.9763C227.3 61.9763 227.142 62.1344 227.142 62.3296C227.142 62.5247 227.3 62.6828 227.495 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M227.495 62.6828C227.69 62.6828 227.849 62.5247 227.849 62.3296C227.849 62.1344 227.69 61.9763 227.495 61.9763C227.3 61.9763 227.142 62.1344 227.142 62.3296C227.142 62.5247 227.3 62.6828 227.495 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M231.077 59.2495C230.94 59.3861 230.714 59.3861 230.577 59.2495C230.441 59.1129 230.441 58.8868 230.577 58.7502C230.714 58.6136 230.94 58.6136 231.077 58.7502C231.214 58.8868 231.214 59.1129 231.077 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M231.077 59.2495C230.94 59.3861 230.714 59.3861 230.577 59.2495C230.441 59.1129 230.441 58.8868 230.577 58.7502C230.714 58.6136 230.94 58.6136 231.077 58.7502C231.214 58.8868 231.214 59.1129 231.077 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M234.408 55.9177C234.272 56.0543 234.046 56.0543 233.909 55.9177C233.772 55.7811 233.772 55.555 233.909 55.4184C234.046 55.2818 234.272 55.2818 234.408 55.4184C234.545 55.555 234.545 55.7764 234.408 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M234.408 55.9177C234.272 56.0543 234.046 56.0543 233.909 55.9177C233.772 55.7811 233.772 55.555 233.909 55.4184C234.046 55.2818 234.272 55.2818 234.408 55.4184C234.545 55.555 234.545 55.7764 234.408 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M237.49 52.6899C237.685 52.6899 237.844 52.5317 237.844 52.3366C237.844 52.1415 237.685 51.9833 237.49 51.9833C237.295 51.9833 237.137 52.1415 237.137 52.3366C237.137 52.5317 237.295 52.6899 237.49 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M237.49 52.6899C237.685 52.6899 237.844 52.5317 237.844 52.3366C237.844 52.1415 237.685 51.9833 237.49 51.9833C237.295 51.9833 237.137 52.1415 237.137 52.3366C237.137 52.5317 237.295 52.6899 237.49 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M241.072 49.2543C240.935 49.3909 240.709 49.3909 240.572 49.2543C240.436 49.1177 240.436 48.8916 240.572 48.755C240.709 48.6184 240.935 48.6184 241.072 48.755C241.209 48.8916 241.209 49.113 241.072 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M241.072 49.2543C240.935 49.3909 240.709 49.3909 240.572 49.2543C240.436 49.1177 240.436 48.8916 240.572 48.755C240.709 48.6184 240.935 48.6184 241.072 48.755C241.209 48.8916 241.209 49.113 241.072 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M244.403 45.9175C244.267 46.0541 244.041 46.0541 243.904 45.9175C243.767 45.7809 243.767 45.5548 243.904 45.4182C244.041 45.2816 244.267 45.2816 244.403 45.4182C244.54 45.5548 244.54 45.7809 244.403 45.9175Z"
        fill="#324A52"
      />
      <path
        d="M244.403 45.9175C244.267 46.0541 244.041 46.0541 243.904 45.9175C243.767 45.7809 243.767 45.5548 243.904 45.4182C244.041 45.2816 244.267 45.2816 244.403 45.4182C244.54 45.5548 244.54 45.7809 244.403 45.9175Z"
        fill="#324A52"
      />
      <path
        d="M247.486 42.6915C247.681 42.6915 247.839 42.5333 247.839 42.3382C247.839 42.1431 247.681 41.9849 247.486 41.9849C247.29 41.9849 247.132 42.1431 247.132 42.3382C247.132 42.5333 247.29 42.6915 247.486 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M247.486 42.6915C247.681 42.6915 247.839 42.5333 247.839 42.3382C247.839 42.1431 247.681 41.9849 247.486 41.9849C247.29 41.9849 247.132 42.1431 247.132 42.3382C247.132 42.5333 247.29 42.6915 247.486 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M187.506 96.0058C187.701 96.0058 187.859 95.8476 187.859 95.6525C187.859 95.4574 187.701 95.2993 187.506 95.2993C187.311 95.2993 187.152 95.4574 187.152 95.6525C187.152 95.8476 187.311 96.0058 187.506 96.0058Z"
        fill="#324A52"
      />
      <path
        d="M187.506 96.0058C187.701 96.0058 187.859 95.8476 187.859 95.6525C187.859 95.4574 187.701 95.2993 187.506 95.2993C187.311 95.2993 187.152 95.4574 187.152 95.6525C187.152 95.8476 187.311 96.0058 187.506 96.0058Z"
        fill="#324A52"
      />
      <path
        d="M190.838 92.6741C191.033 92.6741 191.191 92.5159 191.191 92.3208C191.191 92.1257 191.033 91.9675 190.838 91.9675C190.642 91.9675 190.484 92.1257 190.484 92.3208C190.484 92.5159 190.642 92.6741 190.838 92.6741Z"
        fill="#324A52"
      />
      <path
        d="M190.838 92.6741C191.033 92.6741 191.191 92.5159 191.191 92.3208C191.191 92.1257 191.033 91.9675 190.838 91.9675C190.642 91.9675 190.484 92.1257 190.484 92.3208C190.484 92.5159 190.642 92.6741 190.838 92.6741Z"
        fill="#324A52"
      />
      <path
        d="M194.174 89.3423C194.369 89.3423 194.527 89.1842 194.527 88.9891C194.527 88.7939 194.369 88.6358 194.174 88.6358C193.979 88.6358 193.821 88.7939 193.821 88.9891C193.821 89.1842 193.979 89.3423 194.174 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M194.174 89.3423C194.369 89.3423 194.527 89.1842 194.527 88.9891C194.527 88.7939 194.369 88.6358 194.174 88.6358C193.979 88.6358 193.821 88.7939 193.821 88.9891C193.821 89.1842 193.979 89.3423 194.174 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M197.505 86.0112C197.7 86.0112 197.859 85.8531 197.859 85.658C197.859 85.4629 197.7 85.3047 197.505 85.3047C197.31 85.3047 197.152 85.4629 197.152 85.658C197.152 85.8531 197.31 86.0112 197.505 86.0112Z"
        fill="#324A52"
      />
      <path
        d="M197.505 86.0112C197.7 86.0112 197.859 85.8531 197.859 85.658C197.859 85.4629 197.7 85.3047 197.505 85.3047C197.31 85.3047 197.152 85.4629 197.152 85.658C197.152 85.8531 197.31 86.0112 197.505 86.0112Z"
        fill="#324A52"
      />
      <path
        d="M200.837 82.6795C201.032 82.6795 201.19 82.5213 201.19 82.3262C201.19 82.1311 201.032 81.9729 200.837 81.9729C200.642 81.9729 200.483 82.1311 200.483 82.3262C200.483 82.5213 200.642 82.6795 200.837 82.6795Z"
        fill="#324A52"
      />
      <path
        d="M200.837 82.6795C201.032 82.6795 201.19 82.5213 201.19 82.3262C201.19 82.1311 201.032 81.9729 200.837 81.9729C200.642 81.9729 200.483 82.1311 200.483 82.3262C200.483 82.5213 200.642 82.6795 200.837 82.6795Z"
        fill="#324A52"
      />
      <path
        d="M204.168 79.3446C204.364 79.3446 204.522 79.1864 204.522 78.9913C204.522 78.7962 204.364 78.638 204.168 78.638C203.973 78.638 203.815 78.7962 203.815 78.9913C203.815 79.1864 203.973 79.3446 204.168 79.3446Z"
        fill="#324A52"
      />
      <path
        d="M204.168 79.3446C204.364 79.3446 204.522 79.1864 204.522 78.9913C204.522 78.7962 204.364 78.638 204.168 78.638C203.973 78.638 203.815 78.7962 203.815 78.9913C203.815 79.1864 203.973 79.3446 204.168 79.3446Z"
        fill="#324A52"
      />
      <path
        d="M207.75 75.9081C207.613 76.0447 207.387 76.0447 207.251 75.9081C207.114 75.7715 207.114 75.5454 207.251 75.4088C207.387 75.2722 207.613 75.2722 207.75 75.4088C207.887 75.5501 207.887 75.7715 207.75 75.9081Z"
        fill="#324A52"
      />
      <path
        d="M207.75 75.9081C207.613 76.0447 207.387 76.0447 207.251 75.9081C207.114 75.7715 207.114 75.5454 207.251 75.4088C207.387 75.2722 207.613 75.2722 207.75 75.4088C207.887 75.5501 207.887 75.7715 207.75 75.9081Z"
        fill="#324A52"
      />
      <path
        d="M210.832 72.6802C211.027 72.6802 211.185 72.522 211.185 72.3269C211.185 72.1318 211.027 71.9736 210.832 71.9736C210.637 71.9736 210.478 72.1318 210.478 72.3269C210.478 72.522 210.637 72.6802 210.832 72.6802Z"
        fill="#324A52"
      />
      <path
        d="M210.832 72.6802C211.027 72.6802 211.185 72.522 211.185 72.3269C211.185 72.1318 211.027 71.9736 210.832 71.9736C210.637 71.9736 210.478 72.1318 210.478 72.3269C210.478 72.522 210.637 72.6802 210.832 72.6802Z"
        fill="#324A52"
      />
      <path
        d="M214.164 69.3484C214.359 69.3484 214.517 69.1902 214.517 68.9951C214.517 68.8 214.359 68.6419 214.164 68.6419C213.969 68.6419 213.81 68.8 213.81 68.9951C213.81 69.1902 213.969 69.3484 214.164 69.3484Z"
        fill="#324A52"
      />
      <path
        d="M214.164 69.3484C214.359 69.3484 214.517 69.1902 214.517 68.9951C214.517 68.8 214.359 68.6419 214.164 68.6419C213.969 68.6419 213.81 68.8 213.81 68.9951C213.81 69.1902 213.969 69.3484 214.164 69.3484Z"
        fill="#324A52"
      />
      <path
        d="M217.745 65.9135C217.608 66.0501 217.382 66.0501 217.245 65.9135C217.109 65.7769 217.109 65.5508 217.245 65.4142C217.382 65.2776 217.608 65.2776 217.745 65.4142C217.886 65.5508 217.886 65.7769 217.745 65.9135Z"
        fill="#324A52"
      />
      <path
        d="M217.745 65.9135C217.608 66.0501 217.382 66.0501 217.245 65.9135C217.109 65.7769 217.109 65.5508 217.245 65.4142C217.382 65.2776 217.608 65.2776 217.745 65.4142C217.886 65.5508 217.886 65.7769 217.745 65.9135Z"
        fill="#324A52"
      />
      <path
        d="M220.827 62.685C221.022 62.685 221.181 62.5268 221.181 62.3317C221.181 62.1366 221.022 61.9784 220.827 61.9784C220.632 61.9784 220.474 62.1366 220.474 62.3317C220.474 62.5268 220.632 62.685 220.827 62.685Z"
        fill="#324A52"
      />
      <path
        d="M220.827 62.685C221.022 62.685 221.181 62.5268 221.181 62.3317C221.181 62.1366 221.022 61.9784 220.827 61.9784C220.632 61.9784 220.474 62.1366 220.474 62.3317C220.474 62.5268 220.632 62.685 220.827 62.685Z"
        fill="#324A52"
      />
      <path
        d="M224.413 59.2501C224.276 59.3867 224.05 59.3867 223.914 59.2501C223.777 59.1135 223.777 58.8874 223.914 58.7508C224.05 58.6142 224.276 58.6142 224.413 58.7508C224.55 58.8874 224.55 59.1135 224.413 59.2501Z"
        fill="#324A52"
      />
      <path
        d="M224.413 59.2501C224.276 59.3867 224.05 59.3867 223.914 59.2501C223.777 59.1135 223.777 58.8874 223.914 58.7508C224.05 58.6142 224.276 58.6142 224.413 58.7508C224.55 58.8874 224.55 59.1135 224.413 59.2501Z"
        fill="#324A52"
      />
      <path
        d="M227.745 55.9183C227.608 56.0549 227.382 56.0549 227.245 55.9183C227.108 55.7817 227.108 55.5556 227.245 55.419C227.382 55.2824 227.608 55.2824 227.745 55.419C227.881 55.5556 227.881 55.777 227.745 55.9183Z"
        fill="#324A52"
      />
      <path
        d="M227.745 55.9183C227.608 56.0549 227.382 56.0549 227.245 55.9183C227.108 55.7817 227.108 55.5556 227.245 55.419C227.382 55.2824 227.608 55.2824 227.745 55.419C227.881 55.5556 227.881 55.777 227.745 55.9183Z"
        fill="#324A52"
      />
      <path
        d="M230.827 52.6904C231.022 52.6904 231.18 52.5322 231.18 52.3371C231.18 52.142 231.022 51.9839 230.827 51.9839C230.632 51.9839 230.474 52.142 230.474 52.3371C230.474 52.5322 230.632 52.6904 230.827 52.6904Z"
        fill="#324A52"
      />
      <path
        d="M230.827 52.6904C231.022 52.6904 231.18 52.5322 231.18 52.3371C231.18 52.142 231.022 51.9839 230.827 51.9839C230.632 51.9839 230.474 52.142 230.474 52.3371C230.474 52.5322 230.632 52.6904 230.827 52.6904Z"
        fill="#324A52"
      />
      <path
        d="M234.408 49.2564C234.271 49.393 234.045 49.393 233.908 49.2564C233.772 49.1198 233.772 48.8937 233.908 48.7571C234.045 48.6205 234.271 48.6205 234.408 48.7571C234.544 48.8937 234.544 49.1151 234.408 49.2564Z"
        fill="#324A52"
      />
      <path
        d="M234.408 49.2564C234.271 49.393 234.045 49.393 233.908 49.2564C233.772 49.1198 233.772 48.8937 233.908 48.7571C234.045 48.6205 234.271 48.6205 234.408 48.7571C234.544 48.8937 234.544 49.1151 234.408 49.2564Z"
        fill="#324A52"
      />
      <path
        d="M237.74 45.919C237.603 46.0556 237.377 46.0556 237.24 45.919C237.104 45.7824 237.104 45.5563 237.24 45.4197C237.377 45.2831 237.603 45.2831 237.74 45.4197C237.877 45.5563 237.877 45.7824 237.74 45.919Z"
        fill="#324A52"
      />
      <path
        d="M237.74 45.919C237.603 46.0556 237.377 46.0556 237.24 45.919C237.104 45.7824 237.104 45.5563 237.24 45.4197C237.377 45.2831 237.603 45.2831 237.74 45.4197C237.877 45.5563 237.877 45.7824 237.74 45.919Z"
        fill="#324A52"
      />
      <path
        d="M241.072 42.5888C240.935 42.7254 240.709 42.7254 240.572 42.5888C240.436 42.4522 240.436 42.2261 240.572 42.0895C240.709 41.9529 240.935 41.9529 241.072 42.0895C241.209 42.2308 241.209 42.4522 241.072 42.5888Z"
        fill="#324A52"
      />
      <path
        d="M241.072 42.5888C240.935 42.7254 240.709 42.7254 240.572 42.5888C240.436 42.4522 240.436 42.2261 240.572 42.0895C240.709 41.9529 240.935 41.9529 241.072 42.0895C241.209 42.2308 241.209 42.4522 241.072 42.5888Z"
        fill="#324A52"
      />
      <path
        d="M244.403 39.2561C244.266 39.3927 244.04 39.3927 243.904 39.2561C243.767 39.1195 243.767 38.8934 243.904 38.7568C244.04 38.6202 244.266 38.6202 244.403 38.7568C244.54 38.8934 244.54 39.1195 244.403 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M244.403 39.2561C244.266 39.3927 244.04 39.3927 243.904 39.2561C243.767 39.1195 243.767 38.8934 243.904 38.7568C244.04 38.6202 244.266 38.6202 244.403 38.7568C244.54 38.8934 244.54 39.1195 244.403 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M184.174 92.674C184.369 92.674 184.527 92.5158 184.527 92.3207C184.527 92.1256 184.369 91.9674 184.174 91.9674C183.978 91.9674 183.82 92.1256 183.82 92.3207C183.82 92.5158 183.978 92.674 184.174 92.674Z"
        fill="#324A52"
      />
      <path
        d="M184.174 92.674C184.369 92.674 184.527 92.5158 184.527 92.3207C184.527 92.1256 184.369 91.9674 184.174 91.9674C183.978 91.9674 183.82 92.1256 183.82 92.3207C183.82 92.5158 183.978 92.674 184.174 92.674Z"
        fill="#324A52"
      />
      <path
        d="M187.505 89.3423C187.7 89.3423 187.858 89.1841 187.858 88.989C187.858 88.7939 187.7 88.6357 187.505 88.6357C187.31 88.6357 187.151 88.7939 187.151 88.989C187.151 89.1841 187.31 89.3423 187.505 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M187.505 89.3423C187.7 89.3423 187.858 89.1841 187.858 88.989C187.858 88.7939 187.7 88.6357 187.505 88.6357C187.31 88.6357 187.151 88.7939 187.151 88.989C187.151 89.1841 187.31 89.3423 187.505 89.3423Z"
        fill="#324A52"
      />
      <path
        d="M190.837 86.0111C191.033 86.0111 191.191 85.853 191.191 85.6579C191.191 85.4628 191.033 85.3046 190.837 85.3046C190.642 85.3046 190.484 85.4628 190.484 85.6579C190.484 85.853 190.642 86.0111 190.837 86.0111Z"
        fill="#324A52"
      />
      <path
        d="M190.837 86.0111C191.033 86.0111 191.191 85.853 191.191 85.6579C191.191 85.4628 191.033 85.3046 190.837 85.3046C190.642 85.3046 190.484 85.4628 190.484 85.6579C190.484 85.853 190.642 86.0111 190.837 86.0111Z"
        fill="#324A52"
      />
      <path
        d="M194.173 82.6794C194.369 82.6794 194.527 82.5212 194.527 82.3261C194.527 82.131 194.369 81.9729 194.173 81.9729C193.978 81.9729 193.82 82.131 193.82 82.3261C193.82 82.5212 193.978 82.6794 194.173 82.6794Z"
        fill="#324A52"
      />
      <path
        d="M194.173 82.6794C194.369 82.6794 194.527 82.5212 194.527 82.3261C194.527 82.131 194.369 81.9729 194.173 81.9729C193.978 81.9729 193.82 82.131 193.82 82.3261C193.82 82.5212 193.978 82.6794 194.173 82.6794Z"
        fill="#324A52"
      />
      <path
        d="M197.505 79.3436C197.7 79.3436 197.858 79.1854 197.858 78.9903C197.858 78.7952 197.7 78.637 197.505 78.637C197.31 78.637 197.151 78.7952 197.151 78.9903C197.151 79.1854 197.31 79.3436 197.505 79.3436Z"
        fill="#324A52"
      />
      <path
        d="M197.505 79.3436C197.7 79.3436 197.858 79.1854 197.858 78.9903C197.858 78.7952 197.7 78.637 197.505 78.637C197.31 78.637 197.151 78.7952 197.151 78.9903C197.151 79.1854 197.31 79.3436 197.505 79.3436Z"
        fill="#324A52"
      />
      <path
        d="M201.087 75.907C200.95 76.0436 200.724 76.0436 200.587 75.907C200.45 75.7704 200.45 75.5443 200.587 75.4077C200.724 75.2711 200.95 75.2711 201.087 75.4077C201.223 75.549 201.223 75.7704 201.087 75.907Z"
        fill="#324A52"
      />
      <path
        d="M201.087 75.907C200.95 76.0436 200.724 76.0436 200.587 75.907C200.45 75.7704 200.45 75.5443 200.587 75.4077C200.724 75.2711 200.95 75.2711 201.087 75.4077C201.223 75.549 201.223 75.7704 201.087 75.907Z"
        fill="#324A52"
      />
      <path
        d="M204.169 72.6801C204.364 72.6801 204.522 72.5219 204.522 72.3268C204.522 72.1317 204.364 71.9735 204.169 71.9735C203.974 71.9735 203.815 72.1317 203.815 72.3268C203.815 72.5219 203.974 72.6801 204.169 72.6801Z"
        fill="#324A52"
      />
      <path
        d="M204.169 72.6801C204.364 72.6801 204.522 72.5219 204.522 72.3268C204.522 72.1317 204.364 71.9735 204.169 71.9735C203.974 71.9735 203.815 72.1317 203.815 72.3268C203.815 72.5219 203.974 72.6801 204.169 72.6801Z"
        fill="#324A52"
      />
      <path
        d="M207.5 69.3483C207.695 69.3483 207.853 69.1902 207.853 68.995C207.853 68.7999 207.695 68.6418 207.5 68.6418C207.304 68.6418 207.146 68.7999 207.146 68.995C207.146 69.1902 207.304 69.3483 207.5 69.3483Z"
        fill="#324A52"
      />
      <path
        d="M207.5 69.3483C207.695 69.3483 207.853 69.1902 207.853 68.995C207.853 68.7999 207.695 68.6418 207.5 68.6418C207.304 68.6418 207.146 68.7999 207.146 68.995C207.146 69.1902 207.304 69.3483 207.5 69.3483Z"
        fill="#324A52"
      />
      <path
        d="M211.081 65.9134C210.945 66.05 210.719 66.05 210.582 65.9134C210.445 65.7768 210.445 65.5507 210.582 65.4141C210.719 65.2775 210.945 65.2775 211.081 65.4141C211.218 65.5507 211.218 65.7768 211.081 65.9134Z"
        fill="#324A52"
      />
      <path
        d="M211.081 65.9134C210.945 66.05 210.719 66.05 210.582 65.9134C210.445 65.7768 210.445 65.5507 210.582 65.4141C210.719 65.2775 210.945 65.2775 211.081 65.4141C211.218 65.5507 211.218 65.7768 211.081 65.9134Z"
        fill="#324A52"
      />
      <path
        d="M214.164 62.6833C214.359 62.6833 214.517 62.5251 214.517 62.33C214.517 62.1349 214.359 61.9767 214.164 61.9767C213.969 61.9767 213.81 62.1349 213.81 62.33C213.81 62.5251 213.969 62.6833 214.164 62.6833Z"
        fill="#324A52"
      />
      <path
        d="M214.164 62.6833C214.359 62.6833 214.517 62.5251 214.517 62.33C214.517 62.1349 214.359 61.9767 214.164 61.9767C213.969 61.9767 213.81 62.1349 213.81 62.33C213.81 62.5251 213.969 62.6833 214.164 62.6833Z"
        fill="#324A52"
      />
      <path
        d="M217.745 59.25C217.608 59.3866 217.382 59.3866 217.245 59.25C217.109 59.1134 217.109 58.8873 217.245 58.7507C217.382 58.6141 217.608 58.6141 217.745 58.7507C217.886 58.8873 217.886 59.1134 217.745 59.25Z"
        fill="#324A52"
      />
      <path
        d="M217.745 59.25C217.608 59.3866 217.382 59.3866 217.245 59.25C217.109 59.1134 217.109 58.8873 217.245 58.7507C217.382 58.6141 217.608 58.6141 217.745 58.7507C217.886 58.8873 217.886 59.1134 217.745 59.25Z"
        fill="#324A52"
      />
      <path
        d="M221.076 55.9182C220.94 56.0548 220.714 56.0548 220.577 55.9182C220.44 55.7816 220.44 55.5555 220.577 55.4189C220.714 55.2823 220.94 55.2823 221.076 55.4189C221.213 55.5555 221.218 55.7769 221.076 55.9182Z"
        fill="#324A52"
      />
      <path
        d="M221.076 55.9182C220.94 56.0548 220.714 56.0548 220.577 55.9182C220.44 55.7816 220.44 55.5555 220.577 55.4189C220.714 55.2823 220.94 55.2823 221.076 55.4189C221.213 55.5555 221.218 55.7769 221.076 55.9182Z"
        fill="#324A52"
      />
      <path
        d="M224.413 52.5865C224.276 52.7231 224.05 52.7231 223.913 52.5865C223.777 52.4499 223.777 52.2238 223.913 52.0872C224.05 51.9506 224.276 51.9506 224.413 52.0872C224.549 52.2238 224.549 52.4452 224.413 52.5865Z"
        fill="#324A52"
      />
      <path
        d="M224.413 52.5865C224.276 52.7231 224.05 52.7231 223.913 52.5865C223.777 52.4499 223.777 52.2238 223.913 52.0872C224.05 51.9506 224.276 51.9506 224.413 52.0872C224.549 52.2238 224.549 52.4452 224.413 52.5865Z"
        fill="#324A52"
      />
      <path
        d="M227.745 49.2547C227.608 49.3913 227.382 49.3913 227.245 49.2547C227.108 49.1181 227.108 48.892 227.245 48.7554C227.382 48.6188 227.608 48.6188 227.745 48.7554C227.881 48.892 227.881 49.1134 227.745 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M227.745 49.2547C227.608 49.3913 227.382 49.3913 227.245 49.2547C227.108 49.1181 227.108 48.892 227.245 48.7554C227.382 48.6188 227.608 48.6188 227.745 48.7554C227.881 48.892 227.881 49.1134 227.745 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M231.077 45.9179C230.94 46.0545 230.714 46.0545 230.577 45.9179C230.44 45.7813 230.44 45.5552 230.577 45.4186C230.714 45.282 230.94 45.282 231.077 45.4186C231.213 45.5552 231.213 45.7813 231.077 45.9179Z"
        fill="#324A52"
      />
      <path
        d="M231.077 45.9179C230.94 46.0545 230.714 46.0545 230.577 45.9179C230.44 45.7813 230.44 45.5552 230.577 45.4186C230.714 45.282 230.94 45.282 231.077 45.4186C231.213 45.5552 231.213 45.7813 231.077 45.9179Z"
        fill="#324A52"
      />
      <path
        d="M234.408 42.5872C234.271 42.7238 234.045 42.7238 233.908 42.5872C233.772 42.4506 233.772 42.2245 233.908 42.0879C234.045 41.9513 234.271 41.9513 234.408 42.0879C234.544 42.2245 234.544 42.4506 234.408 42.5872Z"
        fill="#324A52"
      />
      <path
        d="M234.408 42.5872C234.271 42.7238 234.045 42.7238 233.908 42.5872C233.772 42.4506 233.772 42.2245 233.908 42.0879C234.045 41.9513 234.271 41.9513 234.408 42.0879C234.544 42.2245 234.544 42.4506 234.408 42.5872Z"
        fill="#324A52"
      />
      <path
        d="M237.74 39.2561C237.603 39.3927 237.377 39.3927 237.24 39.2561C237.103 39.1195 237.103 38.8934 237.24 38.7568C237.377 38.6202 237.603 38.6202 237.74 38.7568C237.876 38.8934 237.876 39.1195 237.74 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M237.74 39.2561C237.603 39.3927 237.377 39.3927 237.24 39.2561C237.103 39.1195 237.103 38.8934 237.24 38.7568C237.377 38.6202 237.603 38.6202 237.74 38.7568C237.876 38.8934 237.876 39.1195 237.74 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M241.071 35.9244C240.935 36.061 240.708 36.061 240.572 35.9244C240.435 35.7877 240.435 35.5616 240.572 35.425C240.708 35.2884 240.935 35.2884 241.071 35.425C241.208 35.5616 241.208 35.7877 241.071 35.9244Z"
        fill="#324A52"
      />
      <path
        d="M241.071 35.9244C240.935 36.061 240.708 36.061 240.572 35.9244C240.435 35.7877 240.435 35.5616 240.572 35.425C240.708 35.2884 240.935 35.2884 241.071 35.425C241.208 35.5616 241.208 35.7877 241.071 35.9244Z"
        fill="#324A52"
      />
      <path
        d="M180.842 89.342C181.038 89.342 181.196 89.1838 181.196 88.9887C181.196 88.7936 181.038 88.6355 180.842 88.6355C180.647 88.6355 180.489 88.7936 180.489 88.9887C180.489 89.1838 180.647 89.342 180.842 89.342Z"
        fill="#324A52"
      />
      <path
        d="M180.842 89.342C181.038 89.342 181.196 89.1838 181.196 88.9887C181.196 88.7936 181.038 88.6355 180.842 88.6355C180.647 88.6355 180.489 88.7936 180.489 88.9887C180.489 89.1838 180.647 89.342 180.842 89.342Z"
        fill="#324A52"
      />
      <path
        d="M184.174 86.0109C184.369 86.0109 184.527 85.8527 184.527 85.6576C184.527 85.4625 184.369 85.3043 184.174 85.3043C183.978 85.3043 183.82 85.4625 183.82 85.6576C183.82 85.8527 183.978 86.0109 184.174 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M184.174 86.0109C184.369 86.0109 184.527 85.8527 184.527 85.6576C184.527 85.4625 184.369 85.3043 184.174 85.3043C183.978 85.3043 183.82 85.4625 183.82 85.6576C183.82 85.8527 183.978 86.0109 184.174 86.0109Z"
        fill="#324A52"
      />
      <path
        d="M187.506 82.6792C187.701 82.6792 187.859 82.521 187.859 82.3259C187.859 82.1308 187.701 81.9726 187.506 81.9726C187.311 81.9726 187.152 82.1308 187.152 82.3259C187.152 82.521 187.311 82.6792 187.506 82.6792Z"
        fill="#324A52"
      />
      <path
        d="M187.506 82.6792C187.701 82.6792 187.859 82.521 187.859 82.3259C187.859 82.1308 187.701 81.9726 187.506 81.9726C187.311 81.9726 187.152 82.1308 187.152 82.3259C187.152 82.521 187.311 82.6792 187.506 82.6792Z"
        fill="#324A52"
      />
      <path
        d="M190.838 79.3443C191.033 79.3443 191.191 79.1861 191.191 78.991C191.191 78.7959 191.033 78.6377 190.838 78.6377C190.642 78.6377 190.484 78.7959 190.484 78.991C190.484 79.1861 190.642 79.3443 190.838 79.3443Z"
        fill="#324A52"
      />
      <path
        d="M190.838 79.3443C191.033 79.3443 191.191 79.1861 191.191 78.991C191.191 78.7959 191.033 78.6377 190.838 78.6377C190.642 78.6377 190.484 78.7959 190.484 78.991C190.484 79.1861 190.642 79.3443 190.838 79.3443Z"
        fill="#324A52"
      />
      <path
        d="M194.424 75.9077C194.287 76.0443 194.061 76.0443 193.924 75.9077C193.787 75.7711 193.787 75.545 193.924 75.4084C194.061 75.2718 194.287 75.2718 194.424 75.4084C194.56 75.5497 194.56 75.7711 194.424 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M194.424 75.9077C194.287 76.0443 194.061 76.0443 193.924 75.9077C193.787 75.7711 193.787 75.545 193.924 75.4084C194.061 75.2718 194.287 75.2718 194.424 75.4084C194.56 75.5497 194.56 75.7711 194.424 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M197.505 72.6799C197.7 72.6799 197.859 72.5217 197.859 72.3266C197.859 72.1315 197.7 71.9733 197.505 71.9733C197.31 71.9733 197.152 72.1315 197.152 72.3266C197.152 72.5217 197.31 72.6799 197.505 72.6799Z"
        fill="#324A52"
      />
      <path
        d="M197.505 72.6799C197.7 72.6799 197.859 72.5217 197.859 72.3266C197.859 72.1315 197.7 71.9733 197.505 71.9733C197.31 71.9733 197.152 72.1315 197.152 72.3266C197.152 72.5217 197.31 72.6799 197.505 72.6799Z"
        fill="#324A52"
      />
      <path
        d="M200.837 69.3481C201.032 69.3481 201.191 69.1899 201.191 68.9948C201.191 68.7997 201.032 68.6415 200.837 68.6415C200.642 68.6415 200.484 68.7997 200.484 68.9948C200.484 69.1899 200.642 69.3481 200.837 69.3481Z"
        fill="#324A52"
      />
      <path
        d="M200.837 69.3481C201.032 69.3481 201.191 69.1899 201.191 68.9948C201.191 68.7997 201.032 68.6415 200.837 68.6415C200.642 68.6415 200.484 68.7997 200.484 68.9948C200.484 69.1899 200.642 69.3481 200.837 69.3481Z"
        fill="#324A52"
      />
      <path
        d="M204.418 65.9132C204.282 66.0498 204.055 66.0498 203.919 65.9132C203.782 65.7766 203.782 65.5505 203.919 65.4139C204.055 65.2773 204.282 65.2773 204.418 65.4139C204.555 65.5505 204.555 65.7766 204.418 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M204.418 65.9132C204.282 66.0498 204.055 66.0498 203.919 65.9132C203.782 65.7766 203.782 65.5505 203.919 65.4139C204.055 65.2773 204.282 65.2773 204.418 65.4139C204.555 65.5505 204.555 65.7766 204.418 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M207.501 62.6847C207.696 62.6847 207.854 62.5265 207.854 62.3314C207.854 62.1363 207.696 61.9781 207.501 61.9781C207.305 61.9781 207.147 62.1363 207.147 62.3314C207.147 62.5265 207.305 62.6847 207.501 62.6847Z"
        fill="#324A52"
      />
      <path
        d="M207.501 62.6847C207.696 62.6847 207.854 62.5265 207.854 62.3314C207.854 62.1363 207.696 61.9781 207.501 61.9781C207.305 61.9781 207.147 62.1363 207.147 62.3314C207.147 62.5265 207.305 62.6847 207.501 62.6847Z"
        fill="#324A52"
      />
      <path
        d="M211.082 59.2498C210.945 59.3864 210.719 59.3864 210.582 59.2498C210.446 59.1132 210.446 58.8871 210.582 58.7505C210.719 58.6139 210.945 58.6139 211.082 58.7505C211.218 58.8871 211.218 59.1132 211.082 59.2498Z"
        fill="#324A52"
      />
      <path
        d="M211.082 59.2498C210.945 59.3864 210.719 59.3864 210.582 59.2498C210.446 59.1132 210.446 58.8871 210.582 58.7505C210.719 58.6139 210.945 58.6139 211.082 58.7505C211.218 58.8871 211.218 59.1132 211.082 59.2498Z"
        fill="#324A52"
      />
      <path
        d="M214.414 55.918C214.277 56.0546 214.051 56.0546 213.914 55.918C213.777 55.7814 213.777 55.5553 213.914 55.4187C214.051 55.2821 214.277 55.2821 214.414 55.4187C214.55 55.5553 214.55 55.7767 214.414 55.918Z"
        fill="#324A52"
      />
      <path
        d="M214.414 55.918C214.277 56.0546 214.051 56.0546 213.914 55.918C213.777 55.7814 213.777 55.5553 213.914 55.4187C214.051 55.2821 214.277 55.2821 214.414 55.4187C214.55 55.5553 214.55 55.7767 214.414 55.918Z"
        fill="#324A52"
      />
      <path
        d="M217.495 52.6901C217.691 52.6901 217.849 52.5319 217.849 52.3368C217.849 52.1417 217.691 51.9835 217.495 51.9835C217.3 51.9835 217.142 52.1417 217.142 52.3368C217.142 52.5319 217.3 52.6901 217.495 52.6901Z"
        fill="#324A52"
      />
      <path
        d="M217.495 52.6901C217.691 52.6901 217.849 52.5319 217.849 52.3368C217.849 52.1417 217.691 51.9835 217.495 51.9835C217.3 51.9835 217.142 52.1417 217.142 52.3368C217.142 52.5319 217.3 52.6901 217.495 52.6901Z"
        fill="#324A52"
      />
      <path
        d="M221.077 49.2561C220.94 49.3927 220.714 49.3927 220.578 49.2561C220.441 49.1195 220.441 48.8934 220.578 48.7568C220.714 48.6202 220.94 48.6202 221.077 48.7568C221.218 48.8934 221.218 49.1148 221.077 49.2561Z"
        fill="#324A52"
      />
      <path
        d="M221.077 49.2561C220.94 49.3927 220.714 49.3927 220.578 49.2561C220.441 49.1195 220.441 48.8934 220.578 48.7568C220.714 48.6202 220.94 48.6202 221.077 48.7568C221.218 48.8934 221.218 49.1148 221.077 49.2561Z"
        fill="#324A52"
      />
      <path
        d="M224.413 45.9186C224.277 46.0552 224.051 46.0552 223.914 45.9186C223.777 45.782 223.777 45.5559 223.914 45.4193C224.051 45.2827 224.277 45.2827 224.413 45.4193C224.55 45.5559 224.55 45.782 224.413 45.9186Z"
        fill="#324A52"
      />
      <path
        d="M224.413 45.9186C224.277 46.0552 224.051 46.0552 223.914 45.9186C223.777 45.782 223.777 45.5559 223.914 45.4193C224.051 45.2827 224.277 45.2827 224.413 45.4193C224.55 45.5559 224.55 45.782 224.413 45.9186Z"
        fill="#324A52"
      />
      <path
        d="M227.495 42.6917C227.69 42.6917 227.849 42.5336 227.849 42.3384C227.849 42.1433 227.69 41.9852 227.495 41.9852C227.3 41.9852 227.142 42.1433 227.142 42.3384C227.142 42.5336 227.3 42.6917 227.495 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M227.495 42.6917C227.69 42.6917 227.849 42.5336 227.849 42.3384C227.849 42.1433 227.69 41.9852 227.495 41.9852C227.3 41.9852 227.142 42.1433 227.142 42.3384C227.142 42.5336 227.3 42.6917 227.495 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M231.077 39.2558C230.94 39.3924 230.714 39.3924 230.577 39.2558C230.441 39.1192 230.441 38.8931 230.577 38.7565C230.714 38.6199 230.94 38.6199 231.077 38.7565C231.214 38.8931 231.214 39.1192 231.077 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M231.077 39.2558C230.94 39.3924 230.714 39.3924 230.577 39.2558C230.441 39.1192 230.441 38.8931 230.577 38.7565C230.714 38.6199 230.94 38.6199 231.077 38.7565C231.214 38.8931 231.214 39.1192 231.077 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M234.408 35.9251C234.272 36.0617 234.046 36.0617 233.909 35.9251C233.772 35.7885 233.772 35.5623 233.909 35.4257C234.046 35.2891 234.272 35.2891 234.408 35.4257C234.545 35.5623 234.545 35.7885 234.408 35.9251Z"
        fill="#324A52"
      />
      <path
        d="M234.408 35.9251C234.272 36.0617 234.046 36.0617 233.909 35.9251C233.772 35.7885 233.772 35.5623 233.909 35.4257C234.046 35.2891 234.272 35.2891 234.408 35.4257C234.545 35.5623 234.545 35.7885 234.408 35.9251Z"
        fill="#324A52"
      />
      <path
        d="M237.49 32.6956C237.685 32.6956 237.844 32.5374 237.844 32.3423C237.844 32.1472 237.685 31.989 237.49 31.989C237.295 31.989 237.137 32.1472 237.137 32.3423C237.137 32.5374 237.295 32.6956 237.49 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M237.49 32.6956C237.685 32.6956 237.844 32.5374 237.844 32.3423C237.844 32.1472 237.685 31.989 237.49 31.989C237.295 31.989 237.137 32.1472 237.137 32.3423C237.137 32.5374 237.295 32.6956 237.49 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M177.76 85.9071C177.623 86.0437 177.397 86.0437 177.26 85.9071C177.124 85.7705 177.124 85.5444 177.26 85.4078C177.397 85.2712 177.623 85.2712 177.76 85.4078C177.897 85.5444 177.897 85.7658 177.76 85.9071Z"
        fill="#324A52"
      />
      <path
        d="M177.76 85.9071C177.623 86.0437 177.397 86.0437 177.26 85.9071C177.124 85.7705 177.124 85.5444 177.26 85.4078C177.397 85.2712 177.623 85.2712 177.76 85.4078C177.897 85.5444 177.897 85.7658 177.76 85.9071Z"
        fill="#324A52"
      />
      <path
        d="M180.842 82.6793C181.037 82.6793 181.195 82.5211 181.195 82.326C181.195 82.1309 181.037 81.9727 180.842 81.9727C180.647 81.9727 180.489 82.1309 180.489 82.326C180.489 82.5211 180.647 82.6793 180.842 82.6793Z"
        fill="#324A52"
      />
      <path
        d="M180.842 82.6793C181.037 82.6793 181.195 82.5211 181.195 82.326C181.195 82.1309 181.037 81.9727 180.842 81.9727C180.647 81.9727 180.489 82.1309 180.489 82.326C180.489 82.5211 180.647 82.6793 180.842 82.6793Z"
        fill="#324A52"
      />
      <path
        d="M184.174 79.3434C184.369 79.3434 184.527 79.1852 184.527 78.9901C184.527 78.795 184.369 78.6368 184.174 78.6368C183.978 78.6368 183.82 78.795 183.82 78.9901C183.82 79.1852 183.978 79.3434 184.174 79.3434Z"
        fill="#324A52"
      />
      <path
        d="M184.174 79.3434C184.369 79.3434 184.527 79.1852 184.527 78.9901C184.527 78.795 184.369 78.6368 184.174 78.6368C183.978 78.6368 183.82 78.795 183.82 78.9901C183.82 79.1852 183.978 79.3434 184.174 79.3434Z"
        fill="#324A52"
      />
      <path
        d="M187.755 75.9069C187.619 76.0435 187.392 76.0435 187.256 75.9069C187.119 75.7703 187.119 75.5442 187.256 75.4076C187.392 75.271 187.619 75.271 187.755 75.4076C187.892 75.5442 187.897 75.7703 187.755 75.9069Z"
        fill="#324A52"
      />
      <path
        d="M187.755 75.9069C187.619 76.0435 187.392 76.0435 187.256 75.9069C187.119 75.7703 187.119 75.5442 187.256 75.4076C187.392 75.271 187.619 75.271 187.755 75.4076C187.892 75.5442 187.897 75.7703 187.755 75.9069Z"
        fill="#324A52"
      />
      <path
        d="M190.837 72.6799C191.032 72.6799 191.19 72.5218 191.19 72.3267C191.19 72.1315 191.032 71.9734 190.837 71.9734C190.642 71.9734 190.484 72.1315 190.484 72.3267C190.484 72.5218 190.642 72.6799 190.837 72.6799Z"
        fill="#324A52"
      />
      <path
        d="M190.837 72.6799C191.032 72.6799 191.19 72.5218 191.19 72.3267C191.19 72.1315 191.032 71.9734 190.837 71.9734C190.642 71.9734 190.484 72.1315 190.484 72.3267C190.484 72.5218 190.642 72.6799 190.837 72.6799Z"
        fill="#324A52"
      />
      <path
        d="M194.173 69.3482C194.369 69.3482 194.527 69.19 194.527 68.9949C194.527 68.7998 194.369 68.6416 194.173 68.6416C193.978 68.6416 193.82 68.7998 193.82 68.9949C193.82 69.19 193.978 69.3482 194.173 69.3482Z"
        fill="#324A52"
      />
      <path
        d="M194.173 69.3482C194.369 69.3482 194.527 69.19 194.527 68.9949C194.527 68.7998 194.369 68.6416 194.173 68.6416C193.978 68.6416 193.82 68.7998 193.82 68.9949C193.82 69.19 193.978 69.3482 194.173 69.3482Z"
        fill="#324A52"
      />
      <path
        d="M197.755 65.9132C197.618 66.0498 197.392 66.0498 197.255 65.9132C197.119 65.7766 197.119 65.5505 197.255 65.4139C197.392 65.2773 197.618 65.2773 197.755 65.4139C197.891 65.5505 197.891 65.7766 197.755 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M197.755 65.9132C197.618 66.0498 197.392 66.0498 197.255 65.9132C197.119 65.7766 197.119 65.5505 197.255 65.4139C197.392 65.2773 197.618 65.2773 197.755 65.4139C197.891 65.5505 197.891 65.7766 197.755 65.9132Z"
        fill="#324A52"
      />
      <path
        d="M200.837 62.6832C201.032 62.6832 201.19 62.525 201.19 62.3299C201.19 62.1348 201.032 61.9766 200.837 61.9766C200.642 61.9766 200.483 62.1348 200.483 62.3299C200.483 62.525 200.642 62.6832 200.837 62.6832Z"
        fill="#324A52"
      />
      <path
        d="M200.837 62.6832C201.032 62.6832 201.19 62.525 201.19 62.3299C201.19 62.1348 201.032 61.9766 200.837 61.9766C200.642 61.9766 200.483 62.1348 200.483 62.3299C200.483 62.525 200.642 62.6832 200.837 62.6832Z"
        fill="#324A52"
      />
      <path
        d="M204.418 59.2499C204.282 59.3865 204.055 59.3865 203.919 59.2499C203.782 59.1133 203.782 58.8871 203.919 58.7505C204.055 58.6139 204.282 58.6139 204.418 58.7505C204.555 58.8871 204.555 59.1133 204.418 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M204.418 59.2499C204.282 59.3865 204.055 59.3865 203.919 59.2499C203.782 59.1133 203.782 58.8871 203.919 58.7505C204.055 58.6139 204.282 58.6139 204.418 58.7505C204.555 58.8871 204.555 59.1133 204.418 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M207.75 55.918C207.613 56.0546 207.387 56.0546 207.25 55.918C207.113 55.7814 207.113 55.5553 207.25 55.4187C207.387 55.2821 207.613 55.2821 207.75 55.4187C207.886 55.5553 207.886 55.7767 207.75 55.918Z"
        fill="#324A52"
      />
      <path
        d="M207.75 55.918C207.613 56.0546 207.387 56.0546 207.25 55.918C207.113 55.7814 207.113 55.5553 207.25 55.4187C207.387 55.2821 207.613 55.2821 207.75 55.4187C207.886 55.5553 207.886 55.7767 207.75 55.918Z"
        fill="#324A52"
      />
      <path
        d="M210.832 52.6902C211.027 52.6902 211.185 52.532 211.185 52.3369C211.185 52.1418 211.027 51.9836 210.832 51.9836C210.637 51.9836 210.478 52.1418 210.478 52.3369C210.478 52.532 210.637 52.6902 210.832 52.6902Z"
        fill="#324A52"
      />
      <path
        d="M210.832 52.6902C211.027 52.6902 211.185 52.532 211.185 52.3369C211.185 52.1418 211.027 51.9836 210.832 51.9836C210.637 51.9836 210.478 52.1418 210.478 52.3369C210.478 52.532 210.637 52.6902 210.832 52.6902Z"
        fill="#324A52"
      />
      <path
        d="M214.413 49.2546C214.277 49.3912 214.05 49.3912 213.914 49.2546C213.777 49.118 213.777 48.8919 213.914 48.7553C214.05 48.6187 214.277 48.6187 214.413 48.7553C214.55 48.8919 214.55 49.1133 214.413 49.2546Z"
        fill="#324A52"
      />
      <path
        d="M214.413 49.2546C214.277 49.3912 214.05 49.3912 213.914 49.2546C213.777 49.118 213.777 48.8919 213.914 48.7553C214.05 48.6187 214.277 48.6187 214.413 48.7553C214.55 48.8919 214.55 49.1133 214.413 49.2546Z"
        fill="#324A52"
      />
      <path
        d="M217.745 45.9178C217.608 46.0544 217.382 46.0544 217.245 45.9178C217.109 45.7812 217.109 45.5551 217.245 45.4185C217.382 45.2819 217.608 45.2819 217.745 45.4185C217.886 45.5598 217.886 45.7812 217.745 45.9178Z"
        fill="#324A52"
      />
      <path
        d="M217.745 45.9178C217.608 46.0544 217.382 46.0544 217.245 45.9178C217.109 45.7812 217.109 45.5551 217.245 45.4185C217.382 45.2819 217.608 45.2819 217.745 45.4185C217.886 45.5598 217.886 45.7812 217.745 45.9178Z"
        fill="#324A52"
      />
      <path
        d="M220.827 42.6918C221.022 42.6918 221.181 42.5336 221.181 42.3385C221.181 42.1434 221.022 41.9852 220.827 41.9852C220.632 41.9852 220.474 42.1434 220.474 42.3385C220.474 42.5336 220.632 42.6918 220.827 42.6918Z"
        fill="#324A52"
      />
      <path
        d="M220.827 42.6918C221.022 42.6918 221.181 42.5336 221.181 42.3385C221.181 42.1434 221.022 41.9852 220.827 41.9852C220.632 41.9852 220.474 42.1434 220.474 42.3385C220.474 42.5336 220.632 42.6918 220.827 42.6918Z"
        fill="#324A52"
      />
      <path
        d="M224.413 39.2559C224.276 39.3925 224.05 39.3925 223.914 39.2559C223.777 39.1193 223.777 38.8932 223.914 38.7566C224.05 38.62 224.276 38.62 224.413 38.7566C224.55 38.8932 224.55 39.1193 224.413 39.2559Z"
        fill="#324A52"
      />
      <path
        d="M224.413 39.2559C224.276 39.3925 224.05 39.3925 223.914 39.2559C223.777 39.1193 223.777 38.8932 223.914 38.7566C224.05 38.62 224.276 38.62 224.413 38.7566C224.55 38.8932 224.55 39.1193 224.413 39.2559Z"
        fill="#324A52"
      />
      <path
        d="M227.495 36.0274C227.69 36.0274 227.848 35.8692 227.848 35.6741C227.848 35.479 227.69 35.3208 227.495 35.3208C227.3 35.3208 227.141 35.479 227.141 35.6741C227.141 35.8692 227.3 36.0274 227.495 36.0274Z"
        fill="#324A52"
      />
      <path
        d="M227.495 36.0274C227.69 36.0274 227.848 35.8692 227.848 35.6741C227.848 35.479 227.69 35.3208 227.495 35.3208C227.3 35.3208 227.141 35.479 227.141 35.6741C227.141 35.8692 227.3 36.0274 227.495 36.0274Z"
        fill="#324A52"
      />
      <path
        d="M230.827 32.6956C231.022 32.6956 231.18 32.5375 231.18 32.3424C231.18 32.1473 231.022 31.9891 230.827 31.9891C230.632 31.9891 230.473 32.1473 230.473 32.3424C230.473 32.5375 230.632 32.6956 230.827 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M230.827 32.6956C231.022 32.6956 231.18 32.5375 231.18 32.3424C231.18 32.1473 231.022 31.9891 230.827 31.9891C230.632 31.9891 230.473 32.1473 230.473 32.3424C230.473 32.5375 230.632 32.6956 230.827 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M234.408 29.2607C234.271 29.3973 234.045 29.3973 233.908 29.2607C233.772 29.1241 233.772 28.898 233.908 28.7614C234.045 28.6248 234.271 28.6248 234.408 28.7614C234.544 28.898 234.544 29.1241 234.408 29.2607Z"
        fill="#324A52"
      />
      <path
        d="M234.408 29.2607C234.271 29.3973 234.045 29.3973 233.908 29.2607C233.772 29.1241 233.772 28.898 233.908 28.7614C234.045 28.6248 234.271 28.6248 234.408 28.7614C234.544 28.898 234.544 29.1241 234.408 29.2607Z"
        fill="#324A52"
      />
      <path
        d="M174.179 82.679C174.374 82.679 174.533 82.5208 174.533 82.3257C174.533 82.1306 174.374 81.9725 174.179 81.9725C173.984 81.9725 173.826 82.1306 173.826 82.3257C173.826 82.5208 173.984 82.679 174.179 82.679Z"
        fill="#324A52"
      />
      <path
        d="M174.179 82.679C174.374 82.679 174.533 82.5208 174.533 82.3257C174.533 82.1306 174.374 81.9725 174.179 81.9725C173.984 81.9725 173.826 82.1306 173.826 82.3257C173.826 82.5208 173.984 82.679 174.179 82.679Z"
        fill="#324A52"
      />
      <path
        d="M177.761 79.2393C177.624 79.3759 177.398 79.3759 177.261 79.2393C177.124 79.1027 177.124 78.8766 177.261 78.74C177.398 78.6034 177.624 78.6034 177.761 78.74C177.897 78.8813 177.897 79.1027 177.761 79.2393Z"
        fill="#324A52"
      />
      <path
        d="M177.761 79.2393C177.624 79.3759 177.398 79.3759 177.261 79.2393C177.124 79.1027 177.124 78.8766 177.261 78.74C177.398 78.6034 177.624 78.6034 177.761 78.74C177.897 78.8813 177.897 79.1027 177.761 79.2393Z"
        fill="#324A52"
      />
      <path
        d="M181.092 75.9076C180.955 76.0442 180.729 76.0442 180.593 75.9076C180.456 75.771 180.456 75.5449 180.593 75.4083C180.729 75.2717 180.955 75.2717 181.092 75.4083C181.229 75.5496 181.229 75.771 181.092 75.9076Z"
        fill="#324A52"
      />
      <path
        d="M181.092 75.9076C180.955 76.0442 180.729 76.0442 180.593 75.9076C180.456 75.771 180.456 75.5449 180.593 75.4083C180.729 75.2717 180.955 75.2717 181.092 75.4083C181.229 75.5496 181.229 75.771 181.092 75.9076Z"
        fill="#324A52"
      />
      <path
        d="M184.174 72.6797C184.369 72.6797 184.528 72.5215 184.528 72.3264C184.528 72.1313 184.369 71.9731 184.174 71.9731C183.979 71.9731 183.821 72.1313 183.821 72.3264C183.821 72.5215 183.979 72.6797 184.174 72.6797Z"
        fill="#324A52"
      />
      <path
        d="M184.174 72.6797C184.369 72.6797 184.528 72.5215 184.528 72.3264C184.528 72.1313 184.369 71.9731 184.174 71.9731C183.979 71.9731 183.821 72.1313 183.821 72.3264C183.821 72.5215 183.979 72.6797 184.174 72.6797Z"
        fill="#324A52"
      />
      <path
        d="M187.506 69.3479C187.701 69.3479 187.859 69.1898 187.859 68.9946C187.859 68.7995 187.701 68.6414 187.506 68.6414C187.311 68.6414 187.152 68.7995 187.152 68.9946C187.152 69.1898 187.311 69.3479 187.506 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M187.506 69.3479C187.701 69.3479 187.859 69.1898 187.859 68.9946C187.859 68.7995 187.701 68.6414 187.506 68.6414C187.311 68.6414 187.152 68.7995 187.152 68.9946C187.152 69.1898 187.311 69.3479 187.506 69.3479Z"
        fill="#324A52"
      />
      <path
        d="M191.088 65.913C190.951 66.0496 190.725 66.0496 190.588 65.913C190.451 65.7764 190.451 65.5503 190.588 65.4137C190.725 65.2771 190.951 65.2771 191.088 65.4137C191.229 65.5503 191.229 65.7764 191.088 65.913Z"
        fill="#324A52"
      />
      <path
        d="M191.088 65.913C190.951 66.0496 190.725 66.0496 190.588 65.913C190.451 65.7764 190.451 65.5503 190.588 65.4137C190.725 65.2771 190.951 65.2771 191.088 65.4137C191.229 65.5503 191.229 65.7764 191.088 65.913Z"
        fill="#324A52"
      />
      <path
        d="M194.174 62.6845C194.37 62.6845 194.528 62.5263 194.528 62.3312C194.528 62.1361 194.37 61.9779 194.174 61.9779C193.979 61.9779 193.821 62.1361 193.821 62.3312C193.821 62.5263 193.979 62.6845 194.174 62.6845Z"
        fill="#324A52"
      />
      <path
        d="M194.174 62.6845C194.37 62.6845 194.528 62.5263 194.528 62.3312C194.528 62.1361 194.37 61.9779 194.174 61.9779C193.979 61.9779 193.821 62.1361 193.821 62.3312C193.821 62.5263 193.979 62.6845 194.174 62.6845Z"
        fill="#324A52"
      />
      <path
        d="M197.755 59.2496C197.618 59.3862 197.392 59.3862 197.256 59.2496C197.119 59.113 197.119 58.8869 197.256 58.7503C197.392 58.6137 197.618 58.6137 197.755 58.7503C197.892 58.8869 197.892 59.113 197.755 59.2496Z"
        fill="#324A52"
      />
      <path
        d="M197.755 59.2496C197.618 59.3862 197.392 59.3862 197.256 59.2496C197.119 59.113 197.119 58.8869 197.256 58.7503C197.392 58.6137 197.618 58.6137 197.755 58.7503C197.892 58.8869 197.892 59.113 197.755 59.2496Z"
        fill="#324A52"
      />
      <path
        d="M201.087 55.9178C200.95 56.0544 200.724 56.0544 200.587 55.9178C200.45 55.7812 200.45 55.5551 200.587 55.4185C200.724 55.2819 200.95 55.2819 201.087 55.4185C201.223 55.5551 201.223 55.7765 201.087 55.9178Z"
        fill="#324A52"
      />
      <path
        d="M201.087 55.9178C200.95 56.0544 200.724 56.0544 200.587 55.9178C200.45 55.7812 200.45 55.5551 200.587 55.4185C200.724 55.2819 200.95 55.2819 201.087 55.4185C201.223 55.5551 201.223 55.7765 201.087 55.9178Z"
        fill="#324A52"
      />
      <path
        d="M204.169 52.6899C204.365 52.6899 204.523 52.5318 204.523 52.3366C204.523 52.1415 204.365 51.9834 204.169 51.9834C203.974 51.9834 203.816 52.1415 203.816 52.3366C203.816 52.5318 203.974 52.6899 204.169 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M204.169 52.6899C204.365 52.6899 204.523 52.5318 204.523 52.3366C204.523 52.1415 204.365 51.9834 204.169 51.9834C203.974 51.9834 203.816 52.1415 203.816 52.3366C203.816 52.5318 203.974 52.6899 204.169 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M207.75 49.2559C207.613 49.3925 207.387 49.3925 207.251 49.2559C207.114 49.1193 207.114 48.8932 207.251 48.7566C207.387 48.62 207.613 48.62 207.75 48.7566C207.887 48.8932 207.887 49.1146 207.75 49.2559Z"
        fill="#324A52"
      />
      <path
        d="M207.75 49.2559C207.613 49.3925 207.387 49.3925 207.251 49.2559C207.114 49.1193 207.114 48.8932 207.251 48.7566C207.387 48.62 207.613 48.62 207.75 48.7566C207.887 48.8932 207.887 49.1146 207.75 49.2559Z"
        fill="#324A52"
      />
      <path
        d="M211.082 45.9185C210.945 46.0551 210.719 46.0551 210.582 45.9185C210.446 45.7819 210.446 45.5558 210.582 45.4192C210.719 45.2826 210.945 45.2826 211.082 45.4192C211.218 45.5558 211.218 45.7819 211.082 45.9185Z"
        fill="#324A52"
      />
      <path
        d="M211.082 45.9185C210.945 46.0551 210.719 46.0551 210.582 45.9185C210.446 45.7819 210.446 45.5558 210.582 45.4192C210.719 45.2826 210.945 45.2826 211.082 45.4192C211.218 45.5558 211.218 45.7819 211.082 45.9185Z"
        fill="#324A52"
      />
      <path
        d="M214.164 42.6916C214.359 42.6916 214.517 42.5334 214.517 42.3383C214.517 42.1432 214.359 41.985 214.164 41.985C213.969 41.985 213.81 42.1432 213.81 42.3383C213.81 42.5334 213.969 42.6916 214.164 42.6916Z"
        fill="#324A52"
      />
      <path
        d="M214.164 42.6916C214.359 42.6916 214.517 42.5334 214.517 42.3383C214.517 42.1432 214.359 41.985 214.164 41.985C213.969 41.985 213.81 42.1432 213.81 42.3383C213.81 42.5334 213.969 42.6916 214.164 42.6916Z"
        fill="#324A52"
      />
      <path
        d="M217.745 39.2557C217.609 39.3923 217.383 39.3923 217.246 39.2557C217.109 39.119 217.109 38.893 217.246 38.7564C217.383 38.6197 217.609 38.6197 217.745 38.7564C217.887 38.893 217.887 39.119 217.745 39.2557Z"
        fill="#324A52"
      />
      <path
        d="M217.745 39.2557C217.609 39.3923 217.383 39.3923 217.246 39.2557C217.109 39.119 217.109 38.893 217.246 38.7564C217.383 38.6197 217.609 38.6197 217.745 38.7564C217.887 38.893 217.887 39.119 217.745 39.2557Z"
        fill="#324A52"
      />
      <path
        d="M220.827 36.0271C221.023 36.0271 221.181 35.869 221.181 35.6738C221.181 35.4787 221.023 35.3206 220.827 35.3206C220.632 35.3206 220.474 35.4787 220.474 35.6738C220.474 35.869 220.632 36.0271 220.827 36.0271Z"
        fill="#324A52"
      />
      <path
        d="M220.827 36.0271C221.023 36.0271 221.181 35.869 221.181 35.6738C221.181 35.4787 221.023 35.3206 220.827 35.3206C220.632 35.3206 220.474 35.4787 220.474 35.6738C220.474 35.869 220.632 36.0271 220.827 36.0271Z"
        fill="#324A52"
      />
      <path
        d="M224.413 32.5922C224.277 32.7288 224.051 32.7288 223.914 32.5922C223.777 32.4556 223.777 32.2295 223.914 32.0929C224.051 31.9563 224.277 31.9563 224.413 32.0929C224.55 32.2295 224.55 32.4556 224.413 32.5922Z"
        fill="#324A52"
      />
      <path
        d="M224.413 32.5922C224.277 32.7288 224.051 32.7288 223.914 32.5922C223.777 32.4556 223.777 32.2295 223.914 32.0929C224.051 31.9563 224.277 31.9563 224.413 32.0929C224.55 32.2295 224.55 32.4556 224.413 32.5922Z"
        fill="#324A52"
      />
      <path
        d="M227.745 29.262C227.608 29.3986 227.382 29.3986 227.245 29.262C227.109 29.1254 227.109 28.8993 227.245 28.7627C227.382 28.6261 227.608 28.6261 227.745 28.7627C227.882 28.8993 227.882 29.1254 227.745 29.262Z"
        fill="#324A52"
      />
      <path
        d="M227.745 29.262C227.608 29.3986 227.382 29.3986 227.245 29.262C227.109 29.1254 227.109 28.8993 227.245 28.7627C227.382 28.6261 227.608 28.6261 227.745 28.7627C227.882 28.8993 227.882 29.1254 227.745 29.262Z"
        fill="#324A52"
      />
      <path
        d="M230.827 26.0319C231.022 26.0319 231.18 25.8738 231.18 25.6787C231.18 25.4835 231.022 25.3254 230.827 25.3254C230.632 25.3254 230.474 25.4835 230.474 25.6787C230.474 25.8738 230.632 26.0319 230.827 26.0319Z"
        fill="#324A52"
      />
      <path
        d="M230.827 26.0319C231.022 26.0319 231.18 25.8738 231.18 25.6787C231.18 25.4835 231.022 25.3254 230.827 25.3254C230.632 25.3254 230.474 25.4835 230.474 25.6787C230.474 25.8738 230.632 26.0319 230.827 26.0319Z"
        fill="#324A52"
      />
      <path
        d="M170.848 79.344C171.043 79.344 171.201 79.1858 171.201 78.9907C171.201 78.7956 171.043 78.6375 170.848 78.6375C170.652 78.6375 170.494 78.7956 170.494 78.9907C170.494 79.1858 170.652 79.344 170.848 79.344Z"
        fill="#324A52"
      />
      <path
        d="M170.848 79.344C171.043 79.344 171.201 79.1858 171.201 78.9907C171.201 78.7956 171.043 78.6375 170.848 78.6375C170.652 78.6375 170.494 78.7956 170.494 78.9907C170.494 79.1858 170.652 79.344 170.848 79.344Z"
        fill="#324A52"
      />
      <path
        d="M174.429 75.9065C174.293 76.0431 174.067 76.0431 173.93 75.9065C173.793 75.7699 173.793 75.5438 173.93 75.4072C174.067 75.2706 174.293 75.2706 174.429 75.4072C174.566 75.5438 174.566 75.7699 174.429 75.9065Z"
        fill="#324A52"
      />
      <path
        d="M174.429 75.9065C174.293 76.0431 174.067 76.0431 173.93 75.9065C173.793 75.7699 173.793 75.5438 173.93 75.4072C174.067 75.2706 174.293 75.2706 174.429 75.4072C174.566 75.5438 174.566 75.7699 174.429 75.9065Z"
        fill="#324A52"
      />
      <path
        d="M177.761 72.5764C177.624 72.713 177.398 72.713 177.261 72.5764C177.125 72.4398 177.125 72.2137 177.261 72.0771C177.398 71.9405 177.624 71.9405 177.761 72.0771C177.898 72.2184 177.898 72.4398 177.761 72.5764Z"
        fill="#324A52"
      />
      <path
        d="M177.761 72.5764C177.624 72.713 177.398 72.713 177.261 72.5764C177.125 72.4398 177.125 72.2137 177.261 72.0771C177.398 71.9405 177.624 71.9405 177.761 72.0771C177.898 72.2184 177.898 72.4398 177.761 72.5764Z"
        fill="#324A52"
      />
      <path
        d="M180.843 69.3478C181.038 69.3478 181.196 69.1897 181.196 68.9945C181.196 68.7994 181.038 68.6413 180.843 68.6413C180.647 68.6413 180.489 68.7994 180.489 68.9945C180.489 69.1897 180.647 69.3478 180.843 69.3478Z"
        fill="#324A52"
      />
      <path
        d="M180.843 69.3478C181.038 69.3478 181.196 69.1897 181.196 68.9945C181.196 68.7994 181.038 68.6413 180.843 68.6413C180.647 68.6413 180.489 68.7994 180.489 68.9945C180.489 69.1897 180.647 69.3478 180.843 69.3478Z"
        fill="#324A52"
      />
      <path
        d="M184.424 65.9129C184.288 66.0495 184.062 66.0495 183.925 65.9129C183.788 65.7763 183.788 65.5502 183.925 65.4136C184.062 65.277 184.288 65.277 184.424 65.4136C184.566 65.5502 184.566 65.7763 184.424 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M184.424 65.9129C184.288 66.0495 184.062 66.0495 183.925 65.9129C183.788 65.7763 183.788 65.5502 183.925 65.4136C184.062 65.277 184.288 65.277 184.424 65.4136C184.566 65.5502 184.566 65.7763 184.424 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M187.506 62.6828C187.702 62.6828 187.86 62.5246 187.86 62.3295C187.86 62.1344 187.702 61.9763 187.506 61.9763C187.311 61.9763 187.153 62.1344 187.153 62.3295C187.153 62.5246 187.311 62.6828 187.506 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M187.506 62.6828C187.702 62.6828 187.86 62.5246 187.86 62.3295C187.86 62.1344 187.702 61.9763 187.506 61.9763C187.311 61.9763 187.153 62.1344 187.153 62.3295C187.153 62.5246 187.311 62.6828 187.506 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M191.088 59.2495C190.951 59.3861 190.725 59.3861 190.588 59.2495C190.451 59.1129 190.451 58.8868 190.588 58.7502C190.725 58.6136 190.951 58.6136 191.088 58.7502C191.229 58.8868 191.229 59.1129 191.088 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M191.088 59.2495C190.951 59.3861 190.725 59.3861 190.588 59.2495C190.451 59.1129 190.451 58.8868 190.588 58.7502C190.725 58.6136 190.951 58.6136 191.088 58.7502C191.229 58.8868 191.229 59.1129 191.088 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M194.424 55.9177C194.287 56.0543 194.061 56.0543 193.924 55.9177C193.788 55.7811 193.788 55.555 193.924 55.4184C194.061 55.2818 194.287 55.2818 194.424 55.4184C194.561 55.555 194.561 55.7764 194.424 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M194.424 55.9177C194.287 56.0543 194.061 56.0543 193.924 55.9177C193.788 55.7811 193.788 55.555 193.924 55.4184C194.061 55.2818 194.287 55.2818 194.424 55.4184C194.561 55.555 194.561 55.7764 194.424 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M197.506 52.6898C197.701 52.6898 197.86 52.5317 197.86 52.3366C197.86 52.1414 197.701 51.9833 197.506 51.9833C197.311 51.9833 197.153 52.1414 197.153 52.3366C197.153 52.5317 197.311 52.6898 197.506 52.6898Z"
        fill="#324A52"
      />
      <path
        d="M197.506 52.6898C197.701 52.6898 197.86 52.5317 197.86 52.3366C197.86 52.1414 197.701 51.9833 197.506 51.9833C197.311 51.9833 197.153 52.1414 197.153 52.3366C197.153 52.5317 197.311 52.6898 197.506 52.6898Z"
        fill="#324A52"
      />
      <path
        d="M201.087 49.2542C200.951 49.3908 200.724 49.3908 200.588 49.2542C200.451 49.1176 200.451 48.8915 200.588 48.7549C200.724 48.6183 200.951 48.6183 201.087 48.7549C201.224 48.8915 201.224 49.1129 201.087 49.2542Z"
        fill="#324A52"
      />
      <path
        d="M201.087 49.2542C200.951 49.3908 200.724 49.3908 200.588 49.2542C200.451 49.1176 200.451 48.8915 200.588 48.7549C200.724 48.6183 200.951 48.6183 201.087 48.7549C201.224 48.8915 201.224 49.1129 201.087 49.2542Z"
        fill="#324A52"
      />
      <path
        d="M204.419 45.9174C204.282 46.054 204.056 46.054 203.919 45.9174C203.783 45.7808 203.783 45.5547 203.919 45.4181C204.056 45.2815 204.282 45.2815 204.419 45.4181C204.556 45.5595 204.556 45.7808 204.419 45.9174Z"
        fill="#324A52"
      />
      <path
        d="M204.419 45.9174C204.282 46.054 204.056 46.054 203.919 45.9174C203.783 45.7808 203.783 45.5547 203.919 45.4181C204.056 45.2815 204.282 45.2815 204.419 45.4181C204.556 45.5595 204.556 45.7808 204.419 45.9174Z"
        fill="#324A52"
      />
      <path
        d="M207.501 42.6915C207.696 42.6915 207.854 42.5333 207.854 42.3382C207.854 42.1431 207.696 41.9849 207.501 41.9849C207.305 41.9849 207.147 42.1431 207.147 42.3382C207.147 42.5333 207.305 42.6915 207.501 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M207.501 42.6915C207.696 42.6915 207.854 42.5333 207.854 42.3382C207.854 42.1431 207.696 41.9849 207.501 41.9849C207.305 41.9849 207.147 42.1431 207.147 42.3382C207.147 42.5333 207.305 42.6915 207.501 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M211.082 39.2556C210.946 39.3922 210.72 39.3922 210.583 39.2556C210.446 39.119 210.446 38.8929 210.583 38.7563C210.72 38.6197 210.946 38.6197 211.082 38.7563C211.219 38.8929 211.219 39.119 211.082 39.2556Z"
        fill="#324A52"
      />
      <path
        d="M211.082 39.2556C210.946 39.3922 210.72 39.3922 210.583 39.2556C210.446 39.119 210.446 38.8929 210.583 38.7563C210.72 38.6197 210.946 38.6197 211.082 38.7563C211.219 38.8929 211.219 39.119 211.082 39.2556Z"
        fill="#324A52"
      />
      <path
        d="M214.164 36.027C214.359 36.027 214.517 35.8689 214.517 35.6738C214.517 35.4786 214.359 35.3205 214.164 35.3205C213.969 35.3205 213.81 35.4786 213.81 35.6738C213.81 35.8689 213.969 36.027 214.164 36.027Z"
        fill="#324A52"
      />
      <path
        d="M214.164 36.027C214.359 36.027 214.517 35.8689 214.517 35.6738C214.517 35.4786 214.359 35.3205 214.164 35.3205C213.969 35.3205 213.81 35.4786 213.81 35.6738C213.81 35.8689 213.969 36.027 214.164 36.027Z"
        fill="#324A52"
      />
      <path
        d="M217.496 32.6953C217.691 32.6953 217.849 32.5372 217.849 32.342C217.849 32.1469 217.691 31.9888 217.496 31.9888C217.301 31.9888 217.143 32.1469 217.143 32.342C217.143 32.5372 217.301 32.6953 217.496 32.6953Z"
        fill="#324A52"
      />
      <path
        d="M217.496 32.6953C217.691 32.6953 217.849 32.5372 217.849 32.342C217.849 32.1469 217.691 31.9888 217.496 31.9888C217.301 31.9888 217.143 32.1469 217.143 32.342C217.143 32.5372 217.301 32.6953 217.496 32.6953Z"
        fill="#324A52"
      />
      <path
        d="M221.077 29.2604C220.94 29.397 220.714 29.397 220.578 29.2604C220.441 29.1237 220.441 28.8977 220.578 28.7611C220.714 28.6244 220.94 28.6244 221.077 28.7611C221.218 28.8977 221.218 29.1237 221.077 29.2604Z"
        fill="#324A52"
      />
      <path
        d="M221.077 29.2604C220.94 29.397 220.714 29.397 220.578 29.2604C220.441 29.1237 220.441 28.8977 220.578 28.7611C220.714 28.6244 220.94 28.6244 221.077 28.7611C221.218 28.8977 221.218 29.1237 221.077 29.2604Z"
        fill="#324A52"
      />
      <path
        d="M224.413 25.9286C224.277 26.0652 224.051 26.0652 223.914 25.9286C223.777 25.792 223.777 25.5659 223.914 25.4293C224.051 25.2927 224.277 25.2927 224.413 25.4293C224.55 25.5659 224.55 25.7873 224.413 25.9286Z"
        fill="#324A52"
      />
      <path
        d="M224.413 25.9286C224.277 26.0652 224.051 26.0652 223.914 25.9286C223.777 25.792 223.777 25.5659 223.914 25.4293C224.051 25.2927 224.277 25.2927 224.413 25.4293C224.55 25.5659 224.55 25.7873 224.413 25.9286Z"
        fill="#324A52"
      />
      <path
        d="M227.496 22.7001C227.691 22.7001 227.849 22.542 227.849 22.3468C227.849 22.1517 227.691 21.9936 227.496 21.9936C227.301 21.9936 227.142 22.1517 227.142 22.3468C227.142 22.542 227.301 22.7001 227.496 22.7001Z"
        fill="#324A52"
      />
      <path
        d="M227.496 22.7001C227.691 22.7001 227.849 22.542 227.849 22.3468C227.849 22.1517 227.691 21.9936 227.496 21.9936C227.301 21.9936 227.142 22.1517 227.142 22.3468C227.142 22.542 227.301 22.7001 227.496 22.7001Z"
        fill="#324A52"
      />
      <path
        d="M167.765 75.9077C167.629 76.0443 167.402 76.0443 167.266 75.9077C167.129 75.7711 167.129 75.545 167.266 75.4084C167.402 75.2718 167.629 75.2718 167.765 75.4084C167.902 75.5497 167.902 75.7711 167.765 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M167.765 75.9077C167.629 76.0443 167.402 76.0443 167.266 75.9077C167.129 75.7711 167.129 75.545 167.266 75.4084C167.402 75.2718 167.629 75.2718 167.765 75.4084C167.902 75.5497 167.902 75.7711 167.765 75.9077Z"
        fill="#324A52"
      />
      <path
        d="M170.847 72.6798C171.042 72.6798 171.201 72.5217 171.201 72.3265C171.201 72.1314 171.042 71.9733 170.847 71.9733C170.652 71.9733 170.494 72.1314 170.494 72.3265C170.494 72.5217 170.652 72.6798 170.847 72.6798Z"
        fill="#324A52"
      />
      <path
        d="M170.847 72.6798C171.042 72.6798 171.201 72.5217 171.201 72.3265C171.201 72.1314 171.042 71.9733 170.847 71.9733C170.652 71.9733 170.494 72.1314 170.494 72.3265C170.494 72.5217 170.652 72.6798 170.847 72.6798Z"
        fill="#324A52"
      />
      <path
        d="M174.179 69.3481C174.374 69.3481 174.533 69.1899 174.533 68.9948C174.533 68.7997 174.374 68.6415 174.179 68.6415C173.984 68.6415 173.826 68.7997 173.826 68.9948C173.826 69.1899 173.984 69.3481 174.179 69.3481Z"
        fill="#324A52"
      />
      <path
        d="M174.179 69.3481C174.374 69.3481 174.533 69.1899 174.533 68.9948C174.533 68.7997 174.374 68.6415 174.179 68.6415C173.984 68.6415 173.826 68.7997 173.826 68.9948C173.826 69.1899 173.984 69.3481 174.179 69.3481Z"
        fill="#324A52"
      />
      <path
        d="M177.76 65.9131C177.624 66.0497 177.397 66.0497 177.261 65.9131C177.124 65.7765 177.124 65.5504 177.261 65.4138C177.397 65.2772 177.624 65.2772 177.76 65.4138C177.897 65.5504 177.897 65.7765 177.76 65.9131Z"
        fill="#324A52"
      />
      <path
        d="M177.76 65.9131C177.624 66.0497 177.397 66.0497 177.261 65.9131C177.124 65.7765 177.124 65.5504 177.261 65.4138C177.397 65.2772 177.624 65.2772 177.76 65.4138C177.897 65.5504 177.897 65.7765 177.76 65.9131Z"
        fill="#324A52"
      />
      <path
        d="M180.842 62.683C181.037 62.683 181.195 62.5249 181.195 62.3298C181.195 62.1347 181.037 61.9765 180.842 61.9765C180.647 61.9765 180.489 62.1347 180.489 62.3298C180.489 62.5249 180.647 62.683 180.842 62.683Z"
        fill="#324A52"
      />
      <path
        d="M180.842 62.683C181.037 62.683 181.195 62.5249 181.195 62.3298C181.195 62.1347 181.037 61.9765 180.842 61.9765C180.647 61.9765 180.489 62.1347 180.489 62.3298C180.489 62.5249 180.647 62.683 180.842 62.683Z"
        fill="#324A52"
      />
      <path
        d="M184.424 59.2498C184.287 59.3864 184.061 59.3864 183.924 59.2498C183.788 59.1132 183.788 58.887 183.924 58.7504C184.061 58.6138 184.287 58.6138 184.424 58.7504C184.565 58.887 184.565 59.1132 184.424 59.2498Z"
        fill="#324A52"
      />
      <path
        d="M184.424 59.2498C184.287 59.3864 184.061 59.3864 183.924 59.2498C183.788 59.1132 183.788 58.887 183.924 58.7504C184.061 58.6138 184.287 58.6138 184.424 58.7504C184.565 58.887 184.565 59.1132 184.424 59.2498Z"
        fill="#324A52"
      />
      <path
        d="M187.755 55.9179C187.619 56.0545 187.392 56.0545 187.256 55.9179C187.119 55.7813 187.119 55.5552 187.256 55.4186C187.392 55.282 187.619 55.282 187.755 55.4186C187.892 55.5552 187.897 55.7766 187.755 55.9179Z"
        fill="#324A52"
      />
      <path
        d="M187.755 55.9179C187.619 56.0545 187.392 56.0545 187.256 55.9179C187.119 55.7813 187.119 55.5552 187.256 55.4186C187.392 55.282 187.619 55.282 187.755 55.4186C187.892 55.5552 187.897 55.7766 187.755 55.9179Z"
        fill="#324A52"
      />
      <path
        d="M190.837 52.6901C191.033 52.6901 191.191 52.5319 191.191 52.3368C191.191 52.1417 191.033 51.9835 190.837 51.9835C190.642 51.9835 190.484 52.1417 190.484 52.3368C190.484 52.5319 190.642 52.6901 190.837 52.6901Z"
        fill="#324A52"
      />
      <path
        d="M190.837 52.6901C191.033 52.6901 191.191 52.5319 191.191 52.3368C191.191 52.1417 191.033 51.9835 190.837 51.9835C190.642 51.9835 190.484 52.1417 190.484 52.3368C190.484 52.5319 190.642 52.6901 190.837 52.6901Z"
        fill="#324A52"
      />
      <path
        d="M194.424 49.2561C194.287 49.3927 194.061 49.3927 193.924 49.2561C193.787 49.1195 193.787 48.8934 193.924 48.7568C194.061 48.6202 194.287 48.6202 194.424 48.7568C194.56 48.8934 194.56 49.1148 194.424 49.2561Z"
        fill="#324A52"
      />
      <path
        d="M194.424 49.2561C194.287 49.3927 194.061 49.3927 193.924 49.2561C193.787 49.1195 193.787 48.8934 193.924 48.7568C194.061 48.6202 194.287 48.6202 194.424 48.7568C194.56 48.8934 194.56 49.1148 194.424 49.2561Z"
        fill="#324A52"
      />
      <path
        d="M197.755 45.9186C197.618 46.0552 197.392 46.0552 197.255 45.9186C197.119 45.782 197.119 45.5559 197.255 45.4193C197.392 45.2827 197.618 45.2827 197.755 45.4193C197.891 45.5559 197.891 45.782 197.755 45.9186Z"
        fill="#324A52"
      />
      <path
        d="M197.755 45.9186C197.618 46.0552 197.392 46.0552 197.255 45.9186C197.119 45.782 197.119 45.5559 197.255 45.4193C197.392 45.2827 197.618 45.2827 197.755 45.4193C197.891 45.5559 197.891 45.782 197.755 45.9186Z"
        fill="#324A52"
      />
      <path
        d="M200.837 42.6917C201.032 42.6917 201.191 42.5335 201.191 42.3384C201.191 42.1433 201.032 41.9851 200.837 41.9851C200.642 41.9851 200.484 42.1433 200.484 42.3384C200.484 42.5335 200.642 42.6917 200.837 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M200.837 42.6917C201.032 42.6917 201.191 42.5335 201.191 42.3384C201.191 42.1433 201.032 41.9851 200.837 41.9851C200.642 41.9851 200.484 42.1433 200.484 42.3384C200.484 42.5335 200.642 42.6917 200.837 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M204.418 39.2558C204.282 39.3924 204.055 39.3924 203.919 39.2558C203.782 39.1192 203.782 38.8931 203.919 38.7565C204.055 38.6199 204.282 38.6199 204.418 38.7565C204.555 38.8931 204.555 39.1192 204.418 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M204.418 39.2558C204.282 39.3924 204.055 39.3924 203.919 39.2558C203.782 39.1192 203.782 38.8931 203.919 38.7565C204.055 38.6199 204.282 38.6199 204.418 38.7565C204.555 38.8931 204.555 39.1192 204.418 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M207.501 36.0273C207.696 36.0273 207.854 35.8691 207.854 35.674C207.854 35.4789 207.696 35.3207 207.501 35.3207C207.305 35.3207 207.147 35.4789 207.147 35.674C207.147 35.8691 207.305 36.0273 207.501 36.0273Z"
        fill="#324A52"
      />
      <path
        d="M207.501 36.0273C207.696 36.0273 207.854 35.8691 207.854 35.674C207.854 35.4789 207.696 35.3207 207.501 35.3207C207.305 35.3207 207.147 35.4789 207.147 35.674C207.147 35.8691 207.305 36.0273 207.501 36.0273Z"
        fill="#324A52"
      />
      <path
        d="M210.832 32.6955C211.027 32.6955 211.185 32.5374 211.185 32.3423C211.185 32.1472 211.027 31.989 210.832 31.989C210.637 31.989 210.478 32.1472 210.478 32.3423C210.478 32.5374 210.637 32.6955 210.832 32.6955Z"
        fill="#324A52"
      />
      <path
        d="M210.832 32.6955C211.027 32.6955 211.185 32.5374 211.185 32.3423C211.185 32.1472 211.027 31.989 210.832 31.989C210.637 31.989 210.478 32.1472 210.478 32.3423C210.478 32.5374 210.637 32.6955 210.832 32.6955Z"
        fill="#324A52"
      />
      <path
        d="M214.414 29.2606C214.277 29.3972 214.051 29.3972 213.914 29.2606C213.777 29.124 213.777 28.8979 213.914 28.7613C214.051 28.6247 214.277 28.6247 214.414 28.7613C214.55 28.8979 214.55 29.124 214.414 29.2606Z"
        fill="#324A52"
      />
      <path
        d="M214.414 29.2606C214.277 29.3972 214.051 29.3972 213.914 29.2606C213.777 29.124 213.777 28.8979 213.914 28.7613C214.051 28.6247 214.277 28.6247 214.414 28.7613C214.55 28.8979 214.55 29.124 214.414 29.2606Z"
        fill="#324A52"
      />
      <path
        d="M217.495 26.0321C217.691 26.0321 217.849 25.8739 217.849 25.6788C217.849 25.4837 217.691 25.3255 217.495 25.3255C217.3 25.3255 217.142 25.4837 217.142 25.6788C217.142 25.8739 217.3 26.0321 217.495 26.0321Z"
        fill="#324A52"
      />
      <path
        d="M217.495 26.0321C217.691 26.0321 217.849 25.8739 217.849 25.6788C217.849 25.4837 217.691 25.3255 217.495 25.3255C217.3 25.3255 217.142 25.4837 217.142 25.6788C217.142 25.8739 217.3 26.0321 217.495 26.0321Z"
        fill="#324A52"
      />
      <path
        d="M220.827 22.7003C221.022 22.7003 221.181 22.5422 221.181 22.3471C221.181 22.152 221.022 21.9938 220.827 21.9938C220.632 21.9938 220.474 22.152 220.474 22.3471C220.474 22.5422 220.632 22.7003 220.827 22.7003Z"
        fill="#324A52"
      />
      <path
        d="M220.827 22.7003C221.022 22.7003 221.181 22.5422 221.181 22.3471C221.181 22.152 221.022 21.9938 220.827 21.9938C220.632 21.9938 220.474 22.152 220.474 22.3471C220.474 22.5422 220.632 22.7003 220.827 22.7003Z"
        fill="#324A52"
      />
      <path
        d="M224.413 19.267C224.276 19.4036 224.05 19.4036 223.914 19.267C223.777 19.1304 223.777 18.9043 223.914 18.7677C224.05 18.6311 224.276 18.6311 224.413 18.7677C224.55 18.9043 224.55 19.1257 224.413 19.267Z"
        fill="#324A52"
      />
      <path
        d="M224.413 19.267C224.276 19.4036 224.05 19.4036 223.914 19.267C223.777 19.1304 223.777 18.9043 223.914 18.7677C224.05 18.6311 224.276 18.6311 224.413 18.7677C224.55 18.9043 224.55 19.1257 224.413 19.267Z"
        fill="#324A52"
      />
      <path
        d="M164.184 72.6796C164.379 72.6796 164.538 72.5215 164.538 72.3263C164.538 72.1312 164.379 71.9731 164.184 71.9731C163.989 71.9731 163.831 72.1312 163.831 72.3263C163.831 72.5215 163.989 72.6796 164.184 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M164.184 72.6796C164.379 72.6796 164.538 72.5215 164.538 72.3263C164.538 72.1312 164.379 71.9731 164.184 71.9731C163.989 71.9731 163.831 72.1312 163.831 72.3263C163.831 72.5215 163.989 72.6796 164.184 72.6796Z"
        fill="#324A52"
      />
      <path
        d="M167.765 69.243C167.629 69.3796 167.402 69.3796 167.266 69.243C167.129 69.1064 167.129 68.8803 167.266 68.7437C167.402 68.6071 167.629 68.6071 167.765 68.7437C167.902 68.8803 167.902 69.1064 167.765 69.243Z"
        fill="#324A52"
      />
      <path
        d="M167.765 69.243C167.629 69.3796 167.402 69.3796 167.266 69.243C167.129 69.1064 167.129 68.8803 167.266 68.7437C167.402 68.6071 167.629 68.6071 167.765 68.7437C167.902 68.8803 167.902 69.1064 167.765 69.243Z"
        fill="#324A52"
      />
      <path
        d="M171.098 65.9129C170.961 66.0495 170.735 66.0495 170.599 65.9129C170.462 65.7763 170.462 65.5502 170.599 65.4136C170.735 65.277 170.961 65.277 171.098 65.4136C171.235 65.5502 171.235 65.7763 171.098 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M171.098 65.9129C170.961 66.0495 170.735 66.0495 170.599 65.9129C170.462 65.7763 170.462 65.5502 170.599 65.4136C170.735 65.277 170.961 65.277 171.098 65.4136C171.235 65.5502 171.235 65.7763 171.098 65.9129Z"
        fill="#324A52"
      />
      <path
        d="M174.18 62.6828C174.375 62.6828 174.533 62.5247 174.533 62.3296C174.533 62.1344 174.375 61.9763 174.18 61.9763C173.984 61.9763 173.826 62.1344 173.826 62.3296C173.826 62.5247 173.984 62.6828 174.18 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M174.18 62.6828C174.375 62.6828 174.533 62.5247 174.533 62.3296C174.533 62.1344 174.375 61.9763 174.18 61.9763C173.984 61.9763 173.826 62.1344 173.826 62.3296C173.826 62.5247 173.984 62.6828 174.18 62.6828Z"
        fill="#324A52"
      />
      <path
        d="M177.761 59.2495C177.624 59.3861 177.398 59.3861 177.261 59.2495C177.124 59.1129 177.124 58.8868 177.261 58.7502C177.398 58.6136 177.624 58.6136 177.761 58.7502C177.897 58.8868 177.897 59.1129 177.761 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M177.761 59.2495C177.624 59.3861 177.398 59.3861 177.261 59.2495C177.124 59.1129 177.124 58.8868 177.261 58.7502C177.398 58.6136 177.624 58.6136 177.761 58.7502C177.897 58.8868 177.897 59.1129 177.761 59.2495Z"
        fill="#324A52"
      />
      <path
        d="M181.093 55.9177C180.956 56.0543 180.73 56.0543 180.593 55.9177C180.457 55.7811 180.457 55.555 180.593 55.4184C180.73 55.2818 180.956 55.2818 181.093 55.4184C181.229 55.555 181.229 55.7764 181.093 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M181.093 55.9177C180.956 56.0543 180.73 56.0543 180.593 55.9177C180.457 55.7811 180.457 55.555 180.593 55.4184C180.73 55.2818 180.956 55.2818 181.093 55.4184C181.229 55.555 181.229 55.7764 181.093 55.9177Z"
        fill="#324A52"
      />
      <path
        d="M184.175 52.6899C184.37 52.6899 184.528 52.5317 184.528 52.3366C184.528 52.1415 184.37 51.9833 184.175 51.9833C183.979 51.9833 183.821 52.1415 183.821 52.3366C183.821 52.5317 183.979 52.6899 184.175 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M184.175 52.6899C184.37 52.6899 184.528 52.5317 184.528 52.3366C184.528 52.1415 184.37 51.9833 184.175 51.9833C183.979 51.9833 183.821 52.1415 183.821 52.3366C183.821 52.5317 183.979 52.6899 184.175 52.6899Z"
        fill="#324A52"
      />
      <path
        d="M187.756 49.2543C187.619 49.3909 187.393 49.3909 187.256 49.2543C187.12 49.1177 187.12 48.8916 187.256 48.755C187.393 48.6184 187.619 48.6184 187.756 48.755C187.897 48.8916 187.897 49.113 187.756 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M187.756 49.2543C187.619 49.3909 187.393 49.3909 187.256 49.2543C187.12 49.1177 187.12 48.8916 187.256 48.755C187.393 48.6184 187.619 48.6184 187.756 48.755C187.897 48.8916 187.897 49.113 187.756 49.2543Z"
        fill="#324A52"
      />
      <path
        d="M191.088 45.9184C190.951 46.055 190.725 46.055 190.588 45.9184C190.451 45.7818 190.451 45.5557 190.588 45.4191C190.725 45.2825 190.951 45.2825 191.088 45.4191C191.229 45.5604 191.229 45.7818 191.088 45.9184Z"
        fill="#324A52"
      />
      <path
        d="M191.088 45.9184C190.951 46.055 190.725 46.055 190.588 45.9184C190.451 45.7818 190.451 45.5557 190.588 45.4191C190.725 45.2825 190.951 45.2825 191.088 45.4191C191.229 45.5604 191.229 45.7818 191.088 45.9184Z"
        fill="#324A52"
      />
      <path
        d="M194.174 42.6915C194.37 42.6915 194.528 42.5333 194.528 42.3382C194.528 42.1431 194.37 41.9849 194.174 41.9849C193.979 41.9849 193.821 42.1431 193.821 42.3382C193.821 42.5333 193.979 42.6915 194.174 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M194.174 42.6915C194.37 42.6915 194.528 42.5333 194.528 42.3382C194.528 42.1431 194.37 41.9849 194.174 41.9849C193.979 41.9849 193.821 42.1431 193.821 42.3382C193.821 42.5333 193.979 42.6915 194.174 42.6915Z"
        fill="#324A52"
      />
      <path
        d="M197.755 39.2556C197.619 39.3922 197.393 39.3922 197.256 39.2556C197.119 39.119 197.119 38.8929 197.256 38.7563C197.393 38.6197 197.619 38.6197 197.755 38.7563C197.892 38.8929 197.892 39.119 197.755 39.2556Z"
        fill="#324A52"
      />
      <path
        d="M197.755 39.2556C197.619 39.3922 197.393 39.3922 197.256 39.2556C197.119 39.119 197.119 38.8929 197.256 38.7563C197.393 38.6197 197.619 38.6197 197.755 38.7563C197.892 38.8929 197.892 39.119 197.755 39.2556Z"
        fill="#324A52"
      />
      <path
        d="M200.838 36.0271C201.033 36.0271 201.191 35.8689 201.191 35.6738C201.191 35.4787 201.033 35.3205 200.838 35.3205C200.643 35.3205 200.484 35.4787 200.484 35.6738C200.484 35.8689 200.643 36.0271 200.838 36.0271Z"
        fill="#324A52"
      />
      <path
        d="M200.838 36.0271C201.033 36.0271 201.191 35.8689 201.191 35.6738C201.191 35.4787 201.033 35.3205 200.838 35.3205C200.643 35.3205 200.484 35.4787 200.484 35.6738C200.484 35.8689 200.643 36.0271 200.838 36.0271Z"
        fill="#324A52"
      />
      <path
        d="M204.169 32.6953C204.364 32.6953 204.522 32.5372 204.522 32.3421C204.522 32.1469 204.364 31.9888 204.169 31.9888C203.974 31.9888 203.816 32.1469 203.816 32.3421C203.816 32.5372 203.974 32.6953 204.169 32.6953Z"
        fill="#324A52"
      />
      <path
        d="M204.169 32.6953C204.364 32.6953 204.522 32.5372 204.522 32.3421C204.522 32.1469 204.364 31.9888 204.169 31.9888C203.974 31.9888 203.816 32.1469 203.816 32.3421C203.816 32.5372 203.974 32.6953 204.169 32.6953Z"
        fill="#324A52"
      />
      <path
        d="M207.75 29.2604C207.613 29.397 207.387 29.397 207.25 29.2604C207.114 29.1238 207.114 28.8977 207.25 28.7611C207.387 28.6245 207.613 28.6245 207.75 28.7611C207.886 28.8977 207.886 29.1238 207.75 29.2604Z"
        fill="#324A52"
      />
      <path
        d="M207.75 29.2604C207.613 29.397 207.387 29.397 207.25 29.2604C207.114 29.1238 207.114 28.8977 207.25 28.7611C207.387 28.6245 207.613 28.6245 207.75 28.7611C207.886 28.8977 207.886 29.1238 207.75 29.2604Z"
        fill="#324A52"
      />
      <path
        d="M210.832 26.0319C211.027 26.0319 211.185 25.8737 211.185 25.6786C211.185 25.4835 211.027 25.3253 210.832 25.3253C210.637 25.3253 210.478 25.4835 210.478 25.6786C210.478 25.8737 210.637 26.0319 210.832 26.0319Z"
        fill="#324A52"
      />
      <path
        d="M210.832 26.0319C211.027 26.0319 211.185 25.8737 211.185 25.6786C211.185 25.4835 211.027 25.3253 210.832 25.3253C210.637 25.3253 210.478 25.4835 210.478 25.6786C210.478 25.8737 210.637 26.0319 210.832 26.0319Z"
        fill="#324A52"
      />
      <path
        d="M214.164 22.7001C214.359 22.7001 214.517 22.542 214.517 22.3469C214.517 22.1517 214.359 21.9936 214.164 21.9936C213.969 21.9936 213.81 22.1517 213.81 22.3469C213.81 22.542 213.969 22.7001 214.164 22.7001Z"
        fill="#324A52"
      />
      <path
        d="M214.164 22.7001C214.359 22.7001 214.517 22.542 214.517 22.3469C214.517 22.1517 214.359 21.9936 214.164 21.9936C213.969 21.9936 213.81 22.1517 213.81 22.3469C213.81 22.542 213.969 22.7001 214.164 22.7001Z"
        fill="#324A52"
      />
      <path
        d="M217.496 19.37C217.691 19.37 217.849 19.2118 217.849 19.0167C217.849 18.8216 217.691 18.6634 217.496 18.6634C217.3 18.6634 217.142 18.8216 217.142 19.0167C217.142 19.2118 217.3 19.37 217.496 19.37Z"
        fill="#324A52"
      />
      <path
        d="M217.496 19.37C217.691 19.37 217.849 19.2118 217.849 19.0167C217.849 18.8216 217.691 18.6634 217.496 18.6634C217.3 18.6634 217.142 18.8216 217.142 19.0167C217.142 19.2118 217.3 19.37 217.496 19.37Z"
        fill="#324A52"
      />
      <path
        d="M220.827 16.0325C221.022 16.0325 221.181 15.8744 221.181 15.6793C221.181 15.4842 221.022 15.326 220.827 15.326C220.632 15.326 220.474 15.4842 220.474 15.6793C220.474 15.8744 220.632 16.0325 220.827 16.0325Z"
        fill="#324A52"
      />
      <path
        d="M220.827 16.0325C221.022 16.0325 221.181 15.8744 221.181 15.6793C221.181 15.4842 221.022 15.326 220.827 15.326C220.632 15.326 220.474 15.4842 220.474 15.6793C220.474 15.8744 220.632 16.0325 220.827 16.0325Z"
        fill="#324A52"
      />
      <path
        d="M161.097 69.2434C160.961 69.38 160.735 69.38 160.598 69.2434C160.461 69.1068 160.461 68.8807 160.598 68.7441C160.735 68.6075 160.961 68.6075 161.097 68.7441C161.234 68.8807 161.239 69.1068 161.097 69.2434Z"
        fill="#324A52"
      />
      <path
        d="M161.097 69.2434C160.961 69.38 160.735 69.38 160.598 69.2434C160.461 69.1068 160.461 68.8807 160.598 68.7441C160.735 68.6075 160.961 68.6075 161.097 68.7441C161.234 68.8807 161.239 69.1068 161.097 69.2434Z"
        fill="#324A52"
      />
      <path
        d="M164.434 65.9118C164.297 66.0484 164.071 66.0484 163.934 65.9118C163.798 65.7752 163.798 65.5491 163.934 65.4125C164.071 65.2759 164.297 65.2759 164.434 65.4125C164.57 65.5491 164.57 65.7752 164.434 65.9118Z"
        fill="#324A52"
      />
      <path
        d="M164.434 65.9118C164.297 66.0484 164.071 66.0484 163.934 65.9118C163.798 65.7752 163.798 65.5491 163.934 65.4125C164.071 65.2759 164.297 65.2759 164.434 65.4125C164.57 65.5491 164.57 65.7752 164.434 65.9118Z"
        fill="#324A52"
      />
      <path
        d="M167.765 62.58C167.629 62.7166 167.402 62.7166 167.266 62.58C167.129 62.4434 167.129 62.2173 167.266 62.0807C167.402 61.9441 167.629 61.9441 167.765 62.0807C167.902 62.2173 167.902 62.4434 167.765 62.58Z"
        fill="#324A52"
      />
      <path
        d="M167.765 62.58C167.629 62.7166 167.402 62.7166 167.266 62.58C167.129 62.4434 167.129 62.2173 167.266 62.0807C167.402 61.9441 167.629 61.9441 167.765 62.0807C167.902 62.2173 167.902 62.4434 167.765 62.58Z"
        fill="#324A52"
      />
      <path
        d="M171.097 59.2483C170.96 59.3849 170.734 59.3849 170.598 59.2483C170.461 59.1117 170.461 58.8856 170.598 58.749C170.734 58.6124 170.96 58.6124 171.097 58.749C171.234 58.8856 171.234 59.1117 171.097 59.2483Z"
        fill="#324A52"
      />
      <path
        d="M171.097 59.2483C170.96 59.3849 170.734 59.3849 170.598 59.2483C170.461 59.1117 170.461 58.8856 170.598 58.749C170.734 58.6124 170.96 58.6124 171.097 58.749C171.234 58.8856 171.234 59.1117 171.097 59.2483Z"
        fill="#324A52"
      />
      <path
        d="M174.429 55.9181C174.292 56.0547 174.066 56.0547 173.929 55.9181C173.793 55.7815 173.793 55.5554 173.929 55.4188C174.066 55.2822 174.292 55.2822 174.429 55.4188C174.565 55.5554 174.565 55.7768 174.429 55.9181Z"
        fill="#324A52"
      />
      <path
        d="M174.429 55.9181C174.292 56.0547 174.066 56.0547 173.929 55.9181C173.793 55.7815 173.793 55.5554 173.929 55.4188C174.066 55.2822 174.292 55.2822 174.429 55.4188C174.565 55.5554 174.565 55.7768 174.429 55.9181Z"
        fill="#324A52"
      />
      <path
        d="M177.761 52.5855C177.624 52.7221 177.398 52.7221 177.261 52.5855C177.124 52.4489 177.124 52.2228 177.261 52.0862C177.398 51.9496 177.624 51.9496 177.761 52.0862C177.897 52.2228 177.897 52.4441 177.761 52.5855Z"
        fill="#324A52"
      />
      <path
        d="M177.761 52.5855C177.624 52.7221 177.398 52.7221 177.261 52.5855C177.124 52.4489 177.124 52.2228 177.261 52.0862C177.398 51.9496 177.624 51.9496 177.761 52.0862C177.897 52.2228 177.897 52.4441 177.761 52.5855Z"
        fill="#324A52"
      />
      <path
        d="M181.092 49.2547C180.956 49.3913 180.729 49.3913 180.593 49.2547C180.456 49.1181 180.456 48.892 180.593 48.7554C180.729 48.6188 180.956 48.6188 181.092 48.7554C181.229 48.892 181.229 49.1134 181.092 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M181.092 49.2547C180.956 49.3913 180.729 49.3913 180.593 49.2547C180.456 49.1181 180.456 48.892 180.593 48.7554C180.729 48.6188 180.956 48.6188 181.092 48.7554C181.229 48.892 181.229 49.1134 181.092 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M184.424 45.9179C184.287 46.0545 184.061 46.0545 183.925 45.9179C183.788 45.7813 183.788 45.5552 183.925 45.4186C184.061 45.282 184.287 45.282 184.424 45.4186C184.565 45.5599 184.565 45.7813 184.424 45.9179Z"
        fill="#324A52"
      />
      <path
        d="M184.424 45.9179C184.287 46.0545 184.061 46.0545 183.925 45.9179C183.788 45.7813 183.788 45.5552 183.925 45.4186C184.061 45.282 184.287 45.282 184.424 45.4186C184.565 45.5599 184.565 45.7813 184.424 45.9179Z"
        fill="#324A52"
      />
      <path
        d="M187.506 42.6919C187.701 42.6919 187.859 42.5337 187.859 42.3386C187.859 42.1435 187.701 41.9853 187.506 41.9853C187.311 41.9853 187.152 42.1435 187.152 42.3386C187.152 42.5337 187.311 42.6919 187.506 42.6919Z"
        fill="#324A52"
      />
      <path
        d="M187.506 42.6919C187.701 42.6919 187.859 42.5337 187.859 42.3386C187.859 42.1435 187.701 41.9853 187.506 41.9853C187.311 41.9853 187.152 42.1435 187.152 42.3386C187.152 42.5337 187.311 42.6919 187.506 42.6919Z"
        fill="#324A52"
      />
      <path
        d="M191.087 39.256C190.951 39.3926 190.724 39.3926 190.588 39.256C190.451 39.1194 190.451 38.8933 190.588 38.7567C190.724 38.6201 190.951 38.6201 191.087 38.7567C191.229 38.8933 191.229 39.1194 191.087 39.256Z"
        fill="#324A52"
      />
      <path
        d="M191.087 39.256C190.951 39.3926 190.724 39.3926 190.588 39.256C190.451 39.1194 190.451 38.8933 190.588 38.7567C190.724 38.6201 190.951 38.6201 191.087 38.7567C191.229 38.8933 191.229 39.1194 191.087 39.256Z"
        fill="#324A52"
      />
      <path
        d="M194.173 36.0275C194.369 36.0275 194.527 35.8693 194.527 35.6742C194.527 35.4791 194.369 35.3209 194.173 35.3209C193.978 35.3209 193.82 35.4791 193.82 35.6742C193.82 35.8693 193.978 36.0275 194.173 36.0275Z"
        fill="#324A52"
      />
      <path
        d="M194.173 36.0275C194.369 36.0275 194.527 35.8693 194.527 35.6742C194.527 35.4791 194.369 35.3209 194.173 35.3209C193.978 35.3209 193.82 35.4791 193.82 35.6742C193.82 35.8693 193.978 36.0275 194.173 36.0275Z"
        fill="#324A52"
      />
      <path
        d="M197.506 32.6957C197.701 32.6957 197.859 32.5376 197.859 32.3425C197.859 32.1474 197.701 31.9892 197.506 31.9892C197.31 31.9892 197.152 32.1474 197.152 32.3425C197.152 32.5376 197.31 32.6957 197.506 32.6957Z"
        fill="#324A52"
      />
      <path
        d="M197.506 32.6957C197.701 32.6957 197.859 32.5376 197.859 32.3425C197.859 32.1474 197.701 31.9892 197.506 31.9892C197.31 31.9892 197.152 32.1474 197.152 32.3425C197.152 32.5376 197.31 32.6957 197.506 32.6957Z"
        fill="#324A52"
      />
      <path
        d="M201.087 29.2608C200.95 29.3974 200.724 29.3974 200.587 29.2608C200.451 29.1242 200.451 28.8981 200.587 28.7615C200.724 28.6249 200.95 28.6249 201.087 28.7615C201.223 28.8981 201.223 29.1242 201.087 29.2608Z"
        fill="#324A52"
      />
      <path
        d="M201.087 29.2608C200.95 29.3974 200.724 29.3974 200.587 29.2608C200.451 29.1242 200.451 28.8981 200.587 28.7615C200.724 28.6249 200.95 28.6249 201.087 28.7615C201.223 28.8981 201.223 29.1242 201.087 29.2608Z"
        fill="#324A52"
      />
      <path
        d="M204.168 26.0313C204.364 26.0313 204.522 25.8732 204.522 25.678C204.522 25.4829 204.364 25.3248 204.168 25.3248C203.973 25.3248 203.815 25.4829 203.815 25.678C203.815 25.8732 203.973 26.0313 204.168 26.0313Z"
        fill="#324A52"
      />
      <path
        d="M204.168 26.0313C204.364 26.0313 204.522 25.8732 204.522 25.678C204.522 25.4829 204.364 25.3248 204.168 25.3248C203.973 25.3248 203.815 25.4829 203.815 25.678C203.815 25.8732 203.973 26.0313 204.168 26.0313Z"
        fill="#324A52"
      />
      <path
        d="M207.5 22.7005C207.695 22.7005 207.853 22.5424 207.853 22.3473C207.853 22.1521 207.695 21.994 207.5 21.994C207.304 21.994 207.146 22.1521 207.146 22.3473C207.146 22.5424 207.304 22.7005 207.5 22.7005Z"
        fill="#324A52"
      />
      <path
        d="M207.5 22.7005C207.695 22.7005 207.853 22.5424 207.853 22.3473C207.853 22.1521 207.695 21.994 207.5 21.994C207.304 21.994 207.146 22.1521 207.146 22.3473C207.146 22.5424 207.304 22.7005 207.5 22.7005Z"
        fill="#324A52"
      />
      <path
        d="M210.832 19.3704C211.027 19.3704 211.185 19.2122 211.185 19.0171C211.185 18.822 211.027 18.6638 210.832 18.6638C210.636 18.6638 210.478 18.822 210.478 19.0171C210.478 19.2122 210.636 19.3704 210.832 19.3704Z"
        fill="#324A52"
      />
      <path
        d="M210.832 19.3704C211.027 19.3704 211.185 19.2122 211.185 19.0171C211.185 18.822 211.027 18.6638 210.832 18.6638C210.636 18.6638 210.478 18.822 210.478 19.0171C210.478 19.2122 210.636 19.3704 210.832 19.3704Z"
        fill="#324A52"
      />
      <path
        d="M214.164 16.032C214.359 16.032 214.517 15.8738 214.517 15.6787C214.517 15.4836 214.359 15.3254 214.164 15.3254C213.969 15.3254 213.81 15.4836 213.81 15.6787C213.81 15.8738 213.969 16.032 214.164 16.032Z"
        fill="#324A52"
      />
      <path
        d="M214.164 16.032C214.359 16.032 214.517 15.8738 214.517 15.6787C214.517 15.4836 214.359 15.3254 214.164 15.3254C213.969 15.3254 213.81 15.4836 213.81 15.6787C213.81 15.8738 213.969 16.032 214.164 16.032Z"
        fill="#324A52"
      />
      <path
        d="M217.495 12.7003C217.69 12.7003 217.848 12.5421 217.848 12.347C217.848 12.1519 217.69 11.9937 217.495 11.9937C217.3 11.9937 217.142 12.1519 217.142 12.347C217.142 12.5421 217.3 12.7003 217.495 12.7003Z"
        fill="#324A52"
      />
      <path
        d="M217.495 12.7003C217.69 12.7003 217.848 12.5421 217.848 12.347C217.848 12.1519 217.69 11.9937 217.495 11.9937C217.3 11.9937 217.142 12.1519 217.142 12.347C217.142 12.5421 217.3 12.7003 217.495 12.7003Z"
        fill="#324A52"
      />
      <path
        d="M157.765 65.9134C157.629 66.05 157.403 66.05 157.266 65.9134C157.129 65.7768 157.129 65.5507 157.266 65.4141C157.403 65.2775 157.629 65.2775 157.765 65.4141C157.907 65.5507 157.907 65.7768 157.765 65.9134Z"
        fill="#324A52"
      />
      <path
        d="M157.765 65.9134C157.629 66.05 157.403 66.05 157.266 65.9134C157.129 65.7768 157.129 65.5507 157.266 65.4141C157.403 65.2775 157.629 65.2775 157.765 65.4141C157.907 65.5507 157.907 65.7768 157.765 65.9134Z"
        fill="#324A52"
      />
      <path
        d="M161.098 62.5801C160.961 62.7167 160.735 62.7167 160.598 62.5801C160.462 62.4435 160.462 62.2174 160.598 62.0808C160.735 61.9442 160.961 61.9442 161.098 62.0808C161.234 62.2174 161.239 62.4435 161.098 62.5801Z"
        fill="#324A52"
      />
      <path
        d="M161.098 62.5801C160.961 62.7167 160.735 62.7167 160.598 62.5801C160.462 62.4435 160.462 62.2174 160.598 62.0808C160.735 61.9442 160.961 61.9442 161.098 62.0808C161.234 62.2174 161.239 62.4435 161.098 62.5801Z"
        fill="#324A52"
      />
      <path
        d="M164.434 59.25C164.297 59.3866 164.071 59.3866 163.934 59.25C163.798 59.1134 163.798 58.8873 163.934 58.7507C164.071 58.6141 164.297 58.6141 164.434 58.7507C164.57 58.8873 164.57 59.1134 164.434 59.25Z"
        fill="#324A52"
      />
      <path
        d="M164.434 59.25C164.297 59.3866 164.071 59.3866 163.934 59.25C163.798 59.1134 163.798 58.8873 163.934 58.7507C164.071 58.6141 164.297 58.6141 164.434 58.7507C164.57 58.8873 164.57 59.1134 164.434 59.25Z"
        fill="#324A52"
      />
      <path
        d="M167.765 55.9182C167.629 56.0548 167.402 56.0548 167.266 55.9182C167.129 55.7816 167.129 55.5555 167.266 55.4189C167.402 55.2823 167.629 55.2823 167.765 55.4189C167.902 55.5555 167.902 55.7769 167.765 55.9182Z"
        fill="#324A52"
      />
      <path
        d="M167.765 55.9182C167.629 56.0548 167.402 56.0548 167.266 55.9182C167.129 55.7816 167.129 55.5555 167.266 55.4189C167.402 55.2823 167.629 55.2823 167.765 55.4189C167.902 55.5555 167.902 55.7769 167.765 55.9182Z"
        fill="#324A52"
      />
      <path
        d="M170.848 52.6903C171.043 52.6903 171.201 52.5322 171.201 52.3371C171.201 52.1419 171.043 51.9838 170.848 51.9838C170.652 51.9838 170.494 52.1419 170.494 52.3371C170.494 52.5322 170.652 52.6903 170.848 52.6903Z"
        fill="#324A52"
      />
      <path
        d="M170.848 52.6903C171.043 52.6903 171.201 52.5322 171.201 52.3371C171.201 52.1419 171.043 51.9838 170.848 51.9838C170.652 51.9838 170.494 52.1419 170.494 52.3371C170.494 52.5322 170.652 52.6903 170.848 52.6903Z"
        fill="#324A52"
      />
      <path
        d="M174.429 49.2547C174.292 49.3913 174.066 49.3913 173.929 49.2547C173.793 49.1181 173.793 48.892 173.929 48.7554C174.066 48.6188 174.292 48.6188 174.429 48.7554C174.565 48.892 174.565 49.1134 174.429 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M174.429 49.2547C174.292 49.3913 174.066 49.3913 173.929 49.2547C173.793 49.1181 173.793 48.892 173.929 48.7554C174.066 48.6188 174.292 48.6188 174.429 48.7554C174.565 48.892 174.565 49.1134 174.429 49.2547Z"
        fill="#324A52"
      />
      <path
        d="M177.761 45.9189C177.624 46.0555 177.398 46.0555 177.261 45.9189C177.124 45.7823 177.124 45.5562 177.261 45.4196C177.398 45.283 177.624 45.283 177.761 45.4196C177.897 45.5609 177.897 45.7823 177.761 45.9189Z"
        fill="#324A52"
      />
      <path
        d="M177.761 45.9189C177.624 46.0555 177.398 46.0555 177.261 45.9189C177.124 45.7823 177.124 45.5562 177.261 45.4196C177.398 45.283 177.624 45.283 177.761 45.4196C177.897 45.5609 177.897 45.7823 177.761 45.9189Z"
        fill="#324A52"
      />
      <path
        d="M180.842 42.692C181.037 42.692 181.195 42.5338 181.195 42.3387C181.195 42.1436 181.037 41.9854 180.842 41.9854C180.647 41.9854 180.489 42.1436 180.489 42.3387C180.489 42.5338 180.647 42.692 180.842 42.692Z"
        fill="#324A52"
      />
      <path
        d="M180.842 42.692C181.037 42.692 181.195 42.5338 181.195 42.3387C181.195 42.1436 181.037 41.9854 180.842 41.9854C180.647 41.9854 180.489 42.1436 180.489 42.3387C180.489 42.5338 180.647 42.692 180.842 42.692Z"
        fill="#324A52"
      />
      <path
        d="M184.424 39.2561C184.287 39.3927 184.061 39.3927 183.925 39.2561C183.788 39.1195 183.788 38.8934 183.925 38.7568C184.061 38.6202 184.287 38.6202 184.424 38.7568C184.565 38.8934 184.565 39.1195 184.424 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M184.424 39.2561C184.287 39.3927 184.061 39.3927 183.925 39.2561C183.788 39.1195 183.788 38.8934 183.925 38.7568C184.061 38.6202 184.287 38.6202 184.424 38.7568C184.565 38.8934 184.565 39.1195 184.424 39.2561Z"
        fill="#324A52"
      />
      <path
        d="M187.506 36.0275C187.701 36.0275 187.859 35.8694 187.859 35.6742C187.859 35.4791 187.701 35.321 187.506 35.321C187.311 35.321 187.152 35.4791 187.152 35.6742C187.152 35.8694 187.311 36.0275 187.506 36.0275Z"
        fill="#324A52"
      />
      <path
        d="M187.506 36.0275C187.701 36.0275 187.859 35.8694 187.859 35.6742C187.859 35.4791 187.701 35.321 187.506 35.321C187.311 35.321 187.152 35.4791 187.152 35.6742C187.152 35.8694 187.311 36.0275 187.506 36.0275Z"
        fill="#324A52"
      />
      <path
        d="M190.837 32.6958C191.033 32.6958 191.191 32.5376 191.191 32.3425C191.191 32.1474 191.033 31.9893 190.837 31.9893C190.642 31.9893 190.484 32.1474 190.484 32.3425C190.484 32.5376 190.642 32.6958 190.837 32.6958Z"
        fill="#324A52"
      />
      <path
        d="M190.837 32.6958C191.033 32.6958 191.191 32.5376 191.191 32.3425C191.191 32.1474 191.033 31.9893 190.837 31.9893C190.642 31.9893 190.484 32.1474 190.484 32.3425C190.484 32.5376 190.642 32.6958 190.837 32.6958Z"
        fill="#324A52"
      />
      <path
        d="M194.423 29.2608C194.287 29.3974 194.06 29.3974 193.924 29.2608C193.787 29.1242 193.787 28.8981 193.924 28.7615C194.06 28.6249 194.287 28.6249 194.423 28.7615C194.56 28.8981 194.56 29.1242 194.423 29.2608Z"
        fill="#324A52"
      />
      <path
        d="M194.423 29.2608C194.287 29.3974 194.06 29.3974 193.924 29.2608C193.787 29.1242 193.787 28.8981 193.924 28.7615C194.06 28.6249 194.287 28.6249 194.423 28.7615C194.56 28.8981 194.56 29.1242 194.423 29.2608Z"
        fill="#324A52"
      />
      <path
        d="M197.505 26.0323C197.7 26.0323 197.859 25.8742 197.859 25.6791C197.859 25.484 197.7 25.3258 197.505 25.3258C197.31 25.3258 197.152 25.484 197.152 25.6791C197.152 25.8742 197.31 26.0323 197.505 26.0323Z"
        fill="#324A52"
      />
      <path
        d="M197.505 26.0323C197.7 26.0323 197.859 25.8742 197.859 25.6791C197.859 25.484 197.7 25.3258 197.505 25.3258C197.31 25.3258 197.152 25.484 197.152 25.6791C197.152 25.8742 197.31 26.0323 197.505 26.0323Z"
        fill="#324A52"
      />
      <path
        d="M200.837 22.7006C201.032 22.7006 201.191 22.5424 201.191 22.3473C201.191 22.1522 201.032 21.994 200.837 21.994C200.642 21.994 200.484 22.1522 200.484 22.3473C200.484 22.5424 200.642 22.7006 200.837 22.7006Z"
        fill="#324A52"
      />
      <path
        d="M200.837 22.7006C201.032 22.7006 201.191 22.5424 201.191 22.3473C201.191 22.1522 201.032 21.994 200.837 21.994C200.642 21.994 200.484 22.1522 200.484 22.3473C200.484 22.5424 200.642 22.7006 200.837 22.7006Z"
        fill="#324A52"
      />
      <path
        d="M204.169 19.3705C204.364 19.3705 204.522 19.2123 204.522 19.0172C204.522 18.8221 204.364 18.6639 204.169 18.6639C203.974 18.6639 203.815 18.8221 203.815 19.0172C203.815 19.2123 203.974 19.3705 204.169 19.3705Z"
        fill="#324A52"
      />
      <path
        d="M204.169 19.3705C204.364 19.3705 204.522 19.2123 204.522 19.0172C204.522 18.8221 204.364 18.6639 204.169 18.6639C203.974 18.6639 203.815 18.8221 203.815 19.0172C203.815 19.2123 203.974 19.3705 204.169 19.3705Z"
        fill="#324A52"
      />
      <path
        d="M207.5 16.033C207.695 16.033 207.853 15.8749 207.853 15.6797C207.853 15.4846 207.695 15.3265 207.5 15.3265C207.305 15.3265 207.147 15.4846 207.147 15.6797C207.147 15.8749 207.305 16.033 207.5 16.033Z"
        fill="#324A52"
      />
      <path
        d="M207.5 16.033C207.695 16.033 207.853 15.8749 207.853 15.6797C207.853 15.4846 207.695 15.3265 207.5 15.3265C207.305 15.3265 207.147 15.4846 207.147 15.6797C207.147 15.8749 207.305 16.033 207.5 16.033Z"
        fill="#324A52"
      />
      <path
        d="M210.832 12.7003C211.027 12.7003 211.185 12.5422 211.185 12.3471C211.185 12.152 211.027 11.9938 210.832 11.9938C210.637 11.9938 210.478 12.152 210.478 12.3471C210.478 12.5422 210.637 12.7003 210.832 12.7003Z"
        fill="#324A52"
      />
      <path
        d="M210.832 12.7003C211.027 12.7003 211.185 12.5422 211.185 12.3471C211.185 12.152 211.027 11.9938 210.832 11.9938C210.637 11.9938 210.478 12.152 210.478 12.3471C210.478 12.5422 210.637 12.7003 210.832 12.7003Z"
        fill="#324A52"
      />
      <path
        d="M214.164 9.37019C214.359 9.37019 214.517 9.21203 214.517 9.01691C214.517 8.8218 214.359 8.66364 214.164 8.66364C213.969 8.66364 213.81 8.8218 213.81 9.01691C213.81 9.21203 213.969 9.37019 214.164 9.37019Z"
        fill="#324A52"
      />
      <path
        d="M214.164 9.37019C214.359 9.37019 214.517 9.21203 214.517 9.01691C214.517 8.8218 214.359 8.66364 214.164 8.66364C213.969 8.66364 213.81 8.8218 213.81 9.01691C213.81 9.21203 213.969 9.37019 214.164 9.37019Z"
        fill="#324A52"
      />
      <path
        d="M154.184 62.6831C154.379 62.6831 154.537 62.5249 154.537 62.3298C154.537 62.1347 154.379 61.9765 154.184 61.9765C153.989 61.9765 153.83 62.1347 153.83 62.3298C153.83 62.5249 153.989 62.6831 154.184 62.6831Z"
        fill="#324A52"
      />
      <path
        d="M154.184 62.6831C154.379 62.6831 154.537 62.5249 154.537 62.3298C154.537 62.1347 154.379 61.9765 154.184 61.9765C153.989 61.9765 153.83 62.1347 153.83 62.3298C153.83 62.5249 153.989 62.6831 154.184 62.6831Z"
        fill="#324A52"
      />
      <path
        d="M157.765 59.2481C157.629 59.3847 157.403 59.3847 157.266 59.2481C157.129 59.1115 157.129 58.8854 157.266 58.7488C157.403 58.6122 157.629 58.6122 157.765 58.7488C157.907 58.8854 157.907 59.1115 157.765 59.2481Z"
        fill="#324A52"
      />
      <path
        d="M157.765 59.2481C157.629 59.3847 157.403 59.3847 157.266 59.2481C157.129 59.1115 157.129 58.8854 157.266 58.7488C157.403 58.6122 157.629 58.6122 157.765 58.7488C157.907 58.8854 157.907 59.1115 157.765 59.2481Z"
        fill="#324A52"
      />
      <path
        d="M161.097 55.918C160.961 56.0546 160.735 56.0546 160.598 55.918C160.461 55.7814 160.461 55.5553 160.598 55.4187C160.735 55.2821 160.961 55.2821 161.097 55.4187C161.234 55.5553 161.239 55.7767 161.097 55.918Z"
        fill="#324A52"
      />
      <path
        d="M161.097 55.918C160.961 56.0546 160.735 56.0546 160.598 55.918C160.461 55.7814 160.461 55.5553 160.598 55.4187C160.735 55.2821 160.961 55.2821 161.097 55.4187C161.234 55.5553 161.239 55.7767 161.097 55.918Z"
        fill="#324A52"
      />
      <path
        d="M164.183 52.6885C164.378 52.6885 164.537 52.5303 164.537 52.3352C164.537 52.1401 164.378 51.9819 164.183 51.9819C163.988 51.9819 163.83 52.1401 163.83 52.3352C163.83 52.5303 163.988 52.6885 164.183 52.6885Z"
        fill="#324A52"
      />
      <path
        d="M164.183 52.6885C164.378 52.6885 164.537 52.5303 164.537 52.3352C164.537 52.1401 164.378 51.9819 164.183 51.9819C163.988 51.9819 163.83 52.1401 163.83 52.3352C163.83 52.5303 163.988 52.6885 164.183 52.6885Z"
        fill="#324A52"
      />
      <path
        d="M167.765 49.2545C167.628 49.3911 167.402 49.3911 167.265 49.2545C167.129 49.1179 167.129 48.8918 167.265 48.7552C167.402 48.6186 167.628 48.6186 167.765 48.7552C167.902 48.8918 167.902 49.1132 167.765 49.2545Z"
        fill="#324A52"
      />
      <path
        d="M167.765 49.2545C167.628 49.3911 167.402 49.3911 167.265 49.2545C167.129 49.1179 167.129 48.8918 167.265 48.7552C167.402 48.6186 167.628 48.6186 167.765 48.7552C167.902 48.8918 167.902 49.1132 167.765 49.2545Z"
        fill="#324A52"
      />
      <path
        d="M171.097 45.9177C170.961 46.0543 170.734 46.0543 170.598 45.9177C170.461 45.7811 170.461 45.555 170.598 45.4184C170.734 45.2818 170.961 45.2818 171.097 45.4184C171.234 45.5597 171.234 45.7811 171.097 45.9177Z"
        fill="#324A52"
      />
      <path
        d="M171.097 45.9177C170.961 46.0543 170.734 46.0543 170.598 45.9177C170.461 45.7811 170.461 45.555 170.598 45.4184C170.734 45.2818 170.961 45.2818 171.097 45.4184C171.234 45.5597 171.234 45.7811 171.097 45.9177Z"
        fill="#324A52"
      />
      <path
        d="M174.179 42.6917C174.374 42.6917 174.532 42.5336 174.532 42.3384C174.532 42.1433 174.374 41.9852 174.179 41.9852C173.984 41.9852 173.825 42.1433 173.825 42.3384C173.825 42.5336 173.984 42.6917 174.179 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M174.179 42.6917C174.374 42.6917 174.532 42.5336 174.532 42.3384C174.532 42.1433 174.374 41.9852 174.179 41.9852C173.984 41.9852 173.825 42.1433 173.825 42.3384C173.825 42.5336 173.984 42.6917 174.179 42.6917Z"
        fill="#324A52"
      />
      <path
        d="M177.76 39.2558C177.623 39.3924 177.397 39.3924 177.26 39.2558C177.124 39.1192 177.124 38.8931 177.26 38.7565C177.397 38.6199 177.623 38.6199 177.76 38.7565C177.897 38.8931 177.897 39.1192 177.76 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M177.76 39.2558C177.623 39.3924 177.397 39.3924 177.26 39.2558C177.124 39.1192 177.124 38.8931 177.26 38.7565C177.397 38.6199 177.623 38.6199 177.76 38.7565C177.897 38.8931 177.897 39.1192 177.76 39.2558Z"
        fill="#324A52"
      />
      <path
        d="M180.842 36.0273C181.037 36.0273 181.195 35.8691 181.195 35.674C181.195 35.4789 181.037 35.3207 180.842 35.3207C180.647 35.3207 180.489 35.4789 180.489 35.674C180.489 35.8691 180.647 36.0273 180.842 36.0273Z"
        fill="#324A52"
      />
      <path
        d="M180.842 36.0273C181.037 36.0273 181.195 35.8691 181.195 35.674C181.195 35.4789 181.037 35.3207 180.842 35.3207C180.647 35.3207 180.489 35.4789 180.489 35.674C180.489 35.8691 180.647 36.0273 180.842 36.0273Z"
        fill="#324A52"
      />
      <path
        d="M184.174 32.6956C184.369 32.6956 184.527 32.5374 184.527 32.3423C184.527 32.1472 184.369 31.989 184.174 31.989C183.978 31.989 183.82 32.1472 183.82 32.3423C183.82 32.5374 183.978 32.6956 184.174 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M184.174 32.6956C184.369 32.6956 184.527 32.5374 184.527 32.3423C184.527 32.1472 184.369 31.989 184.174 31.989C183.978 31.989 183.82 32.1472 183.82 32.3423C183.82 32.5374 183.978 32.6956 184.174 32.6956Z"
        fill="#324A52"
      />
      <path
        d="M187.755 29.2606C187.619 29.3972 187.393 29.3972 187.256 29.2606C187.119 29.124 187.119 28.8979 187.256 28.7613C187.393 28.6247 187.619 28.6247 187.755 28.7613C187.897 28.8979 187.897 29.124 187.755 29.2606Z"
        fill="#324A52"
      />
      <path
        d="M187.755 29.2606C187.619 29.3972 187.393 29.3972 187.256 29.2606C187.119 29.124 187.119 28.8979 187.256 28.7613C187.393 28.6247 187.619 28.6247 187.755 28.7613C187.897 28.8979 187.897 29.124 187.755 29.2606Z"
        fill="#324A52"
      />
      <path
        d="M190.837 26.0312C191.033 26.0312 191.191 25.873 191.191 25.6779C191.191 25.4828 191.033 25.3246 190.837 25.3246C190.642 25.3246 190.484 25.4828 190.484 25.6779C190.484 25.873 190.642 26.0312 190.837 26.0312Z"
        fill="#324A52"
      />
      <path
        d="M190.837 26.0312C191.033 26.0312 191.191 25.873 191.191 25.6779C191.191 25.4828 191.033 25.3246 190.837 25.3246C190.642 25.3246 190.484 25.4828 190.484 25.6779C190.484 25.873 190.642 26.0312 190.837 26.0312Z"
        fill="#324A52"
      />
      <path
        d="M194.173 22.7004C194.369 22.7004 194.527 22.5422 194.527 22.3471C194.527 22.152 194.369 21.9938 194.173 21.9938C193.978 21.9938 193.82 22.152 193.82 22.3471C193.82 22.5422 193.978 22.7004 194.173 22.7004Z"
        fill="#324A52"
      />
      <path
        d="M194.173 22.7004C194.369 22.7004 194.527 22.5422 194.527 22.3471C194.527 22.152 194.369 21.9938 194.173 21.9938C193.978 21.9938 193.82 22.152 193.82 22.3471C193.82 22.5422 193.978 22.7004 194.173 22.7004Z"
        fill="#324A52"
      />
      <path
        d="M197.506 19.3702C197.701 19.3702 197.859 19.2121 197.859 19.0169C197.859 18.8218 197.701 18.6637 197.506 18.6637C197.311 18.6637 197.153 18.8218 197.153 19.0169C197.153 19.2121 197.311 19.3702 197.506 19.3702Z"
        fill="#324A52"
      />
      <path
        d="M197.506 19.3702C197.701 19.3702 197.859 19.2121 197.859 19.0169C197.859 18.8218 197.701 18.6637 197.506 18.6637C197.311 18.6637 197.153 18.8218 197.153 19.0169C197.153 19.2121 197.311 19.3702 197.506 19.3702Z"
        fill="#324A52"
      />
      <path
        d="M200.837 16.0318C201.032 16.0318 201.19 15.8737 201.19 15.6786C201.19 15.4834 201.032 15.3253 200.837 15.3253C200.642 15.3253 200.483 15.4834 200.483 15.6786C200.483 15.8737 200.642 16.0318 200.837 16.0318Z"
        fill="#324A52"
      />
      <path
        d="M200.837 16.0318C201.032 16.0318 201.19 15.8737 201.19 15.6786C201.19 15.4834 201.032 15.3253 200.837 15.3253C200.642 15.3253 200.483 15.4834 200.483 15.6786C200.483 15.8737 200.642 16.0318 200.837 16.0318Z"
        fill="#324A52"
      />
      <path
        d="M204.168 12.7001C204.364 12.7001 204.522 12.5419 204.522 12.3468C204.522 12.1517 204.364 11.9935 204.168 11.9935C203.973 11.9935 203.815 12.1517 203.815 12.3468C203.815 12.5419 203.973 12.7001 204.168 12.7001Z"
        fill="#324A52"
      />
      <path
        d="M204.168 12.7001C204.364 12.7001 204.522 12.5419 204.522 12.3468C204.522 12.1517 204.364 11.9935 204.168 11.9935C203.973 11.9935 203.815 12.1517 203.815 12.3468C203.815 12.5419 203.973 12.7001 204.168 12.7001Z"
        fill="#324A52"
      />
      <path
        d="M207.5 9.36836C207.695 9.36836 207.853 9.21019 207.853 9.01508C207.853 8.81997 207.695 8.6618 207.5 8.6618C207.305 8.6618 207.147 8.81997 207.147 9.01508C207.147 9.21019 207.305 9.36836 207.5 9.36836Z"
        fill="#324A52"
      />
      <path
        d="M207.5 9.36836C207.695 9.36836 207.853 9.21019 207.853 9.01508C207.853 8.81997 207.695 8.6618 207.5 8.6618C207.305 8.6618 207.147 8.81997 207.147 9.01508C207.147 9.21019 207.305 9.36836 207.5 9.36836Z"
        fill="#324A52"
      />
      <path
        d="M210.832 6.03664C211.027 6.03664 211.185 5.87847 211.185 5.68336C211.185 5.48825 211.027 5.33008 210.832 5.33008C210.636 5.33008 210.478 5.48825 210.478 5.68336C210.478 5.87847 210.636 6.03664 210.832 6.03664Z"
        fill="#324A52"
      />
      <path
        d="M210.832 6.03664C211.027 6.03664 211.185 5.87847 211.185 5.68336C211.185 5.48825 211.027 5.33008 210.832 5.33008C210.636 5.33008 210.478 5.48825 210.478 5.68336C210.478 5.87847 210.636 6.03664 210.832 6.03664Z"
        fill="#324A52"
      />
      <path
        d="M151.102 59.2499C150.965 59.3865 150.739 59.3865 150.602 59.2499C150.466 59.1132 150.466 58.8871 150.602 58.7505C150.739 58.6139 150.965 58.6139 151.102 58.7505C151.239 58.8871 151.239 59.1132 151.102 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M151.102 59.2499C150.965 59.3865 150.739 59.3865 150.602 59.2499C150.466 59.1132 150.466 58.8871 150.602 58.7505C150.739 58.6139 150.965 58.6139 151.102 58.7505C151.239 58.8871 151.239 59.1132 151.102 59.2499Z"
        fill="#324A52"
      />
      <path
        d="M154.434 55.918C154.297 56.0546 154.071 56.0546 153.934 55.918C153.798 55.7814 153.798 55.5553 153.934 55.4187C154.071 55.2821 154.297 55.2821 154.434 55.4187C154.571 55.5553 154.575 55.7767 154.434 55.918Z"
        fill="#324A52"
      />
      <path
        d="M154.434 55.918C154.297 56.0546 154.071 56.0546 153.934 55.918C153.798 55.7814 153.798 55.5553 153.934 55.4187C154.071 55.2821 154.297 55.2821 154.434 55.4187C154.571 55.5553 154.575 55.7767 154.434 55.918Z"
        fill="#324A52"
      />
      <path
        d="M157.765 52.5863C157.629 52.7229 157.403 52.7229 157.266 52.5863C157.129 52.4497 157.129 52.2236 157.266 52.087C157.403 51.9504 157.629 51.9504 157.765 52.087C157.907 52.2236 157.907 52.445 157.765 52.5863Z"
        fill="#324A52"
      />
      <path
        d="M157.765 52.5863C157.629 52.7229 157.403 52.7229 157.266 52.5863C157.129 52.4497 157.129 52.2236 157.266 52.087C157.403 51.9504 157.629 51.9504 157.765 52.087C157.907 52.2236 157.907 52.445 157.765 52.5863Z"
        fill="#324A52"
      />
      <path
        d="M161.097 49.2546C160.96 49.3912 160.734 49.3912 160.597 49.2546C160.461 49.118 160.461 48.8919 160.597 48.7553C160.734 48.6187 160.96 48.6187 161.097 48.7553C161.238 48.8919 161.238 49.1133 161.097 49.2546Z"
        fill="#324A52"
      />
      <path
        d="M161.097 49.2546C160.96 49.3912 160.734 49.3912 160.597 49.2546C160.461 49.118 160.461 48.8919 160.597 48.7553C160.734 48.6187 160.96 48.6187 161.097 48.7553C161.238 48.8919 161.238 49.1133 161.097 49.2546Z"
        fill="#324A52"
      />
      <path
        d="M164.433 45.9187C164.296 46.0553 164.07 46.0553 163.934 45.9187C163.797 45.7821 163.797 45.556 163.934 45.4194C164.07 45.2828 164.296 45.2828 164.433 45.4194C164.57 45.556 164.57 45.7821 164.433 45.9187Z"
        fill="#324A52"
      />
      <path
        d="M164.433 45.9187C164.296 46.0553 164.07 46.0553 163.934 45.9187C163.797 45.7821 163.797 45.556 163.934 45.4194C164.07 45.2828 164.296 45.2828 164.433 45.4194C164.57 45.556 164.57 45.7821 164.433 45.9187Z"
        fill="#324A52"
      />
      <path
        d="M167.765 42.587C167.629 42.7236 167.402 42.7236 167.266 42.587C167.129 42.4504 167.129 42.2243 167.266 42.0877C167.402 41.9511 167.629 41.9511 167.765 42.0877C167.902 42.229 167.902 42.4504 167.765 42.587Z"
        fill="#324A52"
      />
      <path
        d="M167.765 42.587C167.629 42.7236 167.402 42.7236 167.266 42.587C167.129 42.4504 167.129 42.2243 167.266 42.0877C167.402 41.9511 167.629 41.9511 167.765 42.0877C167.902 42.229 167.902 42.4504 167.765 42.587Z"
        fill="#324A52"
      />
      <path
        d="M171.097 39.2559C170.96 39.3925 170.734 39.3925 170.598 39.2559C170.461 39.1193 170.461 38.8932 170.598 38.7566C170.734 38.62 170.96 38.62 171.097 38.7566C171.234 38.8932 171.234 39.1193 171.097 39.2559Z"
        fill="#324A52"
      />
      <path
        d="M171.097 39.2559C170.96 39.3925 170.734 39.3925 170.598 39.2559C170.461 39.1193 170.461 38.8932 170.598 38.7566C170.734 38.62 170.96 38.62 171.097 38.7566C171.234 38.8932 171.234 39.1193 171.097 39.2559Z"
        fill="#324A52"
      />
      <path
        d="M174.179 36.0274C174.374 36.0274 174.532 35.8692 174.532 35.6741C174.532 35.479 174.374 35.3208 174.179 35.3208C173.984 35.3208 173.825 35.479 173.825 35.6741C173.825 35.8692 173.984 36.0274 174.179 36.0274Z"
        fill="#324A52"
      />
      <path
        d="M174.179 36.0274C174.374 36.0274 174.532 35.8692 174.532 35.6741C174.532 35.479 174.374 35.3208 174.179 35.3208C173.984 35.3208 173.825 35.479 173.825 35.6741C173.825 35.8692 173.984 36.0274 174.179 36.0274Z"
        fill="#324A52"
      />
      <path
        d="M177.761 32.5924C177.624 32.729 177.398 32.729 177.261 32.5924C177.124 32.4558 177.124 32.2297 177.261 32.0931C177.398 31.9565 177.624 31.9565 177.761 32.0931C177.897 32.2297 177.897 32.4558 177.761 32.5924Z"
        fill="#324A52"
      />
      <path
        d="M177.761 32.5924C177.624 32.729 177.398 32.729 177.261 32.5924C177.124 32.4558 177.124 32.2297 177.261 32.0931C177.398 31.9565 177.624 31.9565 177.761 32.0931C177.897 32.2297 177.897 32.4558 177.761 32.5924Z"
        fill="#324A52"
      />
      <path
        d="M181.092 29.2607C180.956 29.3973 180.729 29.3973 180.593 29.2607C180.456 29.1241 180.456 28.898 180.593 28.7614C180.729 28.6248 180.956 28.6248 181.092 28.7614C181.229 28.898 181.229 29.1241 181.092 29.2607Z"
        fill="#324A52"
      />
      <path
        d="M181.092 29.2607C180.956 29.3973 180.729 29.3973 180.593 29.2607C180.456 29.1241 180.456 28.898 180.593 28.7614C180.729 28.6248 180.956 28.6248 181.092 28.7614C181.229 28.898 181.229 29.1241 181.092 29.2607Z"
        fill="#324A52"
      />
      <path
        d="M184.174 26.0322C184.369 26.0322 184.528 25.874 184.528 25.6789C184.528 25.4838 184.369 25.3256 184.174 25.3256C183.979 25.3256 183.821 25.4838 183.821 25.6789C183.821 25.874 183.979 26.0322 184.174 26.0322Z"
        fill="#324A52"
      />
      <path
        d="M184.174 26.0322C184.369 26.0322 184.528 25.874 184.528 25.6789C184.528 25.4838 184.369 25.3256 184.174 25.3256C183.979 25.3256 183.821 25.4838 183.821 25.6789C183.821 25.874 183.979 26.0322 184.174 26.0322Z"
        fill="#324A52"
      />
      <path
        d="M187.505 22.7004C187.701 22.7004 187.859 22.5423 187.859 22.3472C187.859 22.152 187.701 21.9939 187.505 21.9939C187.31 21.9939 187.152 22.152 187.152 22.3472C187.152 22.5423 187.31 22.7004 187.505 22.7004Z"
        fill="#324A52"
      />
      <path
        d="M187.505 22.7004C187.701 22.7004 187.859 22.5423 187.859 22.3472C187.859 22.152 187.701 21.9939 187.505 21.9939C187.31 21.9939 187.152 22.152 187.152 22.3472C187.152 22.5423 187.31 22.7004 187.505 22.7004Z"
        fill="#324A52"
      />
      <path
        d="M190.838 19.3703C191.033 19.3703 191.191 19.2121 191.191 19.017C191.191 18.8219 191.033 18.6637 190.838 18.6637C190.642 18.6637 190.484 18.8219 190.484 19.017C190.484 19.2121 190.642 19.3703 190.838 19.3703Z"
        fill="#324A52"
      />
      <path
        d="M190.838 19.3703C191.033 19.3703 191.191 19.2121 191.191 19.017C191.191 18.8219 191.033 18.6637 190.838 18.6637C190.642 18.6637 190.484 18.8219 190.484 19.017C190.484 19.2121 190.642 19.3703 190.838 19.3703Z"
        fill="#324A52"
      />
      <path
        d="M194.173 16.0329C194.369 16.0329 194.527 15.8747 194.527 15.6796C194.527 15.4845 194.369 15.3263 194.173 15.3263C193.978 15.3263 193.82 15.4845 193.82 15.6796C193.82 15.8747 193.978 16.0329 194.173 16.0329Z"
        fill="#324A52"
      />
      <path
        d="M194.173 16.0329C194.369 16.0329 194.527 15.8747 194.527 15.6796C194.527 15.4845 194.369 15.3263 194.173 15.3263C193.978 15.3263 193.82 15.4845 193.82 15.6796C193.82 15.8747 193.978 16.0329 194.173 16.0329Z"
        fill="#324A52"
      />
      <path
        d="M197.505 12.7002C197.7 12.7002 197.859 12.542 197.859 12.3469C197.859 12.1518 197.7 11.9936 197.505 11.9936C197.31 11.9936 197.152 12.1518 197.152 12.3469C197.152 12.542 197.31 12.7002 197.505 12.7002Z"
        fill="#324A52"
      />
      <path
        d="M197.505 12.7002C197.7 12.7002 197.859 12.542 197.859 12.3469C197.859 12.1518 197.7 11.9936 197.505 11.9936C197.31 11.9936 197.152 12.1518 197.152 12.3469C197.152 12.542 197.31 12.7002 197.505 12.7002Z"
        fill="#324A52"
      />
      <path
        d="M200.837 9.37003C201.032 9.37003 201.19 9.21186 201.19 9.01675C201.19 8.82164 201.032 8.66347 200.837 8.66347C200.642 8.66347 200.483 8.82164 200.483 9.01675C200.483 9.21186 200.642 9.37003 200.837 9.37003Z"
        fill="#324A52"
      />
      <path
        d="M200.837 9.37003C201.032 9.37003 201.19 9.21186 201.19 9.01675C201.19 8.82164 201.032 8.66347 200.837 8.66347C200.642 8.66347 200.483 8.82164 200.483 9.01675C200.483 9.21186 200.642 9.37003 200.837 9.37003Z"
        fill="#324A52"
      />
      <path
        d="M204.168 6.03671C204.364 6.03671 204.522 5.87854 204.522 5.68343C204.522 5.48832 204.364 5.33015 204.168 5.33015C203.973 5.33015 203.815 5.48832 203.815 5.68343C203.815 5.87854 203.973 6.03671 204.168 6.03671Z"
        fill="#324A52"
      />
      <path
        d="M204.168 6.03671C204.364 6.03671 204.522 5.87854 204.522 5.68343C204.522 5.48832 204.364 5.33015 204.168 5.33015C203.973 5.33015 203.815 5.48832 203.815 5.68343C203.815 5.87854 203.973 6.03671 204.168 6.03671Z"
        fill="#324A52"
      />
      <path
        d="M207.5 2.70656C207.695 2.70656 207.853 2.54839 207.853 2.35328C207.853 2.15817 207.695 2 207.5 2C207.304 2 207.146 2.15817 207.146 2.35328C207.146 2.54839 207.304 2.70656 207.5 2.70656Z"
        fill="#324A52"
      />
      <path
        d="M207.5 2.70656C207.695 2.70656 207.853 2.54839 207.853 2.35328C207.853 2.15817 207.695 2 207.5 2C207.304 2 207.146 2.15817 207.146 2.35328C207.146 2.54839 207.304 2.70656 207.5 2.70656Z"
        fill="#324A52"
      />
      <path
        d="M113.646 231.104C113.646 233.176 120.779 235.163 133.477 236.628C146.175 238.094 163.397 238.917 181.354 238.917C199.312 238.917 216.533 238.094 229.231 236.628C241.929 235.163 249.063 233.176 249.063 231.104C249.063 229.032 241.929 227.045 229.231 225.58C216.533 224.115 199.312 223.292 181.354 223.292C163.397 223.292 146.175 224.115 133.477 225.58C120.779 227.045 113.646 229.032 113.646 231.104Z"
        fill="#324A52"
        opacity="0.15"
      />
      <path d="M90.7292 81.2084H233.958V195.792H90.7292V81.2084Z" fill="#FA715B" />
      <path
        d="M218.333 81.2084H106.458C102.314 81.2084 98.3401 82.8546 95.4098 85.7848C92.4796 88.7151 90.8334 92.6893 90.8334 96.8334V117.667C90.8334 113.523 92.4796 109.548 95.4098 106.618C98.3401 103.688 102.314 102.042 106.458 102.042H218.438C222.582 102.042 226.556 103.688 229.486 106.618C232.416 109.548 234.063 113.523 234.063 117.667V96.8334C234.063 94.7727 233.655 92.7323 232.863 90.8298C232.072 88.9272 230.911 87.2001 229.449 85.7478C227.987 84.2955 226.253 83.1468 224.345 82.3677C222.437 81.5886 220.394 81.1946 218.333 81.2084Z"
        fill="#E64F3A"
      />
      <path
        d="M90.7292 81.2084H233.958V195.792H90.7292V81.2084Z"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.20833"
      />
      <path
        d="M162.344 3.08335C147.517 3.12468 133.31 9.04015 122.836 19.5343C112.361 30.0284 106.472 44.2458 106.458 59.0729V81.2084H129.896V59.0729C129.896 50.4396 133.325 42.1598 139.43 36.0551C145.535 29.9504 153.815 26.5208 162.448 26.5208C171.081 26.5208 179.361 29.9504 185.466 36.0551C191.57 42.1598 195 50.4396 195 59.0729V81.2084H218.438V59.0729C218.438 51.7115 216.986 44.4223 214.166 37.6226C211.345 30.8228 207.212 24.6459 202.002 19.4454C196.792 14.245 190.607 10.123 183.802 7.31537C176.997 4.50776 169.705 3.06965 162.344 3.08335Z"
        fill="#F0F0F0"
      />
      <path
        d="M162.344 3.08335C147.517 3.12468 133.31 9.04015 122.836 19.5343C112.361 30.0284 106.472 44.2458 106.458 59.0729V72.0938C106.458 57.2444 112.357 43.0032 122.857 32.5032C133.357 22.0031 147.599 16.1042 162.448 16.1042C177.297 16.1042 191.538 22.0031 202.039 32.5032C212.539 43.0032 218.438 57.2444 218.438 72.0938V59.0729C218.438 51.7115 216.986 44.4223 214.166 37.6226C211.345 30.8228 207.212 24.6459 202.002 19.4454C196.792 14.245 190.607 10.123 183.802 7.31537C176.997 4.50776 169.705 3.06965 162.344 3.08335Z"
        fill="white"
      />
      <path
        d="M162.344 3.08335C147.517 3.12468 133.31 9.04015 122.836 19.5343C112.361 30.0284 106.472 44.2458 106.458 59.0729V81.2084H129.896V59.0729C129.896 50.4396 133.325 42.1598 139.43 36.0551C145.535 29.9504 153.815 26.5208 162.448 26.5208C171.081 26.5208 179.361 29.9504 185.466 36.0551C191.57 42.1598 195 50.4396 195 59.0729V81.2084H218.438V59.0729C218.438 51.7115 216.986 44.4223 214.166 37.6226C211.345 30.8228 207.212 24.6459 202.002 19.4454C196.792 14.245 190.607 10.123 183.802 7.31537C176.997 4.50776 169.705 3.06965 162.344 3.08335V3.08335Z"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.20833"
      />
      <path
        d="M287.813 121C281.296 114.501 272.693 110.511 263.522 109.735C254.351 108.959 245.2 111.446 237.684 116.758C230.167 122.07 224.768 129.865 222.438 138.769C220.108 147.673 220.997 157.114 224.948 165.427L175.417 214.75C174.867 215.296 174.446 215.959 174.185 216.689C173.923 217.419 173.828 218.198 173.906 218.969L175.052 228.917C175.175 230.096 175.696 231.197 176.529 232.04C177.362 232.883 178.458 233.416 179.635 233.552L189.583 234.646C190.363 234.732 191.152 234.641 191.892 234.379C192.631 234.118 193.302 233.693 193.854 233.135L199.74 227.25C200.222 226.763 200.604 226.186 200.863 225.552C201.123 224.917 201.254 224.238 201.25 223.552V218.344H206.458C207.144 218.348 207.823 218.216 208.458 217.957C209.092 217.698 209.67 217.316 210.156 216.833L214.792 212.198C215.274 211.711 215.656 211.134 215.915 210.5C216.175 209.865 216.306 209.185 216.302 208.5V205.427C216.322 204.053 216.883 202.743 217.865 201.781L224.01 195.635C224.493 195.143 225.068 194.752 225.703 194.484C226.338 194.215 227.019 194.076 227.708 194.073H230.729C231.415 194.077 232.094 193.946 232.729 193.686C233.363 193.427 233.94 193.045 234.427 192.563L243.385 183.604C251.657 187.402 260.995 188.191 269.787 185.837C278.578 183.483 286.272 178.133 291.54 170.711C296.807 163.288 299.317 154.26 298.637 145.184C297.956 136.108 294.128 127.554 287.813 121ZM269.427 139.438C268.66 138.722 268.044 137.86 267.617 136.901C267.19 135.943 266.96 134.909 266.942 133.86C266.923 132.811 267.116 131.769 267.509 130.796C267.902 129.823 268.487 128.939 269.229 128.198C269.971 127.456 270.854 126.871 271.827 126.478C272.8 126.085 273.842 125.892 274.891 125.911C275.94 125.929 276.974 126.159 277.933 126.586C278.891 127.013 279.754 127.628 280.469 128.396C281.849 129.877 282.6 131.836 282.564 133.86C282.529 135.884 281.709 137.815 280.277 139.246C278.846 140.677 276.915 141.497 274.891 141.533C272.867 141.569 270.908 140.818 269.427 139.438Z"
        fill="#146EE8"
      />
      <path
        d="M232.552 137.406C237.459 132.523 243.571 129.025 250.267 127.269C256.963 125.513 264.005 125.56 270.677 127.406C272.16 126.401 273.946 125.939 275.731 126.101C277.516 126.262 279.19 127.036 280.469 128.292C281.723 129.588 282.479 131.284 282.604 133.083C284.457 134.378 286.199 135.824 287.813 137.406C293.083 142.723 296.701 149.452 298.229 156.781C299.483 151.083 299.443 145.176 298.111 139.495C296.779 133.814 294.19 128.504 290.535 123.956C286.879 119.409 282.25 115.739 276.988 113.218C271.726 110.696 265.965 109.387 260.13 109.387C254.295 109.387 248.535 110.696 243.273 113.218C238.011 115.739 233.382 119.409 229.726 123.956C226.07 128.504 223.481 133.814 222.149 139.495C220.818 145.176 220.777 151.083 222.031 156.781C223.613 149.45 227.265 142.726 232.552 137.406Z"
        fill="#115BBE"
      />
      <path
        d="M175.729 231.104L224.948 181.833C223.044 177.745 221.863 173.357 221.458 168.865L175.417 214.75C174.867 215.296 174.446 215.959 174.185 216.689C173.923 217.419 173.828 218.197 173.906 218.969L175.052 228.917C175.093 229.691 175.326 230.442 175.729 231.104Z"
        fill="#115BBE"
      />
      <path
        d="M287.813 121C281.296 114.501 272.693 110.511 263.522 109.735C254.351 108.959 245.2 111.446 237.684 116.758C230.167 122.07 224.768 129.865 222.438 138.769C220.108 147.673 220.997 157.114 224.948 165.427L175.417 214.75C174.867 215.296 174.446 215.959 174.185 216.689C173.923 217.419 173.828 218.197 173.906 218.969L175.052 228.917C175.175 230.096 175.696 231.197 176.529 232.04C177.362 232.883 178.458 233.416 179.635 233.552L189.583 234.646C190.363 234.732 191.152 234.641 191.892 234.379C192.631 234.118 193.302 233.693 193.854 233.135L199.74 227.25C200.222 226.763 200.604 226.186 200.863 225.552C201.123 224.917 201.254 224.238 201.25 223.552V218.344H206.458C207.144 218.348 207.823 218.216 208.458 217.957C209.092 217.698 209.67 217.316 210.156 216.833L214.792 212.198C215.274 211.711 215.656 211.134 215.915 210.5C216.175 209.865 216.306 209.185 216.302 208.5V205.427C216.322 204.053 216.883 202.743 217.865 201.781L224.01 195.635C224.493 195.143 225.068 194.752 225.703 194.484C226.338 194.215 227.019 194.076 227.708 194.073H230.729C231.415 194.077 232.094 193.946 232.729 193.686C233.363 193.427 233.94 193.045 234.427 192.563L243.385 183.604C251.657 187.402 260.995 188.191 269.787 185.837C278.578 183.483 286.272 178.133 291.54 170.711C296.807 163.288 299.317 154.26 298.637 145.184C297.956 136.108 294.128 127.554 287.813 121V121ZM269.427 139.438C268.66 138.722 268.044 137.86 267.617 136.901C267.19 135.943 266.96 134.909 266.942 133.86C266.923 132.811 267.116 131.769 267.509 130.796C267.902 129.823 268.487 128.939 269.229 128.198C269.971 127.456 270.854 126.871 271.827 126.478C272.8 126.085 273.842 125.892 274.891 125.911C275.94 125.929 276.974 126.159 277.933 126.586C278.891 127.013 279.754 127.628 280.469 128.396C281.849 129.877 282.6 131.836 282.564 133.86C282.529 135.884 281.709 137.815 280.277 139.246C278.846 140.677 276.915 141.497 274.891 141.533C272.867 141.569 270.908 140.818 269.427 139.438V139.438Z"
        stroke="#324A52"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5.20833"
      />
    </SimpleIcon>
  );
}
